/* eslint-disable */
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** String containing a date (YYYY-MM-DD) */
  Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
  /** Represents untyped JSON */
  JSON: any;
  /** Float with milliseconds since epoch */
  Time: any;
};




export type ApiKey = {
  __typename?: 'APIKey';
  apiKey: Scalars['String'];
  id: Scalars['ID'];
  target: ApiKeyTarget;
};

/** The API key target */
export enum ApiKeyTarget {
  Rest = 'rest'
}

/** Autogenerated input type of AcceptInvitation */
export type AcceptInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Invitation token */
  invitationToken: Scalars['String'];
  /** Password */
  password: Scalars['String'];
  /** Password confirmation */
  passwordConfirmation: Scalars['String'];
  updatedUserData?: Maybe<UpdatedUserData>;
};

/** Autogenerated return type of AcceptInvitation. */
export type AcceptInvitationPayload = {
  __typename?: 'AcceptInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The new user */
  user: Maybe<User>;
};

/** An Action */
export type Action = Node & {
  __typename?: 'Action';
  actionAssignmentGroups: Maybe<Array<Maybe<ActionAssignmentGroup>>>;
  actionEntities: Maybe<Array<Maybe<ActionEntity>>>;
  actionFields: Maybe<Array<Maybe<ActionField>>>;
  active: Maybe<Scalars['Boolean']>;
  campaign: Maybe<CampaignPublic>;
  canvassingEnabled: Maybe<Scalars['Boolean']>;
  canvassingType: Maybe<CanvassingTypes>;
  completed: Maybe<Scalars['Boolean']>;
  /** @deprecated Will be removed in future release */
  completedPercentage: Maybe<Scalars['Float']>;
  contactAttemptsContactedCount: Maybe<Scalars['Int']>;
  contactAttemptsCount: Maybe<Scalars['Int']>;
  createdAt: Scalars['Time'];
  createdBy: Maybe<UserPublic>;
  dueDate: Maybe<Scalars['Date']>;
  entityType: EntityType;
  householdingEnabled: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notificationEnabled: Scalars['Boolean'];
  targetIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Entities with at least one mappable address */
  targetIdsWithMappableAddresses: Maybe<Array<Maybe<Scalars['String']>>>;
  targets: Array<Maybe<Entity>>;
  targetsAllPendingCount: Maybe<Scalars['Int']>;
  targetsCompleted: Maybe<Scalars['Int']>;
  targetsCount: Maybe<Scalars['Int']>;
  targetsPending: Maybe<Scalars['Int']>;
  targetsQueryJson: Maybe<Scalars['JSON']>;
  text: Maybe<Scalars['String']>;
  updatedAt: Scalars['Time'];
};


/** An Action */
export type ActionTargetIdsArgs = {
  limit?: Maybe<Scalars['Int']>;
};


/** An Action */
export type ActionTargetIdsWithMappableAddressesArgs = {
  limit?: Maybe<Scalars['Int']>;
};

/** An Action assignment group type */
export type ActionAssignmentGroup = {
  __typename?: 'ActionAssignmentGroup';
  action: Action;
  actionEntities: Maybe<Array<Maybe<ActionEntity>>>;
  contactAttemptsContactedCount: Maybe<Scalars['Int']>;
  contactAttemptsCount: Maybe<Scalars['Int']>;
  createdAt: Scalars['Time'];
  id: Scalars['ID'];
  isRoutable: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  /** Returns routing info based upon current user */
  routingInfo: Maybe<AssignmentRoutingOptions>;
  targetIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of ids which are already assigned to other action assignment groups */
  targetIdsAssignedToOtherGroups: Maybe<Array<Maybe<Scalars['String']>>>;
  targetsCount: Maybe<Scalars['Int']>;
  targetsWithAllTasksCompletedCount: Maybe<Scalars['Int']>;
  targetsWithNoTasksCompletedCount: Maybe<Scalars['Int']>;
  targetsWithSomeTasksCompletedCount: Maybe<Scalars['Int']>;
  uniqueGeocodesForBestAddressesCount: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Time'];
  users: Maybe<Array<User>>;
};


/** An Action assignment group type */
export type ActionAssignmentGroupActionEntitiesArgs = {
  withMappableAddresses?: Maybe<Scalars['Boolean']>;
};


/** An Action assignment group type */
export type ActionAssignmentGroupTargetIdsArgs = {
  limit?: Maybe<Scalars['Int']>;
};

/** Strategy-specific parameters for generating action assignment groups */
export type ActionAssignmentGroupingParamsInput = {
  /** Used by by_aggregators: primary WallChart3 aggregator entry */
  groupBy?: Maybe<AggregatorEntry>;
  /** Used by by_size: number of entities per turf */
  groupSize?: Maybe<Scalars['Int']>;
  /** Used by by_aggregators: optional secondary aggregator for two-level nesting */
  thenBy?: Maybe<AggregatorEntry>;
};

/** Available strategies for auto-generating action assignment groups (turfs) */
export enum ActionAssignmentGroupingStrategy {
  /** One turf per aggregator group using any WallChart3 aggregator type (group_by + optional then_by) */
  ByAggregators = 'by_aggregators',
  /** Split entities into equal-sized turfs */
  BySize = 'by_size'
}

/** Update Action input. */
export type ActionChangesInput = {
  dueDate?: Maybe<Scalars['Date']>;
  /** Enable householding */
  householdingEnabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  /** Enable notification */
  notificationEnabled?: Maybe<Scalars['Boolean']>;
  targetsQueryJson?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

/** An Action and entity relation */
export type ActionEntity = {
  __typename?: 'ActionEntity';
  action: Maybe<Action>;
  completed: Maybe<Scalars['Boolean']>;
  completedAt: Maybe<Scalars['Time']>;
  completedCount: Maybe<Scalars['Int']>;
  contactAttemptsAttemptedCount: Maybe<Scalars['Int']>;
  contactAttemptsMarkedAsBadCount: Maybe<Scalars['Int']>;
  contactAttemptsMarkedAsDoNotContactCount: Maybe<Scalars['Int']>;
  contacted: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['Time'];
  entity: Maybe<Entity>;
  hasContactInfo: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  mostRecentContactAttempt: Maybe<ContactAttempt>;
  /** Related pending tasks count */
  pendingCount: Maybe<Scalars['Int']>;
  /** A entity status related to associated action tasks */
  status: Maybe<Scalars['String']>;
  tasks: Maybe<Array<Maybe<Task>>>;
  updatedAt: Scalars['Time'];
};

export type ActionEntityAddressMatchResult = {
  __typename?: 'ActionEntityAddressMatchResult';
  /** Action Entity */
  actionEntity: Maybe<ActionEntity>;
  /** First Matched Address Id */
  firstMatchedAddressId: Maybe<Scalars['ID']>;
  /** Matched Address Ids */
  matchedAddressIds: Maybe<Array<Scalars['ID']>>;
};

export type ActionEntityAssignmentOrdering = {
  __typename?: 'ActionEntityAssignmentOrdering';
  /** Action Assignment Group Id */
  actionAssignmentGroupId: Scalars['ID'];
  /** Ordered Action Entity Ids */
  actionEntityIds: Maybe<Array<Scalars['ID']>>;
  /** Action Id */
  actionId: Scalars['ID'];
};

/** The connection type for ActionEntity. */
export type ActionEntityConnectionWithTotalCount = {
  __typename?: 'ActionEntityConnectionWithTotalCount';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ActionEntityEdge>>>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<ActionEntity>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ActionEntityEdge = {
  __typename?: 'ActionEntityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<ActionEntity>;
};

/** An Action field */
export type ActionField = {
  __typename?: 'ActionField';
  action: Maybe<Action>;
  calendarEvent: Maybe<CalendarEvent>;
  calendarEventAction: Maybe<CalendarEventAction>;
  createdAt: Scalars['Time'];
  defaultResponse: Maybe<Tag>;
  defaultResponseId: Maybe<Scalars['ID']>;
  entityConnectionType: Maybe<EntityConnectionType>;
  id: Scalars['ID'];
  isOptional: Maybe<Scalars['Boolean']>;
  objectAttribute: Maybe<Scalars['String']>;
  objectType: Maybe<TaskObjectTypes>;
  position: Maybe<Scalars['Int']>;
  quickCheckIn: Maybe<Scalars['Boolean']>;
  relatedObjectId: Maybe<Scalars['ID']>;
  relatedObjectType: Maybe<Scalars['String']>;
  tagCategory: Maybe<TagCategory>;
  updatedAt: Scalars['Time'];
};

export type ActionHouseholdMatchResult = {
  __typename?: 'ActionHouseholdMatchResult';
  /** Address used when searching */
  address: Address;
  /** Array of model containing the ActionEntity the matched address ids */
  matches: Maybe<Array<ActionEntityAddressMatchResult>>;
};

/** Autogenerated input type of ActionNetworkAddCampaignTagMapping */
export type ActionNetworkAddCampaignTagMappingInput = {
  actionNetwork: ActionNetworkTagMappingInputConfig;
  /** The id of the campaign to which the group is being added. */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the Action Builder Tag */
  tagId: Scalars['ID'];
};

/** Autogenerated return type of ActionNetworkAddCampaignTagMapping. */
export type ActionNetworkAddCampaignTagMappingPayload = {
  __typename?: 'ActionNetworkAddCampaignTagMappingPayload';
  /** The added tag mapping. */
  actionNetworkTagMapping: ActionNetworkTagMapping;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of ActionNetworkAddGroup */
export type ActionNetworkAddGroupInput = {
  /** The group api key */
  apiKey: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ActionNetworkAddGroup. */
export type ActionNetworkAddGroupPayload = {
  __typename?: 'ActionNetworkAddGroupPayload';
  /** The new action network group */
  actionNetworkGroup: Maybe<ActionNetworkGroup>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of ActionNetworkAddIntegrationToCampaign */
export type ActionNetworkAddIntegrationToCampaignInput = {
  /** The ID of the campaign */
  campaignId: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the entity type used to create new entities from ActionNetwork */
  entityTypeId?: Maybe<Scalars['ID']>;
  /** The group's internal id */
  groupId: Scalars['ID'];
};

/** Autogenerated return type of ActionNetworkAddIntegrationToCampaign. */
export type ActionNetworkAddIntegrationToCampaignPayload = {
  __typename?: 'ActionNetworkAddIntegrationToCampaignPayload';
  /** The associated campaign */
  campaign: Maybe<Campaign>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Action Network Custom Field */
export type ActionNetworkCustomField = {
  __typename?: 'ActionNetworkCustomField';
  /** The name of the custom field */
  name: Scalars['String'];
};

/** ActionNetwork event */
export type ActionNetworkEvent = {
  __typename?: 'ActionNetworkEvent';
  /** The event administrative title */
  administrativeTitle: Maybe<Scalars['String']>;
  /** The ActionNetwork event ID */
  id: Scalars['ID'];
  /** The event permalink */
  permalink: Maybe<Scalars['String']>;
  /** The event start timestamp */
  startAt: Maybe<Scalars['ISO8601DateTime']>;
  /** The event timezone */
  timezone: Maybe<Scalars['String']>;
  /** The event title */
  title: Maybe<Scalars['String']>;
};

/** Action Network Group */
export type ActionNetworkGroup = {
  __typename?: 'ActionNetworkGroup';
  /** The Action Network group's ID */
  groupId: Scalars['ID'];
  /** The organization integration ID */
  id: Scalars['ID'];
  /** The Action Network group's name */
  name: Scalars['String'];
};

/** Action Network Integration */
export type ActionNetworkIntegration = {
  __typename?: 'ActionNetworkIntegration';
  /** The default entity type ID for new entities created during sync */
  defaultEntityType: Maybe<EntityType>;
  /** Whether Action Network Event Subscription sync is enabled */
  eventSyncEnabled: Scalars['Boolean'];
  /** Action Network Group */
  group: ActionNetworkGroup;
  /** The unique identifier for this integration */
  id: Scalars['ID'];
  /** The magic tag */
  magicTag: ActionNetworkTag;
  /** Mappings between Action Builder tags and Action Network objects */
  mappings: Array<ActionNetworkTagMapping>;
};


/** Action Network Integration */
export type ActionNetworkIntegrationMappingsArgs = {
  mappingType?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of ActionNetworkRemoveCampaignIntegration */
export type ActionNetworkRemoveCampaignIntegrationInput = {
  /** The id of the campaign to which the group is being added */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ActionNetworkRemoveCampaignIntegration. */
export type ActionNetworkRemoveCampaignIntegrationPayload = {
  __typename?: 'ActionNetworkRemoveCampaignIntegrationPayload';
  /** Was it a sucessfull operation? */
  campaign: Maybe<Campaign>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of ActionNetworkRemoveCampaignTagMapping */
export type ActionNetworkRemoveCampaignTagMappingInput = {
  actionNetwork: ActionNetworkTagMappingInputConfig;
  /** The id of the campaign to which the group is being added. */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the Action Builder Tag. */
  tagId: Scalars['ID'];
};

/** Autogenerated return type of ActionNetworkRemoveCampaignTagMapping. */
export type ActionNetworkRemoveCampaignTagMappingPayload = {
  __typename?: 'ActionNetworkRemoveCampaignTagMappingPayload';
  /** The removed tag mapping. */
  actionNetworkTagMapping: ActionNetworkTagMapping;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of ActionNetworkRemoveGroup */
export type ActionNetworkRemoveGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The group api key */
  groupId: Scalars['String'];
};

/** Autogenerated return type of ActionNetworkRemoveGroup. */
export type ActionNetworkRemoveGroupPayload = {
  __typename?: 'ActionNetworkRemoveGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Was it a sucessfull operation? */
  success: Maybe<Scalars['Boolean']>;
};

/** Action Network Tag */
export type ActionNetworkTag = {
  __typename?: 'ActionNetworkTag';
  /** The tag's name */
  name: Scalars['String'];
  /** The Action Network tag's uuid. */
  uuid: Maybe<Scalars['String']>;
};

/** Relation between AN/AB tags */
export type ActionNetworkTagMapping = {
  __typename?: 'ActionNetworkTagMapping';
  /** ActionBuilder Tag */
  actionBuilder: Tag;
  /** Action Network mapping */
  actionNetwork: ActionNetworkTagMappingConfig;
};

export type ActionNetworkTagMappingConfig = {
  __typename?: 'ActionNetworkTagMappingConfig';
  /** The name of the custom field */
  customField: Maybe<Scalars['String']>;
  /** The ID of the tag */
  tagId: Maybe<Scalars['ID']>;
};

export type ActionNetworkTagMappingInputConfig = {
  /** The name of the custom field */
  customFieldName?: Maybe<Scalars['String']>;
  /** The ID of the tag */
  tagId?: Maybe<Scalars['ID']>;
};

/** Autogenerated input type of ActionNetworkUpdateIntegration */
export type ActionNetworkUpdateIntegrationInput = {
  /** The ID of the campaign */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the entity type used to create new entities from ActionNetwork */
  entityTypeId?: Maybe<Scalars['ID']>;
  /** Whether to enable Action Network Event Subscription sync */
  eventSyncEnabled?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of ActionNetworkUpdateIntegration. */
export type ActionNetworkUpdateIntegrationPayload = {
  __typename?: 'ActionNetworkUpdateIntegrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated integration */
  integration: ActionNetworkIntegration;
};

/** An activity_event */
export type ActivityEvent = {
  __typename?: 'ActivityEvent';
  campaign: CampaignPublic;
  createdAt: Scalars['Time'];
  eventType: Maybe<ActivityEventTypes>;
  id: Scalars['ID'];
  itemId: Maybe<Scalars['ID']>;
  itemType: Maybe<Scalars['String']>;
  name: ActivityEventNames;
  payload: Maybe<Scalars['JSON']>;
  target: Maybe<ActivityEventTarget>;
  user: UserPublic;
  userId: Maybe<Scalars['ID']>;
};

/** The connection type for ActivityEvent. */
export type ActivityEventConnection = {
  __typename?: 'ActivityEventConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ActivityEventEdge>>>;
  /** Count of unique entities */
  entityCount: Maybe<Scalars['Int']>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<ActivityEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ActivityEventEdge = {
  __typename?: 'ActivityEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<ActivityEvent>;
};

/** Activity event names types */
export enum ActivityEventNames {
  /** complete_follow_up activity event */
  CompleteFollowUp = 'complete_follow_up',
  /** create_address activity event */
  CreateAddress = 'create_address',
  /** create_address_mailing activity event */
  CreateAddressMailing = 'create_address_mailing',
  /** create_address_physical activity event */
  CreateAddressPhysical = 'create_address_physical',
  /** create_assessment activity event */
  CreateAssessment = 'create_assessment',
  /** create_calendar_event_response_tags activity event */
  CreateCalendarEventResponseTags = 'create_calendar_event_response_tags',
  /** create_campaign_entity activity event */
  CreateCampaignEntity = 'create_campaign_entity',
  /** create_contact_attempt_action_attempted activity event */
  CreateContactAttemptActionAttempted = 'create_contact_attempt_action_attempted',
  /** create_contact_attempt_action_contacted activity event */
  CreateContactAttemptActionContacted = 'create_contact_attempt_action_contacted',
  /** create_contact_attempt_action_marked_as_bad activity event */
  CreateContactAttemptActionMarkedAsBad = 'create_contact_attempt_action_marked_as_bad',
  /** create_contact_attempt_action_marked_as_do_not_contact activity event */
  CreateContactAttemptActionMarkedAsDoNotContact = 'create_contact_attempt_action_marked_as_do_not_contact',
  /** create_contact_attempt_custom_form_attempted activity event */
  CreateContactAttemptCustomFormAttempted = 'create_contact_attempt_custom_form_attempted',
  /** create_contact_attempt_custom_form_contacted activity event */
  CreateContactAttemptCustomFormContacted = 'create_contact_attempt_custom_form_contacted',
  /** create_contact_attempt_custom_form_marked_as_bad activity event */
  CreateContactAttemptCustomFormMarkedAsBad = 'create_contact_attempt_custom_form_marked_as_bad',
  /** create_contact_attempt_custom_form_marked_as_do_not_contact activity event */
  CreateContactAttemptCustomFormMarkedAsDoNotContact = 'create_contact_attempt_custom_form_marked_as_do_not_contact',
  /** create_email_home activity event */
  CreateEmailHome = 'create_email_home',
  /** create_email_work activity event */
  CreateEmailWork = 'create_email_work',
  /** create_entity_connection activity event */
  CreateEntityConnection = 'create_entity_connection',
  /** create_entity_connection_tags activity event */
  CreateEntityConnectionTags = 'create_entity_connection_tags',
  /** create_entity_global_note activity event */
  CreateEntityGlobalNote = 'create_entity_global_note',
  /** create_entity_tags activity event */
  CreateEntityTags = 'create_entity_tags',
  /** create_follow_up activity event */
  CreateFollowUp = 'create_follow_up',
  /** create_phone_number_cell activity event */
  CreatePhoneNumberCell = 'create_phone_number_cell',
  /** create_phone_number_home activity event */
  CreatePhoneNumberHome = 'create_phone_number_home',
  /** create_phone_number_work activity event */
  CreatePhoneNumberWork = 'create_phone_number_work',
  /** create_relationship activity event */
  CreateRelationship = 'create_relationship',
  /** create_social_profile_discord activity event */
  CreateSocialProfileDiscord = 'create_social_profile_discord',
  /** create_social_profile_facebook activity event */
  CreateSocialProfileFacebook = 'create_social_profile_facebook',
  /** create_social_profile_instagram activity event */
  CreateSocialProfileInstagram = 'create_social_profile_instagram',
  /** create_social_profile_linkedin activity event */
  CreateSocialProfileLinkedin = 'create_social_profile_linkedin',
  /** create_social_profile_other activity event */
  CreateSocialProfileOther = 'create_social_profile_other',
  /** create_social_profile_tiktok activity event */
  CreateSocialProfileTiktok = 'create_social_profile_tiktok',
  /** create_social_profile_twitter activity event */
  CreateSocialProfileTwitter = 'create_social_profile_twitter',
  /** create_social_profile_website activity event */
  CreateSocialProfileWebsite = 'create_social_profile_website',
  /** create_social_profile_wechat activity event */
  CreateSocialProfileWechat = 'create_social_profile_wechat',
  /** create_social_profile_whatsapp activity event */
  CreateSocialProfileWhatsapp = 'create_social_profile_whatsapp',
  /** create_upload activity event */
  CreateUpload = 'create_upload',
  /** create_user activity event */
  CreateUser = 'create_user',
  /** export activity event */
  Export = 'export',
  /** mass_add_assessment activity event */
  MassAddAssessment = 'mass_add_assessment',
  /** mass_add_entities_to_action activity event */
  MassAddEntitiesToAction = 'mass_add_entities_to_action',
  /** mass_add_entities_to_campaign activity event */
  MassAddEntitiesToCampaign = 'mass_add_entities_to_campaign',
  /** mass_add_follow_up activity event */
  MassAddFollowUp = 'mass_add_follow_up',
  /** mass_add_or_update_entity_connection activity event */
  MassAddOrUpdateEntityConnection = 'mass_add_or_update_entity_connection',
  /** mass_apply_tags activity event */
  MassApplyTags = 'mass_apply_tags',
  /** mass_complete_follow_up activity event */
  MassCompleteFollowUp = 'mass_complete_follow_up',
  /** mass_remove_entity_connection activity event */
  MassRemoveEntityConnection = 'mass_remove_entity_connection',
  /** mass_remove_tags activity event */
  MassRemoveTags = 'mass_remove_tags',
  /** reassign_follow_up activity event */
  ReassignFollowUp = 'reassign_follow_up',
  /** remove_entities_from_campaigns activity event */
  RemoveEntitiesFromCampaigns = 'remove_entities_from_campaigns',
  /** remove_entity_from_campaign activity event */
  RemoveEntityFromCampaign = 'remove_entity_from_campaign',
  /** subscribe_email_home activity event */
  SubscribeEmailHome = 'subscribe_email_home',
  /** subscribe_email_work activity event */
  SubscribeEmailWork = 'subscribe_email_work',
  /** subscribe_phone_number_cell activity event */
  SubscribePhoneNumberCell = 'subscribe_phone_number_cell',
  /** subscribe_phone_number_home activity event */
  SubscribePhoneNumberHome = 'subscribe_phone_number_home',
  /** subscribe_phone_number_work activity event */
  SubscribePhoneNumberWork = 'subscribe_phone_number_work',
  /** unsubscribe_email_home activity event */
  UnsubscribeEmailHome = 'unsubscribe_email_home',
  /** unsubscribe_email_work activity event */
  UnsubscribeEmailWork = 'unsubscribe_email_work',
  /** unsubscribe_phone_number_cell activity event */
  UnsubscribePhoneNumberCell = 'unsubscribe_phone_number_cell',
  /** unsubscribe_phone_number_home activity event */
  UnsubscribePhoneNumberHome = 'unsubscribe_phone_number_home',
  /** unsubscribe_phone_number_work activity event */
  UnsubscribePhoneNumberWork = 'unsubscribe_phone_number_work',
  /** update_address activity event */
  UpdateAddress = 'update_address',
  /** update_address_bad activity event */
  UpdateAddressBad = 'update_address_bad',
  /** update_address_do_not_contact activity event */
  UpdateAddressDoNotContact = 'update_address_do_not_contact',
  /** update_address_mailing activity event */
  UpdateAddressMailing = 'update_address_mailing',
  /** update_address_mailing_bad activity event */
  UpdateAddressMailingBad = 'update_address_mailing_bad',
  /** update_address_mailing_do_not_contact activity event */
  UpdateAddressMailingDoNotContact = 'update_address_mailing_do_not_contact',
  /** update_address_mailing_verified activity event */
  UpdateAddressMailingVerified = 'update_address_mailing_verified',
  /** update_address_physical activity event */
  UpdateAddressPhysical = 'update_address_physical',
  /** update_address_physical_bad activity event */
  UpdateAddressPhysicalBad = 'update_address_physical_bad',
  /** update_address_physical_do_not_contact activity event */
  UpdateAddressPhysicalDoNotContact = 'update_address_physical_do_not_contact',
  /** update_address_physical_verified activity event */
  UpdateAddressPhysicalVerified = 'update_address_physical_verified',
  /** update_address_verified activity event */
  UpdateAddressVerified = 'update_address_verified',
  /** update_calendar_event_response_status_attended activity event */
  UpdateCalendarEventResponseStatusAttended = 'update_calendar_event_response_status_attended',
  /** update_calendar_event_response_status_confirmed activity event */
  UpdateCalendarEventResponseStatusConfirmed = 'update_calendar_event_response_status_confirmed',
  /** update_calendar_event_response_status_declined activity event */
  UpdateCalendarEventResponseStatusDeclined = 'update_calendar_event_response_status_declined',
  /** update_calendar_event_response_status_double_confirmed activity event */
  UpdateCalendarEventResponseStatusDoubleConfirmed = 'update_calendar_event_response_status_double_confirmed',
  /** update_calendar_event_response_status_no_show activity event */
  UpdateCalendarEventResponseStatusNoShow = 'update_calendar_event_response_status_no_show',
  /** update_calendar_event_response_status_rsvp activity event */
  UpdateCalendarEventResponseStatusRsvp = 'update_calendar_event_response_status_rsvp',
  /** update_calendar_event_response_status_tentative activity event */
  UpdateCalendarEventResponseStatusTentative = 'update_calendar_event_response_status_tentative',
  /** update_email_home activity event */
  UpdateEmailHome = 'update_email_home',
  /** update_email_home_bad activity event */
  UpdateEmailHomeBad = 'update_email_home_bad',
  /** update_email_home_do_not_contact activity event */
  UpdateEmailHomeDoNotContact = 'update_email_home_do_not_contact',
  /** update_email_home_verified activity event */
  UpdateEmailHomeVerified = 'update_email_home_verified',
  /** update_email_work activity event */
  UpdateEmailWork = 'update_email_work',
  /** update_email_work_bad activity event */
  UpdateEmailWorkBad = 'update_email_work_bad',
  /** update_email_work_do_not_contact activity event */
  UpdateEmailWorkDoNotContact = 'update_email_work_do_not_contact',
  /** update_email_work_verified activity event */
  UpdateEmailWorkVerified = 'update_email_work_verified',
  /** update_follow_up activity event */
  UpdateFollowUp = 'update_follow_up',
  /** update_phone_number_cell activity event */
  UpdatePhoneNumberCell = 'update_phone_number_cell',
  /** update_phone_number_cell_bad activity event */
  UpdatePhoneNumberCellBad = 'update_phone_number_cell_bad',
  /** update_phone_number_cell_do_not_contact activity event */
  UpdatePhoneNumberCellDoNotContact = 'update_phone_number_cell_do_not_contact',
  /** update_phone_number_cell_verified activity event */
  UpdatePhoneNumberCellVerified = 'update_phone_number_cell_verified',
  /** update_phone_number_home activity event */
  UpdatePhoneNumberHome = 'update_phone_number_home',
  /** update_phone_number_home_bad activity event */
  UpdatePhoneNumberHomeBad = 'update_phone_number_home_bad',
  /** update_phone_number_home_do_not_contact activity event */
  UpdatePhoneNumberHomeDoNotContact = 'update_phone_number_home_do_not_contact',
  /** update_phone_number_home_verified activity event */
  UpdatePhoneNumberHomeVerified = 'update_phone_number_home_verified',
  /** update_phone_number_work activity event */
  UpdatePhoneNumberWork = 'update_phone_number_work',
  /** update_phone_number_work_bad activity event */
  UpdatePhoneNumberWorkBad = 'update_phone_number_work_bad',
  /** update_phone_number_work_do_not_contact activity event */
  UpdatePhoneNumberWorkDoNotContact = 'update_phone_number_work_do_not_contact',
  /** update_phone_number_work_verified activity event */
  UpdatePhoneNumberWorkVerified = 'update_phone_number_work_verified',
  /** update_social_profile_discord activity event */
  UpdateSocialProfileDiscord = 'update_social_profile_discord',
  /** update_social_profile_discord_bad activity event */
  UpdateSocialProfileDiscordBad = 'update_social_profile_discord_bad',
  /** update_social_profile_discord_verified activity event */
  UpdateSocialProfileDiscordVerified = 'update_social_profile_discord_verified',
  /** update_social_profile_facebook activity event */
  UpdateSocialProfileFacebook = 'update_social_profile_facebook',
  /** update_social_profile_facebook_bad activity event */
  UpdateSocialProfileFacebookBad = 'update_social_profile_facebook_bad',
  /** update_social_profile_facebook_verified activity event */
  UpdateSocialProfileFacebookVerified = 'update_social_profile_facebook_verified',
  /** update_social_profile_instagram activity event */
  UpdateSocialProfileInstagram = 'update_social_profile_instagram',
  /** update_social_profile_instagram_bad activity event */
  UpdateSocialProfileInstagramBad = 'update_social_profile_instagram_bad',
  /** update_social_profile_instagram_verified activity event */
  UpdateSocialProfileInstagramVerified = 'update_social_profile_instagram_verified',
  /** update_social_profile_linkedin activity event */
  UpdateSocialProfileLinkedin = 'update_social_profile_linkedin',
  /** update_social_profile_linkedin_bad activity event */
  UpdateSocialProfileLinkedinBad = 'update_social_profile_linkedin_bad',
  /** update_social_profile_linkedin_verified activity event */
  UpdateSocialProfileLinkedinVerified = 'update_social_profile_linkedin_verified',
  /** update_social_profile_other activity event */
  UpdateSocialProfileOther = 'update_social_profile_other',
  /** update_social_profile_other_bad activity event */
  UpdateSocialProfileOtherBad = 'update_social_profile_other_bad',
  /** update_social_profile_other_verified activity event */
  UpdateSocialProfileOtherVerified = 'update_social_profile_other_verified',
  /** update_social_profile_tiktok activity event */
  UpdateSocialProfileTiktok = 'update_social_profile_tiktok',
  /** update_social_profile_tiktok_bad activity event */
  UpdateSocialProfileTiktokBad = 'update_social_profile_tiktok_bad',
  /** update_social_profile_tiktok_verified activity event */
  UpdateSocialProfileTiktokVerified = 'update_social_profile_tiktok_verified',
  /** update_social_profile_twitter activity event */
  UpdateSocialProfileTwitter = 'update_social_profile_twitter',
  /** update_social_profile_twitter_bad activity event */
  UpdateSocialProfileTwitterBad = 'update_social_profile_twitter_bad',
  /** update_social_profile_twitter_verified activity event */
  UpdateSocialProfileTwitterVerified = 'update_social_profile_twitter_verified',
  /** update_social_profile_website activity event */
  UpdateSocialProfileWebsite = 'update_social_profile_website',
  /** update_social_profile_website_bad activity event */
  UpdateSocialProfileWebsiteBad = 'update_social_profile_website_bad',
  /** update_social_profile_website_verified activity event */
  UpdateSocialProfileWebsiteVerified = 'update_social_profile_website_verified',
  /** update_social_profile_wechat activity event */
  UpdateSocialProfileWechat = 'update_social_profile_wechat',
  /** update_social_profile_wechat_bad activity event */
  UpdateSocialProfileWechatBad = 'update_social_profile_wechat_bad',
  /** update_social_profile_wechat_verified activity event */
  UpdateSocialProfileWechatVerified = 'update_social_profile_wechat_verified',
  /** update_social_profile_whatsapp activity event */
  UpdateSocialProfileWhatsapp = 'update_social_profile_whatsapp',
  /** update_social_profile_whatsapp_bad activity event */
  UpdateSocialProfileWhatsappBad = 'update_social_profile_whatsapp_bad',
  /** update_social_profile_whatsapp_verified activity event */
  UpdateSocialProfileWhatsappVerified = 'update_social_profile_whatsapp_verified'
}

export type ActivityEventTarget = CalendarEventResponse | Entity | EntityConnection;

/** Activity event types */
export enum ActivityEventTypes {
  /** New record created */
  Create = 'create',
  /** Record deleted */
  Delete = 'delete',
  /** Record updated */
  Update = 'update'
}

/** Autogenerated input type of AddAPIKey */
export type AddApiKeyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  target: ApiKeyTarget;
};

/** Autogenerated return type of AddAPIKey. */
export type AddApiKeyPayload = {
  __typename?: 'AddAPIKeyPayload';
  /** The newly created API key */
  apiKey: ApiKey;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of AddActionField */
export type AddActionFieldInput = {
  /** Action Id */
  actionId: Scalars['ID'];
  /** Campaign Id */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** a standard tag id to be applied when action is a quick action */
  defaultResponseId?: Maybe<Scalars['ID']>;
  /** whether this is an optional action_field */
  isOptional?: Maybe<Scalars['Boolean']>;
  objectAttribute?: Maybe<Scalars['String']>;
  objectType: TaskObjectTypes;
  /** related_object_type ID */
  relatedObjectId?: Maybe<Scalars['ID']>;
  /** Related object type */
  relatedObjectType?: Maybe<TaskRelatedObjectTypes>;
};

/** Autogenerated return type of AddActionField. */
export type AddActionFieldPayload = {
  __typename?: 'AddActionFieldPayload';
  /** The related action */
  action: Maybe<Action>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of AddAllCampaignEntitiesToAction */
export type AddAllCampaignEntitiesToActionInput = {
  /** An Action ID */
  actionId: Scalars['ID'];
  /** A campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of AddAllCampaignEntitiesToAction. */
export type AddAllCampaignEntitiesToActionPayload = {
  __typename?: 'AddAllCampaignEntitiesToActionPayload';
  /** The related action */
  action: Maybe<Action>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of AddCalendarEventUsers */
export type AddCalendarEventUsersInput = {
  /** The calendar event ID */
  calendarEventId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ids for the assigned users */
  userIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of AddCalendarEventUsers. */
export type AddCalendarEventUsersPayload = {
  __typename?: 'AddCalendarEventUsersPayload';
  /** The updated calendar event */
  calendarEvent: CalendarEvent;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of AddCampaignParticipant */
export type AddCampaignParticipantInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** User ID */
  userId: Scalars['ID'];
};

/** Autogenerated return type of AddCampaignParticipant. */
export type AddCampaignParticipantPayload = {
  __typename?: 'AddCampaignParticipantPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** New participant info */
  user: Maybe<User>;
};

/** Autogenerated input type of AddCustomFormField */
export type AddCustomFormFieldInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customFormId: Scalars['ID'];
  field: CustomFormFieldInput;
};

/** Autogenerated return type of AddCustomFormField. */
export type AddCustomFormFieldPayload = {
  __typename?: 'AddCustomFormFieldPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  customFormField: CustomFormField;
};

/** Autogenerated input type of AddEntitiesToActionAssignmentGroup */
export type AddEntitiesToActionAssignmentGroupInput = {
  /** Action assignment group ID */
  actionAssignmentGroupId: Scalars['ID'];
  /** Action ID */
  actionId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of entities IDs */
  entityIds: Array<Scalars['ID']>;
  /** If true, turf notifications are never sent */
  skipNotifyTurf?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of AddEntitiesToActionAssignmentGroup. */
export type AddEntitiesToActionAssignmentGroupPayload = {
  __typename?: 'AddEntitiesToActionAssignmentGroupPayload';
  /** The action_assignment group created */
  actionAssignmentGroup: Maybe<ActionAssignmentGroup>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of AddEntitiesToAction */
export type AddEntitiesToActionInput = {
  /** An Action ID */
  actionId: Scalars['ID'];
  /** A campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** A list of Entity IDs */
  entityIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of AddEntitiesToAction. */
export type AddEntitiesToActionPayload = {
  __typename?: 'AddEntitiesToActionPayload';
  /** The related action */
  action: Maybe<Action>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of AddEntityToActionAssignmentGroup */
export type AddEntityToActionAssignmentGroupInput = {
  /** Group to be assigned in */
  actionAssignmentGroupId: Scalars['ID'];
  /** An Action ID */
  actionId: Scalars['ID'];
  /** Campaign Id */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Entity to be assigned */
  entityId: Scalars['ID'];
};

/** Autogenerated return type of AddEntityToActionAssignmentGroup. */
export type AddEntityToActionAssignmentGroupPayload = {
  __typename?: 'AddEntityToActionAssignmentGroupPayload';
  /** An Action Entity */
  actionEntity: Maybe<ActionEntity>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of AddEntityToCampaign */
export type AddEntityToCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Entity ID */
  entityId: Scalars['ID'];
  /** New campaign ID */
  newCampaignId: Scalars['ID'];
};

/** Autogenerated return type of AddEntityToCampaign. */
export type AddEntityToCampaignPayload = {
  __typename?: 'AddEntityToCampaignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated entity */
  entity: Maybe<Entity>;
};

/** Autogenerated input type of AddSocialProfile */
export type AddSocialProfileInput = {
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  entityId: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  networkType: Scalars['ID'];
  profile: Scalars['String'];
  status?: Maybe<FieldStatusInput>;
};

/** Autogenerated return type of AddSocialProfile. */
export type AddSocialProfilePayload = {
  __typename?: 'AddSocialProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  entity: Maybe<Entity>;
};

/** Autogenerated input type of AddTagCategoryToCampaign */
export type AddTagCategoryToCampaignInput = {
  /** A campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An tag category ID */
  tagCategoryId: Scalars['ID'];
};

/** Autogenerated return type of AddTagCategoryToCampaign. */
export type AddTagCategoryToCampaignPayload = {
  __typename?: 'AddTagCategoryToCampaignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated tag category */
  tagCategory: Maybe<TagCategory>;
};

/** Autogenerated input type of AddUsersToActionAssignmentGroup */
export type AddUsersToActionAssignmentGroupInput = {
  /** The action assignment group id */
  actionAssignmentGroupId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of User IDs */
  userIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of AddUsersToActionAssignmentGroup. */
export type AddUsersToActionAssignmentGroupPayload = {
  __typename?: 'AddUsersToActionAssignmentGroupPayload';
  actionAssignmentGroup: Maybe<ActionAssignmentGroup>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

export type Address = {
  __typename?: 'Address';
  accuracy: Maybe<Scalars['Float']>;
  accuracyType: Maybe<Scalars['String']>;
  addressType: AddressType;
  city: Maybe<Scalars['String']>;
  complement: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  createdAt: Scalars['Time'];
  createdBy: UserPublic;
  electoralDistricts: Maybe<Array<ElectoralDistrict>>;
  geocodeBad: Maybe<Scalars['Boolean']>;
  geocodeSource: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  latitude: Maybe<Scalars['Float']>;
  longitude: Maybe<Scalars['Float']>;
  normalized: Scalars['Boolean'];
  original: Maybe<OriginalAddress>;
  source: FieldSource;
  state: Maybe<Scalars['String']>;
  status: FieldStatus;
  streetAddress: Maybe<Scalars['String']>;
  timezone: Maybe<Scalars['String']>;
  updatedAt: Scalars['Time'];
  updatedBy: Maybe<UserPublic>;
  zip: Maybe<Scalars['String']>;
};

/** Update address input. */
export type AddressChangesInput = {
  addressType?: Maybe<AddressType>;
  city?: Maybe<Scalars['String']>;
  complement?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<FieldStatusInput>;
  streetAddress?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** Address input. */
export type AddressInput = {
  addressType?: Maybe<AddressType>;
  city?: Maybe<Scalars['String']>;
  complement?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  /** List of notes */
  notes?: Maybe<Array<NoteInput>>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<FieldStatusInput>;
  streetAddress?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** CSV import address mapping type */
export type AddressMapping = {
  __typename?: 'AddressMapping';
  addressType: Maybe<PropertyMapping>;
  city: Maybe<PropertyMapping>;
  country: Maybe<PropertyMapping>;
  geocodeBad: Maybe<PropertyMapping>;
  latitude: Maybe<PropertyMapping>;
  longitude: Maybe<PropertyMapping>;
  postalCode: Maybe<PropertyMapping>;
  state: Maybe<PropertyMapping>;
  status: Maybe<PropertyMapping>;
  streetAddress: Maybe<PropertyMapping>;
};

export type AddressMappingInput = {
  addressType?: Maybe<PropertyMappingInput>;
  city?: Maybe<PropertyMappingInput>;
  country?: Maybe<PropertyMappingInput>;
  geocodeBad?: Maybe<PropertyMappingInput>;
  latitude?: Maybe<PropertyMappingInput>;
  longitude?: Maybe<PropertyMappingInput>;
  postalCode?: Maybe<PropertyMappingInput>;
  state?: Maybe<PropertyMappingInput>;
  status?: Maybe<PropertyMappingInput>;
  streetAddress?: Maybe<PropertyMappingInput>;
};

export type AddressTag = Tag & {
  __typename?: 'AddressTag';
  address: Maybe<Address>;
  archived: Maybe<Scalars['Boolean']>;
  associatedCampaignIds: Array<Maybe<Scalars['String']>>;
  /** Attachments are allowed on tag */
  attachmentsEnabled: Maybe<Scalars['Boolean']>;
  campaignContextId: Maybe<Scalars['String']>;
  category: TagCategory;
  createdAt: Scalars['Time'];
  group: TagGroup;
  id: Scalars['ID'];
  isInCampaign: Maybe<Scalars['Boolean']>;
  isUniversal: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  readonly: Scalars['Boolean'];
  tagType: TagType;
  targetType: TagTargetAssociation;
  updatedAt: Scalars['Time'];
};


export type AddressTagIsInCampaignArgs = {
  campaignId?: Maybe<Scalars['ID']>;
};

/** Address types. */
export enum AddressType {
  /** Mailing address type. */
  Mailing = 'mailing',
  /** Physical address type. */
  Physical = 'physical'
}

/** Aggregation matched */
export type AggregationMatched = {
  __typename?: 'AggregationMatched';
  entities: Array<Scalars['Int']>;
  matchGroupId: Maybe<Scalars['String']>;
  matchGroupLabel: Scalars['String'];
  matchGroupMatched: AggregatorSplitMatchType;
};

/** Aggregation Result */
export type AggregationResult = {
  __typename?: 'AggregationResult';
  groupBy: Maybe<Array<AggregationResult>>;
  label: Scalars['String'];
  labelId: Maybe<Scalars['ID']>;
  matches: Array<AggregationMatched>;
};

/** Wall Chart Aggregator entry */
export type AggregatorEntry = {
  aggregator: AggregatorType;
  params?: Maybe<AggregatorEntryParamsInput>;
  value?: Maybe<Scalars['String']>;
};

/** optional params for aggregator Entry Type */
export type AggregatorEntryParamsInput = {
  addressPart?: Maybe<Scalars['String']>;
  entityTypeId?: Maybe<Scalars['String']>;
  tagCategoryId?: Maybe<Scalars['String']>;
};

/** Wall Chart Aggregator split match type */
export enum AggregatorSplitMatchType {
  /** Split by assessment level. */
  AssessmentLevel = 'assessment_level',
  /** Split by tag. */
  Tag = 'tag'
}

/** Wall Chart Aggregator type */
export enum AggregatorType {
  /** connection_tag aggregation type. */
  ConnectionTag = 'connection_tag',
  /** entity_connection aggregation type. */
  EntityConnection = 'entity_connection',
  /** location aggregation type. */
  Location = 'location',
  /** tag aggregation type. */
  Tag = 'tag'
}

export type AppliedToplineItem = {
  __typename?: 'AppliedToplineItem';
  appliedToplineValue: Maybe<AppliedToplineItemValue>;
  toplineItem: Maybe<ToplineSettingItem>;
};

export type AppliedToplineItemValue = Address | Email | EntityLanguage | Note | PhoneNumber | SocialProfile | ToplineAge | ToplineAppliedEntityConnections | ToplineAppliedTags | ToplinePreferredLanguage;

export type AppliedToplines = {
  __typename?: 'AppliedToplines';
  campaignContextId: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  item0: Maybe<AppliedToplineItem>;
  item1: Maybe<AppliedToplineItem>;
  item2: Maybe<AppliedToplineItem>;
  item3: Maybe<AppliedToplineItem>;
  item4: Maybe<AppliedToplineItem>;
  item5: Maybe<AppliedToplineItem>;
};

/** Autogenerated input type of ApplyMassOperation */
export type ApplyMassOperationInput = {
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  operation: MassOperationName;
  operationData?: Maybe<Scalars['JSON']>;
  targetIds?: Maybe<Array<Scalars['ID']>>;
  targetQuery?: Maybe<Scalars['JSON']>;
};

/** Autogenerated return type of ApplyMassOperation. */
export type ApplyMassOperationPayload = {
  __typename?: 'ApplyMassOperationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  targetCount: Scalars['Int'];
};

/** Autogenerated input type of ApplyTag */
export type ApplyTagInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Optional note for the tag, could be text, date, or number */
  note?: Maybe<Scalars['String']>;
  /** Optional - shift input data for shift tags */
  shift?: Maybe<ShiftInput>;
  /** Tag id */
  tagId: Scalars['ID'];
  /** A target ID */
  targetId: Scalars['ID'];
  /** 'Entity', 'CalendarEventResponse' or 'EntityConnection' */
  targetType: Scalars['String'];
};

/** Autogenerated return type of ApplyTag. */
export type ApplyTagPayload = {
  __typename?: 'ApplyTagPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The created taggable logbook */
  taggableLogbook: Maybe<TaggableLogbook>;
};

/** Autogenerated input type of ApplyTagToEntityConnection */
export type ApplyTagToEntityConnectionInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** entity_connection ID */
  entityConnectionId: Scalars['ID'];
  /** Optional note for the tag, could be text, date, or number */
  note?: Maybe<Scalars['String']>;
  /** Optional - shift input data for shift tags */
  shift?: Maybe<ShiftInput>;
  /** Tag id */
  tagId: Scalars['ID'];
};

/** Autogenerated return type of ApplyTagToEntityConnection. */
export type ApplyTagToEntityConnectionPayload = {
  __typename?: 'ApplyTagToEntityConnectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The entity_connection the tag was applied to */
  entityConnection: Maybe<EntityConnection>;
};

/** Autogenerated input type of ApplyTagToEntity */
export type ApplyTagToEntityInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** A target ID */
  entityId: Scalars['ID'];
  /** Optional note for the tag, could be text, date, or number */
  note?: Maybe<Scalars['String']>;
  /** Optional - shift input data for shift tags */
  shift?: Maybe<ShiftInput>;
  /** Tag id */
  tagId: Scalars['ID'];
};

/** Autogenerated return type of ApplyTagToEntity. */
export type ApplyTagToEntityPayload = {
  __typename?: 'ApplyTagToEntityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The entity the tag was applied to */
  entity: Maybe<Entity>;
};

export type Assessment = {
  __typename?: 'Assessment';
  createdAt: Scalars['Time'];
  createdBy: UserPublic;
  id: Scalars['ID'];
  level: Scalars['Int'];
};

/** Assessment count. */
export type AssessmentCount = {
  __typename?: 'AssessmentCount';
  entitiesCount: Maybe<Scalars['Int']>;
  level: Scalars['Int'];
};

export type AssessmentInfo = {
  __typename?: 'AssessmentInfo';
  colors: Array<Scalars['String']>;
  descriptions: Array<Scalars['String']>;
  detailedDescriptions: Array<Scalars['String']>;
  entityTypeOverrides: Array<EntityTypeAssessmentOverrides>;
  isDefault: Scalars['Boolean'];
  numberOfLevels: Scalars['Int'];
};

/** Assessment input. */
export type AssessmentInput = {
  level: Scalars['Int'];
  /** List of notes */
  notes?: Maybe<Array<NoteInput>>;
};

/** Autogenerated input type of AssignFollowUp */
export type AssignFollowUpInput = {
  /** User id to assign the follow up */
  assignUserId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** ID of the follow up */
  followUpId: Scalars['ID'];
};

/** Autogenerated return type of AssignFollowUp. */
export type AssignFollowUpPayload = {
  __typename?: 'AssignFollowUpPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Updated follow up */
  followUp: FollowUp;
};

/** Routing options for a users assigned action turf */
export type AssignmentRoutingOptions = {
  __typename?: 'AssignmentRoutingOptions';
  actionEntityRoutePairs: Maybe<Array<Maybe<ActionHouseholdMatchResult>>>;
  endAddress: Maybe<Address>;
  excludeCompletedActions: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  /** Returns ActionEntities who have addreses which can be mapped, if exclude_completed_actions is true any entities with completed actions are not included */
  routableActionEntities: Maybe<Array<Maybe<ActionEntity>>>;
  /** Returns a count of ActionEntities who have addreses which can be mapped, if exclude_completed_actions is true any entities with completed actions are not included */
  routableActionEntitiesCount: Maybe<Scalars['Int']>;
  startAddress: Maybe<Address>;
  user: User;
};

/** Autogenerated input type of AssociateTagToCampaign */
export type AssociateTagToCampaignInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The Tag id */
  tagId: Scalars['ID'];
};

/** Autogenerated return type of AssociateTagToCampaign. */
export type AssociateTagToCampaignPayload = {
  __typename?: 'AssociateTagToCampaignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated Tag */
  tag: Maybe<Tag>;
};

/** File Attachment */
export type Attachment = {
  __typename?: 'Attachment';
  createdAt: Scalars['Time'];
  createdBy: UserPublic;
  downloadUrl: Scalars['String'];
  id: Scalars['ID'];
  mimeType: Scalars['String'];
  name: Scalars['String'];
  size: Scalars['Int'];
  updatedAt: Scalars['Time'];
};

/** An event (physical or virtual) scheduled to happen in the future */
export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  /** The canvassing type for actions (the default for the campaign if null) */
  actionCanvassingType: Maybe<CanvassingTypes>;
  /** ActionNetwork event ID */
  actionNetworkEventId: Maybe<Scalars['ID']>;
  /** The address for the location, if a physical one */
  address: Maybe<Address>;
  /** Users assigned to the event */
  assignedUsers: UserPublicConnectionWithTotalCount;
  /** Details on the event actions that are linked to this event */
  calendarEventActions: Array<CalendarEventAction>;
  /** campaign id for the event */
  campaignId: Scalars['ID'];
  /** Creation time */
  createdAt: Scalars['Time'];
  /** Creator */
  createdBy: UserPublic;
  /** text description of the event */
  description: Maybe<Scalars['String']>;
  /** end date and time of the event */
  endDate: Maybe<Scalars['ISO8601DateTime']>;
  entityResponse: Maybe<CalendarEventResponse>;
  /** the type of entity this event is for */
  entityType: EntityType;
  /** id of the event */
  id: Scalars['ID'];
  /** A link to a virtual event or other additional note about a physical venue */
  locationNote: Maybe<Scalars['String']>;
  /** The event location type */
  locationType: CalendarEventLocationTypeEnum;
  /** name of the event */
  name: Scalars['String'];
  /** RSVP Counts for the event */
  responseCounts: CalendarEventResponseCounts;
  /** start date and time of the event */
  startDate: Scalars['ISO8601DateTime'];
  /** ISO-8601 time zone of the event */
  timeZone: Scalars['String'];
  /** Update time */
  updatedAt: Scalars['Time'];
  /** Updator */
  updatedBy: UserPublic;
};


/** An event (physical or virtual) scheduled to happen in the future */
export type CalendarEventAssignedUsersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** An event (physical or virtual) scheduled to happen in the future */
export type CalendarEventEntityResponseArgs = {
  entityId?: Maybe<Scalars['ID']>;
};

/** An action linked to an event */
export type CalendarEventAction = {
  __typename?: 'CalendarEventAction';
  /** The action (if created) */
  action: Maybe<Action>;
  /** The purpose of the action for the event */
  actionPurpose: CalendarEventActionPurposeEnum;
  /** The the calendar event */
  calendarEvent: CalendarEvent;
  /** ID of the event action configuration */
  id: Scalars['ID'];
  /** Days from the start when the event will be scheduled */
  scheduleCreateDaysBeforeEventStart: Maybe<Scalars['Int']>;
};

export enum CalendarEventActionPurposeEnum {
  Confirm = 'Confirm',
  DoubleConfirm = 'DoubleConfirm',
  LogAttendance = 'LogAttendance',
  Recruit = 'Recruit'
}

/** The connection type for CalendarEvent. */
export type CalendarEventCollectionWithTotalCount = {
  __typename?: 'CalendarEventCollectionWithTotalCount';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CalendarEventEdge>>>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CalendarEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CalendarEventEdge = {
  __typename?: 'CalendarEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<CalendarEvent>;
};

/** A calendar event */
export type CalendarEventInput = {
  /** The canvassing type for actions (the default for the campaign if null) */
  actionCanvassingType?: Maybe<CanvassingTypes>;
  /** The number of days before the event "Confirm" actions should be created */
  actionConfirmScheduledDays?: Maybe<Scalars['Int']>;
  /** The number of days before the event "Double Confirm" actions should be created */
  actionDoubleConfirmScheduledDays?: Maybe<Scalars['Int']>;
  /** The number of days before the event "Log Attendance" actions should be created */
  actionLogAttendanceScheduledDays?: Maybe<Scalars['Int']>;
  /** The address for the location, if a physical one */
  address?: Maybe<AddressInput>;
  /** An array of user ids assigned to the event, in addition to the creator */
  assignedUsers?: Maybe<Array<Scalars['ID']>>;
  /** Campaign ID to associate event with */
  campaignId?: Maybe<Scalars['ID']>;
  /** text description of the event */
  description?: Maybe<Scalars['String']>;
  /** End date and time of the event */
  endDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** The type of entity this event is fo */
  entityTypeId: Scalars['ID'];
  /** A link to a virtual event or other additional note about a physical venue */
  locationNote?: Maybe<Scalars['String']>;
  /** The type of location that will host this event */
  locationType: CalendarEventLocationTypeEnum;
  /** The name of the event */
  name: Scalars['String'];
  /** Start date and time of the event */
  startDate: Scalars['ISO8601DateTime'];
  /** ISO-8601 time zone of the event */
  timeZone?: Maybe<Scalars['String']>;
};

export enum CalendarEventLocationTypeEnum {
  /** Physical venue or in-person event */
  InPerson = 'InPerson',
  /** Virtual event */
  Virtual = 'Virtual'
}

/** An response to an event (physical or virtual) scheduled to happen in the future */
export type CalendarEventResponse = {
  __typename?: 'CalendarEventResponse';
  /** List of tags applied to this response */
  appliedTags: Array<TaggableLogbook>;
  /** The calendar event associated with this response */
  calendarEvent: CalendarEvent;
  /** id of the calendar event */
  calendarEventId: Scalars['ID'];
  /** the campaign this event is assigned to */
  campaign: CampaignPublic;
  /** id of the campaign. front-end helper */
  campaignContextId: Scalars['ID'];
  /** User who created the response */
  createdBy: UserPublic;
  /** The entity associated with this response */
  entity: Entity;
  /** id of the entity */
  entityId: Scalars['ID'];
  /** id of the response */
  id: Scalars['ID'];
  /** Timestamp of the last response */
  respondedAt: Scalars['ISO8601DateTime'];
  /** Status of the response */
  status: CalendarEventResponseStatusEnum;
  /** User who updated the response */
  updatedBy: UserPublic;
};

/** The connection type for CalendarEventResponse. */
export type CalendarEventResponseCollectionWithTotalCount = {
  __typename?: 'CalendarEventResponseCollectionWithTotalCount';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CalendarEventResponseEdge>>>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CalendarEventResponse>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

/** Counts for responses */
export type CalendarEventResponseCounts = {
  __typename?: 'CalendarEventResponseCounts';
  /** Number of entities with Attended status */
  attended: Scalars['Int'];
  /** Number of entities with Confirmed status */
  confirmed: Scalars['Int'];
  /** Number of entities with Declined status */
  declined: Scalars['Int'];
  /** Number of entities with Double Confirmed status */
  doubleConfirmed: Scalars['Int'];
  /** Calculated ID. */
  id: Scalars['ID'];
  /** Number of entities with No Show status */
  noShow: Scalars['Int'];
  /** Number of entities with RSVP status */
  rsvp: Scalars['Int'];
  /** Number of entities with Tentative status */
  tentative: Scalars['Int'];
};

/** An edge in a connection. */
export type CalendarEventResponseEdge = {
  __typename?: 'CalendarEventResponseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<CalendarEventResponse>;
};

export type CalendarEventResponseEntityCount = {
  __typename?: 'CalendarEventResponseEntityCount';
  /** past events */
  past: CalendarEventResponseCounts;
  /** Upcoming Events */
  upcoming: CalendarEventResponseCounts;
};

export enum CalendarEventResponseStatusEnum {
  Attended = 'Attended',
  Confirmed = 'Confirmed',
  Declined = 'Declined',
  DoubleConfirmed = 'DoubleConfirmed',
  NoShow = 'NoShow',
  Rsvp = 'RSVP',
  Tentative = 'Tentative'
}

export type CalendarEventType = {
  __typename?: 'CalendarEventType';
  createdAt: Scalars['Time'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['Time'];
};

/** Full campaign data (role must be authorized)  */
export type Campaign = {
  __typename?: 'Campaign';
  /** If true, Entity Activity Stream will be the initial view for an entity */
  activityStreamAsInitialEntityView: Maybe<Scalars['Boolean']>;
  allowOrganizersToExport: Maybe<Scalars['Boolean']>;
  associatedTagCategories: Array<Maybe<TagCategory>>;
  associatedTagGroups: Array<Maybe<TagGroup>>;
  /** The default canvassing type for tasks */
  calendarEventCanvassingType: Maybe<CanvassingTypes>;
  /** Whether to enable Events for the campaign */
  calendarEventsEnabled: Maybe<Scalars['Boolean']>;
  campaignIntegrations: Maybe<CampaignIntegrations>;
  /** If true, the Overview tab will be displayed for that campaign */
  campaignOverviewEnabled: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['Time'];
  createdBy: Maybe<UserPublic>;
  defaultCountry: Maybe<Scalars['String']>;
  defaultEntityType: Maybe<EntityType>;
  defaultHomepage: Maybe<DefaultHomepage>;
  defaultQuery: Maybe<SavedQuery>;
  entitiesAssessmentCount: Maybe<Array<Maybe<AssessmentCount>>>;
  entitiesCount: Maybe<Scalars['Int']>;
  entityConnectionTypes: Maybe<Array<EntityConnectionType>>;
  entityTypes: Maybe<Array<EntityType>>;
  id: Scalars['ID'];
  integrations: Maybe<Array<Maybe<Integration>>>;
  name: Scalars['String'];
  notes: Maybe<NoteConnection>;
  participants: Maybe<UserConnectionWithTotalCount>;
  participantsCount: Maybe<Scalars['Int']>;
  restrictedExportingSettings: Maybe<RestrictedExportingSettings>;
  showCustomIds: Maybe<Scalars['Boolean']>;
  showElectoralDistricts: Scalars['Boolean'];
  status: CampaignStatusType;
  supportUser: Maybe<User>;
  targetNumber: Maybe<Scalars['Int']>;
};


/** Full campaign data (role must be authorized)  */
export type CampaignNotesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Full campaign data (role must be authorized)  */
export type CampaignParticipantsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** Update campaign input. */
export type CampaignChangesInput = {
  /** The activity stream will be the default view for an entity profile */
  activityStreamAsInitialEntityView?: Maybe<Scalars['Boolean']>;
  /** Allow Organizers role to export entities via Entities Report */
  allowOrganizersToExport?: Maybe<Scalars['Boolean']>;
  /** The default canvassing type for tasks */
  calendarEventCanvassingType?: Maybe<CanvassingTypes>;
  /** Whether to enable Events for the campaign */
  calendarEventsEnabled?: Maybe<Scalars['Boolean']>;
  /** Enable showing the Campaign Overview tab for the campaign */
  campaignOverviewEnabled?: Maybe<Scalars['Boolean']>;
  /** Campaign default country */
  defaultCountry?: Maybe<Scalars['String']>;
  /** Campaign's default EntityType ID */
  defaultEntityTypeId?: Maybe<Scalars['ID']>;
  /** The default homepage */
  defaultHomepage?: Maybe<DefaultHomepage>;
  /** A list of EntityConnectionType IDs */
  entityConnectionTypeIds?: Maybe<Array<Scalars['ID']>>;
  /** A list of EntityType IDs */
  entityTypeIds?: Maybe<Array<Scalars['ID']>>;
  name?: Maybe<Scalars['String']>;
  /** Show Entity Custom Ids on profile page */
  showCustomIds?: Maybe<Scalars['Boolean']>;
  /** Allow Electoral Districs to be shown */
  showElectoralDistricts?: Maybe<Scalars['Boolean']>;
  status?: Maybe<CampaignStatusType>;
  /** Campaign Support User ID */
  supportUserId?: Maybe<Scalars['ID']>;
  targetNumber?: Maybe<Scalars['Int']>;
};

/** The connection type for Campaign. */
export type CampaignConnectionWithTotalCount = {
  __typename?: 'CampaignConnectionWithTotalCount';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CampaignEdge>>>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Campaign>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CampaignEdge = {
  __typename?: 'CampaignEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<Campaign>;
};

/** campaign_entity_connection_type_configuration type */
export type CampaignEntityConnectionTypeConfiguration = {
  __typename?: 'CampaignEntityConnectionTypeConfiguration';
  campaign: Campaign;
  entityConnectionType: EntityConnectionType;
  entityConnectionTypeId: Scalars['ID'];
  id: Scalars['ID'];
  toplineSettingItems: Maybe<Array<ToplineSettingItem>>;
};

/** Settings to update campaign entity spotlight configuration */
export type CampaignEntitySpotlightSettingsInput = {
  icon: Scalars['String'];
  tagIds?: Maybe<Array<Scalars['ID']>>;
};

/** campaign_entity_type_configuration type */
export type CampaignEntityTypeConfiguration = {
  __typename?: 'CampaignEntityTypeConfiguration';
  campaign: CampaignPublic;
  /** The custom form used to create a new entity */
  creationCustomForm: Maybe<CustomForm>;
  /** The custom form that will be used for the contact form */
  customForm: Maybe<CustomForm>;
  defaultTagCategories: Maybe<Array<TagCategory>>;
  entityType: EntityType;
  entityTypeId: Scalars['ID'];
  id: Scalars['ID'];
  spotlightIcon: Maybe<Scalars['String']>;
  spotlightTags: Maybe<Array<Tag>>;
  toplineSettingItems: Maybe<Array<ToplineSettingItem>>;
};

/** Campaign Integration */
export type CampaignIntegrations = {
  __typename?: 'CampaignIntegrations';
  /** Action Network Integration */
  actionNetwork: Maybe<ActionNetworkIntegration>;
};

export type CampaignObjectVisibilityResult = {
  __typename?: 'CampaignObjectVisibilityResult';
  campaignId: Scalars['ID'];
  campaignName: Scalars['String'];
  visibleInCampaign: Scalars['Boolean'];
};

/** The connection type for CampaignObjectVisibilityResult. */
export type CampaignObjectVisibilityResultConnection = {
  __typename?: 'CampaignObjectVisibilityResultConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CampaignObjectVisibilityResultEdge>>>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CampaignObjectVisibilityResult>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CampaignObjectVisibilityResultEdge = {
  __typename?: 'CampaignObjectVisibilityResultEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<CampaignObjectVisibilityResult>;
};

/** Accepted SearchCampaignObjectVisibility object_type values. */
export enum CampaignObjectVisibilityTypesType {
  /** EntityConnectionType */
  EntityConnectionType = 'EntityConnectionType',
  /** EntityType */
  EntityType = 'EntityType',
  /** Tag */
  Tag = 'Tag',
  /** TagCategory */
  TagCategory = 'TagCategory'
}

/** Public campaign data (accessible by any authenticated user) */
export type CampaignPublic = {
  __typename?: 'CampaignPublic';
  createdBy: Maybe<UserPublic>;
  createdById: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum CampaignStatusType {
  /** Campaign active status. */
  Active = 'active',
  /** Campaign archived status. */
  Archived = 'archived'
}

/** campaign_topline_settings_item input type */
export type CampaignToplineSettingItemInput = {
  itemId?: Maybe<Scalars['ID']>;
  itemType: CampaignToplineSettingItemTypes;
  position: Scalars['Int'];
};

/** Available campaign_topline_setting_items.item_type values */
export enum CampaignToplineSettingItemTypes {
  /** Address */
  Address = 'Address',
  /** Age */
  Age = 'Age',
  /** CityState */
  CityState = 'CityState',
  /** Email */
  Email = 'Email',
  /** EntityConnectionType */
  EntityConnectionType = 'EntityConnectionType',
  /** EntityLanguage */
  EntityLanguage = 'EntityLanguage',
  /** Note */
  Note = 'Note',
  /** PhoneNumber */
  PhoneNumber = 'PhoneNumber',
  /** PreferredLanguage */
  PreferredLanguage = 'PreferredLanguage',
  /** SocialNetwork */
  SocialNetwork = 'SocialNetwork',
  /** TagCategory */
  TagCategory = 'TagCategory'
}

/** Autogenerated input type of CancelInvitation */
export type CancelInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Email */
  email: Scalars['String'];
};

/** Autogenerated return type of CancelInvitation. */
export type CancelInvitationPayload = {
  __typename?: 'CancelInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Deleted user record */
  user: Maybe<User>;
};

/** Action Canvassing types */
export enum CanvassingTypes {
  /** CustomForm */
  CustomForm = 'custom_form',
  /** HomeVisit */
  HomeVisit = 'home_visit',
  /** InPersonVisit */
  InPersonVisit = 'in_person_visit',
  /** PhoneBank */
  PhoneBank = 'phone_bank',
  /** TextBank */
  TextBank = 'text_bank'
}

/** Autogenerated input type of ChangeTagCategoryGroup */
export type ChangeTagCategoryGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Tag Group ID */
  groupId: Scalars['ID'];
  /** Tag Category ID */
  tagCategoryId: Scalars['ID'];
};

/** Autogenerated return type of ChangeTagCategoryGroup. */
export type ChangeTagCategoryGroupPayload = {
  __typename?: 'ChangeTagCategoryGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Updated tag category */
  tagCategory: Maybe<TagCategory>;
};

export enum ChartAggregationMethodEnumType {
  Cumulative = 'cumulative',
  Discrete = 'discrete'
}

export enum ChartPeriodType {
  Day = 'day',
  Month = 'month',
  Quarter = 'quarter',
  Week = 'week',
  Year = 'year'
}

/** Autogenerated input type of CompleteActiveFollowUps */
export type CompleteActiveFollowUpsInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Follow up ID */
  entityId: Scalars['ID'];
};

/** Autogenerated return type of CompleteActiveFollowUps. */
export type CompleteActiveFollowUpsPayload = {
  __typename?: 'CompleteActiveFollowUpsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Updated entity */
  entity: Entity;
};

/** Contact attempt */
export type ContactAttempt = {
  __typename?: 'ContactAttempt';
  action: Maybe<Action>;
  actionEntity: Maybe<ActionEntity>;
  address: Maybe<Address>;
  campaign: CampaignPublic;
  contactInfoId: Maybe<Scalars['ID']>;
  contactInfoType: Maybe<ContactAttemptInfoType>;
  createdAt: Scalars['Time'];
  createdBy: Maybe<UserPublic>;
  disposition: ContactAttemptDispositionType;
  email: Maybe<Email>;
  entity: Entity;
  id: Scalars['ID'];
  note: Maybe<Scalars['String']>;
  phoneNumber: Maybe<PhoneNumber>;
  target: Maybe<Node>;
};

/** Action Canvassing types */
export enum ContactAttemptDispositionType {
  /** Attempted */
  Attempted = 'attempted',
  /** Contacted */
  Contacted = 'contacted',
  /** Marked as bad */
  MarkedAsBad = 'marked_as_bad',
  /** Marked as do not contact */
  MarkedAsDoNotContact = 'marked_as_do_not_contact',
  /** Skipped */
  Skipped = 'skipped'
}

/** Action Canvassing types */
export enum ContactAttemptInfoType {
  /** Address */
  Address = 'Address',
  /** Email */
  Email = 'Email',
  /** PhoneNumber */
  PhoneNumber = 'PhoneNumber'
}

/** Valid target types for contact attempts */
export enum ContactAttemptTargetType {
  /** Action (canvassing) */
  Action = 'Action',
  /** CustomForm (conversation logging) */
  CustomForm = 'CustomForm'
}

/** Autogenerated input type of CreateActionAssignmentGroup */
export type CreateActionAssignmentGroupInput = {
  /** Action ID */
  actionId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** action_assignment group name */
  name: Scalars['String'];
  /** List of target IDs */
  targetIds?: Maybe<Array<Scalars['ID']>>;
};

/** Autogenerated return type of CreateActionAssignmentGroup. */
export type CreateActionAssignmentGroupPayload = {
  __typename?: 'CreateActionAssignmentGroupPayload';
  /** The action_assignment group created */
  actionAssignmentGroup: Maybe<ActionAssignmentGroup>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateActionForCalendarEventAction */
export type CreateActionForCalendarEventActionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** the calendar event action ID */
  id: Scalars['ID'];
};

/** Autogenerated return type of CreateActionForCalendarEventAction. */
export type CreateActionForCalendarEventActionPayload = {
  __typename?: 'CreateActionForCalendarEventActionPayload';
  /** the calendar event action */
  calendarEventAction: CalendarEventAction;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateAction */
export type CreateActionInput = {
  /** Campaign Id */
  campaignId: Scalars['ID'];
  canvassingEnabled?: Maybe<Scalars['Boolean']>;
  canvassingType?: Maybe<CanvassingTypes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Due date to complete the task */
  dueDate?: Maybe<Scalars['Date']>;
  /** Entity Type Id */
  entityTypeId: Scalars['ID'];
  /** Whether householding is enabled for the action */
  householdingEnabled?: Maybe<Scalars['Boolean']>;
  /** Task name */
  name: Scalars['String'];
  /** Enable notification */
  notificationEnabled?: Maybe<Scalars['Boolean']>;
  /** Task text */
  text?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateAction. */
export type CreateActionPayload = {
  __typename?: 'CreateActionPayload';
  /** The new action */
  action: Maybe<Action>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateAddresses */
export type CreateAddressesInput = {
  /** List of addresses */
  addresses: Array<AddressInput>;
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Entity ID */
  entityId: Scalars['ID'];
};

/** Autogenerated return type of CreateAddresses. */
export type CreateAddressesPayload = {
  __typename?: 'CreateAddressesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated entity */
  entity: Entity;
};

/** Autogenerated input type of CreateAssessments */
export type CreateAssessmentsInput = {
  /** List of assessments */
  assessments?: Maybe<Array<AssessmentInput>>;
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Entity ID */
  entityId: Scalars['ID'];
};

/** Autogenerated return type of CreateAssessments. */
export type CreateAssessmentsPayload = {
  __typename?: 'CreateAssessmentsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated entity */
  entity: Entity;
};

/** Autogenerated input type of CreateCalendarEvent */
export type CreateCalendarEventInput = {
  /** The calendar event to be created */
  calendarEvent: CalendarEventInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateCalendarEvent. */
export type CreateCalendarEventPayload = {
  __typename?: 'CreateCalendarEventPayload';
  /** The new calendar event */
  calendarEvent: CalendarEvent;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateCalendarEvents */
export type CreateCalendarEventsInput = {
  /** The calendar events to be created */
  calendarEvents: Array<CalendarEventInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateCalendarEvents. */
export type CreateCalendarEventsPayload = {
  __typename?: 'CreateCalendarEventsPayload';
  /** The list of newly created calendar events */
  calendarEvents: Array<CalendarEvent>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateCampaignCopy */
export type CreateCampaignCopyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Campaign Id */
  copyFromCampaignId: Scalars['ID'];
  /** New campaign name */
  name: Scalars['String'];
};

/** Autogenerated return type of CreateCampaignCopy. */
export type CreateCampaignCopyPayload = {
  __typename?: 'CreateCampaignCopyPayload';
  /** The new campaign */
  campaign: Maybe<Campaign>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateCampaign */
export type CreateCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Name of the campaign (25 chars max). */
  name: Scalars['String'];
  /** Array with IDs of participants. */
  participants?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Campaign Support User ID */
  supportUserId?: Maybe<Scalars['ID']>;
  /** Campaign target number. */
  targetNumber?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of CreateCampaign. */
export type CreateCampaignPayload = {
  __typename?: 'CreateCampaignPayload';
  /** The new campaign */
  campaign: Maybe<Campaign>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateContactAttempt */
export type CreateContactAttemptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Address or PhoneNumber ID */
  contactInfoId?: Maybe<Scalars['ID']>;
  contactInfoType?: Maybe<ContactAttemptInfoType>;
  /** Disposition Type. */
  disposition: ContactAttemptDispositionType;
  /** Entity ID */
  entityId: Scalars['ID'];
  /** Note */
  note?: Maybe<Scalars['String']>;
  /** CustomForm Or Action ID */
  targetId: Scalars['ID'];
  /** CustomForm Or Action */
  targetType: Scalars['ID'];
};

/** Autogenerated return type of CreateContactAttempt. */
export type CreateContactAttemptPayload = {
  __typename?: 'CreateContactAttemptPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The new contact_attempt */
  contactAttempt: Maybe<ContactAttempt>;
};

/** Autogenerated input type of CreateCustomForm */
export type CreateCustomFormInput = {
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<CustomFormFieldInput>>;
  name: Scalars['String'];
  targetType: CustomFormTargetTypeTypes;
  targetTypeId: Scalars['ID'];
};

/** Autogenerated return type of CreateCustomForm. */
export type CreateCustomFormPayload = {
  __typename?: 'CreateCustomFormPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  customForm: CustomForm;
};

/** Autogenerated input type of CreateCustomId */
export type CreateCustomIdInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  internalName: Scalars['String'];
  label: Scalars['String'];
};

/** Autogenerated return type of CreateCustomId. */
export type CreateCustomIdPayload = {
  __typename?: 'CreateCustomIdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  customIdType: CustomIdType;
};

/** Autogenerated input type of CreateEmails */
export type CreateEmailsInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of emails */
  emails?: Maybe<Array<EmailInput>>;
  /** Entity ID */
  entityId: Scalars['ID'];
};

/** Autogenerated return type of CreateEmails. */
export type CreateEmailsPayload = {
  __typename?: 'CreateEmailsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The emails added */
  emails: Array<Email>;
  /** The emails added */
  entity: Entity;
};

/** Autogenerated input type of CreateEntityConnection */
export type CreateEntityConnectionInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** entity_connection_type ID */
  entityConnectionTypeId: Scalars['ID'];
  /** entity ID */
  fromEntityId: Scalars['ID'];
  /** Optional note. Can be text, date, or number */
  note?: Maybe<Scalars['String']>;
  /** entity ID */
  toEntityId: Scalars['ID'];
};

/** Autogenerated return type of CreateEntityConnection. */
export type CreateEntityConnectionPayload = {
  __typename?: 'CreateEntityConnectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The new connection_entity */
  entityConnection: Maybe<EntityConnection>;
};

/** Autogenerated input type of CreateEntityConnectionType */
export type CreateEntityConnectionTypeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Allowed values: above, below */
  displayPosition: Scalars['String'];
  /** Name type */
  entityType1Id: Scalars['ID'];
  /** Name type */
  entityType2Id: Scalars['ID'];
};

/** Autogenerated return type of CreateEntityConnectionType. */
export type CreateEntityConnectionTypePayload = {
  __typename?: 'CreateEntityConnectionTypePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The new connection_entity_type */
  entityConnectionType: Maybe<EntityConnectionType>;
};

/** Autogenerated input type of CreateEntityCustomId */
export type CreateEntityCustomIdInput = {
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customIdTypeId: Scalars['ID'];
  entityId: Scalars['ID'];
  value: Scalars['String'];
};

/** Autogenerated return type of CreateEntityCustomId. */
export type CreateEntityCustomIdPayload = {
  __typename?: 'CreateEntityCustomIdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  entity: Entity;
};

/** Autogenerated input type of CreateEntity */
export type CreateEntityInput = {
  /** List of addresses */
  addresses?: Maybe<Array<AddressInput>>;
  /** Age */
  age?: Maybe<Scalars['Int']>;
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Date of birth */
  dateOfBirth?: Maybe<Scalars['Date']>;
  /** List of emails */
  emails?: Maybe<Array<EmailInput>>;
  /** List of entity languages */
  entityLanguages?: Maybe<Array<EntityLanguageInput>>;
  /** EntityType ID */
  entityTypeId: Scalars['ID'];
  /** First name */
  firstName: Scalars['String'];
  /** Last name */
  lastName?: Maybe<Scalars['String']>;
  /** Middle name */
  middleName?: Maybe<Scalars['String']>;
  /** Nickname */
  nickname?: Maybe<Scalars['String']>;
  /** List of notes */
  notes?: Maybe<Array<NoteInput>>;
  /** List of phone numbers */
  phoneNumbers?: Maybe<Array<PhoneNumberInput>>;
  /** Pronouns */
  pronouns?: Maybe<Scalars['String']>;
  /** Suffix */
  suffix?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateEntity. */
export type CreateEntityPayload = {
  __typename?: 'CreateEntityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The new entity */
  entity: Entity;
};

/** Autogenerated input type of CreateEntityType */
export type CreateEntityTypeInput = {
  /** Enable/disable field */
  addressEnabled?: Maybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Enable/disable field */
  dateOfBirthEnabled: Scalars['Boolean'];
  /** Enable/disable field */
  emailEnabled?: Maybe<Scalars['Boolean']>;
  /** Icon for the entity type */
  icon?: Maybe<Scalars['String']>;
  /** Enable/disable field */
  languageEnabled?: Maybe<Scalars['Boolean']>;
  /** Plural name */
  namePlural: Scalars['String'];
  /** Singular name */
  nameSingular: Scalars['String'];
  /** Name type */
  nameType: EntityTypeNameType;
  /** Enable/disable field */
  phoneNumberEnabled?: Maybe<Scalars['Boolean']>;
  /** Enable/disable field */
  pronounsEnabled?: Maybe<Scalars['Boolean']>;
  /** Enabled/disable social media profile field */
  socialEnabled?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of CreateEntityType. */
export type CreateEntityTypePayload = {
  __typename?: 'CreateEntityTypePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The new entity type */
  entityType: Maybe<EntityType>;
};

/** Autogenerated input type of CreateExternalService */
export type CreateExternalServiceInput = {
  /** Client ID */
  clientId: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Client secret */
  clientSecret: Scalars['String'];
  /** Name of the service */
  serviceName: Scalars['String'];
  /** Workflow ID */
  workflowId: Scalars['String'];
};

/** Autogenerated return type of CreateExternalService. */
export type CreateExternalServicePayload = {
  __typename?: 'CreateExternalServicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The new external service */
  externalService: Maybe<ExternalService>;
};

/** Autogenerated input type of CreateFollowUp */
export type CreateFollowUpInput = {
  /** Assigned User ID */
  assignedUserId?: Maybe<Scalars['ID']>;
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Optional due date for the follow up */
  dueDate?: Maybe<Scalars['Date']>;
  /** Entity ID */
  entityId: Scalars['ID'];
  /** A note */
  note: Scalars['String'];
};

/** Autogenerated return type of CreateFollowUp. */
export type CreateFollowUpPayload = {
  __typename?: 'CreateFollowUpPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Updated entity */
  entity: Entity;
};

/** Autogenerated input type of CreateImport */
export type CreateImportInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Original upload file, encoded in base64 */
  data: Scalars['String'];
  /** EntityType ID */
  entityTypeId?: Maybe<Scalars['ID']>;
  /** File name */
  filename: Scalars['String'];
  /** CSV import mappings */
  mappings: ImportMappingsInput;
  /** Import name */
  name: Scalars['String'];
};

/** Autogenerated return type of CreateImport. */
export type CreateImportPayload = {
  __typename?: 'CreateImportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Created file import */
  import: Maybe<Import>;
};

/** Autogenerated input type of CreateInvitation */
export type CreateInvitationInput = {
  /** A list of campaign IDs that should include the new user as participant. */
  campaigns?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Date to disable user. null to toggle it off */
  disableOn?: Maybe<Scalars['ISO8601DateTime']>;
  /** Email */
  email: Scalars['String'];
  /** First name */
  firstName: Scalars['String'];
  /** Last name */
  lastName: Scalars['String'];
  /** A entity linked to this account. */
  linkedEntityId?: Maybe<Scalars['ID']>;
  /** Role */
  role: UserRole;
  /** Turf Assignments JSON object */
  turfAssignments?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateInvitation. */
export type CreateInvitationPayload = {
  __typename?: 'CreateInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The new user */
  user: Maybe<User>;
};

/** Autogenerated input type of CreateNotes */
export type CreateNotesInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of notes */
  notes?: Maybe<Array<NoteInput>>;
  /** Target ID */
  targetId: Scalars['ID'];
  /** Target type */
  targetType: NoteTarget;
};

/** Autogenerated return type of CreateNotes. */
export type CreateNotesPayload = {
  __typename?: 'CreateNotesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Accessible notes on target */
  notes: Array<Note>;
};

/** Autogenerated input type of CreatePhoneNumbers */
export type CreatePhoneNumbersInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Entity ID */
  entityId: Scalars['ID'];
  /** List of phone numbers */
  phoneNumbers: Array<PhoneNumberInput>;
};

/** Autogenerated return type of CreatePhoneNumbers. */
export type CreatePhoneNumbersPayload = {
  __typename?: 'CreatePhoneNumbersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated entity */
  entity: Entity;
};

/** Autogenerated input type of CreateSavedQuery */
export type CreateSavedQueryInput = {
  /** Query params as JSON */
  body: Scalars['String'];
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Whether this query is a default query */
  defaultQuery?: Maybe<Scalars['Boolean']>;
  /** Saved query name */
  name: Scalars['String'];
  /** Whether this query is public or private */
  public: Scalars['Boolean'];
  /** Query type */
  queryType?: Maybe<QueryTypesType>;
};

/** Autogenerated return type of CreateSavedQuery. */
export type CreateSavedQueryPayload = {
  __typename?: 'CreateSavedQueryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Created saved query */
  query: SavedQuery;
};

/** Autogenerated input type of CreateTagCategory */
export type CreateTagCategoryInput = {
  /** Specify the type of tags the category can have */
  allowToCreateTagType: TagType;
  /** Allow attachments to be added */
  attachmentsEnabled?: Maybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Whether the tag category is universal */
  isUniversal?: Maybe<Scalars['Boolean']>;
  /** Enable or disable the functionality of adding new tags to the category */
  locked: Scalars['Boolean'];
  /** append or overwrite */
  multiselectSameTagBehavior?: Maybe<TagCategorySameTagBehavior>;
  /** Allow multi selection of tags */
  multiselectable: Scalars['Boolean'];
  /** Tag Category name */
  name: Scalars['String'];
  /** Tags that belongs to readonly tag_categories can only be applied by an admin */
  readonly?: Maybe<Scalars['Boolean']>;
  /** The Tag Group id in which the Tag Category belongs to */
  tagGroupId: Scalars['ID'];
};

/** Autogenerated return type of CreateTagCategory. */
export type CreateTagCategoryPayload = {
  __typename?: 'CreateTagCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The new tag category */
  tagCategory: Maybe<TagCategory>;
};

/** Autogenerated input type of CreateTagGroup */
export type CreateTagGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Whether the tag group is universal */
  isUniversal?: Maybe<Scalars['Boolean']>;
  /** Tag Group name. */
  name: Scalars['String'];
  /** EntityType, EntityConnectionType, or CalendarEventType */
  targetType: Scalars['String'];
  /** The ID of the EntityType, EntityConnectionType, or CalendarEventType. `null` for CalendarEventType */
  targetTypeId?: Maybe<Scalars['ID']>;
};

/** Autogenerated return type of CreateTagGroup. */
export type CreateTagGroupPayload = {
  __typename?: 'CreateTagGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The new tag group */
  tagGroup: Maybe<TagGroup>;
};

/** Autogenerated input type of CreateTag */
export type CreateTagInput = {
  /** Optional address for the tag */
  address?: Maybe<AddressInput>;
  /** Campaign ID to associate tag with. Required for leads and lower */
  campaignId?: Maybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Tag name */
  name: Scalars['String'];
  /** The Tag Category id in which the Tag belongs to */
  tagCategoryId: Scalars['ID'];
  /** The tag type */
  tagType: TagType;
};

/** Autogenerated return type of CreateTag. */
export type CreateTagPayload = {
  __typename?: 'CreateTagPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The new tag */
  tag: Maybe<Tag>;
};

export type CustomForm = Node & {
  __typename?: 'CustomForm';
  campaignId: Scalars['ID'];
  createdAt: Scalars['Time'];
  createdBy: UserPublic;
  deletedBy: UserPublic;
  description: Maybe<Scalars['String']>;
  fields: Array<CustomFormField>;
  id: Scalars['ID'];
  name: Scalars['String'];
  targetType: Scalars['String'];
  targetTypeId: Scalars['ID'];
  updatedAt: Scalars['Time'];
};

/** The connection type for CustomForm. */
export type CustomFormConnection = {
  __typename?: 'CustomFormConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CustomFormEdge>>>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CustomForm>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CustomFormEdge = {
  __typename?: 'CustomFormEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<CustomForm>;
};

export type CustomFormField = {
  __typename?: 'CustomFormField';
  createdAt: Scalars['Time'];
  createdBy: UserPublic;
  customFormId: Scalars['ID'];
  deletedBy: UserPublic;
  entityConnectionType: Maybe<EntityConnectionType>;
  fieldObjectId: Maybe<Scalars['String']>;
  fieldObjectType: CustomFormFieldObjectTypeTypes;
  id: Scalars['ID'];
  objectAttribute: Maybe<Scalars['String']>;
  objectData: Maybe<Scalars['JSON']>;
  position: Scalars['Int'];
  required: Maybe<Scalars['Boolean']>;
  tagCategory: Maybe<TagCategory>;
  updatedAt: Scalars['Time'];
};

export type CustomFormFieldInput = {
  fieldObjectId?: Maybe<Scalars['String']>;
  fieldObjectType: CustomFormFieldObjectTypeTypes;
  id?: Maybe<Scalars['ID']>;
  objectAttribute?: Maybe<Scalars['String']>;
  objectData?: Maybe<Scalars['JSON']>;
  position?: Maybe<Scalars['Int']>;
  required?: Maybe<Scalars['Boolean']>;
};

/** custom form fields object type types. */
export enum CustomFormFieldObjectTypeTypes {
  Address = 'Address',
  Email = 'Email',
  Entity = 'Entity',
  EntityConnectionType = 'EntityConnectionType',
  GlobalNote = 'GlobalNote',
  PhoneNumber = 'PhoneNumber',
  TagCategory = 'TagCategory'
}

/** custom form target type types. */
export enum CustomFormTargetTypeTypes {
  EntityType = 'EntityType'
}

export type CustomIdType = {
  __typename?: 'CustomIdType';
  active: Scalars['Boolean'];
  createdAt: Scalars['Time'];
  id: Scalars['ID'];
  internalName: Scalars['String'];
  label: Scalars['String'];
  updatedAt: Scalars['Time'];
};


export type DateRangeInput = {
  /** Filter on or before this time (inclusive). */
  max?: Maybe<Scalars['ISO8601DateTime']>;
  /** Filter on or after this time (inclusive). */
  min?: Maybe<Scalars['ISO8601DateTime']>;
};

export type DateTag = Tag & {
  __typename?: 'DateTag';
  archived: Maybe<Scalars['Boolean']>;
  associatedCampaignIds: Array<Maybe<Scalars['String']>>;
  /** Attachments are allowed on tag */
  attachmentsEnabled: Maybe<Scalars['Boolean']>;
  campaignContextId: Maybe<Scalars['String']>;
  category: TagCategory;
  createdAt: Scalars['Time'];
  group: TagGroup;
  id: Scalars['ID'];
  isInCampaign: Maybe<Scalars['Boolean']>;
  isUniversal: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  readonly: Scalars['Boolean'];
  tagType: TagType;
  targetType: TagTargetAssociation;
  updatedAt: Scalars['Time'];
};


export type DateTagIsInCampaignArgs = {
  campaignId?: Maybe<Scalars['ID']>;
};

export enum DefaultHomepage {
  /** The list page */
  List = 'list',
  /** The campaign overview page */
  Overview = 'overview'
}

/** Autogenerated input type of DeleteAllActionAssignmentGroups */
export type DeleteAllActionAssignmentGroupsInput = {
  /** Action ID */
  actionId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of DeleteAllActionAssignmentGroups. */
export type DeleteAllActionAssignmentGroupsPayload = {
  __typename?: 'DeleteAllActionAssignmentGroupsPayload';
  /** The action the assignment groups were deleted */
  action: Maybe<Action>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of DeleteAttachment */
export type DeleteAttachmentInput = {
  /** Attachment ID */
  attachmentId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of DeleteAttachment. */
export type DeleteAttachmentPayload = {
  __typename?: 'DeleteAttachmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of DeleteCalendarEvent */
export type DeleteCalendarEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The calendar event id */
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteCalendarEvent. */
export type DeleteCalendarEventPayload = {
  __typename?: 'DeleteCalendarEventPayload';
  /** The deleted calendar event */
  calendarEvent: CalendarEvent;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of DeleteCustomForm */
export type DeleteCustomFormInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customFormId: Scalars['ID'];
};

/** Autogenerated return type of DeleteCustomForm. */
export type DeleteCustomFormPayload = {
  __typename?: 'DeleteCustomFormPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of DeleteEntities */
export type DeleteEntitiesInput = {
  /** List of action_builder_ids to delete */
  actionBuilderIds: Array<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteEntitiesOperation = {
  __typename?: 'DeleteEntitiesOperation';
  actionBuilderIds: Array<Scalars['String']>;
  completedAt: Maybe<Scalars['Time']>;
  createdAt: Scalars['Time'];
  createdBy: UserPublic;
  id: Scalars['ID'];
  notFound: Scalars['Int'];
  status: Maybe<DeleteEntitiesOperationStatusTypes>;
  totalDeleted: Scalars['Int'];
  totalSent: Scalars['Int'];
  updatedAt: Scalars['Time'];
};

/** The connection type for DeleteEntitiesOperation. */
export type DeleteEntitiesOperationConnection = {
  __typename?: 'DeleteEntitiesOperationConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<DeleteEntitiesOperationEdge>>>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<DeleteEntitiesOperation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type DeleteEntitiesOperationEdge = {
  __typename?: 'DeleteEntitiesOperationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<DeleteEntitiesOperation>;
};

/** Delete entities operations status types. */
export enum DeleteEntitiesOperationStatusTypes {
  Done = 'done',
  InProgress = 'in_progress'
}

/** Autogenerated return type of DeleteEntities. */
export type DeleteEntitiesPayload = {
  __typename?: 'DeleteEntitiesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of DeleteEntityConnection */
export type DeleteEntityConnectionInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** entity_connection ID */
  entityConnectionId: Scalars['ID'];
};

/** Autogenerated return type of DeleteEntityConnection. */
export type DeleteEntityConnectionPayload = {
  __typename?: 'DeleteEntityConnectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Deleted entity connection */
  entityConnection: Maybe<EntityConnection>;
};

/** Autogenerated input type of DeleteSavedQuery */
export type DeleteSavedQueryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Saved query ID */
  queryId: Scalars['ID'];
};

/** Autogenerated return type of DeleteSavedQuery. */
export type DeleteSavedQueryPayload = {
  __typename?: 'DeleteSavedQueryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of DisableUser */
export type DisableUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** User ID */
  id: Scalars['ID'];
};

/** Autogenerated return type of DisableUser. */
export type DisableUserPayload = {
  __typename?: 'DisableUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated user */
  user: Maybe<User>;
};

/** Autogenerated input type of DuplicateAction */
export type DuplicateActionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Due date to complete */
  dueDate: Scalars['Date'];
  /** Action Id */
  duplicateFromActionId: Scalars['ID'];
  /** New Action name */
  name: Scalars['String'];
};

/** Autogenerated return type of DuplicateAction. */
export type DuplicateActionPayload = {
  __typename?: 'DuplicateActionPayload';
  /** The duplicated action */
  action: Maybe<Action>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

export type DuplicateMatch = {
  __typename?: 'DuplicateMatch';
  entities: Array<Entity>;
  key: Scalars['String'];
};

export type ElectoralDistrict = {
  __typename?: 'ElectoralDistrict';
  id: Scalars['ID'];
  longName: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

/** The connection type for ElectoralDistrict. */
export type ElectoralDistrictConnection = {
  __typename?: 'ElectoralDistrictConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ElectoralDistrictEdge>>>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<ElectoralDistrict>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ElectoralDistrictEdge = {
  __typename?: 'ElectoralDistrictEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<ElectoralDistrict>;
};

export type Email = {
  __typename?: 'Email';
  createdAt: Scalars['Time'];
  createdBy: UserPublic;
  email: Scalars['String'];
  emailType: EmailType;
  id: Scalars['ID'];
  source: FieldSource;
  status: FieldStatus;
  subscribed: Scalars['Boolean'];
  updatedAt: Scalars['Time'];
  updatedBy: Maybe<UserPublic>;
};

/** Update email input. */
export type EmailChangesInput = {
  email?: Maybe<Scalars['String']>;
  emailType?: Maybe<EmailType>;
  status?: Maybe<FieldStatusInput>;
  subscribe?: Maybe<Scalars['Boolean']>;
};

/** Email input. */
export type EmailInput = {
  email: Scalars['String'];
  emailType: EmailType;
  /** List of notes */
  notes?: Maybe<Array<NoteInput>>;
  status?: Maybe<FieldStatusInput>;
  /** Should this email be subscribed? */
  subscribe?: Maybe<Scalars['Boolean']>;
};

/** CSV import Email mapping type */
export type EmailMapping = {
  __typename?: 'EmailMapping';
  email: PropertyMapping;
  emailType: PropertyMapping;
  status: Maybe<PropertyMapping>;
  subscribed: Maybe<PropertyMapping>;
};

export type EmailMappingInput = {
  email: PropertyMappingInput;
  emailType: PropertyMappingInput;
  status?: Maybe<PropertyMappingInput>;
  subscribed?: Maybe<PropertyMappingInput>;
};

/** Email types. */
export enum EmailType {
  /** Home email type. */
  Home = 'home',
  /** Work email type. */
  Work = 'work'
}

/** Autogenerated input type of EnableUser */
export type EnableUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** User ID */
  id: Scalars['ID'];
};

/** Autogenerated return type of EnableUser. */
export type EnableUserPayload = {
  __typename?: 'EnableUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated user */
  user: Maybe<User>;
};

/** Autogenerated input type of EntitiesReport */
export type EntitiesReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  params?: Maybe<ReportInput>;
};

/** Autogenerated return type of EntitiesReport. */
export type EntitiesReportPayload = {
  __typename?: 'EntitiesReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Whether the report was requested */
  success: Maybe<Scalars['Boolean']>;
};

export type Entity = {
  __typename?: 'Entity';
  actionBuilderId: Maybe<Scalars['String']>;
  activeFollowUp: Maybe<FollowUp>;
  addresses: Maybe<Array<Address>>;
  age: Maybe<Scalars['ID']>;
  appliedToplines: Maybe<AppliedToplines>;
  assessments: Maybe<Array<Maybe<Assessment>>>;
  bestAddress: Maybe<Address>;
  bestEmail: Maybe<Email>;
  bestPhoneNumber: Maybe<PhoneNumber>;
  calculatedBirthDate: Maybe<Scalars['Boolean']>;
  calendarEventResponseCounts: Maybe<CalendarEventResponseEntityCount>;
  calendarEventResponses: Maybe<Array<CalendarEventResponse>>;
  campaignContextId: Maybe<Scalars['ID']>;
  campaigns: Maybe<Array<Maybe<CampaignPublic>>>;
  createdAt: Scalars['Time'];
  currentAssessmentLevel: Maybe<Scalars['Int']>;
  customId: Maybe<Scalars['String']>;
  customId1: Maybe<Scalars['String']>;
  customId2: Maybe<Scalars['String']>;
  customId3: Maybe<Scalars['String']>;
  customId4: Maybe<Scalars['String']>;
  dateOfBirth: Maybe<Scalars['Date']>;
  dwId: Maybe<Scalars['String']>;
  emails: Maybe<Array<Maybe<Email>>>;
  entityConnectionCount: Maybe<Array<EntityConnectionCount>>;
  /** New custom IDs for the entity */
  entityCustomIds: Array<EntityCustomId>;
  entityLanguages: Maybe<Array<EntityLanguage>>;
  entityType: Maybe<EntityType>;
  entityTypeId: Maybe<Scalars['ID']>;
  firstName: Scalars['String'];
  followUp: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lastName: Maybe<Scalars['String']>;
  linkedUser: Maybe<UserPublic>;
  linkedUserId: Maybe<Scalars['ID']>;
  mappableAddresses: Maybe<Array<Address>>;
  middleName: Maybe<Scalars['String']>;
  mostRecentNote: Maybe<Note>;
  nickname: Maybe<Scalars['String']>;
  notes: Maybe<Array<Note>>;
  organizationId: Maybe<Scalars['String']>;
  phoneNumbers: Maybe<Array<Maybe<PhoneNumber>>>;
  preferredLanguage: Maybe<Language>;
  pronouns: Maybe<Scalars['String']>;
  socialProfiles: Maybe<Array<SocialProfile>>;
  spotlightIcon: Maybe<Scalars['String']>;
  suffix: Maybe<Scalars['String']>;
  tags: Maybe<Array<Maybe<TaggableLogbook>>>;
  /** Number of tags */
  tagsCount: Scalars['Int'];
  tagsInCategories: Maybe<Array<Maybe<TaggableLogbook>>>;
  tasks: Maybe<Array<Maybe<Task>>>;
  updatedAt: Scalars['Time'];
  voterbaseId: Maybe<Scalars['String']>;
};


export type EntityTagsInCategoriesArgs = {
  tagCategoryIds?: Maybe<Array<Scalars['ID']>>;
};

/** Update entity input. */
export type EntityChangesInput = {
  age?: Maybe<Scalars['Int']>;
  customId?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  dwId?: Maybe<Scalars['String']>;
  entityLanguages?: Maybe<Array<EntityLanguageInput>>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  linkedUserId?: Maybe<Scalars['ID']>;
  middleName?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  pronouns?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  voterbaseId?: Maybe<Scalars['String']>;
};

export type EntityChartCount = {
  __typename?: 'EntityChartCount';
  count: Scalars['Int'];
  groupLabel: Scalars['String'];
};

export type EntityChartCounts = {
  __typename?: 'EntityChartCounts';
  aggregationMethod: Scalars['String'];
  entitiesCount: Scalars['Int'];
  period: Scalars['String'];
  rangeEnd: Scalars['ISO8601DateTime'];
  rangeStart: Scalars['ISO8601DateTime'];
  results: Array<EntityChartPeriod>;
};

export type EntityChartPeriod = {
  __typename?: 'EntityChartPeriod';
  counts: Array<EntityChartCount>;
  periodEnd: Scalars['ISO8601DateTime'];
  periodStart: Scalars['ISO8601DateTime'];
};

export type EntityConnection = {
  __typename?: 'EntityConnection';
  active: Scalars['Boolean'];
  appliedToplines: Maybe<AppliedToplines>;
  campaign: Maybe<CampaignPublic>;
  campaignId: Scalars['ID'];
  createdAt: Scalars['Time'];
  createdBy: UserPublic;
  entity1: EntityPublic;
  entity2: EntityPublic;
  entityConnectionType: EntityConnectionType;
  entityConnectionTypeId: Scalars['ID'];
  entityConnectionTypeName: Scalars['String'];
  id: Scalars['ID'];
  notes: Maybe<Array<Note>>;
  /** @deprecated Will be removed in future release. Use tags field. */
  taggableTags: Maybe<Array<Maybe<TaggableLogbook>>>;
  tags: Maybe<Array<Maybe<TaggableLogbook>>>;
  /** Number of tags */
  tagsCount: Scalars['Int'];
  updatedAt: Scalars['Time'];
  updatedBy: Maybe<UserPublic>;
};

/** The connection type for EntityConnection. */
export type EntityConnectionConnection = {
  __typename?: 'EntityConnectionConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<EntityConnectionEdge>>>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<EntityConnection>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

export type EntityConnectionCount = {
  __typename?: 'EntityConnectionCount';
  activeConnectionsCount: Scalars['Int'];
  entityConnectionType: EntityConnectionType;
  inactiveConnectionsCount: Scalars['Int'];
};

/** An edge in a connection. */
export type EntityConnectionEdge = {
  __typename?: 'EntityConnectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<EntityConnection>;
};

/** CSV import entity connection mapping type */
export type EntityConnectionMapping = {
  __typename?: 'EntityConnectionMapping';
  entityConnectionTypeId: PropertyMapping;
  note: Maybe<PropertyMapping>;
  noteDate: Maybe<PropertyMapping>;
  status: PropertyMapping;
  tags: Array<TagMapping>;
  toEntity: EntityIdentifierPropertyMapping;
};

export type EntityConnectionMappingInput = {
  entityConnectionTypeId: PropertyMappingInput;
  note?: Maybe<PropertyMappingInput>;
  noteDate?: Maybe<PropertyMappingInput>;
  status: PropertyMappingInput;
  tags: Array<TagMappingInput>;
  toEntity: EntityIdentifierPropertyMappingInput;
};

export type EntityConnectionType = {
  __typename?: 'EntityConnectionType';
  campaignContextId: Maybe<Scalars['ID']>;
  connectionName: Maybe<Scalars['String']>;
  createdAt: Scalars['Time'];
  createdBy: UserPublic;
  displayPosition: Scalars['String'];
  entityType1: EntityType;
  entityType1Id: Scalars['ID'];
  entityType2: EntityType;
  entityType2Id: Scalars['ID'];
  id: Scalars['ID'];
  updatedAt: Scalars['Time'];
  updatedBy: Maybe<UserPublic>;
};

/** The connection type for Entity. */
export type EntityConnectionWithTotalCount = {
  __typename?: 'EntityConnectionWithTotalCount';
  /** Returns a list of all the entities ids matching the query */
  allEntityIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of edges. */
  edges: Maybe<Array<Maybe<EntityEdge>>>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Entity>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

/** CSV import entity core mapping type */
export type EntityCoreMapping = {
  __typename?: 'EntityCoreMapping';
  age: Maybe<PropertyMapping>;
  customId: Maybe<PropertyMapping>;
  customId1: Maybe<PropertyMapping>;
  customId2: Maybe<PropertyMapping>;
  customId3: Maybe<PropertyMapping>;
  customId4: Maybe<PropertyMapping>;
  dateOfBirth: Maybe<PropertyMapping>;
  dwId: Maybe<PropertyMapping>;
  firstName: Maybe<PropertyMapping>;
  lastName: Maybe<PropertyMapping>;
  middleName: Maybe<PropertyMapping>;
  nickname: Maybe<PropertyMapping>;
  pronouns: Maybe<PropertyMapping>;
  suffix: Maybe<PropertyMapping>;
  voterbaseId: Maybe<PropertyMapping>;
};

export type EntityCoreMappingInput = {
  age?: Maybe<PropertyMappingInput>;
  customId?: Maybe<PropertyMappingInput>;
  customId1?: Maybe<PropertyMappingInput>;
  customId2?: Maybe<PropertyMappingInput>;
  customId3?: Maybe<PropertyMappingInput>;
  customId4?: Maybe<PropertyMappingInput>;
  dateOfBirth?: Maybe<PropertyMappingInput>;
  dwId?: Maybe<PropertyMappingInput>;
  firstName?: Maybe<PropertyMappingInput>;
  lastName?: Maybe<PropertyMappingInput>;
  middleName?: Maybe<PropertyMappingInput>;
  nickname?: Maybe<PropertyMappingInput>;
  pronouns?: Maybe<PropertyMappingInput>;
  suffix?: Maybe<PropertyMappingInput>;
  voterbaseId?: Maybe<PropertyMappingInput>;
};

export type EntityCustomId = {
  __typename?: 'EntityCustomId';
  createdAt: Scalars['Time'];
  customIdType: CustomIdType;
  entity: Entity;
  entityId: Scalars['ID'];
  id: Scalars['ID'];
  updatedAt: Scalars['Time'];
  value: Scalars['String'];
};

export type EntityCustomIdConflict = {
  __typename?: 'EntityCustomIdConflict';
  property: Scalars['ID'];
};

/** CSV import entity custom ID mapping type */
export type EntityCustomIdMapping = {
  __typename?: 'EntityCustomIdMapping';
  customIdTypeId: PropertyMapping;
  value: PropertyMapping;
};

export type EntityCustomIdMappingInput = {
  customIdTypeId: PropertyMappingInput;
  value: PropertyMappingInput;
};

export type EntityDuplicates = {
  __typename?: 'EntityDuplicates';
  duplicateReferenceId: Scalars['String'];
  emailMatches: Maybe<Array<DuplicateMatch>>;
  phoneMatches: Maybe<Array<DuplicateMatch>>;
};

/** An edge in a connection. */
export type EntityEdge = {
  __typename?: 'EntityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<Entity>;
};

/** CSV import entity identifier type */
export type EntityIdentifierPropertyMapping = {
  __typename?: 'EntityIdentifierPropertyMapping';
  column: Scalars['Int'];
  identifierType: Scalars['String'];
};

export type EntityIdentifierPropertyMappingInput = {
  column: Scalars['Int'];
  identifierType: Scalars['String'];
};

export type EntityImportField = {
  __typename?: 'EntityImportField';
  /** Field name to display */
  displayName: Scalars['String'];
  /** Field name */
  field: Scalars['String'];
};

export type EntityLanguage = {
  __typename?: 'EntityLanguage';
  languageCode: Language;
  preferred: Scalars['Boolean'];
};

/** Entity language input. */
export type EntityLanguageInput = {
  languageCode: Language;
  preferred?: Maybe<Scalars['Boolean']>;
};

/** CSV import entity language mapping type */
export type EntityLanguageMapping = {
  __typename?: 'EntityLanguageMapping';
  preferredLanguage: Maybe<PropertyMapping>;
  spokenLanguages: Maybe<PropertyMapping>;
};

export type EntityLanguageMappingInput = {
  preferredLanguage?: Maybe<PropertyMappingInput>;
  spokenLanguages?: Maybe<PropertyMappingInput>;
};

/** CSV import entity mapping type */
export type EntityMapping = {
  __typename?: 'EntityMapping';
  addresses: Maybe<Array<AddressMapping>>;
  connections: Maybe<Array<EntityConnectionMapping>>;
  core: EntityCoreMapping;
  currentAssessment: Maybe<PropertyMapping>;
  emails: Maybe<Array<EmailMapping>>;
  entityCustomIds: Maybe<Array<EntityCustomIdMapping>>;
  entityLanguages: Maybe<EntityLanguageMapping>;
  followUpNote: Maybe<PropertyMapping>;
  notes: Maybe<Array<NoteMapping>>;
  phones: Maybe<Array<PhoneMapping>>;
  socialProfiles: Maybe<Array<SocialProfileMapping>>;
  tags: Maybe<Array<TagMapping>>;
};

export type EntityMappingInput = {
  addresses?: Maybe<Array<AddressMappingInput>>;
  connections?: Maybe<Array<EntityConnectionMappingInput>>;
  core: EntityCoreMappingInput;
  currentAssessment?: Maybe<PropertyMappingInput>;
  emails?: Maybe<Array<EmailMappingInput>>;
  entityCustomIds?: Maybe<Array<EntityCustomIdMappingInput>>;
  entityLanguages?: Maybe<EntityLanguageMappingInput>;
  followUpNote?: Maybe<PropertyMappingInput>;
  notes?: Maybe<Array<NoteMappingInput>>;
  phones?: Maybe<Array<PhoneMappingInput>>;
  socialProfiles?: Maybe<Array<SocialProfileMappingInput>>;
  tags?: Maybe<Array<TagMappingInput>>;
};

/** Public entity data (accessible by any authenticated user) */
export type EntityPublic = {
  __typename?: 'EntityPublic';
  bestAddress: Maybe<Address>;
  bestEmail: Maybe<Email>;
  bestPhoneNumber: Maybe<PhoneNumber>;
  campaignContextId: Maybe<Scalars['ID']>;
  campaigns: Maybe<Array<Maybe<CampaignPublic>>>;
  city: Maybe<Scalars['String']>;
  currentAssessmentLevel: Maybe<Scalars['Int']>;
  entityType: Maybe<EntityType>;
  entityTypeId: Maybe<Scalars['ID']>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Maybe<Scalars['String']>;
  middleName: Maybe<Scalars['String']>;
  nickname: Maybe<Scalars['String']>;
  pronouns: Maybe<Scalars['String']>;
  spotlightIcon: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  suffix: Maybe<Scalars['String']>;
};

/** The connection type for EntityPublic. */
export type EntityPublicConnectionWithTotalCount = {
  __typename?: 'EntityPublicConnectionWithTotalCount';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<EntityPublicEdge>>>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<EntityPublic>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type EntityPublicEdge = {
  __typename?: 'EntityPublicEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<EntityPublic>;
};

export type EntityType = {
  __typename?: 'EntityType';
  addressEnabled: Maybe<Scalars['Boolean']>;
  campaigns: Maybe<Array<CampaignPublic>>;
  createdAt: Scalars['Time'];
  dateOfBirthEnabled: Maybe<Scalars['Boolean']>;
  emailEnabled: Maybe<Scalars['Boolean']>;
  icon: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  languageEnabled: Maybe<Scalars['Boolean']>;
  namePlural: Scalars['String'];
  nameSingular: Scalars['String'];
  nameType: Scalars['String'];
  phoneNumberEnabled: Maybe<Scalars['Boolean']>;
  pronounsEnabled: Scalars['Boolean'];
  socialEnabled: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['Time'];
};

export type EntityTypeAssessmentOverrides = {
  __typename?: 'EntityTypeAssessmentOverrides';
  descriptions: Array<Scalars['String']>;
  detailedDescriptions: Array<Scalars['String']>;
  entityTypeId: Scalars['ID'];
};

/** Update EntityType input. */
export type EntityTypeChangesInput = {
  addressEnabled?: Maybe<Scalars['Boolean']>;
  dateOfBirthEnabled?: Maybe<Scalars['Boolean']>;
  emailEnabled?: Maybe<Scalars['Boolean']>;
  icon?: Maybe<Scalars['String']>;
  languageEnabled?: Maybe<Scalars['Boolean']>;
  namePlural: Scalars['String'];
  nameSingular: Scalars['String'];
  nameType?: Maybe<Scalars['String']>;
  phoneNumberEnabled?: Maybe<Scalars['Boolean']>;
  pronounsEnabled?: Maybe<Scalars['Boolean']>;
  socialEnabled?: Maybe<Scalars['Boolean']>;
};

/** The connection type for EntityType. */
export type EntityTypeConnectionWithTotalCount = {
  __typename?: 'EntityTypeConnectionWithTotalCount';
  /** Returns a list of all the entity_type IDs matching the query */
  allEntityTypeIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of edges. */
  edges: Maybe<Array<Maybe<EntityTypeEdge>>>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<EntityType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type EntityTypeEdge = {
  __typename?: 'EntityTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<EntityType>;
};

/** entity_type.name_type types. */
export enum EntityTypeNameType {
  /** Human Name */
  HumanName = 'HumanName',
  /** Single Name */
  SingleName = 'SingleName'
}

/** The connection type for ActionNetworkEvent. */
export type EventConnection = {
  __typename?: 'EventConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<EventEdge>>>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<ActionNetworkEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type EventEdge = {
  __typename?: 'EventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<ActionNetworkEvent>;
};

export type ExternalService = {
  __typename?: 'ExternalService';
  clientId: Scalars['String'];
  id: Scalars['ID'];
  serviceName: Scalars['String'];
  workflowId: Scalars['String'];
};

/** Source of the field. */
export enum FieldSource {
  /** Field added by ActionBuilder. */
  ActionBuilder = 'action_builder',
  /** Field synchronized from ActionNetwork. */
  ActionNetwork = 'action_network',
  /** Field added via the API. */
  Api = 'api',
  /** Field was uploaded. */
  Upload = 'upload',
  /** Field from external service. */
  VoterFile = 'voter_file'
}

/** Status of the field. */
export enum FieldStatus {
  /** Field status: Bad */
  Bad = 'bad',
  /** Field status: Do not contact */
  DoNotContact = 'do_not_contact',
  /** Field status: User added */
  UserAdded = 'user_added',
  /** Field status: Verified */
  Verified = 'verified'
}

/** Allowed input status of the field. */
export enum FieldStatusInput {
  /** Field status: Bad */
  Bad = 'bad',
  /** Field status: Do not contact */
  DoNotContact = 'do_not_contact',
  /** Field status: User added */
  UserAdded = 'user_added',
  /** Field status: Verified */
  Verified = 'verified'
}

export type FollowUp = {
  __typename?: 'FollowUp';
  active: Scalars['Boolean'];
  assignedUser: Maybe<UserPublic>;
  campaign: CampaignPublic;
  campaignId: Maybe<Scalars['ID']>;
  completedAt: Maybe<Scalars['Time']>;
  completedBy: Maybe<UserPublic>;
  createdAt: Scalars['Time'];
  createdBy: Maybe<UserPublic>;
  dueDate: Maybe<Scalars['Date']>;
  entityId: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  note: Maybe<Note>;
};

/** Autogenerated input type of GenerateActionAssignmentGroupsByAggregator */
export type GenerateActionAssignmentGroupsByAggregatorInput = {
  /** Action ID */
  actionId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Group by entry */
  groupBy?: Maybe<AggregatorEntry>;
};

/** Autogenerated return type of GenerateActionAssignmentGroupsByAggregator. */
export type GenerateActionAssignmentGroupsByAggregatorPayload = {
  __typename?: 'GenerateActionAssignmentGroupsByAggregatorPayload';
  /** The related action */
  action: Maybe<Action>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of GenerateActionAssignmentGroupsByStrategy */
export type GenerateActionAssignmentGroupsByStrategyInput = {
  /** Action ID */
  actionId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Strategy-specific parameters */
  params?: Maybe<ActionAssignmentGroupingParamsInput>;
  /** Grouping strategy to apply */
  strategy: ActionAssignmentGroupingStrategy;
};

/** Autogenerated return type of GenerateActionAssignmentGroupsByStrategy. */
export type GenerateActionAssignmentGroupsByStrategyPayload = {
  __typename?: 'GenerateActionAssignmentGroupsByStrategyPayload';
  /** The related action */
  action: Maybe<Action>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of GenerateActionAssignmentGroupsByTag */
export type GenerateActionAssignmentGroupsByTagInput = {
  /** Action Id */
  actionId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  tagCategoryId: Scalars['ID'];
};

/** Autogenerated return type of GenerateActionAssignmentGroupsByTag. */
export type GenerateActionAssignmentGroupsByTagPayload = {
  __typename?: 'GenerateActionAssignmentGroupsByTagPayload';
  /** The related action */
  action: Maybe<Action>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of GenerateActionAssignmentGroups */
export type GenerateActionAssignmentGroupsInput = {
  /** Action Id */
  actionId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  groupSize: Scalars['Int'];
};

/** Autogenerated return type of GenerateActionAssignmentGroups. */
export type GenerateActionAssignmentGroupsPayload = {
  __typename?: 'GenerateActionAssignmentGroupsPayload';
  /** The related action */
  action: Maybe<Action>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

export type GeocodedAddress = {
  __typename?: 'GeocodedAddress';
  accuracy: Maybe<Scalars['Float']>;
  address: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  county: Maybe<Scalars['String']>;
  latitude: Maybe<Scalars['Float']>;
  longitude: Maybe<Scalars['Float']>;
  number: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  streetAddress: Maybe<Scalars['String']>;
  zip: Maybe<Scalars['String']>;
};


/** A file import representation */
export type Import = {
  __typename?: 'Import';
  campaign: Maybe<CampaignPublic>;
  campaignId: Maybe<Scalars['ID']>;
  createdAt: Scalars['Time'];
  createdBy: UserPublic;
  entityType: Maybe<EntityType>;
  entityTypeId: Maybe<Scalars['ID']>;
  errorsDownloadUrl: Maybe<Scalars['String']>;
  filename: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mappings: ImportMappings;
  name: Scalars['String'];
  status: Maybe<ImportStatusType>;
  summary: ImportSummary;
  updatedAt: Scalars['Time'];
  visibilityStatus: Maybe<ImportVisibilityStatusType>;
};

/** The connection type for Import. */
export type ImportConnection = {
  __typename?: 'ImportConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ImportEdge>>>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Import>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ImportEdge = {
  __typename?: 'ImportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<Import>;
};

/** CSV file import mappings type */
export type ImportMappings = {
  __typename?: 'ImportMappings';
  entityIdentifier: Maybe<EntityIdentifierPropertyMapping>;
  entityMapping: EntityMapping;
};

export type ImportMappingsInput = {
  entityIdentifier?: Maybe<EntityIdentifierPropertyMappingInput>;
  entityMapping: EntityMappingInput;
};

/** A file import row error */
export type ImportRowError = {
  __typename?: 'ImportRowError';
  createdAt: Scalars['Time'];
  entityId: Maybe<Scalars['ID']>;
  errorMessage: Maybe<Scalars['String']>;
  errorType: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  importId: Maybe<Scalars['ID']>;
  objectType: Scalars['String'];
  originalRow: Maybe<Scalars['JSON']>;
  rowNumber: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Time'];
};

/** The connection type for ImportRowError. */
export type ImportRowErrorConnection = {
  __typename?: 'ImportRowErrorConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ImportRowErrorEdge>>>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<ImportRowError>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ImportRowErrorEdge = {
  __typename?: 'ImportRowErrorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<ImportRowError>;
};

/** Import Status. */
export enum ImportStatusType {
  /** Status Complete for Import type */
  Complete = 'Complete',
  /** Status Processing for Import type */
  Processing = 'Processing',
  /** Status Received for Import type */
  Received = 'Received'
}

/** A summary of the import process */
export type ImportSummary = {
  __typename?: 'ImportSummary';
  entitiesAddedToCampaignCount: Scalars['Int'];
  entitiesCreatedCount: Scalars['Int'];
  entitiesMatchedCount: Scalars['Int'];
  errorCount: Scalars['Int'];
  processedCount: Scalars['Int'];
  rowsCount: Scalars['Int'];
};

/** Import visibility status. */
export enum ImportVisibilityStatusType {
  /** Visibility status Active for Import type */
  Active = 'active',
  /** Visibility status Archived for Import type */
  Archived = 'archived'
}

/** An Integration with external services fields. */
export type Integration = {
  __typename?: 'Integration';
  campaignId: Maybe<Scalars['ID']>;
  externalServiceId: Maybe<Scalars['ID']>;
  id: Maybe<Scalars['ID']>;
};


/** Language options. */
export enum Language {
  /** Afrikaans */
  Af = 'af',
  /** Amharic */
  Am = 'am',
  /** Arabic */
  Ar = 'ar',
  /** Bulgarian */
  Bg = 'bg',
  /** Bengali */
  Bn = 'bn',
  /** Tibetan */
  Bo = 'bo',
  /** Catalan */
  Ca = 'ca',
  /** Chamorro */
  Ch = 'ch',
  /** Czech */
  Cs = 'cs',
  /** Welsh */
  Cy = 'cy',
  /** Danish */
  Da = 'da',
  /** German */
  De = 'de',
  /** Modern Greek (1453-) */
  El = 'el',
  /** English */
  En = 'en',
  /** Spanish */
  Es = 'es',
  /** Estonian */
  Et = 'et',
  /** Basque */
  Eu = 'eu',
  /** Persian */
  Fa = 'fa',
  /** Finnish */
  Fi = 'fi',
  /** Fijian */
  Fj = 'fj',
  /** French */
  Fr = 'fr',
  /** Irish */
  Ga = 'ga',
  /** Gujarati */
  Gu = 'gu',
  /** Hebrew */
  He = 'he',
  /** Hindi */
  Hi = 'hi',
  /** Croatian */
  Hr = 'hr',
  /** Haitian */
  Ht = 'ht',
  /** Hungarian */
  Hu = 'hu',
  /** Armenian */
  Hy = 'hy',
  /** Indonesian */
  Id = 'id',
  /** Icelandic */
  Is = 'is',
  /** Italian */
  It = 'it',
  /** Japanese */
  Ja = 'ja',
  /** Georgian */
  Ka = 'ka',
  /** Central Khmer */
  Km = 'km',
  /** Korean */
  Ko = 'ko',
  /** Latin */
  La = 'la',
  /** Lao */
  Lo = 'lo',
  /** Lithuanian */
  Lt = 'lt',
  /** Latvian */
  Lv = 'lv',
  /** Marshallese */
  Mh = 'mh',
  /** Maori */
  Mi = 'mi',
  /** Macedonian */
  Mk = 'mk',
  /** Malayalam */
  Ml = 'ml',
  /** Mongolian */
  Mn = 'mn',
  /** Marathi */
  Mr = 'mr',
  /** Malay */
  Ms = 'ms',
  /** Maltese */
  Mt = 'mt',
  /** Nepali */
  Ne = 'ne',
  /** Dutch */
  Nl = 'nl',
  /** Norwegian */
  No = 'no',
  /** Panjabi */
  Pa = 'pa',
  /** Polish */
  Pl = 'pl',
  /** Portuguese */
  Pt = 'pt',
  /** Quechua */
  Qu = 'qu',
  /** Romanian */
  Ro = 'ro',
  /** Russian */
  Ru = 'ru',
  /** Slovak */
  Sk = 'sk',
  /** Slovenian */
  Sl = 'sl',
  /** Samoan */
  Sm = 'sm',
  /** Somali */
  So = 'so',
  /** Albanian */
  Sq = 'sq',
  /** Serbian */
  Sr = 'sr',
  /** Swedish */
  Sv = 'sv',
  /** Swahili */
  Sw = 'sw',
  /** Tamil */
  Ta = 'ta',
  /** Telugu */
  Te = 'te',
  /** Thai */
  Th = 'th',
  /** Tagalog */
  Tl = 'tl',
  /** Tonga (Tonga Islands) */
  To = 'to',
  /** Turkish */
  Tr = 'tr',
  /** Tatar */
  Tt = 'tt',
  /** Ukrainian */
  Uk = 'uk',
  /** Urdu */
  Ur = 'ur',
  /** Uzbek */
  Uz = 'uz',
  /** Vietnamese */
  Vi = 'vi',
  /** Xhosa */
  Xh = 'xh',
  /** Chinese */
  Zh = 'zh'
}

/** Autogenerated input type of LinkEventToActionNetwork */
export type LinkEventToActionNetworkInput = {
  /** The ActionNetwork event id */
  actionNetworkEventId: Scalars['Int'];
  /** The id of the calendar event */
  calendarEventId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of LinkEventToActionNetwork. */
export type LinkEventToActionNetworkPayload = {
  __typename?: 'LinkEventToActionNetworkPayload';
  /** The updated calendar event */
  calendarEvent: CalendarEvent;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of LogContactAttempt */
export type LogContactAttemptInput = {
  /** action_entity ID */
  actionEntityId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Address or PhoneNumber ID */
  contactInfoId: Scalars['ID'];
  contactInfoType: ContactAttemptInfoType;
  /** Disposition Type. */
  disposition: ContactAttemptDispositionType;
};

/** Autogenerated return type of LogContactAttempt. */
export type LogContactAttemptPayload = {
  __typename?: 'LogContactAttemptPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The new contact_attempt */
  contactAttempt: Maybe<ContactAttempt>;
};

/** Available mass operation names */
export enum MassOperationName {
  MassAddAssessment = 'MassAddAssessment',
  MassAddEntitiesToAction = 'MassAddEntitiesToAction',
  MassAddEntitiesToCampaign = 'MassAddEntitiesToCampaign',
  MassAddFollowUp = 'MassAddFollowUp',
  MassAddOrUpdateEntityConnection = 'MassAddOrUpdateEntityConnection',
  MassApplyTags = 'MassApplyTags',
  MassCompleteFollowUp = 'MassCompleteFollowUp',
  MassRemoveEntityConnection = 'MassRemoveEntityConnection',
  MassRemoveTags = 'MassRemoveTags'
}

export type MergeConflictData = {
  __typename?: 'MergeConflictData';
  calendarEventResponseConflicts: Maybe<Array<MergeConflictData>>;
  campaignId: Scalars['ID'];
  connectionConflicts: Maybe<Array<MergeConflictData>>;
  coreConflicts: Array<Scalars['String']>;
  entityCustomIdsConflicts: Maybe<Array<EntityCustomIdConflict>>;
  preferredLanguageConflict: Maybe<Scalars['Boolean']>;
  sourceId: Scalars['ID'];
  taggableConflicts: Maybe<Array<TaggableConflicts>>;
  targetId: Scalars['ID'];
};

/** Autogenerated input type of MergeEntities */
export type MergeEntitiesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  params: MergeInstructionsInput;
};

/** Autogenerated return type of MergeEntities. */
export type MergeEntitiesPayload = {
  __typename?: 'MergeEntitiesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The target entity */
  entity: Maybe<Entity>;
};

/** Merge instructions input */
export type MergeInstructionsInput = {
  campaignId: Scalars['ID'];
  /** 'Entity', 'EntityConnection' or 'CalendarEventResponse' */
  mergeType: Scalars['String'];
  resolveConflictInstructions: ResolveConflictInstructionsInput;
  sourceId: Scalars['String'];
  targetId: Scalars['String'];
};

/** MFA factor (authentication method) for a user */
export type MfaFactor = {
  __typename?: 'MfaFactor';
  /** Type of MFA: SMS or TOTP */
  factorType: MfaMethod;
  id: Scalars['ID'];
  /** Last successful verification */
  lastUsedAt: Maybe<Scalars['ISO8601DateTime']>;
  /** Last 4 digits of phone number for SMS */
  phoneLastFour: Maybe<Scalars['String']>;
  /** TOTP provisioning URI (only during setup) */
  provisioningUri: Maybe<Scalars['String']>;
  /** QR code SVG markup for TOTP setup (only during pending setup) */
  qrCodeSvg: Maybe<Scalars['String']>;
  /** QR code URL for TOTP setup (only during pending setup) */
  qrCodeUrl: Maybe<Scalars['String']>;
  /** TOTP secret key (only during setup, shown once) */
  secret: Maybe<Scalars['String']>;
  /** Status: verified, pending, or inactive */
  status: Scalars['String'];
  /** When the factor was verified */
  verifiedAt: Maybe<Scalars['ISO8601DateTime']>;
};

/** MFA authentication methods */
export enum MfaMethod {
  /** SMS-based verification */
  Sms = 'SMS',
  /** TOTP app-based verification (e.g., Google Authenticator) */
  Totp = 'TOTP'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Accept user invitation. */
  acceptInvitation: Maybe<AcceptInvitationPayload>;
  /** Add an action field to an Action */
  addActionField: Maybe<AddActionFieldPayload>;
  /** Maps an action builder tag (response) to an action network tag */
  addActionNetworkCampaignTagMapping: Maybe<ActionNetworkAddCampaignTagMappingPayload>;
  /** Adds a new action network group. */
  addActionNetworkGroup: Maybe<ActionNetworkAddGroupPayload>;
  /** Adds a new action network integration to the campaign. */
  addActionNetworkIntegrationToCampaign: Maybe<ActionNetworkAddIntegrationToCampaignPayload>;
  /** Adds all campaign entities (targets) to an Action. */
  addAllCampaignEntitiesToAction: Maybe<AddAllCampaignEntitiesToActionPayload>;
  /** Add an API key */
  addApiKey: Maybe<AddApiKeyPayload>;
  addCalendarEventUsers: Maybe<AddCalendarEventUsersPayload>;
  /** Add a new participant (a User) to a campaign. */
  addCampaignParticipant: Maybe<AddCampaignParticipantPayload>;
  addCustomFormField: Maybe<AddCustomFormFieldPayload>;
  /** Adds entities (targets) to an Action. */
  addEntitiesToAction: Maybe<AddEntitiesToActionPayload>;
  /** Add entities to action_assignment group */
  addEntitiesToActionAssignmentGroup: Maybe<AddEntitiesToActionAssignmentGroupPayload>;
  /** Assign a single entity to an assignment group */
  addEntityToActionAssignmentGroup: Maybe<AddEntityToActionAssignmentGroupPayload>;
  /** Add accessible entity to a new campaign. */
  addEntityToCampaign: Maybe<AddEntityToCampaignPayload>;
  addSocialProfile: Maybe<AddSocialProfilePayload>;
  /** Adds all tags in a category to a campaign */
  addTagCategoryToCampaign: Maybe<AddTagCategoryToCampaignPayload>;
  /** Adds a list of users to an action assignment group. */
  addUsersToActionAssignmentGroup: Maybe<AddUsersToActionAssignmentGroupPayload>;
  applyMassOperation: Maybe<ApplyMassOperationPayload>;
  /** Apply a tag to an entity or entity connnection */
  applyTag: Maybe<ApplyTagPayload>;
  /** Apply a tag to a entity */
  applyTagToEntity: Maybe<ApplyTagToEntityPayload>;
  /** Apply a tag to a entity_connection */
  applyTagToEntityConnection: Maybe<ApplyTagToEntityConnectionPayload>;
  /** Assign or reassign a follow up */
  assignFollowUp: Maybe<AssignFollowUpPayload>;
  /** Associates a Tag to a campaign */
  associateTagToCampaign: Maybe<AssociateTagToCampaignPayload>;
  /** Cancel invitation mail to user. */
  cancelInvitation: Maybe<CancelInvitationPayload>;
  /** Change Tag Category Group */
  changeTagCategoryGroup: Maybe<ChangeTagCategoryGroupPayload>;
  /** Completes all active followup flags for an entity */
  completeActiveFollowUps: Maybe<CompleteActiveFollowUpsPayload>;
  /** Create Action */
  createAction: Maybe<CreateActionPayload>;
  /** Create action_assignment group  */
  createActionAssignmentGroup: Maybe<CreateActionAssignmentGroupPayload>;
  createActionForCalendarEventAction: Maybe<CreateActionForCalendarEventActionPayload>;
  /** Create new addresses for an entity. */
  createAddresses: Maybe<CreateAddressesPayload>;
  /** Create new assessments for entity. */
  createAssessments: Maybe<CreateAssessmentsPayload>;
  /** Creates a new calendar event */
  createCalendarEvent: Maybe<CreateCalendarEventPayload>;
  /** Creates a new calendar event */
  createCalendarEvents: Maybe<CreateCalendarEventsPayload>;
  /** Create a new campaign. */
  createCampaign: Maybe<CreateCampaignPayload>;
  /** Create a Campaign copy */
  createCampaignCopy: Maybe<CreateCampaignCopyPayload>;
  /** Create a new contact_attempt */
  createContactAttempt: Maybe<CreateContactAttemptPayload>;
  createCustomForm: Maybe<CreateCustomFormPayload>;
  /** Creates a new CustomIdType record */
  createCustomId: Maybe<CreateCustomIdPayload>;
  /** Create new emails for entity. */
  createEmails: Maybe<CreateEmailsPayload>;
  /** Create a new entity in a campaign. */
  createEntity: Maybe<CreateEntityPayload>;
  /** Create EntityConnection */
  createEntityConnection: Maybe<CreateEntityConnectionPayload>;
  /** Create EntityConnectionType */
  createEntityConnectionType: Maybe<CreateEntityConnectionTypePayload>;
  /** Creates a new EntityCustomId */
  createEntityCustomId: Maybe<CreateEntityCustomIdPayload>;
  /** Create EntityType */
  createEntityType: Maybe<CreateEntityTypePayload>;
  /** Create an external service. */
  createExternalService: Maybe<CreateExternalServicePayload>;
  /** Creates a followUp flag for a given Entity and campaign. */
  createFollowUp: Maybe<CreateFollowUpPayload>;
  /** Create CSV File Import */
  createImport: Maybe<CreateImportPayload>;
  /** Invite new user. */
  createInvitation: Maybe<CreateInvitationPayload>;
  /** Create new notes on target. */
  createNotes: Maybe<CreateNotesPayload>;
  /** Create new phone numbers for entity. */
  createPhoneNumbers: Maybe<CreatePhoneNumbersPayload>;
  /** Creates a saved query */
  createSavedQuery: Maybe<CreateSavedQueryPayload>;
  /** Creates a new tag (field response) */
  createTag: Maybe<CreateTagPayload>;
  /** Create Tag Category */
  createTagCategory: Maybe<CreateTagCategoryPayload>;
  /** Create a tag group. */
  createTagGroup: Maybe<CreateTagGroupPayload>;
  /** Delete all assignment groups from an action */
  deleteAllActionAssignmentGroups: Maybe<DeleteAllActionAssignmentGroupsPayload>;
  /** Delete attachment */
  deleteAttachment: Maybe<DeleteAttachmentPayload>;
  deleteCalendarEvent: Maybe<DeleteCalendarEventPayload>;
  deleteCustomForm: Maybe<DeleteCustomFormPayload>;
  /** Deletes entities */
  deleteEntities: Maybe<DeleteEntitiesPayload>;
  /** Delete EntityConnection */
  deleteEntityConnection: Maybe<DeleteEntityConnectionPayload>;
  /** Deletes a saved query */
  deleteSavedQuery: Maybe<DeleteSavedQueryPayload>;
  /** Disable user access */
  disableUser: Maybe<DisableUserPayload>;
  /** Duplicates an action (description, todos, base query) */
  duplicateAction: Maybe<DuplicateActionPayload>;
  /** Enable user access */
  enableUser: Maybe<EnableUserPayload>;
  /** Generates a entities report async and send it by email */
  entitiesReport: Maybe<EntitiesReportPayload>;
  /**
   * Generates Action Assignment Groups (turfs) for the people
   *               who are targets in a given action. Returns the Action.
   */
  generateActionAssignmentGroups: Maybe<GenerateActionAssignmentGroupsPayload>;
  generateActionAssignmentGroupsByAggregator: Maybe<GenerateActionAssignmentGroupsByAggregatorPayload>;
  /**
   * Generates Action Assignment Groups (turfs) for the targets of an action
   *               using a pluggable grouping strategy. Replaces the legacy per-type mutations.
   */
  generateActionAssignmentGroupsByStrategy: Maybe<GenerateActionAssignmentGroupsByStrategyPayload>;
  /**
   * Generates Action Assignment Groups (turfs) for the people
   *               who are targets in a given action based upon which tag(s) they have applied
   *               with a given tag category id
   */
  generateActionAssignmentGroupsByTag: Maybe<GenerateActionAssignmentGroupsByTagPayload>;
  linkEventToActionNetwork: Maybe<LinkEventToActionNetworkPayload>;
  /** Create a new contact_attempt */
  logContactAttempt: Maybe<LogContactAttemptPayload>;
  /** Enable user access */
  mergeEntities: Maybe<MergeEntitiesPayload>;
  /** Pin a note in a campaign */
  pinNote: Maybe<PinNotePayload>;
  /** Remove action_assignment group */
  removeActionAssignmentGroup: Maybe<RemoveActionAssignmentGroupPayload>;
  /** Remove an action field from an Action by action Field Id */
  removeActionFieldById: Maybe<RemoveActionFieldByIdPayload>;
  /** Removes a tag_mapping from a campaign. */
  removeActionNetworkCampaignTagMapping: Maybe<ActionNetworkRemoveCampaignTagMappingPayload>;
  /** Adds a new action network group. */
  removeActionNetworkGroup: Maybe<ActionNetworkRemoveGroupPayload>;
  /** Removes an integration from the campaign. */
  removeActionNetworkIntegrationFromCampaign: Maybe<ActionNetworkRemoveCampaignIntegrationPayload>;
  /** Reset assignment group user routing options */
  removeAssignmentGroupUserRouting: Maybe<RemoveAssignmentGroupUserRoutingPayload>;
  removeCalendarEventUsers: Maybe<RemoveCalendarEventUsersPayload>;
  /** Removes a participant (a User) from a campaign. */
  removeCampaignParticipant: Maybe<RemoveCampaignParticipantPayload>;
  removeCustomFormFieldById: Maybe<RemoveCustomFormFieldByIdPayload>;
  /** Removes a list of entities (targets) from an action */
  removeEntitiesFromAction: Maybe<RemoveEntitiesFromActionPayload>;
  /** Remove entities from action_assignment group */
  removeEntitiesFromActionAssignmentGroup: Maybe<RemoveEntitiesFromActionAssignmentGroupPayload>;
  /** Removes entities from specified campaigns */
  removeEntitiesFromCampaigns: Maybe<RemoveEntitiesFromCampaignsPayload>;
  /** Removes an existing EntityCustomId */
  removeEntityCustomId: Maybe<RemoveEntityCustomIdPayload>;
  /** Remove accessible entity from a campaign. */
  removeEntityFromCampaign: Maybe<RemoveEntityFromCampaignPayload>;
  /** Remove MFA from user account */
  removeMfa: Maybe<RemoveMfaPayload>;
  /** Removes notes */
  removeNotes: Maybe<RemoveNotesPayload>;
  removeSocialProfile: Maybe<RemoveSocialProfilePayload>;
  /** Removes all tags in a category from a campaign */
  removeTagCategoryFromCampaign: Maybe<RemoveTagCategoryFromCampaignPayload>;
  /** Removes users from action assignment group */
  removeUsersFromActionAssignmentGroup: Maybe<RemoveUsersFromActionAssignmentGroupPayload>;
  /** Rename a tag group. */
  renameTagGroup: Maybe<RenameTagGroupPayload>;
  /** Resend invitation mail to user. */
  resendInvitation: Maybe<ResendInvitationPayload>;
  /** Resend MFA verification code (SMS only) */
  resendMfaCode: Maybe<ResendMfaCodePayload>;
  /** Revert addresses to original(user inputed address) */
  revertAddress: Maybe<RevertAddressPayload>;
  revokeApiKey: Maybe<RevokeApiKeyPayload>;
  /** Sets assessment levels info for this organization. */
  setAssessmentInfo: Maybe<SetAssessmentInfoPayload>;
  /** Sets assessment levels overrides for entity types */
  setAssessmentOverrides: Maybe<SetAssessmentOverridesPayload>;
  setCalendarEventResponse: Maybe<SetCalendarEventResponsePayload>;
  /** Schedule users to be disabled in a given date */
  setUsersDisableOnDate: Maybe<SetUsersDisableOnDatePayload>;
  /** Start MFA setup process (SMS or TOTP) */
  startMfaSetup: Maybe<StartMfaSetupPayload>;
  /** Subscribe/unsubscribe an email. */
  subscribeEmail: Maybe<SubscribeEmailPayload>;
  /** Subscribe/unsubscribe a phone number. */
  subscribePhoneNumber: Maybe<SubscribePhoneNumberPayload>;
  /** Unapply tag from a calendar event repsonse */
  unapplyCalendarEventResponseTag: Maybe<UnapplyCalendarEventResponseTagPayload>;
  /** Unapply tag from a entity_connection */
  unapplyEntityConnectionTag: Maybe<UnapplyEntityConnectionTagPayload>;
  /** Unapply tag from a entity */
  unapplyTag: Maybe<UnapplyTagPayload>;
  /** Unassociates a Tag from one campaign */
  unassociateTagFromCampaign: Maybe<UnassociateTagFromCampaignPayload>;
  unlinkEventFromActionNetwork: Maybe<UnlinkEventFromActionNetworkPayload>;
  /** unpin a note in a campaign */
  unpinNote: Maybe<UnpinNotePayload>;
  /** Update an Action */
  updateAction: Maybe<UpdateActionPayload>;
  /** Update an action_assignment_group */
  updateActionAssignmentGroup: Maybe<UpdateActionAssignmentGroupPayload>;
  /** Update an ActionField by ID */
  updateActionField: Maybe<UpdateActionFieldPayload>;
  /** Update ActionFields positions */
  updateActionFieldsPositions: Maybe<UpdateActionFieldsPositionsPayload>;
  /** Updates settings for an existing integration */
  updateActionNetworkIntegration: Maybe<ActionNetworkUpdateIntegrationPayload>;
  /** Update accessible entity address data. */
  updateAddress: Maybe<UpdateAddressPayload>;
  /** Update Address Geolocation */
  updateAddressGeolocation: Maybe<UpdateAddressGeolocationPayload>;
  /** Update an Address Tag */
  updateAddressTag: Maybe<UpdateAddressTagPayload>;
  /** Updates the entities in an assignment based upon the passed query */
  updateAssignmentGroupEntitiesByQuery: Maybe<UpdateAssignmentGroupEntitiesByQueryPayload>;
  /** Update an Assignment routing options for a user */
  updateAssignmentGroupUserRouting: Maybe<UpdateAssignmentGroupUserRoutingPayload>;
  updateCalendarEvent: Maybe<UpdateCalendarEventPayload>;
  updateCalendarEventActionScheduledDays: Maybe<UpdateCalendarEventActionScheduledDaysPayload>;
  /** Update accessible campaign. */
  updateCampaign: Maybe<UpdateCampaignPayload>;
  /** Updates update_campaign_entity_connection_type_configuration record. */
  updateCampaignEntityConnectionTypeConfiguration: Maybe<UpdateCampaignEntityConnectionTypeConfigurationPayload>;
  /** Updates campaign_entity_type_configuration record. */
  updateCampaignEntityTypeConfiguration: Maybe<UpdateCampaignEntityTypeConfigurationPayload>;
  /** Update campaign restricted exporting settings */
  updateCampaignExportRestrictions: Maybe<UpdateCampaignExportRestrictionsPayload>;
  /** Update current user data. */
  updateCurrentUser: Maybe<UpdateCurrentUserPayload>;
  updateCustomForm: Maybe<UpdateCustomFormPayload>;
  updateCustomFormFieldPositions: Maybe<UpdateCustomFormFieldPositionsPayload>;
  updateCustomFormFields: Maybe<UpdateCustomFormFieldsPayload>;
  /** Updates an existing CustomIdType */
  updateCustomId: Maybe<UpdateCustomIdPayload>;
  /** Update accessible entity email data. */
  updateEmail: Maybe<UpdateEmailPayload>;
  /** Updates the entities in an action based upon the passed query */
  updateEntitiesOnActionByQuery: Maybe<UpdateEntitiesOnActionByQueryPayload>;
  /** Update accessible entity data. */
  updateEntity: Maybe<UpdateEntityPayload>;
  /** Update EntityConnection */
  updateEntityConnection: Maybe<UpdateEntityConnectionPayload>;
  /** Update EntityConnectionType */
  updateEntityConnectionType: Maybe<UpdateEntityConnectionTypePayload>;
  /** Updates an existing EntityCustomId */
  updateEntityCustomId: Maybe<UpdateEntityCustomIdPayload>;
  /** Update entity pronouns */
  updateEntityPronouns: Maybe<UpdateEntityPronounsPayload>;
  /** Update EntityType */
  updateEntityType: Maybe<UpdateEntityTypePayload>;
  /** Update an External Service. */
  updateExternalService: Maybe<UpdateExternalServicePayload>;
  /** Update a follow up */
  updateFollowUp: Maybe<UpdateFollowUpPayload>;
  /** Update file import */
  updateImport: Maybe<UpdateImportPayload>;
  /** Create/Delete an integration. */
  updateIntegrations: Maybe<UpdateIntegrationsPayload>;
  /** Update note data on target. */
  updateNote: Maybe<UpdateNotePayload>;
  /** Update organization. */
  updateOrganization: Maybe<UpdateOrganizationPayload>;
  /** Enable or disable MFA requirement for entire organization (admin only) */
  updateOrganizationMfaEnforcement: Maybe<UpdateOrganizationMfaEnforcementPayload>;
  /** Update accessible entity phone number data. */
  updatePhoneNumber: Maybe<UpdatePhoneNumberPayload>;
  /** Update a saved query */
  updateSavedQuery: Maybe<UpdateSavedQueryPayload>;
  /** Update an existing shift */
  updateShift: Maybe<UpdateShiftPayload>;
  updateSocialProfile: Maybe<UpdateSocialProfilePayload>;
  /** Update Tag */
  updateTag: Maybe<UpdateTagPayload>;
  /** Update Tag Category */
  updateTagCategory: Maybe<UpdateTagCategoryPayload>;
  /** Updates all tags in a category to be either archived or unarchived */
  updateTagStatusByCategory: Maybe<UpdateTagStatusByCategoryPayload>;
  /** Update editable user data. */
  updateUserById: Maybe<UpdateUserByIdPayload>;
  /** Creates, updates or deletes user turf assignments */
  updateUserTurfAssignments: Maybe<UpdateUserTurfAssignmentsPayload>;
  /** Verify MFA code during login (upgrades token to full access) */
  verifyMfaLogin: Maybe<VerifyMfaLoginPayload>;
  /** Verify MFA setup with code (completes setup) */
  verifyMfaSetup: Maybe<VerifyMfaSetupPayload>;
};


export type MutationAcceptInvitationArgs = {
  input: AcceptInvitationInput;
};


export type MutationAddActionFieldArgs = {
  input: AddActionFieldInput;
};


export type MutationAddActionNetworkCampaignTagMappingArgs = {
  input: ActionNetworkAddCampaignTagMappingInput;
};


export type MutationAddActionNetworkGroupArgs = {
  input: ActionNetworkAddGroupInput;
};


export type MutationAddActionNetworkIntegrationToCampaignArgs = {
  input: ActionNetworkAddIntegrationToCampaignInput;
};


export type MutationAddAllCampaignEntitiesToActionArgs = {
  input: AddAllCampaignEntitiesToActionInput;
};


export type MutationAddApiKeyArgs = {
  input: AddApiKeyInput;
};


export type MutationAddCalendarEventUsersArgs = {
  input: AddCalendarEventUsersInput;
};


export type MutationAddCampaignParticipantArgs = {
  input: AddCampaignParticipantInput;
};


export type MutationAddCustomFormFieldArgs = {
  input: AddCustomFormFieldInput;
};


export type MutationAddEntitiesToActionArgs = {
  input: AddEntitiesToActionInput;
};


export type MutationAddEntitiesToActionAssignmentGroupArgs = {
  input: AddEntitiesToActionAssignmentGroupInput;
};


export type MutationAddEntityToActionAssignmentGroupArgs = {
  input: AddEntityToActionAssignmentGroupInput;
};


export type MutationAddEntityToCampaignArgs = {
  input: AddEntityToCampaignInput;
};


export type MutationAddSocialProfileArgs = {
  input: AddSocialProfileInput;
};


export type MutationAddTagCategoryToCampaignArgs = {
  input: AddTagCategoryToCampaignInput;
};


export type MutationAddUsersToActionAssignmentGroupArgs = {
  input: AddUsersToActionAssignmentGroupInput;
};


export type MutationApplyMassOperationArgs = {
  input: ApplyMassOperationInput;
};


export type MutationApplyTagArgs = {
  input: ApplyTagInput;
};


export type MutationApplyTagToEntityArgs = {
  input: ApplyTagToEntityInput;
};


export type MutationApplyTagToEntityConnectionArgs = {
  input: ApplyTagToEntityConnectionInput;
};


export type MutationAssignFollowUpArgs = {
  input: AssignFollowUpInput;
};


export type MutationAssociateTagToCampaignArgs = {
  input: AssociateTagToCampaignInput;
};


export type MutationCancelInvitationArgs = {
  input: CancelInvitationInput;
};


export type MutationChangeTagCategoryGroupArgs = {
  input: ChangeTagCategoryGroupInput;
};


export type MutationCompleteActiveFollowUpsArgs = {
  input: CompleteActiveFollowUpsInput;
};


export type MutationCreateActionArgs = {
  input: CreateActionInput;
};


export type MutationCreateActionAssignmentGroupArgs = {
  input: CreateActionAssignmentGroupInput;
};


export type MutationCreateActionForCalendarEventActionArgs = {
  input: CreateActionForCalendarEventActionInput;
};


export type MutationCreateAddressesArgs = {
  input: CreateAddressesInput;
};


export type MutationCreateAssessmentsArgs = {
  input: CreateAssessmentsInput;
};


export type MutationCreateCalendarEventArgs = {
  input: CreateCalendarEventInput;
};


export type MutationCreateCalendarEventsArgs = {
  input: CreateCalendarEventsInput;
};


export type MutationCreateCampaignArgs = {
  input: CreateCampaignInput;
};


export type MutationCreateCampaignCopyArgs = {
  input: CreateCampaignCopyInput;
};


export type MutationCreateContactAttemptArgs = {
  input: CreateContactAttemptInput;
};


export type MutationCreateCustomFormArgs = {
  input: CreateCustomFormInput;
};


export type MutationCreateCustomIdArgs = {
  input: CreateCustomIdInput;
};


export type MutationCreateEmailsArgs = {
  input: CreateEmailsInput;
};


export type MutationCreateEntityArgs = {
  input: CreateEntityInput;
};


export type MutationCreateEntityConnectionArgs = {
  input: CreateEntityConnectionInput;
};


export type MutationCreateEntityConnectionTypeArgs = {
  input: CreateEntityConnectionTypeInput;
};


export type MutationCreateEntityCustomIdArgs = {
  input: CreateEntityCustomIdInput;
};


export type MutationCreateEntityTypeArgs = {
  input: CreateEntityTypeInput;
};


export type MutationCreateExternalServiceArgs = {
  input: CreateExternalServiceInput;
};


export type MutationCreateFollowUpArgs = {
  input: CreateFollowUpInput;
};


export type MutationCreateImportArgs = {
  input: CreateImportInput;
};


export type MutationCreateInvitationArgs = {
  input: CreateInvitationInput;
};


export type MutationCreateNotesArgs = {
  input: CreateNotesInput;
};


export type MutationCreatePhoneNumbersArgs = {
  input: CreatePhoneNumbersInput;
};


export type MutationCreateSavedQueryArgs = {
  input: CreateSavedQueryInput;
};


export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


export type MutationCreateTagCategoryArgs = {
  input: CreateTagCategoryInput;
};


export type MutationCreateTagGroupArgs = {
  input: CreateTagGroupInput;
};


export type MutationDeleteAllActionAssignmentGroupsArgs = {
  input: DeleteAllActionAssignmentGroupsInput;
};


export type MutationDeleteAttachmentArgs = {
  input: DeleteAttachmentInput;
};


export type MutationDeleteCalendarEventArgs = {
  input: DeleteCalendarEventInput;
};


export type MutationDeleteCustomFormArgs = {
  input: DeleteCustomFormInput;
};


export type MutationDeleteEntitiesArgs = {
  input: DeleteEntitiesInput;
};


export type MutationDeleteEntityConnectionArgs = {
  input: DeleteEntityConnectionInput;
};


export type MutationDeleteSavedQueryArgs = {
  input: DeleteSavedQueryInput;
};


export type MutationDisableUserArgs = {
  input: DisableUserInput;
};


export type MutationDuplicateActionArgs = {
  input: DuplicateActionInput;
};


export type MutationEnableUserArgs = {
  input: EnableUserInput;
};


export type MutationEntitiesReportArgs = {
  input: EntitiesReportInput;
};


export type MutationGenerateActionAssignmentGroupsArgs = {
  input: GenerateActionAssignmentGroupsInput;
};


export type MutationGenerateActionAssignmentGroupsByAggregatorArgs = {
  input: GenerateActionAssignmentGroupsByAggregatorInput;
};


export type MutationGenerateActionAssignmentGroupsByStrategyArgs = {
  input: GenerateActionAssignmentGroupsByStrategyInput;
};


export type MutationGenerateActionAssignmentGroupsByTagArgs = {
  input: GenerateActionAssignmentGroupsByTagInput;
};


export type MutationLinkEventToActionNetworkArgs = {
  input: LinkEventToActionNetworkInput;
};


export type MutationLogContactAttemptArgs = {
  input: LogContactAttemptInput;
};


export type MutationMergeEntitiesArgs = {
  input: MergeEntitiesInput;
};


export type MutationPinNoteArgs = {
  input: PinNoteInput;
};


export type MutationRemoveActionAssignmentGroupArgs = {
  input: RemoveActionAssignmentGroupInput;
};


export type MutationRemoveActionFieldByIdArgs = {
  input: RemoveActionFieldByIdInput;
};


export type MutationRemoveActionNetworkCampaignTagMappingArgs = {
  input: ActionNetworkRemoveCampaignTagMappingInput;
};


export type MutationRemoveActionNetworkGroupArgs = {
  input: ActionNetworkRemoveGroupInput;
};


export type MutationRemoveActionNetworkIntegrationFromCampaignArgs = {
  input: ActionNetworkRemoveCampaignIntegrationInput;
};


export type MutationRemoveAssignmentGroupUserRoutingArgs = {
  input: RemoveAssignmentGroupUserRoutingInput;
};


export type MutationRemoveCalendarEventUsersArgs = {
  input: RemoveCalendarEventUsersInput;
};


export type MutationRemoveCampaignParticipantArgs = {
  input: RemoveCampaignParticipantInput;
};


export type MutationRemoveCustomFormFieldByIdArgs = {
  input: RemoveCustomFormFieldByIdInput;
};


export type MutationRemoveEntitiesFromActionArgs = {
  input: RemoveEntitiesFromActionInput;
};


export type MutationRemoveEntitiesFromActionAssignmentGroupArgs = {
  input: RemoveEntitiesFromActionAssignmentGroupInput;
};


export type MutationRemoveEntitiesFromCampaignsArgs = {
  input: RemoveEntitiesFromCampaignsInput;
};


export type MutationRemoveEntityCustomIdArgs = {
  input: RemoveEntityCustomIdInput;
};


export type MutationRemoveEntityFromCampaignArgs = {
  input: RemoveEntityFromCampaignInput;
};


export type MutationRemoveMfaArgs = {
  input: RemoveMfaInput;
};


export type MutationRemoveNotesArgs = {
  input: RemoveNotesInput;
};


export type MutationRemoveSocialProfileArgs = {
  input: RemoveSocialProfileInput;
};


export type MutationRemoveTagCategoryFromCampaignArgs = {
  input: RemoveTagCategoryFromCampaignInput;
};


export type MutationRemoveUsersFromActionAssignmentGroupArgs = {
  input: RemoveUsersFromActionAssignmentGroupInput;
};


export type MutationRenameTagGroupArgs = {
  input: RenameTagGroupInput;
};


export type MutationResendInvitationArgs = {
  input: ResendInvitationInput;
};


export type MutationResendMfaCodeArgs = {
  input: ResendMfaCodeInput;
};


export type MutationRevertAddressArgs = {
  input: RevertAddressInput;
};


export type MutationRevokeApiKeyArgs = {
  input: RevokeApiKeyInput;
};


export type MutationSetAssessmentInfoArgs = {
  input: SetAssessmentInfoInput;
};


export type MutationSetAssessmentOverridesArgs = {
  input: SetAssessmentOverridesInput;
};


export type MutationSetCalendarEventResponseArgs = {
  input: SetCalendarEventResponseInput;
};


export type MutationSetUsersDisableOnDateArgs = {
  input: SetUsersDisableOnDateInput;
};


export type MutationStartMfaSetupArgs = {
  input: StartMfaSetupInput;
};


export type MutationSubscribeEmailArgs = {
  input: SubscribeEmailInput;
};


export type MutationSubscribePhoneNumberArgs = {
  input: SubscribePhoneNumberInput;
};


export type MutationUnapplyCalendarEventResponseTagArgs = {
  input: UnapplyCalendarEventResponseTagInput;
};


export type MutationUnapplyEntityConnectionTagArgs = {
  input: UnapplyEntityConnectionTagInput;
};


export type MutationUnapplyTagArgs = {
  input: UnapplyTagInput;
};


export type MutationUnassociateTagFromCampaignArgs = {
  input: UnassociateTagFromCampaignInput;
};


export type MutationUnlinkEventFromActionNetworkArgs = {
  input: UnlinkEventFromActionNetworkInput;
};


export type MutationUnpinNoteArgs = {
  input: UnpinNoteInput;
};


export type MutationUpdateActionArgs = {
  input: UpdateActionInput;
};


export type MutationUpdateActionAssignmentGroupArgs = {
  input: UpdateActionAssignmentGroupInput;
};


export type MutationUpdateActionFieldArgs = {
  input: UpdateActionFieldInput;
};


export type MutationUpdateActionFieldsPositionsArgs = {
  input: UpdateActionFieldsPositionsInput;
};


export type MutationUpdateActionNetworkIntegrationArgs = {
  input: ActionNetworkUpdateIntegrationInput;
};


export type MutationUpdateAddressArgs = {
  input: UpdateAddressInput;
};


export type MutationUpdateAddressGeolocationArgs = {
  input: UpdateAddressGeolocationInput;
};


export type MutationUpdateAddressTagArgs = {
  input: UpdateAddressTagInput;
};


export type MutationUpdateAssignmentGroupEntitiesByQueryArgs = {
  input: UpdateAssignmentGroupEntitiesByQueryInput;
};


export type MutationUpdateAssignmentGroupUserRoutingArgs = {
  input: UpdateAssignmentGroupUserRoutingInput;
};


export type MutationUpdateCalendarEventArgs = {
  input: UpdateCalendarEventInput;
};


export type MutationUpdateCalendarEventActionScheduledDaysArgs = {
  input: UpdateCalendarEventActionScheduledDaysInput;
};


export type MutationUpdateCampaignArgs = {
  input: UpdateCampaignInput;
};


export type MutationUpdateCampaignEntityConnectionTypeConfigurationArgs = {
  input: UpdateCampaignEntityConnectionTypeConfigurationInput;
};


export type MutationUpdateCampaignEntityTypeConfigurationArgs = {
  input: UpdateCampaignEntityTypeConfigurationInput;
};


export type MutationUpdateCampaignExportRestrictionsArgs = {
  input: UpdateCampaignExportRestrictionsInput;
};


export type MutationUpdateCurrentUserArgs = {
  input: UpdateCurrentUserInput;
};


export type MutationUpdateCustomFormArgs = {
  input: UpdateCustomFormInput;
};


export type MutationUpdateCustomFormFieldPositionsArgs = {
  input: UpdateCustomFormFieldPositionsInput;
};


export type MutationUpdateCustomFormFieldsArgs = {
  input: UpdateCustomFormFieldsInput;
};


export type MutationUpdateCustomIdArgs = {
  input: UpdateCustomIdInput;
};


export type MutationUpdateEmailArgs = {
  input: UpdateEmailInput;
};


export type MutationUpdateEntitiesOnActionByQueryArgs = {
  input: UpdateEntitiesOnActionByQueryInput;
};


export type MutationUpdateEntityArgs = {
  input: UpdateEntityInput;
};


export type MutationUpdateEntityConnectionArgs = {
  input: UpdateEntityConnectionInput;
};


export type MutationUpdateEntityConnectionTypeArgs = {
  input: UpdateEntityConnectionTypeInput;
};


export type MutationUpdateEntityCustomIdArgs = {
  input: UpdateEntityCustomIdInput;
};


export type MutationUpdateEntityPronounsArgs = {
  input: UpdateEntityPronounsInput;
};


export type MutationUpdateEntityTypeArgs = {
  input: UpdateEntityTypeInput;
};


export type MutationUpdateExternalServiceArgs = {
  input: UpdateExternalServiceInput;
};


export type MutationUpdateFollowUpArgs = {
  input: UpdateFollowUpInput;
};


export type MutationUpdateImportArgs = {
  input: UpdateImportInput;
};


export type MutationUpdateIntegrationsArgs = {
  input: UpdateIntegrationsInput;
};


export type MutationUpdateNoteArgs = {
  input: UpdateNoteInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationMfaEnforcementArgs = {
  input: UpdateOrganizationMfaEnforcementInput;
};


export type MutationUpdatePhoneNumberArgs = {
  input: UpdatePhoneNumberInput;
};


export type MutationUpdateSavedQueryArgs = {
  input: UpdateSavedQueryInput;
};


export type MutationUpdateShiftArgs = {
  input: UpdateShiftInput;
};


export type MutationUpdateSocialProfileArgs = {
  input: UpdateSocialProfileInput;
};


export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
};


export type MutationUpdateTagCategoryArgs = {
  input: UpdateTagCategoryInput;
};


export type MutationUpdateTagStatusByCategoryArgs = {
  input: UpdateTagStatusByCategoryInput;
};


export type MutationUpdateUserByIdArgs = {
  input: UpdateUserByIdInput;
};


export type MutationUpdateUserTurfAssignmentsArgs = {
  input: UpdateUserTurfAssignmentsInput;
};


export type MutationVerifyMfaLoginArgs = {
  input: VerifyMfaLoginInput;
};


export type MutationVerifyMfaSetupArgs = {
  input: VerifyMfaSetupInput;
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars['ID'];
};

export type Note = {
  __typename?: 'Note';
  attachments: Array<Attachment>;
  createdAt: Scalars['Time'];
  createdBy: UserPublic;
  id: Scalars['ID'];
  noteType: Scalars['String'];
  pinnedAt: Maybe<Scalars['Time']>;
  pinnedBy: Maybe<UserPublic>;
  targetType: Scalars['String'];
  text: Scalars['String'];
  updatedAt: Scalars['Time'];
  updatedBy: Maybe<UserPublic>;
};

/** Update note input. */
export type NoteChangesInput = {
  text?: Maybe<Scalars['String']>;
};

/** The connection type for Note. */
export type NoteConnection = {
  __typename?: 'NoteConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<NoteEdge>>>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Note>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type NoteEdge = {
  __typename?: 'NoteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<Note>;
};

/** Notes input. */
export type NoteInput = {
  text: Scalars['String'];
};

/** CSV import Note mapping type */
export type NoteMapping = {
  __typename?: 'NoteMapping';
  noteDate: Maybe<PropertyMapping>;
  text: PropertyMapping;
};

export type NoteMappingInput = {
  noteDate?: Maybe<PropertyMappingInput>;
  text: PropertyMappingInput;
};

/** Note target types. */
export enum NoteTarget {
  /** Note on address. */
  Address = 'Address',
  /** Note on a Campaign */
  Campaign = 'Campaign',
  /** Note on email. */
  Email = 'Email',
  /** Note on entity. */
  Entity = 'Entity',
  /** Note on an EntityConnection. */
  EntityConnection = 'EntityConnection',
  /** Note on an FollowUp. */
  FollowUp = 'FollowUp',
  /** Note on phone number. */
  PhoneNumber = 'PhoneNumber',
  /** Note on a entity tag. */
  TaggableLogbook = 'TaggableLogbook'
}

export type NotesTag = Tag & {
  __typename?: 'NotesTag';
  archived: Maybe<Scalars['Boolean']>;
  associatedCampaignIds: Array<Maybe<Scalars['String']>>;
  /** Attachments are allowed on tag */
  attachmentsEnabled: Maybe<Scalars['Boolean']>;
  campaignContextId: Maybe<Scalars['String']>;
  category: TagCategory;
  createdAt: Scalars['Time'];
  group: TagGroup;
  id: Scalars['ID'];
  isInCampaign: Maybe<Scalars['Boolean']>;
  isUniversal: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  readonly: Scalars['Boolean'];
  tagType: TagType;
  targetType: TagTargetAssociation;
  updatedAt: Scalars['Time'];
};


export type NotesTagIsInCampaignArgs = {
  campaignId?: Maybe<Scalars['ID']>;
};

export type NumberTag = Tag & {
  __typename?: 'NumberTag';
  archived: Maybe<Scalars['Boolean']>;
  associatedCampaignIds: Array<Maybe<Scalars['String']>>;
  /** Attachments are allowed on tag */
  attachmentsEnabled: Maybe<Scalars['Boolean']>;
  campaignContextId: Maybe<Scalars['String']>;
  category: TagCategory;
  createdAt: Scalars['Time'];
  group: TagGroup;
  id: Scalars['ID'];
  isInCampaign: Maybe<Scalars['Boolean']>;
  isUniversal: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  readonly: Scalars['Boolean'];
  tagType: TagType;
  targetType: TagTargetAssociation;
  updatedAt: Scalars['Time'];
};


export type NumberTagIsInCampaignArgs = {
  campaignId?: Maybe<Scalars['ID']>;
};

export type Organization = {
  __typename?: 'Organization';
  administratorUser: Maybe<User>;
  createdAt: Scalars['Time'];
  defaultCountry: Maybe<Scalars['String']>;
  /** Allowed MFA methods (e.g., ['sms', 'totp']) */
  mfaAllowedMethods: Array<Scalars['String']>;
  /** Whether MFA is required for this organization */
  mfaRequired: Scalars['Boolean'];
  /** When MFA requirement was enabled */
  mfaRequiredAt: Maybe<Scalars['ISO8601DateTime']>;
  name: Scalars['String'];
  subdomain: Scalars['String'];
  updatedAt: Scalars['Time'];
};

export type OriginalAddress = {
  __typename?: 'OriginalAddress';
  city: Maybe<Scalars['String']>;
  complement: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  latitude: Maybe<Scalars['Float']>;
  longitude: Maybe<Scalars['Float']>;
  state: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  streetAddress: Maybe<Scalars['String']>;
  zip: Maybe<Scalars['String']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** CSV import Phone mapping type */
export type PhoneMapping = {
  __typename?: 'PhoneMapping';
  ext: Maybe<PropertyMapping>;
  number: PropertyMapping;
  numberType: PropertyMapping;
  status: Maybe<PropertyMapping>;
  subscribed: Maybe<PropertyMapping>;
};

export type PhoneMappingInput = {
  ext?: Maybe<PropertyMappingInput>;
  number: PropertyMappingInput;
  numberType: PropertyMappingInput;
  status?: Maybe<PropertyMappingInput>;
  subscribed?: Maybe<PropertyMappingInput>;
};

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  createdAt: Scalars['Time'];
  createdBy: UserPublic;
  ext: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  number: Scalars['String'];
  numberType: PhoneNumberType;
  source: FieldSource;
  status: FieldStatus;
  subscribed: Scalars['Boolean'];
  updatedAt: Scalars['Time'];
  updatedBy: Maybe<UserPublic>;
};

/** Update phone number input. */
export type PhoneNumberChangesInput = {
  ext?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  numberType?: Maybe<PhoneNumberType>;
  status?: Maybe<FieldStatusInput>;
  subscribe?: Maybe<Scalars['Boolean']>;
};

/** Phone number input. */
export type PhoneNumberInput = {
  ext?: Maybe<Scalars['String']>;
  /** List of notes */
  notes?: Maybe<Array<NoteInput>>;
  number: Scalars['String'];
  numberType: PhoneNumberType;
  status?: Maybe<FieldStatusInput>;
  /** Should this phone number be subscribed? */
  subscribe?: Maybe<Scalars['Boolean']>;
};

/** Phone number types. */
export enum PhoneNumberType {
  /** Cell phone number type. */
  Cell = 'cell',
  /** Home phone number type. */
  Home = 'home',
  /** Work phone number type. */
  Work = 'work'
}

/** Autogenerated input type of PinNote */
export type PinNoteInput = {
  /** Campaign Id */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Note Id to be pinned */
  noteId: Scalars['ID'];
};

/** Autogenerated return type of PinNote. */
export type PinNotePayload = {
  __typename?: 'PinNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Pinned note */
  note: Note;
};

/** CSV import property mapping type */
export type PropertyMapping = {
  __typename?: 'PropertyMapping';
  column: Maybe<Scalars['Int']>;
  includeBlankValues: Maybe<Scalars['Boolean']>;
  overwriteExistingData: Maybe<Scalars['Boolean']>;
  staticValue: Maybe<Scalars['String']>;
};

export type PropertyMappingInput = {
  column?: Maybe<Scalars['Int']>;
  includeBlankValues?: Maybe<Scalars['Boolean']>;
  overwriteExistingData?: Maybe<Scalars['Boolean']>;
  staticValue?: Maybe<Scalars['String']>;
};

/** Queries */
export type Query = {
  __typename?: 'Query';
  /** Simple Query module */
  entitiesQuery: Maybe<EntityConnectionWithTotalCount>;
  /** Return geocoded address results */
  geocodeAddress: Maybe<GeocodedAddress>;
  /** Get action */
  getAction: Maybe<Action>;
  /** Get action assignment group by ID */
  getActionAssignmentGroup: Maybe<ActionAssignmentGroup>;
  /** Get action assignment groups */
  getActionAssignmentGroups: Maybe<Array<ActionAssignmentGroup>>;
  /** Get action assignment groups for the current user */
  getActionAssignmentGroupsForCurrentUser: Maybe<Array<ActionAssignmentGroup>>;
  /** Get action entity */
  getActionEntities: Maybe<Array<ActionEntity>>;
  /** Get action entity */
  getActionEntity: Maybe<ActionEntity>;
  /** Returns action entity ids in the order they should appear to the user */
  getActionEntityAssignmentOrdering: Maybe<ActionEntityAssignmentOrdering>;
  /** Get action entity by action entity id */
  getActionEntityById: Maybe<ActionEntity>;
  /** Find entities within the same household */
  getActionHouseholdMatches: Maybe<ActionHouseholdMatchResult>;
  /** Retrieve all custom fields for an Action Network Group associated with a campaign */
  getActionNetworkCustomFields: Maybe<Array<ActionNetworkCustomField>>;
  /** Get an ActionNetwork event by AB calendar event ID */
  getActionNetworkEvent: Maybe<ActionNetworkEvent>;
  /** Get ActionNetwork events for a group */
  getActionNetworkEvents: Maybe<EventConnection>;
  /** Get all action network groups added to this organization */
  getActionNetworkGroups: Maybe<Array<ActionNetworkGroup>>;
  /** Get all action network tags for a group */
  getActionNetworkTags: Maybe<Array<ActionNetworkTag>>;
  /** Gets Actions In A Campaign */
  getActions: Maybe<Array<Action>>;
  /** Get Actions and entity relation records */
  getActionsByEntity: Maybe<Array<ActionEntity>>;
  /** Return an address record */
  getAddress: Maybe<Address>;
  /** Return all tag groups */
  getAllTagGroups: Maybe<Array<TagGroup>>;
  /** Return all API keys for the organization */
  getApiKeys: Maybe<Array<ApiKey>>;
  /** Return information on this organization's assessment levels */
  getAssessmentInfo: Maybe<AssessmentInfo>;
  /** Get an event by its ID */
  getCalendarEvent: Maybe<CalendarEvent>;
  /** Get a calendar event response by its ID */
  getCalendarEventResponse: Maybe<CalendarEventResponse>;
  /** Get a calendar event response for an entity */
  getCalendarEventResponseForEntity: Maybe<CalendarEventResponse>;
  /** Return an accessible campaign */
  getCampaign: Maybe<Campaign>;
  /** Return campaign_entity_type_configurations. */
  getCampaignEntityConnectionTypeConfiguration: Maybe<CampaignEntityConnectionTypeConfiguration>;
  /** Return campaign_entity_connection_type_configurations. */
  getCampaignEntityConnectionTypeConfigurations: Maybe<Array<CampaignEntityConnectionTypeConfiguration>>;
  /** Return campaign_entity_type_configurations. */
  getCampaignEntityTypeConfiguration: Maybe<CampaignEntityTypeConfiguration>;
  /** Return campaign_entity_type_configurations. */
  getCampaignEntityTypeConfigurations: Maybe<Array<CampaignEntityTypeConfiguration>>;
  /** Return campaign public information */
  getCampaignPublic: Maybe<CampaignPublic>;
  /** Return all accessible campaigns */
  getCampaigns: Maybe<Array<Campaign>>;
  /** Return contact attempts */
  getContactAttempts: Maybe<Array<ContactAttempt>>;
  /** Return contact attempts for an entity */
  getContactAttemptsForEntity: Maybe<Array<ContactAttempt>>;
  /** Get counts for entity chart */
  getCountsForEntityChart: EntityChartCounts;
  /** Return current user. */
  getCurrentUser: Maybe<User>;
  /** Get custom form */
  getCustomForm: Maybe<CustomForm>;
  /** Get all custom forms */
  getCustomForms: Maybe<CustomFormConnection>;
  /** Return all CustomIdTypes */
  getCustomIdTypes: Maybe<Array<CustomIdType>>;
  /** Return the default saved query for a campaign */
  getDefaultSavedQuery: Maybe<SavedQuery>;
  /** Return delete entities operations */
  getDeleteEntitiesOperation: Maybe<DeleteEntitiesOperation>;
  /** Return delete entities operations */
  getDeleteEntitiesOperations: Maybe<DeleteEntitiesOperationConnection>;
  /** Return all accessible entities. */
  getEntities: Maybe<EntityConnectionWithTotalCount>;
  /** Return accessible entities by custom IDs (custom_id_1, custom_id_2, custom_id_3, custom_id_4) */
  getEntitiesByCustomIds: Maybe<Array<Entity>>;
  /** Return accessible entities by IDs */
  getEntitiesByIds: Maybe<Array<Entity>>;
  /** Return accessible entity. */
  getEntity: Maybe<Entity>;
  /** Return EntityConnection */
  getEntityConnection: Maybe<EntityConnection>;
  /** Return an EntityConnectionType */
  getEntityConnectionType: Maybe<EntityConnectionType>;
  /** Return EntityConnectionTypes */
  getEntityConnectionTypes: Maybe<Array<EntityConnectionType>>;
  /** Return EntityConnections connection */
  getEntityConnections: Maybe<EntityConnectionConnection>;
  /** Return all EntityCustomIds for a given entity */
  getEntityCustomIds: Maybe<Array<EntityCustomId>>;
  /** Return entity import fields to be used in the upload */
  getEntityImportFields: Maybe<Array<EntityImportField>>;
  /** Return accessible entity. */
  getEntityPublic: Maybe<EntityPublic>;
  /** Return an EntityType */
  getEntityType: Maybe<EntityType>;
  /** Return all accessible entity_types. */
  getEntityTypes: Maybe<EntityTypeConnectionWithTotalCount>;
  /** Return an external service by id. */
  getExternalService: Maybe<ExternalService>;
  /** Return all external services. */
  getExternalServices: Maybe<Array<ExternalService>>;
  /** Return an CSV import by ID */
  getImportById: Maybe<Import>;
  /** Returns an import download URL */
  getImportDownloadUrl: Maybe<Url>;
  /** Return import row errors */
  getImportErrors: Maybe<ImportRowErrorConnection>;
  /** Returns an import errors output file */
  getImportErrorsUrl: Maybe<Url>;
  /** Return file imports */
  getImports: Maybe<ImportConnection>;
  /** Return merge conflicts between two entities */
  getMergeConflicts: Maybe<MergeConflictData>;
  /** Gets the next action entity in from an action assignment group */
  getNextActionEntity: Maybe<ActionEntity>;
  /** Return notes */
  getNotes: Maybe<NoteConnection>;
  /** Return current organization info */
  getOrganization: Maybe<Organization>;
  /** Finds potential duplicate entities based on email or phone number within the same campaign. */
  getPotentialEntityDuplicates: Maybe<EntityDuplicates>;
  /** Return remove entities from campaigns operation */
  getRemoveEntitiesFromCampaignsOperation: Maybe<RemoveEntitiesFromCampaignsOperation>;
  /** Return remove entities from campaigns operations */
  getRemoveEntitiesFromCampaignsOperations: Maybe<RemoveEntitiesFromCampaignsOperationConnection>;
  /** Return saved queries */
  getSavedQueries: Maybe<SavedQueryConnection>;
  /** Return saved queries */
  getSavedQuery: Maybe<SavedQuery>;
  getSocialNetworks: Maybe<Array<SocialNetwork>>;
  /** Return a tag */
  getTagById: Maybe<Tag>;
  /** Return tag categories */
  getTagCategories: Maybe<TagCategoryConnection>;
  /** Return a tag category */
  getTagCategoryById: Maybe<TagCategory>;
  /** Return a tag group */
  getTagGroupById: Maybe<TagGroup>;
  /** Return tag groups */
  getTagGroups: Maybe<TagGroupConnection>;
  /** Return a taggable logbook item */
  getTaggableLogbookById: Maybe<TaggableLogbook>;
  /** Return tags */
  getTags: Maybe<TagConnection>;
  /** Return tags */
  getTagsByIds: Maybe<Array<Tag>>;
  /** Return uploads */
  getUploadById: Maybe<Upload>;
  /** Returns an upload download URL */
  getUploadDownloadUrl: Maybe<UploadDownloadUrl>;
  /** Returns an uploads error output file */
  getUploadErrorsUrl: Maybe<UploadDownloadUrl>;
  /** Return uploads */
  getUploads: Maybe<UploadConnection>;
  /** Return an accessible user by ID. */
  getUserById: Maybe<User>;
  /** Return user by invitation token. */
  getUserByInvitationToken: User;
  /**
   * Return an accessible user by email.
   * @deprecated May be removed in a future release
   */
  getUserByMail: Maybe<User>;
  /** Return all accessible users. */
  getUsers: Maybe<UserConnectionWithTotalCount>;
  /** Search entities whithin an Action */
  searchActionEntities: Maybe<ActionEntityConnectionWithTotalCount>;
  /** Search through activity_events table */
  searchActivityEvents: Maybe<ActivityEventConnection>;
  /** Searches RSVPs and returns a paginated list of the RSVPs matching the criteria */
  searchCalendarEventResponses: Maybe<CalendarEventResponseCollectionWithTotalCount>;
  /** Search calendar events within a campaign */
  searchCalendarEvents: Maybe<CalendarEventCollectionWithTotalCount>;
  /** Search campaigns that are associated with an object (e.g. an EntityType) */
  searchCampaignObjectVisibility: Maybe<CampaignObjectVisibilityResultConnection>;
  /** Searches accessible campaigns by name */
  searchCampaigns: Maybe<CampaignConnectionWithTotalCount>;
  /** Search by keyword in electoral districts data */
  searchElectoralDistricts: Maybe<ElectoralDistrictConnection>;
  /** Search by keyword and result entities */
  searchEntities: Maybe<EntityConnectionWithTotalCount>;
  /** Search by keyword and result entities public data */
  searchEntitiesPublic: Maybe<EntityPublicConnectionWithTotalCount>;
  /** Searches cities, states and zip codes */
  searchLocations: Maybe<Array<SearchLocationResultItem>>;
  /** Search for tag categories */
  searchTagCategories: Maybe<TagCategoryConnection>;
  /** Search for tags */
  searchTags: Maybe<TagConnection>;
  /** Search by keyword and result users */
  searchUsers: Maybe<UserConnectionWithTotalCount>;
  /** WallChart Report v3 */
  wallchart3: Maybe<Array<AggregationResult>>;
};


/** Queries */
export type QueryEntitiesQueryArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  campaignId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  keyword?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
  queryType?: Maybe<QueryTypesType>;
  save?: Maybe<Scalars['Boolean']>;
};


/** Queries */
export type QueryGeocodeAddressArgs = {
  address: Scalars['String'];
};


/** Queries */
export type QueryGetActionArgs = {
  actionId: Scalars['ID'];
  campaignId: Scalars['ID'];
};


/** Queries */
export type QueryGetActionAssignmentGroupArgs = {
  actionAssignmentGroupId: Scalars['ID'];
  actionId: Scalars['ID'];
};


/** Queries */
export type QueryGetActionAssignmentGroupsArgs = {
  actionId: Scalars['ID'];
};


/** Queries */
export type QueryGetActionAssignmentGroupsForCurrentUserArgs = {
  campaignId: Scalars['ID'];
  endDate?: Maybe<Scalars['Date']>;
  startDate?: Maybe<Scalars['Date']>;
};


/** Queries */
export type QueryGetActionEntitiesArgs = {
  actionId: Scalars['ID'];
  campaignId: Scalars['ID'];
  entityIds: Array<Scalars['ID']>;
};


/** Queries */
export type QueryGetActionEntityArgs = {
  actionId: Scalars['ID'];
  campaignId: Scalars['ID'];
  entityId: Scalars['ID'];
};


/** Queries */
export type QueryGetActionEntityAssignmentOrderingArgs = {
  actionAssignmentGroupId: Scalars['ID'];
  actionId: Scalars['ID'];
};


/** Queries */
export type QueryGetActionEntityByIdArgs = {
  actionEntityId: Scalars['ID'];
};


/** Queries */
export type QueryGetActionHouseholdMatchesArgs = {
  actionAssignmentGroupId: Scalars['ID'];
  actionEntityId: Scalars['ID'];
  addressId: Scalars['ID'];
};


/** Queries */
export type QueryGetActionNetworkCustomFieldsArgs = {
  groupId: Scalars['String'];
};


/** Queries */
export type QueryGetActionNetworkEventArgs = {
  calendarEventId: Scalars['ID'];
};


/** Queries */
export type QueryGetActionNetworkEventsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  groupId: Scalars['String'];
  last?: Maybe<Scalars['Int']>;
};


/** Queries */
export type QueryGetActionNetworkTagsArgs = {
  groupId: Scalars['String'];
};


/** Queries */
export type QueryGetActionsArgs = {
  campaignId: Scalars['ID'];
  completed?: Maybe<Scalars['Boolean']>;
  createdById?: Maybe<Scalars['ID']>;
  dueDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  name?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
};


/** Queries */
export type QueryGetActionsByEntityArgs = {
  campaignId: Scalars['ID'];
  entityId: Scalars['ID'];
};


/** Queries */
export type QueryGetAddressArgs = {
  addressId: Scalars['ID'];
  campaignId: Scalars['ID'];
  entityId: Scalars['ID'];
};


/** Queries */
export type QueryGetApiKeysArgs = {
  target?: Maybe<ApiKeyTarget>;
};


/** Queries */
export type QueryGetCalendarEventArgs = {
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
};


/** Queries */
export type QueryGetCalendarEventResponseArgs = {
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
};


/** Queries */
export type QueryGetCalendarEventResponseForEntityArgs = {
  calendarEventId: Scalars['ID'];
  campaignId: Scalars['ID'];
  entityId: Scalars['ID'];
};


/** Queries */
export type QueryGetCampaignArgs = {
  campaignId: Scalars['ID'];
};


/** Queries */
export type QueryGetCampaignEntityConnectionTypeConfigurationArgs = {
  campaignId: Scalars['ID'];
  entityConnectionTypeId: Scalars['ID'];
};


/** Queries */
export type QueryGetCampaignEntityConnectionTypeConfigurationsArgs = {
  campaignId: Scalars['ID'];
};


/** Queries */
export type QueryGetCampaignEntityTypeConfigurationArgs = {
  campaignId: Scalars['ID'];
  entityTypeId: Scalars['ID'];
};


/** Queries */
export type QueryGetCampaignEntityTypeConfigurationsArgs = {
  campaignId: Scalars['ID'];
};


/** Queries */
export type QueryGetCampaignPublicArgs = {
  campaignId: Scalars['ID'];
};


/** Queries */
export type QueryGetCampaignsArgs = {
  status?: Maybe<CampaignStatusType>;
};


/** Queries */
export type QueryGetContactAttemptsArgs = {
  actionEntityId: Scalars['ID'];
  contactInfoId?: Maybe<Scalars['ID']>;
  contactInfoType?: Maybe<ContactAttemptInfoType>;
  disposition?: Maybe<ContactAttemptDispositionType>;
};


/** Queries */
export type QueryGetContactAttemptsForEntityArgs = {
  campaignId: Scalars['ID'];
  contactInfoId?: Maybe<Scalars['ID']>;
  contactInfoType?: Maybe<ContactAttemptInfoType>;
  disposition?: Maybe<ContactAttemptDispositionType>;
  entityId: Scalars['ID'];
  targetType?: Maybe<ContactAttemptTargetType>;
};


/** Queries */
export type QueryGetCountsForEntityChartArgs = {
  aggregationMethod: ChartAggregationMethodEnumType;
  campaignId: Scalars['ID'];
  endDate: Scalars['ISO8601DateTime'];
  period: ChartPeriodType;
  queryJson: Scalars['String'];
  startDate: Scalars['ISO8601DateTime'];
};


/** Queries */
export type QueryGetCustomFormArgs = {
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
};


/** Queries */
export type QueryGetCustomFormsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  campaignId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  targetType: Scalars['ID'];
  targetTypeId?: Maybe<Scalars['ID']>;
};


/** Queries */
export type QueryGetDefaultSavedQueryArgs = {
  campaignId: Scalars['ID'];
};


/** Queries */
export type QueryGetDeleteEntitiesOperationArgs = {
  id: Scalars['ID'];
};


/** Queries */
export type QueryGetDeleteEntitiesOperationsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Queries */
export type QueryGetEntitiesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  campaignId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Queries */
export type QueryGetEntitiesByCustomIdsArgs = {
  campaignId: Scalars['ID'];
  customIds: Array<Scalars['String']>;
  name: Scalars['String'];
};


/** Queries */
export type QueryGetEntitiesByIdsArgs = {
  campaignId: Scalars['ID'];
  entityIds?: Maybe<Array<Scalars['ID']>>;
};


/** Queries */
export type QueryGetEntityArgs = {
  campaignId: Scalars['ID'];
  entityId: Scalars['ID'];
};


/** Queries */
export type QueryGetEntityConnectionArgs = {
  campaignId: Scalars['ID'];
  entityConnectionId: Scalars['ID'];
};


/** Queries */
export type QueryGetEntityConnectionTypeArgs = {
  campaignId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
};


/** Queries */
export type QueryGetEntityConnectionTypesArgs = {
  campaignId?: Maybe<Scalars['ID']>;
  entityTypeId?: Maybe<Scalars['ID']>;
};


/** Queries */
export type QueryGetEntityConnectionsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  campaignId: Scalars['ID'];
  entityConnectionTypeId?: Maybe<Scalars['ID']>;
  entityId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  includeInactive?: Maybe<Scalars['Boolean']>;
  last?: Maybe<Scalars['Int']>;
};


/** Queries */
export type QueryGetEntityCustomIdsArgs = {
  campaignId: Scalars['ID'];
  entityId: Scalars['ID'];
};


/** Queries */
export type QueryGetEntityImportFieldsArgs = {
  entityTypeId: Scalars['ID'];
};


/** Queries */
export type QueryGetEntityPublicArgs = {
  assessmentCampaignId?: Maybe<Scalars['ID']>;
  campaignId?: Maybe<Scalars['ID']>;
  entityId: Scalars['ID'];
};


/** Queries */
export type QueryGetEntityTypeArgs = {
  entityTypeId: Scalars['ID'];
};


/** Queries */
export type QueryGetEntityTypesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Queries */
export type QueryGetExternalServiceArgs = {
  id: Scalars['ID'];
};


/** Queries */
export type QueryGetImportByIdArgs = {
  importId: Scalars['ID'];
};


/** Queries */
export type QueryGetImportDownloadUrlArgs = {
  importId: Scalars['ID'];
};


/** Queries */
export type QueryGetImportErrorsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  importId: Scalars['ID'];
  last?: Maybe<Scalars['Int']>;
};


/** Queries */
export type QueryGetImportErrorsUrlArgs = {
  importId: Scalars['ID'];
};


/** Queries */
export type QueryGetImportsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Scalars['String']>;
  processingStatus?: Maybe<ImportStatusType>;
  visibilityStatus?: Maybe<ImportVisibilityStatusType>;
};


/** Queries */
export type QueryGetMergeConflictsArgs = {
  campaignId: Scalars['ID'];
  sourceId: Scalars['ID'];
  targetId: Scalars['ID'];
};


/** Queries */
export type QueryGetNextActionEntityArgs = {
  actionAssignmentGroupId: Scalars['ID'];
  actionEntityId: Scalars['String'];
  attemptedActionEntityIds?: Maybe<Array<Scalars['String']>>;
};


/** Queries */
export type QueryGetNotesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  campaignId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  targetId: Scalars['ID'];
  targetType: NoteTarget;
};


/** Queries */
export type QueryGetPotentialEntityDuplicatesArgs = {
  campaignId: Scalars['ID'];
  entityId: Scalars['ID'];
};


/** Queries */
export type QueryGetRemoveEntitiesFromCampaignsOperationArgs = {
  id: Scalars['ID'];
};


/** Queries */
export type QueryGetRemoveEntitiesFromCampaignsOperationsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Queries */
export type QueryGetSavedQueriesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  campaignId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  includePublic?: Maybe<Scalars['Boolean']>;
  keyword?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  queryType?: Maybe<Scalars['String']>;
};


/** Queries */
export type QueryGetSavedQueryArgs = {
  campaignId: Scalars['ID'];
  queryId: Scalars['ID'];
};


/** Queries */
export type QueryGetTagByIdArgs = {
  campaignId?: Maybe<Scalars['ID']>;
  tagId: Scalars['ID'];
};


/** Queries */
export type QueryGetTagCategoriesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  includeNotInCampaign?: Maybe<Scalars['Boolean']>;
  last?: Maybe<Scalars['Int']>;
  tagGroupId?: Maybe<Scalars['ID']>;
  targetType?: Maybe<Scalars['String']>;
  targetTypeId?: Maybe<Scalars['ID']>;
};


/** Queries */
export type QueryGetTagCategoryByIdArgs = {
  campaignId?: Maybe<Scalars['ID']>;
  tagCategoryId: Scalars['ID'];
};


/** Queries */
export type QueryGetTagGroupByIdArgs = {
  campaignId?: Maybe<Scalars['ID']>;
  tagGroupId: Scalars['ID'];
};


/** Queries */
export type QueryGetTagGroupsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  includeNotInCampaign?: Maybe<Scalars['Boolean']>;
  last?: Maybe<Scalars['Int']>;
  targetType?: Maybe<Scalars['String']>;
  targetTypeId?: Maybe<Scalars['ID']>;
};


/** Queries */
export type QueryGetTaggableLogbookByIdArgs = {
  taggableLogbookId: Scalars['ID'];
};


/** Queries */
export type QueryGetTagsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  includeArchived?: Maybe<Scalars['Boolean']>;
  includeNotInCampaign?: Maybe<Scalars['Boolean']>;
  last?: Maybe<Scalars['Int']>;
  tagCategoryId?: Maybe<Scalars['ID']>;
  targetType?: Maybe<Scalars['String']>;
  targetTypeId?: Maybe<Scalars['ID']>;
};


/** Queries */
export type QueryGetTagsByIdsArgs = {
  campaignId?: Maybe<Scalars['ID']>;
  tagIds: Array<Scalars['ID']>;
};


/** Queries */
export type QueryGetUploadByIdArgs = {
  uploadId: Scalars['ID'];
};


/** Queries */
export type QueryGetUploadDownloadUrlArgs = {
  uploadId: Scalars['ID'];
};


/** Queries */
export type QueryGetUploadErrorsUrlArgs = {
  uploadId: Scalars['ID'];
};


/** Queries */
export type QueryGetUploadsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  processingStatus?: Maybe<UploadStatusType>;
  visibilityStatus?: Maybe<UploadVisibilityStatusType>;
};


/** Queries */
export type QueryGetUserByIdArgs = {
  id: Scalars['ID'];
};


/** Queries */
export type QueryGetUserByInvitationTokenArgs = {
  invitationToken: Scalars['String'];
};


/** Queries */
export type QueryGetUserByMailArgs = {
  email: Scalars['String'];
};


/** Queries */
export type QueryGetUsersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Queries */
export type QuerySearchActionEntitiesArgs = {
  actionAssignmentGroupId?: Maybe<Scalars['ID']>;
  actionId: Scalars['ID'];
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  campaignId: Scalars['ID'];
  excludeCompleted?: Maybe<Scalars['Boolean']>;
  first?: Maybe<Scalars['Int']>;
  keyword?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


/** Queries */
export type QuerySearchActivityEventsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  calendarEventIds?: Maybe<Array<Scalars['ID']>>;
  calendarEventResponseTagIds?: Maybe<Array<Scalars['ID']>>;
  campaignId: Scalars['ID'];
  connectionTagIds?: Maybe<Array<Scalars['ID']>>;
  endDate?: Maybe<Scalars['Date']>;
  entityConnectionTypeIds?: Maybe<Array<Scalars['ID']>>;
  entityId?: Maybe<Scalars['ID']>;
  entityTypeIds?: Maybe<Array<Scalars['ID']>>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  names?: Maybe<Array<Scalars['String']>>;
  noteText?: Maybe<Scalars['String']>;
  socialProfile?: Maybe<SocialProfileQueryInput>;
  startDate?: Maybe<Scalars['Date']>;
  tagIds?: Maybe<Array<Scalars['ID']>>;
  userIds?: Maybe<Array<Scalars['ID']>>;
  userRoles?: Maybe<Array<UserRole>>;
};


/** Queries */
export type QuerySearchCalendarEventResponsesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  calendarEventId?: Maybe<Scalars['ID']>;
  campaignId: Scalars['ID'];
  dateRange?: Maybe<DateRangeInput>;
  entityId?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  keyword?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


/** Queries */
export type QuerySearchCalendarEventsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  campaignId: Scalars['ID'];
  dateRange?: Maybe<DateRangeInput>;
  first?: Maybe<Scalars['Int']>;
  keyword?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


/** Queries */
export type QuerySearchCampaignObjectVisibilityArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  keyword?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  objectType: CampaignObjectVisibilityTypesType;
  objectTypeId: Scalars['ID'];
  visibility: Scalars['String'];
};


/** Queries */
export type QuerySearchCampaignsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  keyword?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  status?: Maybe<CampaignStatusType>;
};


/** Queries */
export type QuerySearchElectoralDistrictsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  keyword?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


/** Queries */
export type QuerySearchEntitiesArgs = {
  after?: Maybe<Scalars['String']>;
  assessmentCampaignId?: Maybe<Scalars['ID']>;
  before?: Maybe<Scalars['String']>;
  entityTypeId?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  keyword: Scalars['String'];
  last?: Maybe<Scalars['Int']>;
};


/** Queries */
export type QuerySearchEntitiesPublicArgs = {
  accessibleEntitiesOnly?: Maybe<Scalars['Boolean']>;
  after?: Maybe<Scalars['String']>;
  assessmentCampaignId?: Maybe<Scalars['ID']>;
  before?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['ID']>;
  entityTypeIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  first?: Maybe<Scalars['Int']>;
  keyword: Scalars['String'];
  last?: Maybe<Scalars['Int']>;
  turfOnly?: Maybe<Scalars['Boolean']>;
};


/** Queries */
export type QuerySearchLocationsArgs = {
  campaignId: Scalars['ID'];
  country?: Maybe<Scalars['String']>;
  keyword: Scalars['String'];
  type: Scalars['String'];
};


/** Queries */
export type QuerySearchTagCategoriesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  includeNotInCampaign?: Maybe<Scalars['Boolean']>;
  keyword: Scalars['String'];
  last?: Maybe<Scalars['Int']>;
  tagGroupId?: Maybe<Scalars['ID']>;
  targetType?: Maybe<Scalars['String']>;
  targetTypeId?: Maybe<Scalars['ID']>;
};


/** Queries */
export type QuerySearchTagsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  includeNotInCampaign?: Maybe<Scalars['Boolean']>;
  keyword?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Scalars['String']>;
  status?: Maybe<TagStatus>;
  tagCategoryIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  tagTypes?: Maybe<Array<Maybe<TagType>>>;
  targetType?: Maybe<Scalars['String']>;
  targetTypeId?: Maybe<Scalars['ID']>;
};


/** Queries */
export type QuerySearchUsersArgs = {
  activeOnly?: Maybe<Scalars['Boolean']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['ID']>;
  disabled?: Maybe<Scalars['Boolean']>;
  disabledOnly?: Maybe<Scalars['Boolean']>;
  first?: Maybe<Scalars['Int']>;
  keyword?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  pendingOnly?: Maybe<Scalars['Boolean']>;
};


/** Queries */
export type QueryWallchart3Args = {
  campaignId: Scalars['ID'];
  groupBy?: Maybe<AggregatorEntry>;
  queryBody?: Maybe<Scalars['String']>;
  queryName?: Maybe<Scalars['String']>;
  queryType?: Maybe<QueryTypesType>;
  splitMatchesBy?: Maybe<AggregatorSplitMatchType>;
  splitMatchesByTagIds?: Maybe<Array<Scalars['String']>>;
  thenBy?: Maybe<AggregatorEntry>;
};

/** Query filter operator */
export enum QueryFilterOperator {
  Exclude = 'exclude',
  Include = 'include'
}

/** Query types. */
export enum QueryTypesType {
  Complex = 'complex',
  Simple = 'simple'
}

/** Autogenerated input type of RemoveActionAssignmentGroup */
export type RemoveActionAssignmentGroupInput = {
  /** Action assignment group ID */
  actionAssignmentGroupId: Scalars['ID'];
  /** Action ID */
  actionId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of RemoveActionAssignmentGroup. */
export type RemoveActionAssignmentGroupPayload = {
  __typename?: 'RemoveActionAssignmentGroupPayload';
  /** The related action */
  action: Maybe<Action>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of RemoveActionFieldById */
export type RemoveActionFieldByIdInput = {
  /** Action Field Id */
  actionFieldId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of RemoveActionFieldById. */
export type RemoveActionFieldByIdPayload = {
  __typename?: 'RemoveActionFieldByIdPayload';
  /** The related action */
  action: Maybe<Action>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of RemoveAssignmentGroupUserRouting */
export type RemoveAssignmentGroupUserRoutingInput = {
  /** Action Assignment Group Id */
  actionAssignmentGroupId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** User id */
  userId?: Maybe<Scalars['ID']>;
};

/** Autogenerated return type of RemoveAssignmentGroupUserRouting. */
export type RemoveAssignmentGroupUserRoutingPayload = {
  __typename?: 'RemoveAssignmentGroupUserRoutingPayload';
  /** Updated Routing Options */
  assignmentRoutingOptions: Maybe<AssignmentRoutingOptions>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of RemoveCalendarEventUsers */
export type RemoveCalendarEventUsersInput = {
  /** the calendar event id */
  calendarEventId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** the user ids */
  userIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of RemoveCalendarEventUsers. */
export type RemoveCalendarEventUsersPayload = {
  __typename?: 'RemoveCalendarEventUsersPayload';
  /** the calendar event */
  calendarEvent: CalendarEvent;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of RemoveCampaignParticipant */
export type RemoveCampaignParticipantInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** User ID */
  userId: Scalars['ID'];
};

/** Autogenerated return type of RemoveCampaignParticipant. */
export type RemoveCampaignParticipantPayload = {
  __typename?: 'RemoveCampaignParticipantPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Participant/User info */
  user: Maybe<User>;
};

/** Autogenerated input type of RemoveCustomFormFieldById */
export type RemoveCustomFormFieldByIdInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customFormFieldId: Scalars['ID'];
};

/** Autogenerated return type of RemoveCustomFormFieldById. */
export type RemoveCustomFormFieldByIdPayload = {
  __typename?: 'RemoveCustomFormFieldByIdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  customForm: CustomForm;
};

/** Autogenerated input type of RemoveEntitiesFromActionAssignmentGroup */
export type RemoveEntitiesFromActionAssignmentGroupInput = {
  /** Action assignment group ID */
  actionAssignmentGroupId: Scalars['ID'];
  /** Action ID */
  actionId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of entities IDs to be removed */
  entityIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of RemoveEntitiesFromActionAssignmentGroup. */
export type RemoveEntitiesFromActionAssignmentGroupPayload = {
  __typename?: 'RemoveEntitiesFromActionAssignmentGroupPayload';
  /** The action_assignment group created */
  actionAssignmentGroup: Maybe<ActionAssignmentGroup>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of RemoveEntitiesFromAction */
export type RemoveEntitiesFromActionInput = {
  /** An Action ID */
  actionId: Scalars['ID'];
  /** Campaign Id */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** A list of Entity IDs */
  entityIds?: Maybe<Array<Scalars['ID']>>;
};

/** Autogenerated return type of RemoveEntitiesFromAction. */
export type RemoveEntitiesFromActionPayload = {
  __typename?: 'RemoveEntitiesFromActionPayload';
  /** An action */
  action: Maybe<Action>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of RemoveEntitiesFromCampaigns */
export type RemoveEntitiesFromCampaignsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of entities to remove from campaigns */
  entities: Array<RemoveEntitiesFromCampaignsPayloadInput>;
};

export type RemoveEntitiesFromCampaignsOperation = {
  __typename?: 'RemoveEntitiesFromCampaignsOperation';
  completedAt: Maybe<Scalars['Time']>;
  createdAt: Scalars['Time'];
  createdBy: UserPublic;
  id: Scalars['ID'];
  notFoundIds: Array<Scalars['String']>;
  removalCounts: Array<RemoveEntitiesFromCampaignsOperationRemovalCounts>;
  status: Maybe<RemoveEntitiesFromCampaignsOperationStatusTypes>;
  totalNotFound: Scalars['Int'];
  totalProcessed: Scalars['Int'];
  totalSent: Scalars['Int'];
  updatedAt: Scalars['Time'];
};

/** The connection type for RemoveEntitiesFromCampaignsOperation. */
export type RemoveEntitiesFromCampaignsOperationConnection = {
  __typename?: 'RemoveEntitiesFromCampaignsOperationConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RemoveEntitiesFromCampaignsOperationEdge>>>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<RemoveEntitiesFromCampaignsOperation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type RemoveEntitiesFromCampaignsOperationEdge = {
  __typename?: 'RemoveEntitiesFromCampaignsOperationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<RemoveEntitiesFromCampaignsOperation>;
};

export type RemoveEntitiesFromCampaignsOperationRemovalCounts = {
  __typename?: 'RemoveEntitiesFromCampaignsOperationRemovalCounts';
  campaign: Campaign;
  entitiesRemoved: Scalars['Int'];
};

/** Remove entities from campaigns operations status types. */
export enum RemoveEntitiesFromCampaignsOperationStatusTypes {
  Done = 'done',
  InProgress = 'in_progress',
  Pending = 'pending'
}

/** Autogenerated return type of RemoveEntitiesFromCampaigns. */
export type RemoveEntitiesFromCampaignsPayload = {
  __typename?: 'RemoveEntitiesFromCampaignsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  errors: Maybe<Array<Scalars['String']>>;
  operationId: Maybe<Scalars['ID']>;
  success: Maybe<Scalars['Boolean']>;
};

/** Input for removing entities from campaigns */
export type RemoveEntitiesFromCampaignsPayloadInput = {
  /** The interact_id of the entity to remove */
  actionBuilderId: Scalars['String'];
  /** Whether to remove the entity from all campaigns */
  all?: Maybe<Scalars['Boolean']>;
  /** List of campaign IDs to remove the entity from */
  campaignIds?: Maybe<Array<Scalars['ID']>>;
};

/** Autogenerated input type of RemoveEntityCustomId */
export type RemoveEntityCustomIdInput = {
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of RemoveEntityCustomId. */
export type RemoveEntityCustomIdPayload = {
  __typename?: 'RemoveEntityCustomIdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of RemoveEntityFromCampaign */
export type RemoveEntityFromCampaignInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Entity ID */
  entityId: Scalars['ID'];
};

/** Autogenerated return type of RemoveEntityFromCampaign. */
export type RemoveEntityFromCampaignPayload = {
  __typename?: 'RemoveEntityFromCampaignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated entity */
  entity: Maybe<Entity>;
};

/** Autogenerated input type of RemoveMfa */
export type RemoveMfaInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** User ID to remove MFA from */
  userId: Scalars['ID'];
};

/** Autogenerated return type of RemoveMfa. */
export type RemoveMfaPayload = {
  __typename?: 'RemoveMfaPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** User with MFA removed */
  user: Maybe<User>;
};

/** Autogenerated input type of RemoveNotes */
export type RemoveNotesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** A list of note's IDs */
  noteIds: Array<Maybe<Scalars['ID']>>;
};

/** Autogenerated return type of RemoveNotes. */
export type RemoveNotesPayload = {
  __typename?: 'RemoveNotesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of RemoveSocialProfile */
export type RemoveSocialProfileInput = {
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  entityId: Scalars['ID'];
  socialProfileId: Scalars['ID'];
};

/** Autogenerated return type of RemoveSocialProfile. */
export type RemoveSocialProfilePayload = {
  __typename?: 'RemoveSocialProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  entity: Maybe<Entity>;
};

/** Autogenerated input type of RemoveTagCategoryFromCampaign */
export type RemoveTagCategoryFromCampaignInput = {
  /** A campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An tag category ID */
  tagCategoryId: Scalars['ID'];
};

/** Autogenerated return type of RemoveTagCategoryFromCampaign. */
export type RemoveTagCategoryFromCampaignPayload = {
  __typename?: 'RemoveTagCategoryFromCampaignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated tag category */
  tagCategory: Maybe<TagCategory>;
};

/** Autogenerated input type of RemoveUsersFromActionAssignmentGroup */
export type RemoveUsersFromActionAssignmentGroupInput = {
  /** The action assignment group id */
  actionAssignmentGroupId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** User IDs to remove */
  userIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of RemoveUsersFromActionAssignmentGroup. */
export type RemoveUsersFromActionAssignmentGroupPayload = {
  __typename?: 'RemoveUsersFromActionAssignmentGroupPayload';
  actionAssignmentGroup: Maybe<ActionAssignmentGroup>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of RenameTagGroup */
export type RenameTagGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Tag Group name. */
  name: Scalars['String'];
  /** Tag group id to be updated */
  tagGroupId: Scalars['ID'];
};

/** Autogenerated return type of RenameTagGroup. */
export type RenameTagGroupPayload = {
  __typename?: 'RenameTagGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The renamed tag group */
  tagGroup: Maybe<TagGroup>;
};

export type ReportFieldInput = {
  data?: Maybe<Scalars['JSON']>;
  field: Scalars['String'];
};

export type ReportInput = {
  campaignId?: Maybe<Scalars['ID']>;
  extraParams?: Maybe<Scalars['JSON']>;
  fields?: Maybe<Array<ReportFieldInput>>;
  queryJson?: Maybe<Scalars['String']>;
  reportType?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of ResendInvitation */
export type ResendInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Email */
  email: Scalars['String'];
};

/** Autogenerated return type of ResendInvitation. */
export type ResendInvitationPayload = {
  __typename?: 'ResendInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The invited user */
  user: Maybe<User>;
};

/** Autogenerated input type of ResendMfaCode */
export type ResendMfaCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ResendMfaCode. */
export type ResendMfaCodePayload = {
  __typename?: 'ResendMfaCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** User who received the code */
  user: Maybe<User>;
};

/** Data for resolving conflicts */
export type ResolveConflictInstructionsInput = {
  calendarEventResponses?: Maybe<Array<MergeInstructionsInput>>;
  core?: Maybe<Array<ResolveCoreFieldsInstructionsInput>>;
  entityConnections?: Maybe<Array<MergeInstructionsInput>>;
  entityCustomIds?: Maybe<Array<ResolveEntityCustomIdsConflictInstructionsInput>>;
  preferredLanguage?: Maybe<ResolvePreferredLanguageInstructionsInput>;
  taggableLogbooks?: Maybe<Array<ResolveTaggableLogbookConflictInstructionsInput>>;
};

/** Data for resolving core field conflicts */
export type ResolveCoreFieldsInstructionsInput = {
  property: Scalars['String'];
  resolveWith: Scalars['String'];
};

/** Data for resolving custom id conflicts */
export type ResolveEntityCustomIdsConflictInstructionsInput = {
  property: Scalars['String'];
  resolveWith: Scalars['String'];
};

/** Data for resolving preferred language conflicts */
export type ResolvePreferredLanguageInstructionsInput = {
  resolveWith: Scalars['String'];
};

/** Data for resolving taggable conflicts */
export type ResolveTaggableLogbookConflictInstructionsInput = {
  resolveWith: Scalars['String'];
  sourceTaggableLogbookId: Scalars['ID'];
  tagCategoryId: Scalars['ID'];
  targetTaggableLogbookId: Scalars['ID'];
};

/** Restrict property name type. */
export enum RestrictedExportingPropertyNameType {
  Age = 'age',
  DateOfBirth = 'date_of_birth',
  Emails = 'emails',
  HomeAddresses = 'home_addresses',
  Languages = 'languages',
  MostRecentAssessment = 'most_recent_assessment',
  MostRecentConnection = 'most_recent_connection',
  MostRecentNotes = 'most_recent_notes',
  Name = 'name',
  Nickname = 'nickname',
  PhoneNumbers = 'phone_numbers',
  PreferredLanguage = 'preferred_language',
  SocialProfile = 'social_profile',
  Tags = 'tags'
}

export type RestrictedExportingSettings = {
  __typename?: 'RestrictedExportingSettings';
  properties: Array<RestrictedExportingPropertyNameType>;
  specializedExportsDisabled: Scalars['Boolean'];
  tagCategoryIds: Array<Scalars['String']>;
};

/** Autogenerated input type of RevertAddress */
export type RevertAddressInput = {
  /** Address ID */
  addressId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Entity ID */
  entityId: Scalars['ID'];
};

/** Autogenerated return type of RevertAddress. */
export type RevertAddressPayload = {
  __typename?: 'RevertAddressPayload';
  /** Reverted address */
  address: Maybe<Address>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of RevokeAPIKey */
export type RevokeApiKeyInput = {
  /** The API key you want to revoke */
  apiKey: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The API key target */
  target: ApiKeyTarget;
};

/** Autogenerated return type of RevokeAPIKey. */
export type RevokeApiKeyPayload = {
  __typename?: 'RevokeAPIKeyPayload';
  apiKey: ApiKey;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** A Saved query */
export type SavedQuery = {
  __typename?: 'SavedQuery';
  body: Scalars['JSON'];
  campaign: CampaignPublic;
  canEdit: Scalars['Boolean'];
  createdAt: Scalars['Time'];
  defaultQuery: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  ownedByCurrentUser: Scalars['Boolean'];
  public: Maybe<Scalars['Boolean']>;
  queryType: QueryTypesType;
  updatedAt: Scalars['Time'];
  user: UserPublic;
};

/** The connection type for SavedQuery. */
export type SavedQueryConnection = {
  __typename?: 'SavedQueryConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SavedQueryEdge>>>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<SavedQuery>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type SavedQueryEdge = {
  __typename?: 'SavedQueryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<SavedQuery>;
};

export type SearchLocationResultItem = {
  __typename?: 'SearchLocationResultItem';
  /** Result item type e.g. New York, NY */
  text: Scalars['String'];
  /** Item type: city_state, state or zip */
  type: Scalars['String'];
  /** Result item type e.g. New York, NY */
  value: Scalars['String'];
};

/** Autogenerated input type of SetAssessmentInfo */
export type SetAssessmentInfoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Levels colors between 1 and 20 (e.g. ["1", "2", "5"]) */
  colors: Array<Scalars['String']>;
  /** Levels labels */
  descriptions: Array<Scalars['String']>;
  /** Detailed descriptions */
  detailedDescriptions: Array<Scalars['String']>;
  /** Number of levels (can only be incremented unless if default is true) */
  numberOfLevels: Scalars['Int'];
};

/** Autogenerated return type of SetAssessmentInfo. */
export type SetAssessmentInfoPayload = {
  __typename?: 'SetAssessmentInfoPayload';
  /** The updated assessment levels */
  assessmentInfo: AssessmentInfo;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of SetAssessmentOverrides */
export type SetAssessmentOverridesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Levels labels */
  descriptions: Array<Scalars['String']>;
  /** Detailed descriptions */
  detailedDescriptions: Array<Scalars['String']>;
  /** Override Entity Type Id */
  entityTypeId: Scalars['ID'];
};

/** Autogenerated return type of SetAssessmentOverrides. */
export type SetAssessmentOverridesPayload = {
  __typename?: 'SetAssessmentOverridesPayload';
  /** The full updated assessment levels setting object */
  assessmentInfo: AssessmentInfo;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of SetCalendarEventResponse */
export type SetCalendarEventResponseInput = {
  /** id of the event */
  calendarEventId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** id of entity being updated */
  entityId: Scalars['ID'];
  /** The status for the response */
  status: CalendarEventResponseStatusEnum;
};

/** Autogenerated return type of SetCalendarEventResponse. */
export type SetCalendarEventResponsePayload = {
  __typename?: 'SetCalendarEventResponsePayload';
  calendarEventResponse: CalendarEventResponse;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of SetUsersDisableOnDate */
export type SetUsersDisableOnDateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Date to disable users. null to toggle it off */
  disableOn?: Maybe<Scalars['ISO8601DateTime']>;
  /** User ID */
  userIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of SetUsersDisableOnDate. */
export type SetUsersDisableOnDatePayload = {
  __typename?: 'SetUsersDisableOnDatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated users */
  users: Array<User>;
};

export type Shift = {
  __typename?: 'Shift';
  createdAt: Scalars['Time'];
  createdBy: UserPublic;
  id: Scalars['ID'];
  shiftDays: Maybe<Array<Maybe<Scalars['String']>>>;
  shiftTimes: Maybe<Array<Maybe<ShiftTime>>>;
  target: Maybe<TaggableLogbook>;
  timezone: Maybe<Scalars['String']>;
  updatedAt: Scalars['Time'];
};

/** Shift input. */
export type ShiftInput = {
  /** List of shift times */
  shiftTimes?: Maybe<Array<ShiftTimeInput>>;
  timezone: Scalars['String'];
};

/** CSV import shift mapping type */
export type ShiftMapping = {
  __typename?: 'ShiftMapping';
  friday: Maybe<Array<PropertyMapping>>;
  monday: Maybe<Array<PropertyMapping>>;
  saturday: Maybe<Array<PropertyMapping>>;
  sunday: Maybe<Array<PropertyMapping>>;
  thursday: Maybe<Array<PropertyMapping>>;
  timezone: PropertyMapping;
  tuesday: Maybe<Array<PropertyMapping>>;
  wednesday: Maybe<Array<PropertyMapping>>;
};

export type ShiftMappingInput = {
  friday?: Maybe<Array<PropertyMappingInput>>;
  monday?: Maybe<Array<PropertyMappingInput>>;
  saturday?: Maybe<Array<PropertyMappingInput>>;
  sunday?: Maybe<Array<PropertyMappingInput>>;
  thursday?: Maybe<Array<PropertyMappingInput>>;
  timezone: PropertyMappingInput;
  tuesday?: Maybe<Array<PropertyMappingInput>>;
  wednesday?: Maybe<Array<PropertyMappingInput>>;
};

export type ShiftTag = Tag & {
  __typename?: 'ShiftTag';
  archived: Maybe<Scalars['Boolean']>;
  associatedCampaignIds: Array<Maybe<Scalars['String']>>;
  /** Attachments are allowed on tag */
  attachmentsEnabled: Maybe<Scalars['Boolean']>;
  campaignContextId: Maybe<Scalars['String']>;
  category: TagCategory;
  createdAt: Scalars['Time'];
  group: TagGroup;
  id: Scalars['ID'];
  isInCampaign: Maybe<Scalars['Boolean']>;
  isUniversal: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  readonly: Scalars['Boolean'];
  tagType: TagType;
  targetType: TagTargetAssociation;
  updatedAt: Scalars['Time'];
};


export type ShiftTagIsInCampaignArgs = {
  campaignId?: Maybe<Scalars['ID']>;
};

export type ShiftTime = {
  __typename?: 'ShiftTime';
  createdAt: Scalars['Time'];
  dayOfWeek: Scalars['String'];
  endTime: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  shift: Shift;
  shiftId: Scalars['String'];
  startTime: Maybe<Scalars['String']>;
  timezone: Maybe<Scalars['String']>;
  updatedAt: Scalars['Time'];
};

/** ShiftTime input */
export type ShiftTimeInput = {
  dayOfWeek: Scalars['String'];
  endTime?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
};

export type SocialNetwork = {
  __typename?: 'SocialNetwork';
  allowUrls: Scalars['Boolean'];
  icon: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
  labelRequired: Scalars['Boolean'];
};

export type SocialProfile = {
  __typename?: 'SocialProfile';
  createdAt: Scalars['Time'];
  createdBy: UserPublic;
  id: Scalars['ID'];
  label: Maybe<Scalars['String']>;
  profile: Scalars['String'];
  socialNetwork: SocialNetwork;
  source: FieldSource;
  status: FieldStatus;
  updatedAt: Scalars['Time'];
  updatedBy: Maybe<UserPublic>;
};

/** CSV import Social Profile mapping type */
export type SocialProfileMapping = {
  __typename?: 'SocialProfileMapping';
  label: Maybe<PropertyMapping>;
  profile: PropertyMapping;
  socialNetworkType: PropertyMapping;
};

export type SocialProfileMappingInput = {
  label?: Maybe<PropertyMappingInput>;
  profile: PropertyMappingInput;
  socialNetworkType: PropertyMappingInput;
};

/** Social Profile input */
export type SocialProfileQueryInput = {
  operator?: Maybe<QueryFilterOperator>;
  socialNetworkTypes?: Maybe<Array<Scalars['String']>>;
  verifiedOnly?: Maybe<Scalars['Boolean']>;
};

export type StandardTag = Tag & {
  __typename?: 'StandardTag';
  archived: Maybe<Scalars['Boolean']>;
  associatedCampaignIds: Array<Maybe<Scalars['String']>>;
  /** Attachments are allowed on tag */
  attachmentsEnabled: Maybe<Scalars['Boolean']>;
  campaignContextId: Maybe<Scalars['String']>;
  category: TagCategory;
  createdAt: Scalars['Time'];
  group: TagGroup;
  id: Scalars['ID'];
  isInCampaign: Maybe<Scalars['Boolean']>;
  isUniversal: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  readonly: Scalars['Boolean'];
  tagType: TagType;
  targetType: TagTargetAssociation;
  updatedAt: Scalars['Time'];
};


export type StandardTagIsInCampaignArgs = {
  campaignId?: Maybe<Scalars['ID']>;
};

/** Autogenerated input type of StartMfaSetup */
export type StartMfaSetupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** MFA method to set up */
  mfaMethod: MfaMethod;
  /** Phone number for SMS (E.164 format) */
  phoneNumber?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of StartMfaSetup. */
export type StartMfaSetupPayload = {
  __typename?: 'StartMfaSetupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Created MFA factor (unverified) */
  mfaFactor: Maybe<MfaFactor>;
  /** TOTP provisioning URI */
  provisioningUri: Maybe<Scalars['String']>;
  /** QR code SVG for TOTP setup */
  qrCodeSvg: Maybe<Scalars['String']>;
  /** TOTP secret key (shown once during setup) */
  secret: Maybe<Scalars['String']>;
  /** User starting MFA setup */
  user: Maybe<User>;
};

/** Autogenerated input type of SubscribeEmail */
export type SubscribeEmailInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Email ID */
  emailId: Scalars['ID'];
  /** Entity Id */
  entityId: Scalars['ID'];
  /** Subscribe it? */
  subscribe: Scalars['Boolean'];
};

/** Autogenerated return type of SubscribeEmail. */
export type SubscribeEmailPayload = {
  __typename?: 'SubscribeEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated email */
  email: Maybe<Email>;
};

/** Autogenerated input type of SubscribePhoneNumber */
export type SubscribePhoneNumberInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Entity ID */
  entityId: Scalars['ID'];
  /** Phone Number ID */
  phoneNumberId: Scalars['ID'];
  /** Subscribe it? */
  subscribe: Scalars['Boolean'];
};

/** Autogenerated return type of SubscribePhoneNumber. */
export type SubscribePhoneNumberPayload = {
  __typename?: 'SubscribePhoneNumberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated phone number */
  phoneNumber: Maybe<PhoneNumber>;
};

/** A Tag */
export type Tag = {
  archived: Maybe<Scalars['Boolean']>;
  associatedCampaignIds: Array<Maybe<Scalars['String']>>;
  /** Attachments are allowed on tag */
  attachmentsEnabled: Maybe<Scalars['Boolean']>;
  campaignContextId: Maybe<Scalars['String']>;
  category: TagCategory;
  createdAt: Scalars['Time'];
  group: TagGroup;
  id: Scalars['ID'];
  isInCampaign: Maybe<Scalars['Boolean']>;
  isUniversal: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  readonly: Scalars['Boolean'];
  tagType: TagType;
  targetType: TagTargetAssociation;
  updatedAt: Scalars['Time'];
};


/** A Tag */
export type TagIsInCampaignArgs = {
  campaignId?: Maybe<Scalars['ID']>;
};

/** A Tag Category */
export type TagCategory = {
  __typename?: 'TagCategory';
  allowToCreateTagType: TagType;
  associatedCampaignIds: Array<Maybe<Scalars['String']>>;
  /** Attachments are allowed on category */
  attachmentsEnabled: Scalars['Boolean'];
  campaignContextId: Maybe<Scalars['String']>;
  createdAt: Scalars['Time'];
  group: TagGroup;
  groupName: Scalars['String'];
  /** Checks if the category has active tags, impacted by campaignContextId */
  hasActiveTags: Maybe<Scalars['Boolean']>;
  /** Checks if the category has archived tags, impacted by campaignContextId */
  hasArchivedTags: Maybe<Scalars['Boolean']>;
  /** Checks if the category has any tags, impacted by campaignContextId */
  hasAssociatedTags: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isInCampaign: Maybe<Scalars['Boolean']>;
  isUniversal: Scalars['Boolean'];
  locked: Scalars['Boolean'];
  multiselectSameTagBehavior: Maybe<TagCategorySameTagBehavior>;
  multiselectable: Scalars['Boolean'];
  name: Scalars['String'];
  readonly: Scalars['Boolean'];
  /** Returns all tags (in campaign if passed) for category (including archived) */
  tags: Array<Maybe<Tag>>;
  targetType: TagTargetAssociation;
  updatedAt: Scalars['Time'];
};


/** A Tag Category */
export type TagCategoryIsInCampaignArgs = {
  campaignId?: Maybe<Scalars['ID']>;
};

/** The connection type for TagCategory. */
export type TagCategoryConnection = {
  __typename?: 'TagCategoryConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TagCategoryEdge>>>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<TagCategory>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TagCategoryEdge = {
  __typename?: 'TagCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<TagCategory>;
};

/** Tag category multiselect_same_tag_behavior options. */
export enum TagCategorySameTagBehavior {
  /** Append */
  Append = 'append',
  /** Overwrite */
  Overwrite = 'overwrite'
}

/** The connection type for Tag. */
export type TagConnection = {
  __typename?: 'TagConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TagEdge>>>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Tag>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TagEdge = {
  __typename?: 'TagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<Tag>;
};

/** A Tag Group */
export type TagGroup = {
  __typename?: 'TagGroup';
  associatedCampaignIds: Array<Maybe<Scalars['String']>>;
  campaignContextId: Maybe<Scalars['String']>;
  categories: Maybe<Array<Maybe<TagCategory>>>;
  createdAt: Scalars['Time'];
  id: Scalars['ID'];
  isInCampaign: Maybe<Scalars['Boolean']>;
  isUniversal: Scalars['Boolean'];
  name: Scalars['String'];
  targetName: Scalars['String'];
  targetType: Maybe<TagTargetAssociation>;
  updatedAt: Scalars['Time'];
};


/** A Tag Group */
export type TagGroupIsInCampaignArgs = {
  campaignId?: Maybe<Scalars['ID']>;
};

/** The connection type for TagGroup. */
export type TagGroupConnection = {
  __typename?: 'TagGroupConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TagGroupEdge>>>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<TagGroup>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TagGroupEdge = {
  __typename?: 'TagGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<TagGroup>;
};

/** CSV import tag mapping type */
export type TagMapping = {
  __typename?: 'TagMapping';
  note: Maybe<PropertyMapping>;
  shift: Maybe<ShiftMapping>;
  tagAddress: Maybe<AddressMapping>;
  tagCategoryId: PropertyMapping;
  tagName: PropertyMapping;
};

export type TagMappingInput = {
  note?: Maybe<PropertyMappingInput>;
  shift?: Maybe<ShiftMappingInput>;
  tagAddress?: Maybe<AddressMappingInput>;
  tagCategoryId: PropertyMappingInput;
  tagName: PropertyMappingInput;
};

/** The status of a tag or category, either archived or active */
export enum TagStatus {
  /** Active Status */
  Active = 'Active',
  /** Archived status */
  Archived = 'Archived'
}

export type TagTargetAssociation = CalendarEventType | EntityConnectionType | EntityType;

/** Tag types. */
export enum TagType {
  /** Address tag type */
  Address = 'Address',
  /** Date tag type */
  Date = 'Date',
  /** Notes tag type */
  Notes = 'Notes',
  /** Number tag type */
  Number = 'Number',
  /** Shift tag type */
  Shift = 'Shift',
  /** Signature tag type */
  Signature = 'Signature',
  /** Standard tag type */
  Standard = 'Standard'
}

export type TaggableConflicts = {
  __typename?: 'TaggableConflicts';
  sourceTaggableLogbookId: Scalars['ID'];
  tagCategoryId: Scalars['ID'];
  targetTaggableLogbookId: Scalars['ID'];
};

export type TaggableLogbook = {
  __typename?: 'TaggableLogbook';
  attachments: Array<Attachment>;
  available: Maybe<Scalars['Boolean']>;
  campaign: Maybe<CampaignPublic>;
  createdAt: Scalars['Time'];
  createdBy: UserPublic;
  deleted: Maybe<Scalars['Boolean']>;
  deletedAt: Maybe<Scalars['Time']>;
  deletedBy: Maybe<UserPublic>;
  id: Scalars['ID'];
  notes: Maybe<Array<Note>>;
  shift: Maybe<Shift>;
  tag: Tag;
  /** EntityType, EntityConnectionType, or CalendarEventType */
  targetType: Scalars['String'];
  updatedAt: Scalars['Time'];
};

/** A Task */
export type Task = {
  __typename?: 'Task';
  action: Maybe<Action>;
  actionEntity: Maybe<ActionEntity>;
  actionField: Maybe<ActionField>;
  createdAt: Scalars['Time'];
  entity: Maybe<Entity>;
  entityType: Maybe<EntityType>;
  id: Scalars['ID'];
  isOptional: Scalars['Boolean'];
  resolved: Scalars['Boolean'];
  resolvedAt: Maybe<Scalars['Time']>;
  updatedAt: Scalars['Time'];
};

/** Task Object types Type */
export enum TaskObjectTypes {
  Address = 'Address',
  Assessment = 'Assessment',
  CalendarEventResponse = 'CalendarEventResponse',
  Email = 'Email',
  Entity = 'Entity',
  EntityConnection = 'EntityConnection',
  EntityLanguage = 'EntityLanguage',
  GlobalNote = 'GlobalNote',
  PhoneNumber = 'PhoneNumber',
  Relationship = 'Relationship',
  SocialNetwork = 'SocialNetwork',
  TaggableLogbook = 'TaggableLogbook'
}

/** Task Related Object types Type */
export enum TaskRelatedObjectTypes {
  CalendarEvent = 'CalendarEvent',
  CalendarEventAction = 'CalendarEventAction',
  EntityConnectionType = 'EntityConnectionType',
  TagCategory = 'TagCategory'
}


export type ToplineAge = {
  __typename?: 'ToplineAge';
  age: Maybe<Scalars['String']>;
  dateOfBirth: Maybe<Scalars['Date']>;
};

export type ToplineAppliedEntityConnections = {
  __typename?: 'ToplineAppliedEntityConnections';
  entityConnections: Maybe<Array<Maybe<EntityConnection>>>;
};

export type ToplineAppliedTags = {
  __typename?: 'ToplineAppliedTags';
  appliedTags: Maybe<Array<TaggableLogbook>>;
};

export type ToplinePreferredLanguage = {
  __typename?: 'ToplinePreferredLanguage';
  entityLanguages: Maybe<Array<EntityLanguage>>;
};

/** campaign_topline_settings_item type */
export type ToplineSettingItem = {
  __typename?: 'ToplineSettingItem';
  entityConnectionType: Maybe<EntityConnectionType>;
  itemId: Maybe<Scalars['ID']>;
  itemType: CampaignToplineSettingItemTypes;
  position: Scalars['Int'];
  socialNetwork: Maybe<SocialNetwork>;
  tagCategory: Maybe<TagCategory>;
};

export type TurfAssignment = {
  __typename?: 'TurfAssignment';
  campaign: Maybe<CampaignPublic>;
  id: Scalars['ID'];
  restrictionEnabled: Maybe<Scalars['Boolean']>;
  turfTags: Maybe<Array<Maybe<TurfTag>>>;
  user: Maybe<UserPublic>;
};

export type TurfTag = {
  __typename?: 'TurfTag';
  id: Scalars['ID'];
  tag: Maybe<Tag>;
  turfAssignment: Maybe<TurfAssignment>;
};

/** Autogenerated input type of UnapplyCalendarEventResponseTag */
export type UnapplyCalendarEventResponseTagInput = {
  /** Campaign Id (optional) */
  campaignId?: Maybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** taggable_logbook ID */
  taggableLogbookId: Scalars['ID'];
};

/** Autogenerated return type of UnapplyCalendarEventResponseTag. */
export type UnapplyCalendarEventResponseTagPayload = {
  __typename?: 'UnapplyCalendarEventResponseTagPayload';
  /** The calendar event response */
  calendarEventResponse: Maybe<CalendarEventResponse>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UnapplyEntityConnectionTag */
export type UnapplyEntityConnectionTagInput = {
  /** Campaign Id (optional) */
  campaignId?: Maybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** taggable_logbook ID */
  taggableLogbookId: Scalars['ID'];
};

/** Autogenerated return type of UnapplyEntityConnectionTag. */
export type UnapplyEntityConnectionTagPayload = {
  __typename?: 'UnapplyEntityConnectionTagPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The entity the tag was applied to */
  entityConnection: Maybe<EntityConnection>;
};

/** Autogenerated input type of UnapplyTag */
export type UnapplyTagInput = {
  /** Campaign Id (optional) */
  campaignId?: Maybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** taggable_logbook ID */
  taggableLogbookId: Scalars['ID'];
};

/** Autogenerated return type of UnapplyTag. */
export type UnapplyTagPayload = {
  __typename?: 'UnapplyTagPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The entity the tag was applied to */
  entity: Maybe<Entity>;
};

/** Autogenerated input type of UnassociateTagFromCampaign */
export type UnassociateTagFromCampaignInput = {
  /** Campaign ID to associate to the tag */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The Tag id */
  tagId: Scalars['ID'];
};

/** Autogenerated return type of UnassociateTagFromCampaign. */
export type UnassociateTagFromCampaignPayload = {
  __typename?: 'UnassociateTagFromCampaignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated Tag */
  tag: Maybe<Tag>;
};

/** Autogenerated input type of UnlinkEventFromActionNetwork */
export type UnlinkEventFromActionNetworkInput = {
  /** The id of the calendar event */
  calendarEventId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UnlinkEventFromActionNetwork. */
export type UnlinkEventFromActionNetworkPayload = {
  __typename?: 'UnlinkEventFromActionNetworkPayload';
  /** The updated calendar event */
  calendarEvent: CalendarEvent;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UnpinNote */
export type UnpinNoteInput = {
  /** Campaign Id */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Note Id to be pinned */
  noteId: Scalars['ID'];
};

/** Autogenerated return type of UnpinNote. */
export type UnpinNotePayload = {
  __typename?: 'UnpinNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Unpinned note */
  note: Note;
};

/** Autogenerated input type of UpdateActionAssignmentGroup */
export type UpdateActionAssignmentGroupInput = {
  /** action_assignment_group ID */
  actionAssignmentGroupId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Action assignment group name */
  name?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateActionAssignmentGroup. */
export type UpdateActionAssignmentGroupPayload = {
  __typename?: 'UpdateActionAssignmentGroupPayload';
  /** The action_assignment group updated */
  actionAssignmentGroup: Maybe<ActionAssignmentGroup>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateActionField */
export type UpdateActionFieldInput = {
  /** ActionField ID */
  actionFieldId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** A Tag ID */
  defaultResponseId?: Maybe<Scalars['ID']>;
  /** Whether the action_field is optional */
  isOptional?: Maybe<Scalars['Boolean']>;
  /** Enable/disable quick check-in for this action field */
  quickCheckIn?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of UpdateActionField. */
export type UpdateActionFieldPayload = {
  __typename?: 'UpdateActionFieldPayload';
  /** The action_field to be updated */
  action: Maybe<Action>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateActionFieldsPositions */
export type UpdateActionFieldsPositionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** A list of action_field IDs */
  positions: Array<Scalars['ID']>;
};

/** Autogenerated return type of UpdateActionFieldsPositions. */
export type UpdateActionFieldsPositionsPayload = {
  __typename?: 'UpdateActionFieldsPositionsPayload';
  /** The affected action_fields */
  actionFields: Maybe<Array<ActionField>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateAction */
export type UpdateActionInput = {
  /** Action Id */
  actionId: Scalars['ID'];
  /** Campaign Id */
  campaignId: Scalars['ID'];
  /** Changes on action */
  changes: ActionChangesInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateAction. */
export type UpdateActionPayload = {
  __typename?: 'UpdateActionPayload';
  /** The action to be updated */
  action: Maybe<Action>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateAddressGeolocation */
export type UpdateAddressGeolocationInput = {
  /** Geolocation accuracy */
  accuracy?: Maybe<Scalars['Float']>;
  /** Geolocation accuracy type */
  accuracyType?: Maybe<Scalars['String']>;
  /** An address ID */
  addressId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Whether geolocation data is bad */
  geocodeBad: Scalars['Boolean'];
  /** Latitude */
  latitude?: Maybe<Scalars['Float']>;
  /** Longitude */
  longitude?: Maybe<Scalars['Float']>;
  /** Geolocation source */
  source?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateAddressGeolocation. */
export type UpdateAddressGeolocationPayload = {
  __typename?: 'UpdateAddressGeolocationPayload';
  /** An address */
  address: Maybe<Address>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateAddress */
export type UpdateAddressInput = {
  /** Address ID */
  addressId: Scalars['ID'];
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** Changes on address */
  changes: AddressChangesInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Entity ID */
  entityId: Scalars['ID'];
};

/** Autogenerated return type of UpdateAddress. */
export type UpdateAddressPayload = {
  __typename?: 'UpdateAddressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated entity */
  entity: Maybe<Entity>;
};

/** Autogenerated input type of UpdateAddressTag */
export type UpdateAddressTagInput = {
  /** The address tag */
  address?: Maybe<AddressInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Tag name */
  name?: Maybe<Scalars['String']>;
  /** Tag id */
  tagId: Scalars['ID'];
};

/** Autogenerated return type of UpdateAddressTag. */
export type UpdateAddressTagPayload = {
  __typename?: 'UpdateAddressTagPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The new tag */
  tag: Maybe<AddressTag>;
};

/** Autogenerated input type of UpdateAssignmentGroupEntitiesByQuery */
export type UpdateAssignmentGroupEntitiesByQueryInput = {
  /** Action Assignment Group Id */
  actionAssignmentGroupId: Scalars['ID'];
  /** Action Id */
  actionId: Scalars['ID'];
  /** Campaign Id */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Query to be used */
  queryJson: Scalars['String'];
};

/** Autogenerated return type of UpdateAssignmentGroupEntitiesByQuery. */
export type UpdateAssignmentGroupEntitiesByQueryPayload = {
  __typename?: 'UpdateAssignmentGroupEntitiesByQueryPayload';
  /** The updated group */
  actionAssignmentGroup: Maybe<ActionAssignmentGroup>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateAssignmentGroupUserRouting */
export type UpdateAssignmentGroupUserRoutingInput = {
  /** Id of the assignment group to route */
  actionAssignmentGroupId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Route end address */
  endAddress?: Maybe<AddressInput>;
  /** Whether to exclude entities where all tasks are completed */
  excludeCompletedActions: Scalars['Boolean'];
  /** Route start address */
  startAddress?: Maybe<AddressInput>;
  /** If provided, will update route for given user id.(If admin or lead) Otherwise, will update route for logged in user */
  userId?: Maybe<Scalars['ID']>;
};

/** Autogenerated return type of UpdateAssignmentGroupUserRouting. */
export type UpdateAssignmentGroupUserRoutingPayload = {
  __typename?: 'UpdateAssignmentGroupUserRoutingPayload';
  /** Updated Assignment Routing Options */
  assignmentRoutingOptions: Maybe<AssignmentRoutingOptions>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateCalendarEventActionScheduledDays */
export type UpdateCalendarEventActionScheduledDaysInput = {
  /** the calendar event action id */
  calendarEventActionId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** number of days fromt he start of the event create the action, or null to not create the action */
  scheduledCreateDaysOut?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of UpdateCalendarEventActionScheduledDays. */
export type UpdateCalendarEventActionScheduledDaysPayload = {
  __typename?: 'UpdateCalendarEventActionScheduledDaysPayload';
  /** the updated calendar event action */
  calendarEventAction: CalendarEventAction;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateCalendarEvent */
export type UpdateCalendarEventInput = {
  /** This column determines if canvassing is enabled when creating tasks and what type of canvassing it will be, if [null] use standard type, if not provided at all use default type. */
  actionCanvassingType?: Maybe<Array<Maybe<CanvassingTypes>>>;
  /** Address of the location */
  address?: Maybe<AddressInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** text description of the event */
  description?: Maybe<Scalars['String']>;
  /** start date and time of the event */
  endDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** The id of the event */
  id: Scalars['ID'];
  /** This string will be used to include a link to the virtual event, or other information */
  locationNote?: Maybe<Scalars['String']>;
  /** Enum of 'InPerson' or 'Virtual' */
  locationType?: Maybe<CalendarEventLocationTypeEnum>;
  /** name of the event */
  name?: Maybe<Scalars['String']>;
  /** start date and time of the event */
  startDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** ISO-8601 timezone of the event */
  timeZone?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateCalendarEvent. */
export type UpdateCalendarEventPayload = {
  __typename?: 'UpdateCalendarEventPayload';
  /** The updated calendar event */
  calendarEvent: CalendarEvent;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateCampaignEntityConnectionTypeConfiguration */
export type UpdateCampaignEntityConnectionTypeConfigurationInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  campaignToplineSettingItems?: Maybe<Array<CampaignToplineSettingItemInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of tag category ids */
  defaultTagCategoryIds?: Maybe<Array<Scalars['ID']>>;
  /** EntityConnectionType ID */
  entityConnectionTypeId: Scalars['ID'];
};

/** Autogenerated return type of UpdateCampaignEntityConnectionTypeConfiguration. */
export type UpdateCampaignEntityConnectionTypeConfigurationPayload = {
  __typename?: 'UpdateCampaignEntityConnectionTypeConfigurationPayload';
  campaignEntityConnectionTypeConfiguration: Maybe<CampaignEntityConnectionTypeConfiguration>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateCampaignEntityTypeConfiguration */
export type UpdateCampaignEntityTypeConfigurationInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  campaignToplineSettingItems?: Maybe<Array<CampaignToplineSettingItemInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  creationCustomFormId?: Maybe<Scalars['ID']>;
  /** Custom form ID */
  customFormId?: Maybe<Scalars['ID']>;
  /** Array of tag category ids */
  defaultTagCategoryIds?: Maybe<Array<Scalars['ID']>>;
  /** EntityType ID */
  entityTypeId: Scalars['ID'];
  spotlightSettings?: Maybe<CampaignEntitySpotlightSettingsInput>;
};

/** Autogenerated return type of UpdateCampaignEntityTypeConfiguration. */
export type UpdateCampaignEntityTypeConfigurationPayload = {
  __typename?: 'UpdateCampaignEntityTypeConfigurationPayload';
  campaignEntityTypeConfiguration: Maybe<CampaignEntityTypeConfiguration>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateCampaignExportRestrictions */
export type UpdateCampaignExportRestrictionsInput = {
  /** Campaign Id */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Properties allowed to be exported */
  properties: Array<RestrictedExportingPropertyNameType>;
  /** Are specalized exports disabled? */
  specializedExportsDisabled: Scalars['Boolean'];
  /** Tag category ids allowed to be exported, if blank all categories can be exported */
  tagCategoryIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of UpdateCampaignExportRestrictions. */
export type UpdateCampaignExportRestrictionsPayload = {
  __typename?: 'UpdateCampaignExportRestrictionsPayload';
  /** Updated campaign */
  campaign: Maybe<Campaign>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateCampaign */
export type UpdateCampaignInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** Changes on campaign */
  changes: CampaignChangesInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateCampaign. */
export type UpdateCampaignPayload = {
  __typename?: 'UpdateCampaignPayload';
  /** The updated campaign */
  campaign: Maybe<Campaign>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateCurrentUser */
export type UpdateCurrentUserInput = {
  /** Add the user as participant in these campaigns */
  addCampaigns?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Enable/disable API access */
  apiAccess?: Maybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** First name */
  firstName?: Maybe<Scalars['String']>;
  /** Last name */
  lastName?: Maybe<Scalars['String']>;
  /** Phone number */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Remove the user as a participant in these campaigns */
  removeCampaigns?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Turf Assignments JSON object */
  turfAssignments?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateCurrentUser. */
export type UpdateCurrentUserPayload = {
  __typename?: 'UpdateCurrentUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated user */
  user: Maybe<User>;
};

/** Autogenerated input type of UpdateCustomFormFieldPositions */
export type UpdateCustomFormFieldPositionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customFormId: Scalars['ID'];
  /** A list of custom_form_field IDs */
  positions: Array<Scalars['ID']>;
};

/** Autogenerated return type of UpdateCustomFormFieldPositions. */
export type UpdateCustomFormFieldPositionsPayload = {
  __typename?: 'UpdateCustomFormFieldPositionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  customForm: CustomForm;
};

/** Autogenerated input type of UpdateCustomFormFields */
export type UpdateCustomFormFieldsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customFormId: Scalars['ID'];
  fields: Array<CustomFormFieldInput>;
};

/** Autogenerated return type of UpdateCustomFormFields. */
export type UpdateCustomFormFieldsPayload = {
  __typename?: 'UpdateCustomFormFieldsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  customForm: CustomForm;
};

/** Autogenerated input type of UpdateCustomForm */
export type UpdateCustomFormInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customFormId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateCustomForm. */
export type UpdateCustomFormPayload = {
  __typename?: 'UpdateCustomFormPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  customForm: CustomForm;
};

/** Autogenerated input type of UpdateCustomId */
export type UpdateCustomIdInput = {
  active?: Maybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internalName?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateCustomId. */
export type UpdateCustomIdPayload = {
  __typename?: 'UpdateCustomIdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  customIdType: CustomIdType;
};

/** Autogenerated input type of UpdateEmail */
export type UpdateEmailInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** Changes on email */
  changes: EmailChangesInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Email ID */
  emailId: Scalars['ID'];
  /** Entity ID */
  entityId: Scalars['ID'];
};

/** Autogenerated return type of UpdateEmail. */
export type UpdateEmailPayload = {
  __typename?: 'UpdateEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated entity */
  entity: Maybe<Entity>;
};

/** Autogenerated input type of UpdateEntitiesOnActionByQuery */
export type UpdateEntitiesOnActionByQueryInput = {
  /** Action Id */
  actionId: Scalars['ID'];
  /** Campaign Id */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Query to be used */
  queryJson: Scalars['String'];
};

/** Autogenerated return type of UpdateEntitiesOnActionByQuery. */
export type UpdateEntitiesOnActionByQueryPayload = {
  __typename?: 'UpdateEntitiesOnActionByQueryPayload';
  /** The action to be updated */
  action: Maybe<Action>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateEntityConnection */
export type UpdateEntityConnectionInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** entity_connection ID */
  entityConnectionId: Scalars['ID'];
  /** Whether this entity_connection is active */
  status: Scalars['Boolean'];
};

/** Autogenerated return type of UpdateEntityConnection. */
export type UpdateEntityConnectionPayload = {
  __typename?: 'UpdateEntityConnectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated connection_entity */
  entityConnection: Maybe<EntityConnection>;
};

/** Autogenerated input type of UpdateEntityConnectionType */
export type UpdateEntityConnectionTypeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Allowed values: above, below */
  displayPosition: Scalars['String'];
  /** entity_connection_type ID */
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateEntityConnectionType. */
export type UpdateEntityConnectionTypePayload = {
  __typename?: 'UpdateEntityConnectionTypePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated entity_connection_type */
  entityConnectionType: Maybe<EntityConnectionType>;
};

/** Autogenerated input type of UpdateEntityCustomId */
export type UpdateEntityCustomIdInput = {
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  value?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateEntityCustomId. */
export type UpdateEntityCustomIdPayload = {
  __typename?: 'UpdateEntityCustomIdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  entityCustomId: Maybe<EntityCustomId>;
};

/** Autogenerated input type of UpdateEntity */
export type UpdateEntityInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** Changes on entity */
  changes: EntityChangesInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Entity ID */
  entityId: Scalars['ID'];
};

/** Autogenerated return type of UpdateEntity. */
export type UpdateEntityPayload = {
  __typename?: 'UpdateEntityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated entity */
  entity: Maybe<Entity>;
};

/** Autogenerated input type of UpdateEntityPronouns */
export type UpdateEntityPronounsInput = {
  /** Campaign Id */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Entity Id */
  entityId: Scalars['ID'];
  pronouns?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateEntityPronouns. */
export type UpdateEntityPronounsPayload = {
  __typename?: 'UpdateEntityPronounsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated entity */
  entity: Maybe<Entity>;
};

/** Autogenerated input type of UpdateEntityType */
export type UpdateEntityTypeInput = {
  /** Changes on EntityType */
  changes: EntityTypeChangesInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** EntityType ID */
  entityTypeId: Scalars['ID'];
};

/** Autogenerated return type of UpdateEntityType. */
export type UpdateEntityTypePayload = {
  __typename?: 'UpdateEntityTypePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The new entity type */
  entityType: Maybe<EntityType>;
};

/** Autogenerated input type of UpdateExternalService */
export type UpdateExternalServiceInput = {
  /** Client Id */
  clientId: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Client Secret */
  clientSecret: Scalars['String'];
  /** External Service Id */
  id: Scalars['ID'];
  /** Workflow Id */
  workflowId: Scalars['String'];
};

/** Autogenerated return type of UpdateExternalService. */
export type UpdateExternalServicePayload = {
  __typename?: 'UpdateExternalServicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The service to be updated */
  externalService: Maybe<ExternalService>;
};

/** Autogenerated input type of UpdateFollowUp */
export type UpdateFollowUpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Due date for the follow up */
  dueDate?: Maybe<Scalars['Date']>;
  /** ID of the follow up */
  followUpId: Scalars['ID'];
};

/** Autogenerated return type of UpdateFollowUp. */
export type UpdateFollowUpPayload = {
  __typename?: 'UpdateFollowUpPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Updated follow up */
  followUp: FollowUp;
};

/** Autogenerated input type of UpdateImport */
export type UpdateImportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Import Id */
  importId: Scalars['ID'];
  /** Upload visibility status */
  visibilityStatus?: Maybe<ImportVisibilityStatusType>;
};

/** Autogenerated return type of UpdateImport. */
export type UpdateImportPayload = {
  __typename?: 'UpdateImportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Updated file import */
  import: Maybe<Import>;
};

/** Autogenerated input type of UpdateIntegrations */
export type UpdateIntegrationsInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Enable? */
  enable: Scalars['Boolean'];
  /** External Service ID */
  externalServiceId: Scalars['ID'];
};

/** Autogenerated return type of UpdateIntegrations. */
export type UpdateIntegrationsPayload = {
  __typename?: 'UpdateIntegrationsPayload';
  /** Follow up status flag */
  campaign: Campaign;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateNote */
export type UpdateNoteInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** Changes on note */
  changes: NoteChangesInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Note ID */
  noteId: Scalars['ID'];
  /** Target type */
  targetType: NoteTarget;
};

/** Autogenerated return type of UpdateNote. */
export type UpdateNotePayload = {
  __typename?: 'UpdateNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Updated note on target */
  note: Note;
};

/** Autogenerated input type of UpdateOrganization */
export type UpdateOrganizationInput = {
  /** Administrator User ID */
  administratorUserId?: Maybe<Scalars['ID']>;
  /** Enable/disable API access */
  apiEnabled?: Maybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Organization default country. e.g. 'US' */
  defaultCountry?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateOrganizationMfaEnforcement */
export type UpdateOrganizationMfaEnforcementInput = {
  /** Allowed MFA methods (default: both SMS and TOTP) */
  allowedMethods?: Maybe<Array<Scalars['String']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Whether MFA is REQUIRED for all users. Note: Users who voluntarily enabled MFA will still need to use it even when false. */
  enforced: Scalars['Boolean'];
};

/** Autogenerated return type of UpdateOrganizationMfaEnforcement. */
export type UpdateOrganizationMfaEnforcementPayload = {
  __typename?: 'UpdateOrganizationMfaEnforcementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Updated organization */
  organization: Maybe<Organization>;
};

/** Autogenerated return type of UpdateOrganization. */
export type UpdateOrganizationPayload = {
  __typename?: 'UpdateOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated Organization */
  organization: Maybe<Organization>;
};

/** Autogenerated input type of UpdatePhoneNumber */
export type UpdatePhoneNumberInput = {
  /** Campaign ID */
  campaignId: Scalars['ID'];
  /** Changes on phone number */
  changes: PhoneNumberChangesInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Entity ID */
  entityId: Scalars['ID'];
  /** Phone number ID */
  phoneNumberId: Scalars['ID'];
};

/** Autogenerated return type of UpdatePhoneNumber. */
export type UpdatePhoneNumberPayload = {
  __typename?: 'UpdatePhoneNumberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated entity */
  entity: Maybe<Entity>;
};

/** Autogenerated input type of UpdateSavedQuery */
export type UpdateSavedQueryInput = {
  /** Query body */
  body?: Maybe<Scalars['JSON']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Whether this query is a default query */
  defaultQuery?: Maybe<Scalars['Boolean']>;
  /** Saved query name */
  name?: Maybe<Scalars['String']>;
  /** Whether this query is public or private */
  public: Scalars['Boolean'];
  /** Saved query ID */
  queryId: Scalars['ID'];
};

/** Autogenerated return type of UpdateSavedQuery. */
export type UpdateSavedQueryPayload = {
  __typename?: 'UpdateSavedQueryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Updated saved query */
  query: SavedQuery;
};

/** Autogenerated input type of UpdateShift */
export type UpdateShiftInput = {
  /** Updated shift times / timezone */
  changes: ShiftInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Shift ID */
  shiftId: Scalars['ID'];
};

/** Autogenerated return type of UpdateShift. */
export type UpdateShiftPayload = {
  __typename?: 'UpdateShiftPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated shift */
  shift: Maybe<Shift>;
};

/** Autogenerated input type of UpdateSocialProfile */
export type UpdateSocialProfileInput = {
  campaignId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  entityId: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  profile?: Maybe<Scalars['String']>;
  socialProfileId: Scalars['ID'];
  status?: Maybe<FieldStatusInput>;
};

/** Autogenerated return type of UpdateSocialProfile. */
export type UpdateSocialProfilePayload = {
  __typename?: 'UpdateSocialProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  entity: Maybe<Entity>;
};

/** Autogenerated input type of UpdateTagCategory */
export type UpdateTagCategoryInput = {
  /** Enable the functionality to add attachments to responses */
  attachmentsEnabled?: Maybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Enable or disable the functionality of adding new tags to the category */
  locked?: Maybe<Scalars['Boolean']>;
  /** append or overwrite */
  multiselectSameTagBehavior?: Maybe<TagCategorySameTagBehavior>;
  /** Allow multi selection of tags */
  multiselectable?: Maybe<Scalars['Boolean']>;
  /** Tag Group name. */
  name?: Maybe<Scalars['String']>;
  /** Enable or disable the functionality of adding new tags to the category */
  readonly?: Maybe<Scalars['Boolean']>;
  /** The Tag Category Id */
  tagCategoryId: Scalars['ID'];
};

/** Autogenerated return type of UpdateTagCategory. */
export type UpdateTagCategoryPayload = {
  __typename?: 'UpdateTagCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The new tag category */
  tagCategory: Maybe<TagCategory>;
};

/** Autogenerated input type of UpdateTag */
export type UpdateTagInput = {
  /** Is tag archived? */
  archived?: Maybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Tag name */
  name?: Maybe<Scalars['String']>;
  /** Tag id to be updated */
  tagId: Scalars['ID'];
  /** The tag type */
  tagType?: Maybe<TagType>;
};

/** Autogenerated return type of UpdateTag. */
export type UpdateTagPayload = {
  __typename?: 'UpdateTagPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Updated tag */
  tag: Maybe<Tag>;
};

/** Autogenerated input type of UpdateTagStatusByCategory */
export type UpdateTagStatusByCategoryInput = {
  /** Should the tags be archived */
  archived: Scalars['Boolean'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The Tag Category Id */
  tagCategoryId: Scalars['ID'];
};

/** Autogenerated return type of UpdateTagStatusByCategory. */
export type UpdateTagStatusByCategoryPayload = {
  __typename?: 'UpdateTagStatusByCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The tag category */
  tagCategory: Maybe<TagCategory>;
};

/** Autogenerated input type of UpdateUserById */
export type UpdateUserByIdInput = {
  /** Add the user as participant in these campaigns */
  addCampaigns?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Enable/disable API access */
  apiAccess?: Maybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Date to disable user. null to toggle it off */
  disableOn?: Maybe<Scalars['ISO8601DateTime']>;
  /** First name */
  firstName?: Maybe<Scalars['String']>;
  /** User ID */
  id: Scalars['ID'];
  /** Last name */
  lastName?: Maybe<Scalars['String']>;
  /** Phone number */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Remove the user as a participant in these campaigns */
  removeCampaigns?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** User role */
  role?: Maybe<UserRole>;
  /** Turf Assignments JSON object */
  turfAssignments?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateUserById. */
export type UpdateUserByIdPayload = {
  __typename?: 'UpdateUserByIdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated user */
  user: Maybe<User>;
};

/** Autogenerated input type of UpdateUserTurfAssignments */
export type UpdateUserTurfAssignmentsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Turf Assignments JSON object */
  turfAssignments?: Maybe<Scalars['String']>;
  /** User ID */
  userId: Scalars['ID'];
};

/** Autogenerated return type of UpdateUserTurfAssignments. */
export type UpdateUserTurfAssignmentsPayload = {
  __typename?: 'UpdateUserTurfAssignmentsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The updated user */
  user: Maybe<User>;
};

/** User data to be updated. */
export type UpdatedUserData = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

/** An Upload representation */
export type Upload = {
  __typename?: 'Upload';
  campaign: Maybe<CampaignPublic>;
  createdAt: Scalars['Time'];
  createdBy: UserPublic;
  downloadFilename: Scalars['String'];
  errorsDownloadUrl: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  status: Maybe<UploadStatusType>;
  summary: UploadSummary;
  updatedAt: Scalars['Time'];
  uploadType: Maybe<UploadInformationType>;
  visibilityStatus: Maybe<UploadVisibilityStatusType>;
};

/** The connection type for Upload. */
export type UploadConnection = {
  __typename?: 'UploadConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<UploadEdge>>>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Upload>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

/** Upload download URL */
export type UploadDownloadUrl = {
  __typename?: 'UploadDownloadUrl';
  url: Scalars['String'];
};

/** An edge in a connection. */
export type UploadEdge = {
  __typename?: 'UploadEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<Upload>;
};

/** Upload information types */
export enum UploadInformationType {
  /** Connection upload information type */
  ConnectionUploadInformation = 'ConnectionUploadInformation',
  /** EntityDelete upload information type */
  EntityDeleteUploadInformation = 'EntityDeleteUploadInformation',
  /** Entity upload information type */
  EntityUploadInformation = 'EntityUploadInformation',
  /** Job upload information type */
  JobUploadInformation = 'JobUploadInformation',
  /** Tag upload information type */
  TagUploadInformation = 'TagUploadInformation'
}

/** Upload Status. */
export enum UploadStatusType {
  /** Status Cancelled for Upload type */
  Cancelled = 'Cancelled',
  /** Status Complete for Upload type */
  Complete = 'Complete',
  /** Status Failed for Upload type */
  Failed = 'Failed',
  /** Status PendingUploadFile for Upload type */
  PendingUploadFile = 'PendingUploadFile',
  /** Status Processing for Upload type */
  Processing = 'Processing',
  /** Status UploadedFile for Upload type */
  UploadedFile = 'UploadedFile'
}

/** Upload summary */
export type UploadSummary = {
  __typename?: 'UploadSummary';
  /** Total of entities to add to the campaign */
  addToCampaign: Maybe<Scalars['Int']>;
  /** Total records deleted */
  deleted: Maybe<Scalars['Int']>;
  /** Total number of errors */
  errors: Maybe<Scalars['Int']>;
  /** Newly created records */
  new: Maybe<Scalars['Int']>;
  /** Total of CSV lines */
  scheduled: Maybe<Scalars['Int']>;
  /** Total records attempted */
  total: Maybe<Scalars['Int']>;
  /** Total number of updates */
  updates: Maybe<Scalars['Int']>;
};

/** Upload visibility status. */
export enum UploadVisibilityStatusType {
  /** Status active */
  Active = 'active',
  /** Status archived */
  Archived = 'archived'
}

/** URL */
export type Url = {
  __typename?: 'Url';
  url: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  apiAccess: Maybe<Scalars['Boolean']>;
  campaigns: Maybe<Array<Maybe<CampaignPublic>>>;
  confirmed: Scalars['Boolean'];
  createdAt: Scalars['Time'];
  disableOn: Maybe<Scalars['Time']>;
  disabled: Scalars['Boolean'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastLogin: Maybe<Scalars['Time']>;
  lastName: Scalars['String'];
  linkedEntityId: Maybe<Scalars['ID']>;
  /** User's MFA factor (only visible to self or admins) */
  mfaFactor: Maybe<MfaFactor>;
  /** Whether current user needs to set up MFA (null for other users) */
  mfaRequired: Maybe<Scalars['Boolean']>;
  phoneNumber: Maybe<Scalars['String']>;
  role: UserRole;
  turfAssignments: Maybe<Array<Maybe<TurfAssignment>>>;
};

/** The connection type for User. */
export type UserConnectionWithTotalCount = {
  __typename?: 'UserConnectionWithTotalCount';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<UserEdge>>>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<User>;
};

/** Public user data (accessible by any authenticated user) */
export type UserPublic = {
  __typename?: 'UserPublic';
  email: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  linkedEntityId: Maybe<Scalars['ID']>;
  name: Scalars['String'];
};

/** The connection type for UserPublic. */
export type UserPublicConnectionWithTotalCount = {
  __typename?: 'UserPublicConnectionWithTotalCount';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<UserPublicEdge>>>;
  /** For performance, reasons limits the count statement to 100,000. */
  limitedCount: Scalars['Int'];
  /** Returns a list of all IDs */
  matchingIds: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<UserPublic>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type UserPublicEdge = {
  __typename?: 'UserPublicEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<UserPublic>;
};

/** There are 4 roles in the system, with higher accounts in this list having more permissions than lower. */
export enum UserRole {
  /** Can view only what has been assigned to them by an organizer in a task */
  Activist = 'Activist',
  /** A super user, can do everything. */
  Administrator = 'Administrator',
  /** Can create campaigns, edit fields, upload, etc. A lead is also an organizer. */
  Lead = 'Lead',
  /** Can view the whole campaign, be part of various campaigns, create activists from entity cards. */
  Organizer = 'Organizer'
}

/** Autogenerated input type of VerifyMfaLogin */
export type VerifyMfaLoginInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** 6-digit verification code */
  code: Scalars['String'];
};

/** Autogenerated return type of VerifyMfaLogin. */
export type VerifyMfaLoginPayload = {
  __typename?: 'VerifyMfaLoginPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** User object if verification succeeded */
  user: Maybe<User>;
};

/** Autogenerated input type of VerifyMfaSetup */
export type VerifyMfaSetupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** 6-digit verification code */
  code: Scalars['String'];
};

/** Autogenerated return type of VerifyMfaSetup. */
export type VerifyMfaSetupPayload = {
  __typename?: 'VerifyMfaSetupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Verified MFA factor */
  mfaFactor: Maybe<MfaFactor>;
  /** User with verified MFA */
  user: Maybe<User>;
};

export type AddressDetailsFragment = (
  { __typename?: 'Address' }
  & Pick<Address, 'id' | 'streetAddress' | 'country' | 'city' | 'state' | 'zip' | 'latitude' | 'longitude' | 'geocodeBad' | 'geocodeSource' | 'accuracy' | 'accuracyType' | 'addressType' | 'normalized' | 'status' | 'source' | 'createdAt' | 'updatedAt'>
  & { electoralDistricts: Maybe<Array<(
    { __typename?: 'ElectoralDistrict' }
    & Pick<ElectoralDistrict, 'name' | 'longName' | 'id'>
  )>>, original: Maybe<(
    { __typename?: 'OriginalAddress' }
    & Pick<OriginalAddress, 'streetAddress' | 'city' | 'state' | 'zip' | 'country'>
  )> }
);

export type AssessmentSettingsFragment = (
  { __typename?: 'AssessmentInfo' }
  & Pick<AssessmentInfo, 'isDefault' | 'numberOfLevels' | 'descriptions' | 'detailedDescriptions' | 'colors'>
  & { entityTypeOverrides: Array<(
    { __typename?: 'EntityTypeAssessmentOverrides' }
    & Pick<EntityTypeAssessmentOverrides, 'descriptions' | 'detailedDescriptions' | 'entityTypeId'>
  )> }
);

export type AttachmentDetailsFragment = (
  { __typename?: 'Attachment' }
  & Pick<Attachment, 'createdAt' | 'downloadUrl' | 'id' | 'mimeType' | 'name' | 'size' | 'updatedAt'>
);

export type CampaignConnectionTypeConfigDetailsFragment = (
  { __typename?: 'CampaignEntityConnectionTypeConfiguration' }
  & Pick<CampaignEntityConnectionTypeConfiguration, 'id'>
  & { entityConnectionType: (
    { __typename?: 'EntityConnectionType' }
    & EntityConnectionTypeDetailsFragment
  ), campaign: (
    { __typename?: 'Campaign' }
    & Pick<Campaign, 'id' | 'name'>
  ), toplineSettingItems: Maybe<Array<(
    { __typename?: 'ToplineSettingItem' }
    & ToplineSettingItemDetailsFragment
  )>> }
);

export type CampaignEntityTypeConfigDetailsFragment = (
  { __typename?: 'CampaignEntityTypeConfiguration' }
  & Pick<CampaignEntityTypeConfiguration, 'id' | 'spotlightIcon'>
  & { entityType: (
    { __typename?: 'EntityType' }
    & EntityTypeDetailsFragment
  ), campaign: (
    { __typename?: 'CampaignPublic' }
    & Pick<CampaignPublic, 'id' | 'name'>
  ), toplineSettingItems: Maybe<Array<(
    { __typename?: 'ToplineSettingItem' }
    & ToplineSettingItemDetailsFragment
  )>>, defaultTagCategories: Maybe<Array<(
    { __typename?: 'TagCategory' }
    & TagCategoryInfoFragment
  )>>, creationCustomForm: Maybe<(
    { __typename?: 'CustomForm' }
    & CustomFormDetailsFragment
  )>, customForm: Maybe<(
    { __typename?: 'CustomForm' }
    & CustomFormDetailsFragment
  )>, spotlightTags: Maybe<Array<(
    { __typename?: 'AddressTag' }
    & Pick<AddressTag, 'id' | 'name'>
  ) | (
    { __typename?: 'DateTag' }
    & Pick<DateTag, 'id' | 'name'>
  ) | (
    { __typename?: 'NotesTag' }
    & Pick<NotesTag, 'id' | 'name'>
  ) | (
    { __typename?: 'NumberTag' }
    & Pick<NumberTag, 'id' | 'name'>
  ) | (
    { __typename?: 'ShiftTag' }
    & Pick<ShiftTag, 'id' | 'name'>
  ) | (
    { __typename?: 'StandardTag' }
    & Pick<StandardTag, 'id' | 'name'>
  )>> }
);

export type CampaignWithoutTagsFragment = (
  { __typename?: 'Campaign' }
  & Pick<Campaign, 'id' | 'name' | 'targetNumber' | 'defaultCountry' | 'showCustomIds' | 'showElectoralDistricts' | 'allowOrganizersToExport' | 'calendarEventsEnabled' | 'calendarEventCanvassingType' | 'defaultHomepage' | 'activityStreamAsInitialEntityView' | 'status'>
  & { restrictedExportingSettings: Maybe<(
    { __typename?: 'RestrictedExportingSettings' }
    & RestrictedExportingSettingTypeDetailsFragment
  )>, entityTypes: Maybe<Array<(
    { __typename?: 'EntityType' }
    & EntityTypeDetailsFragment
  )>>, entityConnectionTypes: Maybe<Array<(
    { __typename?: 'EntityConnectionType' }
    & EntityConnectionTypeDetailsFragment
  )>>, defaultEntityType: Maybe<(
    { __typename?: 'EntityType' }
    & EntityTypeDetailsFragment
  )>, supportUser: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'firstName' | 'lastName' | 'email' | 'role' | 'disabled' | 'id' | 'linkedEntityId'>
  )>, createdBy: Maybe<(
    { __typename?: 'UserPublic' }
    & Pick<UserPublic, 'firstName' | 'lastName' | 'id' | 'linkedEntityId'>
  )>, notes: Maybe<(
    { __typename?: 'NoteConnection' }
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'Note' }
      & NoteDetailsFragment
    )>>> }
  )> }
);

export type CustomFormDetailsFragment = (
  { __typename?: 'CustomForm' }
  & Pick<CustomForm, 'id' | 'name' | 'campaignId' | 'targetType' | 'targetTypeId' | 'createdAt'>
  & { fields: Array<(
    { __typename?: 'CustomFormField' }
    & CustomFormFieldDetailsFragment
  )> }
);

export type CustomFormFieldDetailsFragment = (
  { __typename?: 'CustomFormField' }
  & Pick<CustomFormField, 'id' | 'position' | 'fieldObjectType' | 'fieldObjectId' | 'objectData' | 'objectAttribute' | 'required'>
  & { tagCategory: Maybe<(
    { __typename?: 'TagCategory' }
    & TagCategoryInfoFragment
  )>, entityConnectionType: Maybe<(
    { __typename?: 'EntityConnectionType' }
    & EntityConnectionTypeDetailsFragment
  )> }
);

export type EntityConnectionTypeDetailsFragment = (
  { __typename?: 'EntityConnectionType' }
  & Pick<EntityConnectionType, 'id' | 'campaignContextId' | 'displayPosition'>
  & { entityType1: (
    { __typename?: 'EntityType' }
    & EntityTypeDetailsFragment
  ), entityType2: (
    { __typename?: 'EntityType' }
    & EntityTypeDetailsFragment
  ) }
);

export type EntityConnectionCoreFragment = (
  { __typename?: 'EntityConnection' }
  & Pick<EntityConnection, 'id' | 'active' | 'campaignId' | 'entityConnectionTypeId' | 'entityConnectionTypeName' | 'createdAt' | 'updatedAt'>
  & { entity1: (
    { __typename?: 'EntityPublic' }
    & Pick<EntityPublic, 'id' | 'campaignContextId' | 'entityTypeId' | 'currentAssessmentLevel' | 'spotlightIcon' | 'firstName' | 'nickname' | 'middleName' | 'lastName' | 'suffix' | 'pronouns'>
  ), entity2: (
    { __typename?: 'EntityPublic' }
    & Pick<EntityPublic, 'id' | 'campaignContextId' | 'entityTypeId' | 'currentAssessmentLevel' | 'spotlightIcon' | 'firstName' | 'nickname' | 'middleName' | 'lastName' | 'suffix' | 'pronouns'>
  ) }
);

export type EntityConnectionCountMapViewFragment = (
  { __typename?: 'EntityConnectionCount' }
  & Pick<EntityConnectionCount, 'activeConnectionsCount' | 'inactiveConnectionsCount'>
  & { entityConnectionType: (
    { __typename?: 'EntityConnectionType' }
    & Pick<EntityConnectionType, 'id' | 'entityType1Id' | 'entityType2Id'>
  ) }
);

export type EntityConnectionWithHighlightedToplineFragment = (
  { __typename?: 'EntityConnection' }
  & Pick<EntityConnection, 'id'>
  & { appliedToplines: Maybe<(
    { __typename?: 'AppliedToplines' }
    & HighlightedToplineForConnectionFragment
  )> }
);

export type EntityConnectionWithNotesFragment = (
  { __typename?: 'EntityConnection' }
  & Pick<EntityConnection, 'id' | 'active' | 'campaignId' | 'entityConnectionTypeId' | 'createdAt' | 'updatedAt'>
  & { notes: Maybe<Array<(
    { __typename?: 'Note' }
    & NoteDetailsFragment
  )>> }
);

export type EntityConnectionWithTagsFragment = (
  { __typename?: 'EntityConnection' }
  & Pick<EntityConnection, 'tagsCount'>
  & { tags: Maybe<Array<Maybe<(
    { __typename?: 'TaggableLogbook' }
    & TaggableLogbookDetailsFragment
  )>>> }
  & EntityConnectionCoreFragment
);

export type EntityConnectionWithToplinesFragment = (
  { __typename?: 'EntityConnection' }
  & Pick<EntityConnection, 'id'>
  & { appliedToplines: Maybe<(
    { __typename?: 'AppliedToplines' }
    & AppliedToplinesFragmentFragment
  )> }
  & EntityConnectionWithHighlightedToplineFragment
);

export type EntityTypeDetailsFragment = (
  { __typename?: 'EntityType' }
  & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular' | 'nameType' | 'phoneNumberEnabled' | 'addressEnabled' | 'languageEnabled' | 'dateOfBirthEnabled' | 'socialEnabled' | 'emailEnabled' | 'pronounsEnabled' | 'icon'>
);

export type EmailDetailsFragment = (
  { __typename?: 'Email' }
  & Pick<Email, 'id' | 'email' | 'emailType' | 'status' | 'source' | 'subscribed' | 'createdAt' | 'updatedAt'>
);

export type EntityWithToplinesFragment = (
  { __typename?: 'Entity' }
  & Pick<Entity, 'campaignContextId' | 'id'>
  & { appliedToplines: Maybe<(
    { __typename?: 'AppliedToplines' }
    & { item1: Maybe<(
      { __typename?: 'AppliedToplineItem' }
      & AppliedToplineItemWithConnectionToplinesFragment
    )>, item2: Maybe<(
      { __typename?: 'AppliedToplineItem' }
      & AppliedToplineItemWithConnectionToplinesFragment
    )>, item3: Maybe<(
      { __typename?: 'AppliedToplineItem' }
      & AppliedToplineItemWithConnectionToplinesFragment
    )>, item4: Maybe<(
      { __typename?: 'AppliedToplineItem' }
      & AppliedToplineItemWithConnectionToplinesFragment
    )>, item5: Maybe<(
      { __typename?: 'AppliedToplineItem' }
      & AppliedToplineItemWithConnectionToplinesFragment
    )> }
    & AppliedToplinesFragmentFragment
  )> }
  & EntityWithHighlightedToplineFragment
);

export type EntityWithContactIconsFragment = (
  { __typename?: 'Entity' }
  & EntityCoreFragment
  & EntityWithBestAddressFragment
  & EntityWithBestEmailFragment
  & EntityWithBestPhoneFragment
);

export type EntityCoreFragment = (
  { __typename?: 'Entity' }
  & Pick<Entity, 'campaignContextId' | 'id' | 'entityTypeId' | 'updatedAt' | 'spotlightIcon'>
);

export type EntityCustomIdDetailsFragment = (
  { __typename?: 'EntityCustomId' }
  & Pick<EntityCustomId, 'id' | 'value'>
  & { customIdType: (
    { __typename?: 'CustomIdType' }
    & CustomIdTypeDetailsFragment
  ) }
);

export type CustomIdTypeDetailsFragment = (
  { __typename?: 'CustomIdType' }
  & Pick<CustomIdType, 'id' | 'internalName' | 'label' | 'active'>
);

export type EntityWithLinkedUserIdFragment = (
  { __typename?: 'Entity' }
  & Pick<Entity, 'linkedUserId'>
);

export type EntityPublicInfoFragment = (
  { __typename?: 'EntityPublic' }
  & Pick<EntityPublic, 'id' | 'campaignContextId' | 'entityTypeId' | 'currentAssessmentLevel' | 'spotlightIcon' | 'firstName' | 'nickname' | 'middleName' | 'lastName' | 'pronouns' | 'suffix'>
  & { bestAddress: Maybe<(
    { __typename?: 'Address' }
    & AddressDetailsFragment
  )>, bestPhoneNumber: Maybe<(
    { __typename?: 'PhoneNumber' }
    & PhoneDetailsFragment
  )>, bestEmail: Maybe<(
    { __typename?: 'Email' }
    & EmailDetailsFragment
  )> }
);

export type EntityPublicWithCampaignsFragment = (
  { __typename?: 'EntityPublic' }
  & Pick<EntityPublic, 'id' | 'campaignContextId'>
  & { campaigns: Maybe<Array<Maybe<(
    { __typename?: 'CampaignPublic' }
    & Pick<CampaignPublic, 'id' | 'name'>
  )>>> }
);

export type EntityWithAddressesFragment = (
  { __typename?: 'Entity' }
  & { addresses: Maybe<Array<(
    { __typename?: 'Address' }
    & AddressDetailsFragment
  )>> }
  & EntityCoreFragment
);

export type EntityWithAssessmentsFragment = (
  { __typename?: 'Entity' }
  & Pick<Entity, 'currentAssessmentLevel'>
  & { assessments: Maybe<Array<Maybe<(
    { __typename?: 'Assessment' }
    & Pick<Assessment, 'id' | 'level' | 'createdAt'>
    & { createdBy: (
      { __typename?: 'UserPublic' }
      & Pick<UserPublic, 'id' | 'name'>
    ) }
  )>>> }
  & EntityCoreFragment
);

export type EntityWithBasicInfoFragment = (
  { __typename?: 'Entity' }
  & Pick<Entity, 'firstName' | 'middleName' | 'lastName' | 'nickname' | 'suffix' | 'currentAssessmentLevel' | 'followUp' | 'dateOfBirth' | 'age' | 'calculatedBirthDate' | 'linkedUserId' | 'spotlightIcon' | 'pronouns'>
  & { entityLanguages: Maybe<Array<(
    { __typename?: 'EntityLanguage' }
    & Pick<EntityLanguage, 'languageCode' | 'preferred'>
  )>> }
);

export type EntityWithBestAddressFragment = (
  { __typename?: 'Entity' }
  & { bestAddress: Maybe<(
    { __typename?: 'Address' }
    & AddressDetailsFragment
  )> }
);

export type EntityWithBestEmailFragment = (
  { __typename?: 'Entity' }
  & { bestEmail: Maybe<(
    { __typename?: 'Email' }
    & EmailDetailsFragment
  )> }
);

export type EntityWithBestPhoneFragment = (
  { __typename?: 'Entity' }
  & { bestPhoneNumber: Maybe<(
    { __typename?: 'PhoneNumber' }
    & PhoneDetailsFragment
  )> }
);

export type EntityWithCalendarEventCountsFragment = (
  { __typename?: 'Entity' }
  & { calendarEventResponseCounts: Maybe<(
    { __typename?: 'CalendarEventResponseEntityCount' }
    & { past: (
      { __typename?: 'CalendarEventResponseCounts' }
      & Pick<CalendarEventResponseCounts, 'attended' | 'doubleConfirmed' | 'confirmed' | 'rsvp'>
    ), upcoming: (
      { __typename?: 'CalendarEventResponseCounts' }
      & Pick<CalendarEventResponseCounts, 'attended' | 'doubleConfirmed' | 'confirmed' | 'rsvp'>
    ) }
  )> }
);

export type EntityWithCalendarResponsesFragment = (
  { __typename?: 'Entity' }
  & { calendarEventResponses: Maybe<Array<(
    { __typename?: 'CalendarEventResponse' }
    & CalendarEventResponseCoreFragment
  )>> }
);

export type EntityWithCampaignsFragment = (
  { __typename?: 'Entity' }
  & { campaigns: Maybe<Array<Maybe<(
    { __typename?: 'CampaignPublic' }
    & Pick<CampaignPublic, 'id' | 'name'>
  )>>> }
);

export type EntityWithConnectionCountsFragment = (
  { __typename?: 'Entity' }
  & { entityConnectionCount: Maybe<Array<(
    { __typename?: 'EntityConnectionCount' }
    & EntityConnectionCountMapViewFragment
  )>> }
  & EntityCoreFragment
);

export type EntityWithEmailsFragment = (
  { __typename?: 'Entity' }
  & { emails: Maybe<Array<Maybe<(
    { __typename?: 'Email' }
    & EmailDetailsFragment
  )>>> }
  & EntityCoreFragment
);

export type EntityWithEntityTypeFragment = (
  { __typename?: 'Entity' }
  & { entityType: Maybe<(
    { __typename?: 'EntityType' }
    & EntityTypeDetailsFragment
  )> }
);

export type EntityWithFollowUpDetailsFragment = (
  { __typename?: 'Entity' }
  & Pick<Entity, 'followUp'>
  & { activeFollowUp: Maybe<(
    { __typename?: 'FollowUp' }
    & FollowUpDetailsFragment
  )> }
);

export type EntityWithHighlightedToplineFragment = (
  { __typename?: 'Entity' }
  & Pick<Entity, 'campaignContextId' | 'id'>
  & { appliedToplines: Maybe<(
    { __typename?: 'AppliedToplines' }
    & HighlightedToplineForEntityFragment
  )> }
);

export type EntityWithIdsFragment = (
  { __typename?: 'Entity' }
  & Pick<Entity, 'actionBuilderId' | 'dwId' | 'voterbaseId' | 'customId' | 'customId1' | 'customId2' | 'customId3' | 'customId4'>
  & { entityCustomIds: Array<(
    { __typename?: 'EntityCustomId' }
    & EntityCustomIdDetailsFragment
  )> }
  & EntityCoreFragment
);

export type EntityWithMapViewDetailsFragment = (
  { __typename?: 'Entity' }
  & Pick<Entity, 'currentAssessmentLevel'>
  & { entityType: Maybe<(
    { __typename?: 'EntityType' }
    & Pick<EntityType, 'id' | 'icon'>
  )> }
  & EntityCoreFragment
  & EntityWithAddressesFragment
  & EntityWithConnectionCountsFragment
);

export type EntityWithNotesFragment = (
  { __typename?: 'Entity' }
  & { notes: Maybe<Array<(
    { __typename?: 'Note' }
    & NoteDetailsFragment
  )>> }
  & EntityCoreFragment
);

export type EntityWithPhonesFragment = (
  { __typename?: 'Entity' }
  & { phoneNumbers: Maybe<Array<Maybe<(
    { __typename?: 'PhoneNumber' }
    & PhoneDetailsFragment
  )>>> }
  & EntityCoreFragment
);

export type EntityWithSocialProfilesFragment = (
  { __typename?: 'Entity' }
  & { socialProfiles: Maybe<Array<(
    { __typename?: 'SocialProfile' }
    & SocialProfileDetailsFragment
  )>> }
  & EntityCoreFragment
);

export type EntityWithTagsFragment = (
  { __typename?: 'Entity' }
  & Pick<Entity, 'tagsCount'>
  & { tags: Maybe<Array<Maybe<(
    { __typename?: 'TaggableLogbook' }
    & TaggableLogbookDetailsFragment
  )>>> }
  & EntityCoreFragment
);

export type FollowUpDetailsFragment = (
  { __typename?: 'FollowUp' }
  & Pick<FollowUp, 'active' | 'id' | 'campaignId' | 'createdAt' | 'completedAt' | 'dueDate'>
  & { assignedUser: Maybe<(
    { __typename?: 'UserPublic' }
    & UserPublicDetailsFragment
  )>, createdBy: Maybe<(
    { __typename?: 'UserPublic' }
    & UserPublicDetailsFragment
  )>, completedBy: Maybe<(
    { __typename?: 'UserPublic' }
    & UserPublicDetailsFragment
  )>, note: Maybe<(
    { __typename?: 'Note' }
    & NoteDetailsFragment
  )> }
);

export type SocialNetworkDetailsFragment = (
  { __typename?: 'SocialNetwork' }
  & Pick<SocialNetwork, 'id' | 'label' | 'icon' | 'allowUrls' | 'labelRequired'>
);

export type SocialProfileDetailsFragment = (
  { __typename?: 'SocialProfile' }
  & Pick<SocialProfile, 'id' | 'label' | 'profile' | 'source' | 'status' | 'createdAt' | 'updatedAt'>
  & { socialNetwork: (
    { __typename?: 'SocialNetwork' }
    & SocialNetworkDetailsFragment
  ), createdBy: (
    { __typename?: 'UserPublic' }
    & UserPublicDetailsFragment
  ), updatedBy: Maybe<(
    { __typename?: 'UserPublic' }
    & UserPublicDetailsFragment
  )> }
);

export type CalendarEventBaseFragment = (
  { __typename?: 'CalendarEvent' }
  & Pick<CalendarEvent, 'campaignId' | 'createdAt' | 'id' | 'name' | 'startDate' | 'endDate' | 'locationType' | 'timeZone' | 'locationNote' | 'description' | 'actionNetworkEventId'>
  & { createdBy: (
    { __typename?: 'UserPublic' }
    & UserPublicDetailsFragment
  ), entityType: (
    { __typename?: 'EntityType' }
    & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
  ), address: Maybe<(
    { __typename?: 'Address' }
    & AddressDetailsFragment
  )> }
);

export type CalendarEventWithUsersAndCountsFragment = (
  { __typename?: 'CalendarEvent' }
  & { assignedUsers: (
    { __typename?: 'UserPublicConnectionWithTotalCount' }
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'UserPublic' }
      & UserPublicDetailsFragment
    )>>> }
  ), responseCounts: (
    { __typename?: 'CalendarEventResponseCounts' }
    & Pick<CalendarEventResponseCounts, 'confirmed' | 'attended' | 'declined' | 'noShow' | 'doubleConfirmed' | 'rsvp' | 'tentative'>
  ) }
  & CalendarEventBaseFragment
);

export type CalendarEventActionCoreFragment = (
  { __typename?: 'CalendarEventAction' }
  & Pick<CalendarEventAction, 'id' | 'actionPurpose' | 'scheduleCreateDaysBeforeEventStart'>
  & { calendarEvent: (
    { __typename?: 'CalendarEvent' }
    & CalendarEventWithUsersAndCountsFragment
  ) }
);

export type CalendarEventDetailsFragment = (
  { __typename?: 'CalendarEvent' }
  & { calendarEventActions: Array<(
    { __typename?: 'CalendarEventAction' }
    & CalendarEventActionDetailsFragment
  )> }
  & CalendarEventWithUsersAndCountsFragment
);

export type CalendarEventResponseCoreFragment = (
  { __typename?: 'CalendarEventResponse' }
  & Pick<CalendarEventResponse, 'id' | 'respondedAt' | 'status'>
  & { appliedTags: Array<(
    { __typename?: 'TaggableLogbook' }
    & TaggableLogbookDetailsFragment
  )>, calendarEvent: (
    { __typename?: 'CalendarEvent' }
    & CalendarEventWithUsersAndCountsFragment
  ), campaign: (
    { __typename?: 'CampaignPublic' }
    & Pick<CampaignPublic, 'id'>
  ), createdBy: (
    { __typename?: 'UserPublic' }
    & UserPublicDetailsFragment
  ), updatedBy: (
    { __typename?: 'UserPublic' }
    & UserPublicDetailsFragment
  ) }
);

export type CalendarEventActionDetailsFragment = (
  { __typename?: 'CalendarEventAction' }
  & { action: Maybe<(
    { __typename?: 'Action' }
    & ActionDetailsFragment
  )> }
  & CalendarEventActionCoreFragment
);

export type EventWithEntityResponseFragment = (
  { __typename?: 'CalendarEvent' }
  & { entityResponse: Maybe<(
    { __typename?: 'CalendarEventResponse' }
    & Pick<CalendarEventResponse, 'id' | 'campaignContextId' | 'status'>
  )> }
);

export type NoteDetailsFragment = (
  { __typename?: 'Note' }
  & Pick<Note, 'id' | 'text' | 'createdAt' | 'noteType' | 'updatedAt' | 'pinnedAt'>
  & { createdBy: (
    { __typename?: 'UserPublic' }
    & Pick<UserPublic, 'id' | 'name' | 'linkedEntityId'>
  ), updatedBy: Maybe<(
    { __typename?: 'UserPublic' }
    & Pick<UserPublic, 'id' | 'name' | 'linkedEntityId'>
  )> }
);

export type OrganizationDetailsFragment = (
  { __typename?: 'Organization' }
  & Pick<Organization, 'name' | 'defaultCountry' | 'mfaRequired'>
  & { administratorUser: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName' | 'email' | 'confirmed' | 'role' | 'disabled'>
  )> }
);

export type PhoneDetailsFragment = (
  { __typename?: 'PhoneNumber' }
  & Pick<PhoneNumber, 'id' | 'number' | 'ext' | 'numberType' | 'status' | 'source' | 'createdAt' | 'updatedAt' | 'subscribed'>
);

export type RestrictedExportingSettingTypeDetailsFragment = (
  { __typename?: 'RestrictedExportingSettings' }
  & Pick<RestrictedExportingSettings, 'specializedExportsDisabled' | 'properties' | 'tagCategoryIds'>
);

export type SavedQueryDetailsFragment = (
  { __typename?: 'SavedQuery' }
  & Pick<SavedQuery, 'id' | 'name' | 'body' | 'public' | 'createdAt' | 'updatedAt' | 'defaultQuery' | 'ownedByCurrentUser' | 'queryType' | 'canEdit'>
  & { user: (
    { __typename?: 'UserPublic' }
    & Pick<UserPublic, 'id' | 'firstName' | 'lastName' | 'name'>
  ) }
);

export type ShiftInfoFragment = (
  { __typename?: 'Shift' }
  & Pick<Shift, 'id' | 'timezone'>
  & { shiftTimes: Maybe<Array<Maybe<(
    { __typename?: 'ShiftTime' }
    & Pick<ShiftTime, 'dayOfWeek' | 'endTime' | 'startTime' | 'timezone'>
  )>>> }
);

export type TagCategoryInfoFragment = (
  { __typename?: 'TagCategory' }
  & Pick<TagCategory, 'id' | 'name' | 'campaignContextId' | 'multiselectable' | 'groupName' | 'locked' | 'readonly' | 'allowToCreateTagType' | 'multiselectSameTagBehavior' | 'attachmentsEnabled' | 'isUniversal'>
  & TagCategoryTagInfoFragment
);

export type TagCategoryOnlyFragment = (
  { __typename?: 'TagCategory' }
  & Pick<TagCategory, 'id' | 'name' | 'campaignContextId' | 'multiselectable' | 'groupName' | 'locked' | 'readonly' | 'allowToCreateTagType' | 'multiselectSameTagBehavior' | 'attachmentsEnabled' | 'isUniversal'>
);

export type TagCategoryTagInfoFragment = (
  { __typename?: 'TagCategory' }
  & Pick<TagCategory, 'id' | 'name' | 'campaignContextId' | 'hasAssociatedTags' | 'hasActiveTags' | 'hasArchivedTags'>
);

export type TagGroupInfoFragment = (
  { __typename?: 'TagGroup' }
  & Pick<TagGroup, 'id' | 'name' | 'campaignContextId' | 'isUniversal'>
  & { targetType: Maybe<{ __typename?: 'CalendarEventType' } | (
    { __typename?: 'EntityConnectionType' }
    & Pick<EntityConnectionType, 'id' | 'campaignContextId'>
    & { entityType1: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ), entityType2: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ) }
  ) | (
    { __typename?: 'EntityType' }
    & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
  )>, categories: Maybe<Array<Maybe<(
    { __typename?: 'TagCategory' }
    & TagCategoryInfoFragment
  )>>> }
);

type TagInfoForQueryBuilder_AddressTag_Fragment = (
  { __typename?: 'AddressTag' }
  & Pick<AddressTag, 'id' | 'campaignContextId' | 'tagType' | 'name'>
  & { targetType: { __typename?: 'CalendarEventType' } | (
    { __typename?: 'EntityConnectionType' }
    & Pick<EntityConnectionType, 'id' | 'campaignContextId'>
    & { entityType1: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ), entityType2: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ) }
  ) | (
    { __typename?: 'EntityType' }
    & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
  ), category: (
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'campaignContextId' | 'id' | 'name' | 'readonly'>
    & { group: (
      { __typename?: 'TagGroup' }
      & Pick<TagGroup, 'id' | 'name'>
    ) }
  ) }
);

type TagInfoForQueryBuilder_DateTag_Fragment = (
  { __typename?: 'DateTag' }
  & Pick<DateTag, 'id' | 'campaignContextId' | 'tagType' | 'name'>
  & { targetType: { __typename?: 'CalendarEventType' } | (
    { __typename?: 'EntityConnectionType' }
    & Pick<EntityConnectionType, 'id' | 'campaignContextId'>
    & { entityType1: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ), entityType2: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ) }
  ) | (
    { __typename?: 'EntityType' }
    & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
  ), category: (
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'campaignContextId' | 'id' | 'name' | 'readonly'>
    & { group: (
      { __typename?: 'TagGroup' }
      & Pick<TagGroup, 'id' | 'name'>
    ) }
  ) }
);

type TagInfoForQueryBuilder_NotesTag_Fragment = (
  { __typename?: 'NotesTag' }
  & Pick<NotesTag, 'id' | 'campaignContextId' | 'tagType' | 'name'>
  & { targetType: { __typename?: 'CalendarEventType' } | (
    { __typename?: 'EntityConnectionType' }
    & Pick<EntityConnectionType, 'id' | 'campaignContextId'>
    & { entityType1: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ), entityType2: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ) }
  ) | (
    { __typename?: 'EntityType' }
    & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
  ), category: (
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'campaignContextId' | 'id' | 'name' | 'readonly'>
    & { group: (
      { __typename?: 'TagGroup' }
      & Pick<TagGroup, 'id' | 'name'>
    ) }
  ) }
);

type TagInfoForQueryBuilder_NumberTag_Fragment = (
  { __typename?: 'NumberTag' }
  & Pick<NumberTag, 'id' | 'campaignContextId' | 'tagType' | 'name'>
  & { targetType: { __typename?: 'CalendarEventType' } | (
    { __typename?: 'EntityConnectionType' }
    & Pick<EntityConnectionType, 'id' | 'campaignContextId'>
    & { entityType1: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ), entityType2: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ) }
  ) | (
    { __typename?: 'EntityType' }
    & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
  ), category: (
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'campaignContextId' | 'id' | 'name' | 'readonly'>
    & { group: (
      { __typename?: 'TagGroup' }
      & Pick<TagGroup, 'id' | 'name'>
    ) }
  ) }
);

type TagInfoForQueryBuilder_ShiftTag_Fragment = (
  { __typename?: 'ShiftTag' }
  & Pick<ShiftTag, 'id' | 'campaignContextId' | 'tagType' | 'name'>
  & { targetType: { __typename?: 'CalendarEventType' } | (
    { __typename?: 'EntityConnectionType' }
    & Pick<EntityConnectionType, 'id' | 'campaignContextId'>
    & { entityType1: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ), entityType2: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ) }
  ) | (
    { __typename?: 'EntityType' }
    & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
  ), category: (
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'campaignContextId' | 'id' | 'name' | 'readonly'>
    & { group: (
      { __typename?: 'TagGroup' }
      & Pick<TagGroup, 'id' | 'name'>
    ) }
  ) }
);

type TagInfoForQueryBuilder_StandardTag_Fragment = (
  { __typename?: 'StandardTag' }
  & Pick<StandardTag, 'id' | 'campaignContextId' | 'tagType' | 'name'>
  & { targetType: { __typename?: 'CalendarEventType' } | (
    { __typename?: 'EntityConnectionType' }
    & Pick<EntityConnectionType, 'id' | 'campaignContextId'>
    & { entityType1: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ), entityType2: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ) }
  ) | (
    { __typename?: 'EntityType' }
    & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
  ), category: (
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'campaignContextId' | 'id' | 'name' | 'readonly'>
    & { group: (
      { __typename?: 'TagGroup' }
      & Pick<TagGroup, 'id' | 'name'>
    ) }
  ) }
);

export type TagInfoForQueryBuilderFragment = TagInfoForQueryBuilder_AddressTag_Fragment | TagInfoForQueryBuilder_DateTag_Fragment | TagInfoForQueryBuilder_NotesTag_Fragment | TagInfoForQueryBuilder_NumberTag_Fragment | TagInfoForQueryBuilder_ShiftTag_Fragment | TagInfoForQueryBuilder_StandardTag_Fragment;

type TagInfoNoTargetType_AddressTag_Fragment = (
  { __typename?: 'AddressTag' }
  & Pick<AddressTag, 'id' | 'name' | 'campaignContextId' | 'archived' | 'tagType' | 'createdAt' | 'updatedAt'>
  & { address: Maybe<(
    { __typename?: 'Address' }
    & AddressDetailsFragment
  )>, category: (
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'id' | 'readonly' | 'name' | 'groupName' | 'attachmentsEnabled'>
  ) }
);

type TagInfoNoTargetType_DateTag_Fragment = (
  { __typename?: 'DateTag' }
  & Pick<DateTag, 'id' | 'name' | 'campaignContextId' | 'archived' | 'tagType' | 'createdAt' | 'updatedAt'>
  & { category: (
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'id' | 'readonly' | 'name' | 'groupName' | 'attachmentsEnabled'>
  ) }
);

type TagInfoNoTargetType_NotesTag_Fragment = (
  { __typename?: 'NotesTag' }
  & Pick<NotesTag, 'id' | 'name' | 'campaignContextId' | 'archived' | 'tagType' | 'createdAt' | 'updatedAt'>
  & { category: (
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'id' | 'readonly' | 'name' | 'groupName' | 'attachmentsEnabled'>
  ) }
);

type TagInfoNoTargetType_NumberTag_Fragment = (
  { __typename?: 'NumberTag' }
  & Pick<NumberTag, 'id' | 'name' | 'campaignContextId' | 'archived' | 'tagType' | 'createdAt' | 'updatedAt'>
  & { category: (
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'id' | 'readonly' | 'name' | 'groupName' | 'attachmentsEnabled'>
  ) }
);

type TagInfoNoTargetType_ShiftTag_Fragment = (
  { __typename?: 'ShiftTag' }
  & Pick<ShiftTag, 'id' | 'name' | 'campaignContextId' | 'archived' | 'tagType' | 'createdAt' | 'updatedAt'>
  & { category: (
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'id' | 'readonly' | 'name' | 'groupName' | 'attachmentsEnabled'>
  ) }
);

type TagInfoNoTargetType_StandardTag_Fragment = (
  { __typename?: 'StandardTag' }
  & Pick<StandardTag, 'id' | 'name' | 'campaignContextId' | 'archived' | 'tagType' | 'createdAt' | 'updatedAt'>
  & { category: (
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'id' | 'readonly' | 'name' | 'groupName' | 'attachmentsEnabled'>
  ) }
);

export type TagInfoNoTargetTypeFragment = TagInfoNoTargetType_AddressTag_Fragment | TagInfoNoTargetType_DateTag_Fragment | TagInfoNoTargetType_NotesTag_Fragment | TagInfoNoTargetType_NumberTag_Fragment | TagInfoNoTargetType_ShiftTag_Fragment | TagInfoNoTargetType_StandardTag_Fragment;

type TagInfo_AddressTag_Fragment = (
  { __typename?: 'AddressTag' }
  & Pick<AddressTag, 'isUniversal'>
  & { targetType: { __typename?: 'CalendarEventType' } | (
    { __typename?: 'EntityConnectionType' }
    & Pick<EntityConnectionType, 'id' | 'campaignContextId'>
    & { entityType1: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ), entityType2: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ) }
  ) | (
    { __typename?: 'EntityType' }
    & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
  ) }
  & TagInfoNoTargetType_AddressTag_Fragment
);

type TagInfo_DateTag_Fragment = (
  { __typename?: 'DateTag' }
  & Pick<DateTag, 'isUniversal'>
  & { targetType: { __typename?: 'CalendarEventType' } | (
    { __typename?: 'EntityConnectionType' }
    & Pick<EntityConnectionType, 'id' | 'campaignContextId'>
    & { entityType1: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ), entityType2: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ) }
  ) | (
    { __typename?: 'EntityType' }
    & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
  ) }
  & TagInfoNoTargetType_DateTag_Fragment
);

type TagInfo_NotesTag_Fragment = (
  { __typename?: 'NotesTag' }
  & Pick<NotesTag, 'isUniversal'>
  & { targetType: { __typename?: 'CalendarEventType' } | (
    { __typename?: 'EntityConnectionType' }
    & Pick<EntityConnectionType, 'id' | 'campaignContextId'>
    & { entityType1: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ), entityType2: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ) }
  ) | (
    { __typename?: 'EntityType' }
    & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
  ) }
  & TagInfoNoTargetType_NotesTag_Fragment
);

type TagInfo_NumberTag_Fragment = (
  { __typename?: 'NumberTag' }
  & Pick<NumberTag, 'isUniversal'>
  & { targetType: { __typename?: 'CalendarEventType' } | (
    { __typename?: 'EntityConnectionType' }
    & Pick<EntityConnectionType, 'id' | 'campaignContextId'>
    & { entityType1: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ), entityType2: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ) }
  ) | (
    { __typename?: 'EntityType' }
    & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
  ) }
  & TagInfoNoTargetType_NumberTag_Fragment
);

type TagInfo_ShiftTag_Fragment = (
  { __typename?: 'ShiftTag' }
  & Pick<ShiftTag, 'isUniversal'>
  & { targetType: { __typename?: 'CalendarEventType' } | (
    { __typename?: 'EntityConnectionType' }
    & Pick<EntityConnectionType, 'id' | 'campaignContextId'>
    & { entityType1: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ), entityType2: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ) }
  ) | (
    { __typename?: 'EntityType' }
    & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
  ) }
  & TagInfoNoTargetType_ShiftTag_Fragment
);

type TagInfo_StandardTag_Fragment = (
  { __typename?: 'StandardTag' }
  & Pick<StandardTag, 'isUniversal'>
  & { targetType: { __typename?: 'CalendarEventType' } | (
    { __typename?: 'EntityConnectionType' }
    & Pick<EntityConnectionType, 'id' | 'campaignContextId'>
    & { entityType1: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ), entityType2: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ) }
  ) | (
    { __typename?: 'EntityType' }
    & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
  ) }
  & TagInfoNoTargetType_StandardTag_Fragment
);

export type TagInfoFragment = TagInfo_AddressTag_Fragment | TagInfo_DateTag_Fragment | TagInfo_NotesTag_Fragment | TagInfo_NumberTag_Fragment | TagInfo_ShiftTag_Fragment | TagInfo_StandardTag_Fragment;

type TagWithIsInCampaign_AddressTag_Fragment = (
  { __typename?: 'AddressTag' }
  & Pick<AddressTag, 'isInCampaign'>
  & { category: (
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'id' | 'isInCampaign'>
    & { group: (
      { __typename?: 'TagGroup' }
      & Pick<TagGroup, 'id' | 'isInCampaign'>
    ) }
  ) }
);

type TagWithIsInCampaign_DateTag_Fragment = (
  { __typename?: 'DateTag' }
  & Pick<DateTag, 'isInCampaign'>
  & { category: (
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'id' | 'isInCampaign'>
    & { group: (
      { __typename?: 'TagGroup' }
      & Pick<TagGroup, 'id' | 'isInCampaign'>
    ) }
  ) }
);

type TagWithIsInCampaign_NotesTag_Fragment = (
  { __typename?: 'NotesTag' }
  & Pick<NotesTag, 'isInCampaign'>
  & { category: (
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'id' | 'isInCampaign'>
    & { group: (
      { __typename?: 'TagGroup' }
      & Pick<TagGroup, 'id' | 'isInCampaign'>
    ) }
  ) }
);

type TagWithIsInCampaign_NumberTag_Fragment = (
  { __typename?: 'NumberTag' }
  & Pick<NumberTag, 'isInCampaign'>
  & { category: (
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'id' | 'isInCampaign'>
    & { group: (
      { __typename?: 'TagGroup' }
      & Pick<TagGroup, 'id' | 'isInCampaign'>
    ) }
  ) }
);

type TagWithIsInCampaign_ShiftTag_Fragment = (
  { __typename?: 'ShiftTag' }
  & Pick<ShiftTag, 'isInCampaign'>
  & { category: (
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'id' | 'isInCampaign'>
    & { group: (
      { __typename?: 'TagGroup' }
      & Pick<TagGroup, 'id' | 'isInCampaign'>
    ) }
  ) }
);

type TagWithIsInCampaign_StandardTag_Fragment = (
  { __typename?: 'StandardTag' }
  & Pick<StandardTag, 'isInCampaign'>
  & { category: (
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'id' | 'isInCampaign'>
    & { group: (
      { __typename?: 'TagGroup' }
      & Pick<TagGroup, 'id' | 'isInCampaign'>
    ) }
  ) }
);

export type TagWithIsInCampaignFragment = TagWithIsInCampaign_AddressTag_Fragment | TagWithIsInCampaign_DateTag_Fragment | TagWithIsInCampaign_NotesTag_Fragment | TagWithIsInCampaign_NumberTag_Fragment | TagWithIsInCampaign_ShiftTag_Fragment | TagWithIsInCampaign_StandardTag_Fragment;

export type TaggableLogbookDetailsFragment = (
  { __typename?: 'TaggableLogbook' }
  & Pick<TaggableLogbook, 'id' | 'deleted' | 'targetType' | 'createdAt' | 'updatedAt'>
  & { campaign: Maybe<(
    { __typename?: 'CampaignPublic' }
    & Pick<CampaignPublic, 'id'>
  )>, attachments: Array<(
    { __typename?: 'Attachment' }
    & AttachmentDetailsFragment
  )>, notes: Maybe<Array<(
    { __typename?: 'Note' }
    & NoteDetailsFragment
  )>>, shift: Maybe<(
    { __typename?: 'Shift' }
    & ShiftInfoFragment
  )>, tag: (
    { __typename?: 'AddressTag' }
    & TagInfoNoTargetType_AddressTag_Fragment
  ) | (
    { __typename?: 'DateTag' }
    & TagInfoNoTargetType_DateTag_Fragment
  ) | (
    { __typename?: 'NotesTag' }
    & TagInfoNoTargetType_NotesTag_Fragment
  ) | (
    { __typename?: 'NumberTag' }
    & TagInfoNoTargetType_NumberTag_Fragment
  ) | (
    { __typename?: 'ShiftTag' }
    & TagInfoNoTargetType_ShiftTag_Fragment
  ) | (
    { __typename?: 'StandardTag' }
    & TagInfoNoTargetType_StandardTag_Fragment
  ) }
);

export type ToplineSettingItemDetailsFragment = (
  { __typename?: 'ToplineSettingItem' }
  & { tagCategory: Maybe<(
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'id' | 'campaignContextId' | 'readonly' | 'name' | 'allowToCreateTagType'>
  )>, entityConnectionType: Maybe<(
    { __typename?: 'EntityConnectionType' }
    & Pick<EntityConnectionType, 'id'>
    & { entityType1: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ), entityType2: (
      { __typename?: 'EntityType' }
      & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
    ) }
  )> }
  & ToplineSettingItemBasicFragment
);

export type ToplineSettingItemBasicFragment = (
  { __typename?: 'ToplineSettingItem' }
  & Pick<ToplineSettingItem, 'position' | 'itemType' | 'itemId'>
);

export type AppliedToplinesFragmentFragment = (
  { __typename?: 'AppliedToplines' }
  & Pick<AppliedToplines, 'id' | 'campaignContextId'>
  & { item1: Maybe<(
    { __typename?: 'AppliedToplineItem' }
    & AppliedToplineItemFragmentFragment
  )>, item2: Maybe<(
    { __typename?: 'AppliedToplineItem' }
    & AppliedToplineItemFragmentFragment
  )>, item3: Maybe<(
    { __typename?: 'AppliedToplineItem' }
    & AppliedToplineItemFragmentFragment
  )>, item4: Maybe<(
    { __typename?: 'AppliedToplineItem' }
    & AppliedToplineItemFragmentFragment
  )>, item5: Maybe<(
    { __typename?: 'AppliedToplineItem' }
    & AppliedToplineItemFragmentFragment
  )> }
);

export type AppliedToplineItemFragmentFragment = (
  { __typename?: 'AppliedToplineItem' }
  & { toplineItem: Maybe<(
    { __typename?: 'ToplineSettingItem' }
    & ToplineSettingItemBasicFragment
  )>, appliedToplineValue: Maybe<(
    { __typename?: 'Address' }
    & AppliedToplineItemValueFragment_Address_Fragment
  ) | (
    { __typename?: 'Email' }
    & AppliedToplineItemValueFragment_Email_Fragment
  ) | (
    { __typename?: 'EntityLanguage' }
    & AppliedToplineItemValueFragment_EntityLanguage_Fragment
  ) | (
    { __typename?: 'Note' }
    & AppliedToplineItemValueFragment_Note_Fragment
  ) | (
    { __typename?: 'PhoneNumber' }
    & AppliedToplineItemValueFragment_PhoneNumber_Fragment
  ) | (
    { __typename?: 'SocialProfile' }
    & AppliedToplineItemValueFragment_SocialProfile_Fragment
  ) | (
    { __typename?: 'ToplineAge' }
    & AppliedToplineItemValueFragment_ToplineAge_Fragment
  ) | (
    { __typename?: 'ToplineAppliedEntityConnections' }
    & AppliedToplineItemValueFragment_ToplineAppliedEntityConnections_Fragment
  ) | (
    { __typename?: 'ToplineAppliedTags' }
    & AppliedToplineItemValueFragment_ToplineAppliedTags_Fragment
  ) | (
    { __typename?: 'ToplinePreferredLanguage' }
    & AppliedToplineItemValueFragment_ToplinePreferredLanguage_Fragment
  )> }
);

export type AppliedToplineItemWithConnectionToplinesFragment = (
  { __typename?: 'AppliedToplineItem' }
  & { toplineItem: Maybe<(
    { __typename?: 'ToplineSettingItem' }
    & ToplineSettingItemBasicFragment
  )>, appliedToplineValue: Maybe<(
    { __typename?: 'Address' }
    & AppliedToplineValueWithConnectionToplines_Address_Fragment
  ) | (
    { __typename?: 'Email' }
    & AppliedToplineValueWithConnectionToplines_Email_Fragment
  ) | (
    { __typename?: 'EntityLanguage' }
    & AppliedToplineValueWithConnectionToplines_EntityLanguage_Fragment
  ) | (
    { __typename?: 'Note' }
    & AppliedToplineValueWithConnectionToplines_Note_Fragment
  ) | (
    { __typename?: 'PhoneNumber' }
    & AppliedToplineValueWithConnectionToplines_PhoneNumber_Fragment
  ) | (
    { __typename?: 'SocialProfile' }
    & AppliedToplineValueWithConnectionToplines_SocialProfile_Fragment
  ) | (
    { __typename?: 'ToplineAge' }
    & AppliedToplineValueWithConnectionToplines_ToplineAge_Fragment
  ) | (
    { __typename?: 'ToplineAppliedEntityConnections' }
    & AppliedToplineValueWithConnectionToplines_ToplineAppliedEntityConnections_Fragment
  ) | (
    { __typename?: 'ToplineAppliedTags' }
    & AppliedToplineValueWithConnectionToplines_ToplineAppliedTags_Fragment
  ) | (
    { __typename?: 'ToplinePreferredLanguage' }
    & AppliedToplineValueWithConnectionToplines_ToplinePreferredLanguage_Fragment
  )> }
);

type AppliedToplineValueWithConnectionHighlightedTopline_Address_Fragment = { __typename?: 'Address' };

type AppliedToplineValueWithConnectionHighlightedTopline_Email_Fragment = { __typename?: 'Email' };

type AppliedToplineValueWithConnectionHighlightedTopline_EntityLanguage_Fragment = { __typename?: 'EntityLanguage' };

type AppliedToplineValueWithConnectionHighlightedTopline_Note_Fragment = { __typename?: 'Note' };

type AppliedToplineValueWithConnectionHighlightedTopline_PhoneNumber_Fragment = { __typename?: 'PhoneNumber' };

type AppliedToplineValueWithConnectionHighlightedTopline_SocialProfile_Fragment = { __typename?: 'SocialProfile' };

type AppliedToplineValueWithConnectionHighlightedTopline_ToplineAge_Fragment = { __typename?: 'ToplineAge' };

type AppliedToplineValueWithConnectionHighlightedTopline_ToplineAppliedEntityConnections_Fragment = (
  { __typename?: 'ToplineAppliedEntityConnections' }
  & { entityConnections: Maybe<Array<Maybe<(
    { __typename?: 'EntityConnection' }
    & EntityConnectionWithHighlightedToplineFragment
  )>>> }
);

type AppliedToplineValueWithConnectionHighlightedTopline_ToplineAppliedTags_Fragment = { __typename?: 'ToplineAppliedTags' };

type AppliedToplineValueWithConnectionHighlightedTopline_ToplinePreferredLanguage_Fragment = { __typename?: 'ToplinePreferredLanguage' };

export type AppliedToplineValueWithConnectionHighlightedToplineFragment = AppliedToplineValueWithConnectionHighlightedTopline_Address_Fragment | AppliedToplineValueWithConnectionHighlightedTopline_Email_Fragment | AppliedToplineValueWithConnectionHighlightedTopline_EntityLanguage_Fragment | AppliedToplineValueWithConnectionHighlightedTopline_Note_Fragment | AppliedToplineValueWithConnectionHighlightedTopline_PhoneNumber_Fragment | AppliedToplineValueWithConnectionHighlightedTopline_SocialProfile_Fragment | AppliedToplineValueWithConnectionHighlightedTopline_ToplineAge_Fragment | AppliedToplineValueWithConnectionHighlightedTopline_ToplineAppliedEntityConnections_Fragment | AppliedToplineValueWithConnectionHighlightedTopline_ToplineAppliedTags_Fragment | AppliedToplineValueWithConnectionHighlightedTopline_ToplinePreferredLanguage_Fragment;

type AppliedToplineValueWithConnectionToplines_Address_Fragment = { __typename?: 'Address' };

type AppliedToplineValueWithConnectionToplines_Email_Fragment = { __typename?: 'Email' };

type AppliedToplineValueWithConnectionToplines_EntityLanguage_Fragment = { __typename?: 'EntityLanguage' };

type AppliedToplineValueWithConnectionToplines_Note_Fragment = { __typename?: 'Note' };

type AppliedToplineValueWithConnectionToplines_PhoneNumber_Fragment = { __typename?: 'PhoneNumber' };

type AppliedToplineValueWithConnectionToplines_SocialProfile_Fragment = { __typename?: 'SocialProfile' };

type AppliedToplineValueWithConnectionToplines_ToplineAge_Fragment = { __typename?: 'ToplineAge' };

type AppliedToplineValueWithConnectionToplines_ToplineAppliedEntityConnections_Fragment = (
  { __typename?: 'ToplineAppliedEntityConnections' }
  & { entityConnections: Maybe<Array<Maybe<(
    { __typename?: 'EntityConnection' }
    & EntityConnectionWithToplinesFragment
  )>>> }
);

type AppliedToplineValueWithConnectionToplines_ToplineAppliedTags_Fragment = { __typename?: 'ToplineAppliedTags' };

type AppliedToplineValueWithConnectionToplines_ToplinePreferredLanguage_Fragment = { __typename?: 'ToplinePreferredLanguage' };

export type AppliedToplineValueWithConnectionToplinesFragment = AppliedToplineValueWithConnectionToplines_Address_Fragment | AppliedToplineValueWithConnectionToplines_Email_Fragment | AppliedToplineValueWithConnectionToplines_EntityLanguage_Fragment | AppliedToplineValueWithConnectionToplines_Note_Fragment | AppliedToplineValueWithConnectionToplines_PhoneNumber_Fragment | AppliedToplineValueWithConnectionToplines_SocialProfile_Fragment | AppliedToplineValueWithConnectionToplines_ToplineAge_Fragment | AppliedToplineValueWithConnectionToplines_ToplineAppliedEntityConnections_Fragment | AppliedToplineValueWithConnectionToplines_ToplineAppliedTags_Fragment | AppliedToplineValueWithConnectionToplines_ToplinePreferredLanguage_Fragment;

type AppliedToplineItemValueFragment_Address_Fragment = (
  { __typename?: 'Address' }
  & AddressDetailsFragment
);

type AppliedToplineItemValueFragment_Email_Fragment = (
  { __typename?: 'Email' }
  & EmailDetailsFragment
);

type AppliedToplineItemValueFragment_EntityLanguage_Fragment = { __typename?: 'EntityLanguage' };

type AppliedToplineItemValueFragment_Note_Fragment = (
  { __typename?: 'Note' }
  & NoteDetailsFragment
);

type AppliedToplineItemValueFragment_PhoneNumber_Fragment = (
  { __typename?: 'PhoneNumber' }
  & PhoneDetailsFragment
);

type AppliedToplineItemValueFragment_SocialProfile_Fragment = (
  { __typename?: 'SocialProfile' }
  & SocialProfileDetailsFragment
);

type AppliedToplineItemValueFragment_ToplineAge_Fragment = (
  { __typename?: 'ToplineAge' }
  & Pick<ToplineAge, 'dateOfBirth' | 'age'>
);

type AppliedToplineItemValueFragment_ToplineAppliedEntityConnections_Fragment = (
  { __typename?: 'ToplineAppliedEntityConnections' }
  & { entityConnections: Maybe<Array<Maybe<(
    { __typename?: 'EntityConnection' }
    & EntityConnectionCoreFragment
  )>>> }
);

type AppliedToplineItemValueFragment_ToplineAppliedTags_Fragment = (
  { __typename?: 'ToplineAppliedTags' }
  & { appliedTags: Maybe<Array<(
    { __typename?: 'TaggableLogbook' }
    & TaggableLogbookDetailsFragment
  )>> }
);

type AppliedToplineItemValueFragment_ToplinePreferredLanguage_Fragment = (
  { __typename?: 'ToplinePreferredLanguage' }
  & { entityLanguages: Maybe<Array<(
    { __typename?: 'EntityLanguage' }
    & Pick<EntityLanguage, 'languageCode' | 'preferred'>
  )>> }
);

export type AppliedToplineItemValueFragmentFragment = AppliedToplineItemValueFragment_Address_Fragment | AppliedToplineItemValueFragment_Email_Fragment | AppliedToplineItemValueFragment_EntityLanguage_Fragment | AppliedToplineItemValueFragment_Note_Fragment | AppliedToplineItemValueFragment_PhoneNumber_Fragment | AppliedToplineItemValueFragment_SocialProfile_Fragment | AppliedToplineItemValueFragment_ToplineAge_Fragment | AppliedToplineItemValueFragment_ToplineAppliedEntityConnections_Fragment | AppliedToplineItemValueFragment_ToplineAppliedTags_Fragment | AppliedToplineItemValueFragment_ToplinePreferredLanguage_Fragment;

export type HighlightedToplineForEntityFragment = (
  { __typename?: 'AppliedToplines' }
  & Pick<AppliedToplines, 'id' | 'campaignContextId'>
  & { item0: Maybe<(
    { __typename?: 'AppliedToplineItem' }
    & { appliedToplineValue: Maybe<(
      { __typename?: 'Address' }
      & AppliedToplineValueWithConnectionHighlightedTopline_Address_Fragment
    ) | (
      { __typename?: 'Email' }
      & AppliedToplineValueWithConnectionHighlightedTopline_Email_Fragment
    ) | (
      { __typename?: 'EntityLanguage' }
      & AppliedToplineValueWithConnectionHighlightedTopline_EntityLanguage_Fragment
    ) | (
      { __typename?: 'Note' }
      & AppliedToplineValueWithConnectionHighlightedTopline_Note_Fragment
    ) | (
      { __typename?: 'PhoneNumber' }
      & AppliedToplineValueWithConnectionHighlightedTopline_PhoneNumber_Fragment
    ) | (
      { __typename?: 'SocialProfile' }
      & AppliedToplineValueWithConnectionHighlightedTopline_SocialProfile_Fragment
    ) | (
      { __typename?: 'ToplineAge' }
      & AppliedToplineValueWithConnectionHighlightedTopline_ToplineAge_Fragment
    ) | (
      { __typename?: 'ToplineAppliedEntityConnections' }
      & AppliedToplineValueWithConnectionHighlightedTopline_ToplineAppliedEntityConnections_Fragment
    ) | (
      { __typename?: 'ToplineAppliedTags' }
      & AppliedToplineValueWithConnectionHighlightedTopline_ToplineAppliedTags_Fragment
    ) | (
      { __typename?: 'ToplinePreferredLanguage' }
      & AppliedToplineValueWithConnectionHighlightedTopline_ToplinePreferredLanguage_Fragment
    )> }
    & AppliedToplineItemFragmentFragment
  )> }
);

export type HighlightedToplineForConnectionFragment = (
  { __typename?: 'AppliedToplines' }
  & Pick<AppliedToplines, 'id' | 'campaignContextId'>
  & { item0: Maybe<(
    { __typename?: 'AppliedToplineItem' }
    & AppliedToplineItemFragmentFragment
  )> }
);

export type UserDetailsFragment = (
  { __typename?: 'User' }
  & Pick<User, 'id' | 'role' | 'disabled' | 'disableOn' | 'createdAt' | 'confirmed' | 'mfaRequired' | 'email' | 'firstName' | 'lastName' | 'phoneNumber' | 'lastLogin' | 'linkedEntityId'>
  & { mfaFactor: Maybe<(
    { __typename?: 'MfaFactor' }
    & Pick<MfaFactor, 'factorType' | 'id' | 'status'>
  )>, campaigns: Maybe<Array<Maybe<(
    { __typename?: 'CampaignPublic' }
    & Pick<CampaignPublic, 'id' | 'name'>
  )>>> }
);

export type UserPublicDetailsFragment = (
  { __typename?: 'UserPublic' }
  & Pick<UserPublic, 'firstName' | 'lastName' | 'email' | 'linkedEntityId' | 'id' | 'name'>
);

export type UserWithTurfAssignmentsFragment = (
  { __typename?: 'User' }
  & Pick<User, 'id'>
  & { turfAssignments: Maybe<Array<Maybe<(
    { __typename?: 'TurfAssignment' }
    & Pick<TurfAssignment, 'id' | 'restrictionEnabled'>
    & { campaign: Maybe<(
      { __typename?: 'CampaignPublic' }
      & Pick<CampaignPublic, 'id'>
    )>, turfTags: Maybe<Array<Maybe<(
      { __typename?: 'TurfTag' }
      & Pick<TurfTag, 'id'>
      & { tag: Maybe<(
        { __typename?: 'AddressTag' }
        & Pick<AddressTag, 'id'>
      ) | (
        { __typename?: 'DateTag' }
        & Pick<DateTag, 'id'>
      ) | (
        { __typename?: 'NotesTag' }
        & Pick<NotesTag, 'id'>
      ) | (
        { __typename?: 'NumberTag' }
        & Pick<NumberTag, 'id'>
      ) | (
        { __typename?: 'ShiftTag' }
        & Pick<ShiftTag, 'id'>
      ) | (
        { __typename?: 'StandardTag' }
        & Pick<StandardTag, 'id'>
      )> }
    )>>> }
  )>>> }
);

export type GetAssessmentInfoQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssessmentInfoQueryQuery = (
  { __typename?: 'Query' }
  & { getAssessmentInfo: Maybe<(
    { __typename?: 'AssessmentInfo' }
    & AssessmentSettingsFragment
  )> }
);

export type GetCampaignParticipantsQueryVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type GetCampaignParticipantsQuery = (
  { __typename?: 'Query' }
  & { getCampaign: Maybe<(
    { __typename?: 'Campaign' }
    & Pick<Campaign, 'id'>
    & { participants: Maybe<(
      { __typename?: 'UserConnectionWithTotalCount' }
      & { edges: Maybe<Array<Maybe<(
        { __typename?: 'UserEdge' }
        & { node: Maybe<(
          { __typename?: 'User' }
          & Pick<User, 'id' | 'confirmed' | 'disabled' | 'firstName' | 'lastName' | 'email'>
        )> }
      )>>> }
    )> }
  )> }
);

export type SetAssessmentInfoMutationVariables = Exact<{
  input: SetAssessmentInfoInput;
}>;


export type SetAssessmentInfoMutation = (
  { __typename?: 'Mutation' }
  & { setAssessmentInfo: Maybe<(
    { __typename?: 'SetAssessmentInfoPayload' }
    & { assessmentInfo: (
      { __typename?: 'AssessmentInfo' }
      & AssessmentSettingsFragment
    ) }
  )> }
);

export type SetAssessmentOverridesMutationVariables = Exact<{
  input: SetAssessmentOverridesInput;
}>;


export type SetAssessmentOverridesMutation = (
  { __typename?: 'Mutation' }
  & { setAssessmentOverrides: Maybe<(
    { __typename?: 'SetAssessmentOverridesPayload' }
    & { assessmentInfo: (
      { __typename?: 'AssessmentInfo' }
      & AssessmentSettingsFragment
    ) }
  )> }
);

export type CreateCampaignCopyMutationVariables = Exact<{
  input: CreateCampaignCopyInput;
}>;


export type CreateCampaignCopyMutation = (
  { __typename?: 'Mutation' }
  & { createCampaignCopy: Maybe<(
    { __typename?: 'CreateCampaignCopyPayload' }
    & { campaign: Maybe<(
      { __typename?: 'Campaign' }
      & Pick<Campaign, 'entitiesCount'>
      & CampaignWithoutTagsFragment
    )> }
  )> }
);

export type CreateCampaignMutationVariables = Exact<{
  input: CreateCampaignInput;
}>;


export type CreateCampaignMutation = (
  { __typename?: 'Mutation' }
  & { createCampaign: Maybe<(
    { __typename?: 'CreateCampaignPayload' }
    & { campaign: Maybe<(
      { __typename?: 'Campaign' }
      & CampaignWithoutTagsFragment
    )> }
  )> }
);

export type UpdateCampaignConnectionTypeConfigMutationVariables = Exact<{
  input: UpdateCampaignEntityConnectionTypeConfigurationInput;
}>;


export type UpdateCampaignConnectionTypeConfigMutation = (
  { __typename?: 'Mutation' }
  & { updateCampaignEntityConnectionTypeConfiguration: Maybe<(
    { __typename?: 'UpdateCampaignEntityConnectionTypeConfigurationPayload' }
    & { campaignEntityConnectionTypeConfiguration: Maybe<(
      { __typename?: 'CampaignEntityConnectionTypeConfiguration' }
      & CampaignConnectionTypeConfigDetailsFragment
    )> }
  )> }
);

export type UpdateCampaignEntityTypeConfigMutationVariables = Exact<{
  input: UpdateCampaignEntityTypeConfigurationInput;
}>;


export type UpdateCampaignEntityTypeConfigMutation = (
  { __typename?: 'Mutation' }
  & { updateCampaignEntityTypeConfiguration: Maybe<(
    { __typename?: 'UpdateCampaignEntityTypeConfigurationPayload' }
    & { campaignEntityTypeConfiguration: Maybe<(
      { __typename?: 'CampaignEntityTypeConfiguration' }
      & CampaignEntityTypeConfigDetailsFragment
    )> }
  )> }
);

export type UpdateCampaignExportRestrictionsMutationVariables = Exact<{
  input: UpdateCampaignExportRestrictionsInput;
}>;


export type UpdateCampaignExportRestrictionsMutation = (
  { __typename?: 'Mutation' }
  & { updateCampaignExportRestrictions: Maybe<(
    { __typename?: 'UpdateCampaignExportRestrictionsPayload' }
    & { campaign: Maybe<(
      { __typename?: 'Campaign' }
      & CampaignWithoutTagsFragment
    )> }
  )> }
);

export type UpdateCampaignDetailsMutationVariables = Exact<{
  input: UpdateCampaignInput;
}>;


export type UpdateCampaignDetailsMutation = (
  { __typename?: 'Mutation' }
  & { updateCampaign: Maybe<(
    { __typename?: 'UpdateCampaignPayload' }
    & { campaign: Maybe<(
      { __typename?: 'Campaign' }
      & CampaignWithoutTagsFragment
    )> }
  )> }
);

export type CreateEntityConnectionTypeMutationVariables = Exact<{
  input: CreateEntityConnectionTypeInput;
}>;


export type CreateEntityConnectionTypeMutation = (
  { __typename?: 'Mutation' }
  & { createEntityConnectionType: Maybe<(
    { __typename?: 'CreateEntityConnectionTypePayload' }
    & { entityConnectionType: Maybe<(
      { __typename?: 'EntityConnectionType' }
      & EntityConnectionTypeDetailsFragment
    )> }
  )> }
);

export type UpdateEntityConnectionTypeMutationVariables = Exact<{
  input: UpdateEntityConnectionTypeInput;
}>;


export type UpdateEntityConnectionTypeMutation = (
  { __typename?: 'Mutation' }
  & { updateEntityConnectionType: Maybe<(
    { __typename?: 'UpdateEntityConnectionTypePayload' }
    & { entityConnectionType: Maybe<(
      { __typename?: 'EntityConnectionType' }
      & EntityConnectionTypeDetailsFragment
    )> }
  )> }
);

export type CreateContactAttemptMutationVariables = Exact<{
  input: CreateContactAttemptInput;
}>;


export type CreateContactAttemptMutation = (
  { __typename?: 'Mutation' }
  & { createContactAttempt: Maybe<(
    { __typename?: 'CreateContactAttemptPayload' }
    & { contactAttempt: Maybe<(
      { __typename?: 'ContactAttempt' }
      & Pick<ContactAttempt, 'id' | 'contactInfoId' | 'contactInfoType' | 'createdAt' | 'disposition' | 'note'>
      & { createdBy: Maybe<(
        { __typename?: 'UserPublic' }
        & UserPublicDetailsFragment
      )> }
    )> }
  )> }
);

export type CreateCustomIdMutationVariables = Exact<{
  input: CreateCustomIdInput;
}>;


export type CreateCustomIdMutation = (
  { __typename?: 'Mutation' }
  & { createCustomId: Maybe<(
    { __typename?: 'CreateCustomIdPayload' }
    & { customIdType: (
      { __typename?: 'CustomIdType' }
      & CustomIdTypeDetailsFragment
    ) }
  )> }
);

export type CreateCustomFormMutationVariables = Exact<{
  input: CreateCustomFormInput;
}>;


export type CreateCustomFormMutation = (
  { __typename?: 'Mutation' }
  & { createCustomForm: Maybe<(
    { __typename?: 'CreateCustomFormPayload' }
    & { customForm: (
      { __typename?: 'CustomForm' }
      & CustomFormDetailsFragment
    ) }
  )> }
);

export type UpdateCustomFormFieldsMutationVariables = Exact<{
  input: UpdateCustomFormFieldsInput;
}>;


export type UpdateCustomFormFieldsMutation = (
  { __typename?: 'Mutation' }
  & { updateCustomFormFields: Maybe<(
    { __typename?: 'UpdateCustomFormFieldsPayload' }
    & { customForm: (
      { __typename?: 'CustomForm' }
      & CustomFormDetailsFragment
    ) }
  )> }
);

export type DeleteAttachmentMutationVariables = Exact<{
  input: DeleteAttachmentInput;
}>;


export type DeleteAttachmentMutation = (
  { __typename?: 'Mutation' }
  & { deleteAttachment: Maybe<(
    { __typename?: 'DeleteAttachmentPayload' }
    & Pick<DeleteAttachmentPayload, 'success'>
  )> }
);

export type ApplyEntityConnectionTagMutationVariables = Exact<{
  input: ApplyTagToEntityConnectionInput;
}>;


export type ApplyEntityConnectionTagMutation = (
  { __typename?: 'Mutation' }
  & { applyTagToEntityConnection: Maybe<(
    { __typename?: 'ApplyTagToEntityConnectionPayload' }
    & { entityConnection: Maybe<(
      { __typename?: 'EntityConnection' }
      & EntityConnectionWithToplinesFragment
      & EntityConnectionWithTagsFragment
      & EntityConnectionWithNotesFragment
    )> }
  )> }
);

export type CreateEntityConnectionMutationVariables = Exact<{
  input: CreateEntityConnectionInput;
}>;


export type CreateEntityConnectionMutation = (
  { __typename?: 'Mutation' }
  & { createEntityConnection: Maybe<(
    { __typename?: 'CreateEntityConnectionPayload' }
    & { entityConnection: Maybe<(
      { __typename?: 'EntityConnection' }
      & EntityConnectionWithTagsFragment
      & EntityConnectionWithNotesFragment
      & EntityConnectionWithToplinesFragment
    )> }
  )> }
);

export type DeleteEntityConnectionMutationVariables = Exact<{
  input: DeleteEntityConnectionInput;
}>;


export type DeleteEntityConnectionMutation = (
  { __typename?: 'Mutation' }
  & { deleteEntityConnection: Maybe<(
    { __typename?: 'DeleteEntityConnectionPayload' }
    & { entityConnection: Maybe<(
      { __typename?: 'EntityConnection' }
      & EntityConnectionCoreFragment
      & EntityConnectionWithNotesFragment
    )> }
  )> }
);

export type UnapplyEntityConnectionTagMutationVariables = Exact<{
  input: UnapplyEntityConnectionTagInput;
}>;


export type UnapplyEntityConnectionTagMutation = (
  { __typename?: 'Mutation' }
  & { unapplyEntityConnectionTag: Maybe<(
    { __typename?: 'UnapplyEntityConnectionTagPayload' }
    & { entityConnection: Maybe<(
      { __typename?: 'EntityConnection' }
      & EntityConnectionWithToplinesFragment
      & EntityConnectionWithTagsFragment
      & EntityConnectionWithNotesFragment
    )> }
  )> }
);

export type UpdateEntityConnectionMutationVariables = Exact<{
  input: UpdateEntityConnectionInput;
}>;


export type UpdateEntityConnectionMutation = (
  { __typename?: 'Mutation' }
  & { updateEntityConnection: Maybe<(
    { __typename?: 'UpdateEntityConnectionPayload' }
    & { entityConnection: Maybe<(
      { __typename?: 'EntityConnection' }
      & EntityConnectionCoreFragment
      & EntityConnectionWithNotesFragment
    )> }
  )> }
);

export type CreateEntityTypeMutationVariables = Exact<{
  input: CreateEntityTypeInput;
}>;


export type CreateEntityTypeMutation = (
  { __typename?: 'Mutation' }
  & { createEntityType: Maybe<(
    { __typename?: 'CreateEntityTypePayload' }
    & { entityType: Maybe<(
      { __typename?: 'EntityType' }
      & EntityTypeDetailsFragment
    )> }
  )> }
);

export type UpdateEntityTypeMutationVariables = Exact<{
  input: UpdateEntityTypeInput;
}>;


export type UpdateEntityTypeMutation = (
  { __typename?: 'Mutation' }
  & { updateEntityType: Maybe<(
    { __typename?: 'UpdateEntityTypePayload' }
    & { entityType: Maybe<(
      { __typename?: 'EntityType' }
      & EntityTypeDetailsFragment
    )> }
  )> }
);

export type AddEntityToCampaignMutationVariables = Exact<{
  input: AddEntityToCampaignInput;
}>;


export type AddEntityToCampaignMutation = (
  { __typename?: 'Mutation' }
  & { addEntityToCampaign: Maybe<(
    { __typename?: 'AddEntityToCampaignPayload' }
    & { entity: Maybe<(
      { __typename?: 'Entity' }
      & EntityCoreFragment
      & EntityWithCampaignsFragment
      & EntityWithBasicInfoFragment
    )> }
  )> }
);

export type AddSocialProfileMutationVariables = Exact<{
  input: AddSocialProfileInput;
}>;


export type AddSocialProfileMutation = (
  { __typename?: 'Mutation' }
  & { addSocialProfile: Maybe<(
    { __typename?: 'AddSocialProfilePayload' }
    & { entity: Maybe<(
      { __typename?: 'Entity' }
      & EntityCoreFragment
      & EntityWithToplinesFragment
      & EntityWithSocialProfilesFragment
    )> }
  )> }
);

export type ApplyEntityTagMutationVariables = Exact<{
  input: ApplyTagToEntityInput;
}>;


export type ApplyEntityTagMutation = (
  { __typename?: 'Mutation' }
  & { applyTagToEntity: Maybe<(
    { __typename?: 'ApplyTagToEntityPayload' }
    & { entity: Maybe<(
      { __typename?: 'Entity' }
      & EntityCoreFragment
      & EntityWithToplinesFragment
      & EntityWithTagsFragment
    )> }
  )> }
);

export type AssignFollowUpMutationVariables = Exact<{
  input: AssignFollowUpInput;
}>;


export type AssignFollowUpMutation = (
  { __typename?: 'Mutation' }
  & { assignFollowUp: Maybe<(
    { __typename?: 'AssignFollowUpPayload' }
    & { followUp: (
      { __typename?: 'FollowUp' }
      & FollowUpDetailsFragment
    ) }
  )> }
);

export type CompleteActiveFollowUpsMutationVariables = Exact<{
  input: CompleteActiveFollowUpsInput;
}>;


export type CompleteActiveFollowUpsMutation = (
  { __typename?: 'Mutation' }
  & { completeActiveFollowUps: Maybe<(
    { __typename?: 'CompleteActiveFollowUpsPayload' }
    & { entity: (
      { __typename?: 'Entity' }
      & EntityCoreFragment
      & EntityWithBasicInfoFragment
      & EntityWithFollowUpDetailsFragment
    ) }
  )> }
);

export type CreateAddressMutationVariables = Exact<{
  input: CreateAddressesInput;
}>;


export type CreateAddressMutation = (
  { __typename?: 'Mutation' }
  & { createAddresses: Maybe<(
    { __typename?: 'CreateAddressesPayload' }
    & { entity: (
      { __typename?: 'Entity' }
      & EntityCoreFragment
      & EntityWithToplinesFragment
      & EntityWithBestAddressFragment
      & EntityWithAddressesFragment
    ) }
  )> }
);

export type CreateAssessmentMutationVariables = Exact<{
  input: CreateAssessmentsInput;
}>;


export type CreateAssessmentMutation = (
  { __typename?: 'Mutation' }
  & { createAssessments: Maybe<(
    { __typename?: 'CreateAssessmentsPayload' }
    & { entity: (
      { __typename?: 'Entity' }
      & EntityWithAssessmentsFragment
    ) }
  )> }
);

export type CreateEmailMutationVariables = Exact<{
  input: CreateEmailsInput;
}>;


export type CreateEmailMutation = (
  { __typename?: 'Mutation' }
  & { createEmails: Maybe<(
    { __typename?: 'CreateEmailsPayload' }
    & { entity: (
      { __typename?: 'Entity' }
      & { emails: Maybe<Array<Maybe<(
        { __typename?: 'Email' }
        & EmailDetailsFragment
      )>>> }
      & EntityCoreFragment
      & EntityWithToplinesFragment
      & EntityWithBestEmailFragment
    ) }
  )> }
);

export type CreateEntityMutationVariables = Exact<{
  input: CreateEntityInput;
}>;


export type CreateEntityMutation = (
  { __typename?: 'Mutation' }
  & { createEntity: Maybe<(
    { __typename?: 'CreateEntityPayload' }
    & { entity: (
      { __typename?: 'Entity' }
      & EntityCoreFragment
      & EntityWithBasicInfoFragment
      & EntityWithEntityTypeFragment
      & EntityWithToplinesFragment
    ) }
  )> }
);

export type CreateFollowUpMutationVariables = Exact<{
  input: CreateFollowUpInput;
}>;


export type CreateFollowUpMutation = (
  { __typename?: 'Mutation' }
  & { createFollowUp: Maybe<(
    { __typename?: 'CreateFollowUpPayload' }
    & { entity: (
      { __typename?: 'Entity' }
      & EntityCoreFragment
      & EntityWithBasicInfoFragment
      & EntityWithFollowUpDetailsFragment
    ) }
  )> }
);

export type CreatePhoneMutationVariables = Exact<{
  input: CreatePhoneNumbersInput;
}>;


export type CreatePhoneMutation = (
  { __typename?: 'Mutation' }
  & { createPhoneNumbers: Maybe<(
    { __typename?: 'CreatePhoneNumbersPayload' }
    & { entity: (
      { __typename?: 'Entity' }
      & EntityCoreFragment
      & EntityWithToplinesFragment
      & EntityWithBestPhoneFragment
      & EntityWithPhonesFragment
    ) }
  )> }
);

export type ExportEntitiesMutationVariables = Exact<{
  input: EntitiesReportInput;
}>;


export type ExportEntitiesMutation = (
  { __typename?: 'Mutation' }
  & { entitiesReport: Maybe<(
    { __typename?: 'EntitiesReportPayload' }
    & Pick<EntitiesReportPayload, 'success'>
  )> }
);

export type RemoveEntityCustomIdMutationVariables = Exact<{
  input: RemoveEntityCustomIdInput;
}>;


export type RemoveEntityCustomIdMutation = (
  { __typename?: 'Mutation' }
  & { removeEntityCustomId: Maybe<(
    { __typename?: 'RemoveEntityCustomIdPayload' }
    & Pick<RemoveEntityCustomIdPayload, 'success'>
  )> }
);

export type RemoveEntityFromCampaignMutationVariables = Exact<{
  input: RemoveEntityFromCampaignInput;
}>;


export type RemoveEntityFromCampaignMutation = (
  { __typename?: 'Mutation' }
  & { removeEntityFromCampaign: Maybe<(
    { __typename?: 'RemoveEntityFromCampaignPayload' }
    & { entity: Maybe<(
      { __typename?: 'Entity' }
      & Pick<Entity, 'id' | 'campaignContextId' | 'updatedAt'>
      & { campaigns: Maybe<Array<Maybe<(
        { __typename?: 'CampaignPublic' }
        & Pick<CampaignPublic, 'id' | 'name'>
      )>>> }
    )> }
  )> }
);

export type RemoveSocialProfileMutationVariables = Exact<{
  input: RemoveSocialProfileInput;
}>;


export type RemoveSocialProfileMutation = (
  { __typename?: 'Mutation' }
  & { removeSocialProfile: Maybe<(
    { __typename?: 'RemoveSocialProfilePayload' }
    & { entity: Maybe<(
      { __typename?: 'Entity' }
      & EntityCoreFragment
      & EntityWithToplinesFragment
      & EntityWithSocialProfilesFragment
    )> }
  )> }
);

export type UnapplyEntityTagMutationVariables = Exact<{
  input: UnapplyTagInput;
}>;


export type UnapplyEntityTagMutation = (
  { __typename?: 'Mutation' }
  & { unapplyTag: Maybe<(
    { __typename?: 'UnapplyTagPayload' }
    & { entity: Maybe<(
      { __typename?: 'Entity' }
      & EntityWithToplinesFragment
      & EntityWithTagsFragment
    )> }
  )> }
);

export type UpdateAddressMutationVariables = Exact<{
  input: UpdateAddressInput;
}>;


export type UpdateAddressMutation = (
  { __typename?: 'Mutation' }
  & { updateAddress: Maybe<(
    { __typename?: 'UpdateAddressPayload' }
    & { entity: Maybe<(
      { __typename?: 'Entity' }
      & EntityCoreFragment
      & EntityWithToplinesFragment
      & EntityWithBestAddressFragment
      & EntityWithAddressesFragment
    )> }
  )> }
);

export type UpdateEntityCustomIdMutationVariables = Exact<{
  input: UpdateEntityCustomIdInput;
}>;


export type UpdateEntityCustomIdMutation = (
  { __typename?: 'Mutation' }
  & { updateEntityCustomId: Maybe<(
    { __typename?: 'UpdateEntityCustomIdPayload' }
    & { entityCustomId: Maybe<(
      { __typename?: 'EntityCustomId' }
      & EntityCustomIdDetailsFragment
    )> }
  )> }
);

export type UpdateEmailMutationVariables = Exact<{
  input: UpdateEmailInput;
}>;


export type UpdateEmailMutation = (
  { __typename?: 'Mutation' }
  & { updateEmail: Maybe<(
    { __typename?: 'UpdateEmailPayload' }
    & { entity: Maybe<(
      { __typename?: 'Entity' }
      & EntityCoreFragment
      & EntityWithToplinesFragment
      & EntityWithBestEmailFragment
      & EntityWithEmailsFragment
    )> }
  )> }
);

export type UpdateEntityBasicInfoMutationVariables = Exact<{
  input: UpdateEntityInput;
}>;


export type UpdateEntityBasicInfoMutation = (
  { __typename?: 'Mutation' }
  & { updateEntity: Maybe<(
    { __typename?: 'UpdateEntityPayload' }
    & { entity: Maybe<(
      { __typename?: 'Entity' }
      & EntityCoreFragment
      & EntityWithEntityTypeFragment
      & EntityWithToplinesFragment
      & EntityWithBasicInfoFragment
    )> }
  )> }
);

export type UpdateFollowUpMutationVariables = Exact<{
  input: UpdateFollowUpInput;
}>;


export type UpdateFollowUpMutation = (
  { __typename?: 'Mutation' }
  & { updateFollowUp: Maybe<(
    { __typename?: 'UpdateFollowUpPayload' }
    & { followUp: (
      { __typename?: 'FollowUp' }
      & Pick<FollowUp, 'id' | 'dueDate'>
    ) }
  )> }
);

export type UpdatePhoneMutationVariables = Exact<{
  input: UpdatePhoneNumberInput;
}>;


export type UpdatePhoneMutation = (
  { __typename?: 'Mutation' }
  & { updatePhoneNumber: Maybe<(
    { __typename?: 'UpdatePhoneNumberPayload' }
    & { entity: Maybe<(
      { __typename?: 'Entity' }
      & EntityCoreFragment
      & EntityWithToplinesFragment
      & EntityWithBestPhoneFragment
      & EntityWithPhonesFragment
    )> }
  )> }
);

export type UpdateSocialProfileMutationVariables = Exact<{
  input: UpdateSocialProfileInput;
}>;


export type UpdateSocialProfileMutation = (
  { __typename?: 'Mutation' }
  & { updateSocialProfile: Maybe<(
    { __typename?: 'UpdateSocialProfilePayload' }
    & { entity: Maybe<(
      { __typename?: 'Entity' }
      & EntityCoreFragment
      & EntityWithToplinesFragment
      & EntityWithSocialProfilesFragment
    )> }
  )> }
);

export type AddCalendarEventUsersMutationVariables = Exact<{
  input: AddCalendarEventUsersInput;
}>;


export type AddCalendarEventUsersMutation = (
  { __typename?: 'Mutation' }
  & { addCalendarEventUsers: Maybe<(
    { __typename?: 'AddCalendarEventUsersPayload' }
    & { calendarEvent: (
      { __typename?: 'CalendarEvent' }
      & CalendarEventDetailsFragment
    ) }
  )> }
);

export type CreateActionForCalendarEventActionMutationVariables = Exact<{
  input: CreateActionForCalendarEventActionInput;
}>;


export type CreateActionForCalendarEventActionMutation = (
  { __typename?: 'Mutation' }
  & { createActionForCalendarEventAction: Maybe<(
    { __typename?: 'CreateActionForCalendarEventActionPayload' }
    & { calendarEventAction: (
      { __typename?: 'CalendarEventAction' }
      & CalendarEventActionDetailsFragment
    ) }
  )> }
);

export type CreateCalendarEventMutationVariables = Exact<{
  input: CreateCalendarEventInput;
}>;


export type CreateCalendarEventMutation = (
  { __typename?: 'Mutation' }
  & { createCalendarEvent: Maybe<(
    { __typename?: 'CreateCalendarEventPayload' }
    & { calendarEvent: (
      { __typename?: 'CalendarEvent' }
      & CalendarEventDetailsFragment
    ) }
  )> }
);

export type CreateCalendarEventsMutationVariables = Exact<{
  input: CreateCalendarEventsInput;
}>;


export type CreateCalendarEventsMutation = (
  { __typename?: 'Mutation' }
  & { createCalendarEvents: Maybe<(
    { __typename?: 'CreateCalendarEventsPayload' }
    & { calendarEvents: Array<(
      { __typename?: 'CalendarEvent' }
      & CalendarEventDetailsFragment
    )> }
  )> }
);

export type DeleteCalendarEventMutationVariables = Exact<{
  input: DeleteCalendarEventInput;
}>;


export type DeleteCalendarEventMutation = (
  { __typename?: 'Mutation' }
  & { deleteCalendarEvent: Maybe<(
    { __typename?: 'DeleteCalendarEventPayload' }
    & { calendarEvent: (
      { __typename?: 'CalendarEvent' }
      & Pick<CalendarEvent, 'id'>
    ) }
  )> }
);

export type EditEventCompositeMutationVariables = Exact<{
  calendarEventId: Scalars['ID'];
  updateEventInput: UpdateCalendarEventInput;
  removeCalendarEventUsersInput: RemoveCalendarEventUsersInput;
  addCalendarEventUsersInput: AddCalendarEventUsersInput;
  linkToActionNetworkEvent: Scalars['Boolean'];
  actionNetworkEventId?: Maybe<Scalars['Int']>;
}>;


export type EditEventCompositeMutation = (
  { __typename?: 'Mutation' }
  & { removeUsers: Maybe<(
    { __typename?: 'RemoveCalendarEventUsersPayload' }
    & { calendarEvent: (
      { __typename?: 'CalendarEvent' }
      & Pick<CalendarEvent, 'id'>
    ) }
  )>, addUsers: Maybe<(
    { __typename?: 'AddCalendarEventUsersPayload' }
    & { calendarEvent: (
      { __typename?: 'CalendarEvent' }
      & Pick<CalendarEvent, 'id'>
    ) }
  )>, updateDetails: Maybe<(
    { __typename?: 'UpdateCalendarEventPayload' }
    & { calendarEvent: (
      { __typename?: 'CalendarEvent' }
      & CalendarEventDetailsFragment
    ) }
  )>, linkAN: Maybe<(
    { __typename?: 'LinkEventToActionNetworkPayload' }
    & { calendarEvent: (
      { __typename?: 'CalendarEvent' }
      & Pick<CalendarEvent, 'id' | 'actionNetworkEventId'>
    ) }
  )>, unlinkAN: Maybe<(
    { __typename?: 'UnlinkEventFromActionNetworkPayload' }
    & { calendarEvent: (
      { __typename?: 'CalendarEvent' }
      & Pick<CalendarEvent, 'id' | 'actionNetworkEventId'>
    ) }
  )> }
);

export type LinkEventToActionNetworkMutationVariables = Exact<{
  actionNetworkEventId: Scalars['Int'];
  calendarEventId: Scalars['ID'];
}>;


export type LinkEventToActionNetworkMutation = (
  { __typename?: 'Mutation' }
  & { linkEventToActionNetwork: Maybe<(
    { __typename?: 'LinkEventToActionNetworkPayload' }
    & { calendarEvent: (
      { __typename?: 'CalendarEvent' }
      & Pick<CalendarEvent, 'id' | 'actionNetworkEventId'>
    ) }
  )> }
);

export type RemoveCalendarEventUsersMutationVariables = Exact<{
  input: RemoveCalendarEventUsersInput;
}>;


export type RemoveCalendarEventUsersMutation = (
  { __typename?: 'Mutation' }
  & { removeCalendarEventUsers: Maybe<(
    { __typename?: 'RemoveCalendarEventUsersPayload' }
    & { calendarEvent: (
      { __typename?: 'CalendarEvent' }
      & CalendarEventDetailsFragment
    ) }
  )> }
);

export type SetCalendarEventResponseMutationVariables = Exact<{
  input: SetCalendarEventResponseInput;
}>;


export type SetCalendarEventResponseMutation = (
  { __typename?: 'Mutation' }
  & { setCalendarEventResponse: Maybe<(
    { __typename?: 'SetCalendarEventResponsePayload' }
    & { calendarEventResponse: (
      { __typename?: 'CalendarEventResponse' }
      & CalendarEventResponseCoreFragment
    ) }
  )> }
);

export type UnapplyCalendarEventResponseTagMutationVariables = Exact<{
  input: UnapplyCalendarEventResponseTagInput;
}>;


export type UnapplyCalendarEventResponseTagMutation = (
  { __typename?: 'Mutation' }
  & { unapplyCalendarEventResponseTag: Maybe<(
    { __typename?: 'UnapplyCalendarEventResponseTagPayload' }
    & { calendarEventResponse: Maybe<(
      { __typename?: 'CalendarEventResponse' }
      & CalendarEventResponseCoreFragment
    )> }
  )> }
);

export type UnlinkEventFromActionNetworkMutationVariables = Exact<{
  calendarEventId: Scalars['ID'];
}>;


export type UnlinkEventFromActionNetworkMutation = (
  { __typename?: 'Mutation' }
  & { unlinkEventFromActionNetwork: Maybe<(
    { __typename?: 'UnlinkEventFromActionNetworkPayload' }
    & { calendarEvent: (
      { __typename?: 'CalendarEvent' }
      & Pick<CalendarEvent, 'id' | 'actionNetworkEventId'>
    ) }
  )> }
);

export type UpdateCalendarEventActionScheduledDaysMutationVariables = Exact<{
  input: UpdateCalendarEventActionScheduledDaysInput;
}>;


export type UpdateCalendarEventActionScheduledDaysMutation = (
  { __typename?: 'Mutation' }
  & { updateCalendarEventActionScheduledDays: Maybe<(
    { __typename?: 'UpdateCalendarEventActionScheduledDaysPayload' }
    & { calendarEventAction: (
      { __typename?: 'CalendarEventAction' }
      & CalendarEventActionDetailsFragment
    ) }
  )> }
);

export type UpdateCalendarEventMutationVariables = Exact<{
  input: UpdateCalendarEventInput;
}>;


export type UpdateCalendarEventMutation = (
  { __typename?: 'Mutation' }
  & { updateCalendarEvent: Maybe<(
    { __typename?: 'UpdateCalendarEventPayload' }
    & { calendarEvent: (
      { __typename?: 'CalendarEvent' }
      & CalendarEventDetailsFragment
    ) }
  )> }
);

export type CreateExternalServiceMutationVariables = Exact<{
  input: CreateExternalServiceInput;
}>;


export type CreateExternalServiceMutation = (
  { __typename?: 'Mutation' }
  & { createExternalService: Maybe<(
    { __typename?: 'CreateExternalServicePayload' }
    & { externalService: Maybe<(
      { __typename?: 'ExternalService' }
      & Pick<ExternalService, 'id' | 'serviceName' | 'clientId' | 'workflowId'>
    )> }
  )> }
);

export type UpdateCampaignIntegrationsMutationVariables = Exact<{
  input: UpdateIntegrationsInput;
}>;


export type UpdateCampaignIntegrationsMutation = (
  { __typename?: 'Mutation' }
  & { updateIntegrations: Maybe<(
    { __typename?: 'UpdateIntegrationsPayload' }
    & { campaign: (
      { __typename?: 'Campaign' }
      & Pick<Campaign, 'id' | 'name'>
      & { integrations: Maybe<Array<Maybe<(
        { __typename?: 'Integration' }
        & Pick<Integration, 'id' | 'externalServiceId'>
      )>>> }
    ) }
  )> }
);

export type UpdateExternalServiceMutationVariables = Exact<{
  input: UpdateExternalServiceInput;
}>;


export type UpdateExternalServiceMutation = (
  { __typename?: 'Mutation' }
  & { updateExternalService: Maybe<(
    { __typename?: 'UpdateExternalServicePayload' }
    & { externalService: Maybe<(
      { __typename?: 'ExternalService' }
      & Pick<ExternalService, 'id' | 'serviceName' | 'clientId' | 'workflowId'>
    )> }
  )> }
);

export type CreateNoteMutationVariables = Exact<{
  input: CreateNotesInput;
}>;


export type CreateNoteMutation = (
  { __typename?: 'Mutation' }
  & { createNotes: Maybe<(
    { __typename?: 'CreateNotesPayload' }
    & { notes: Array<(
      { __typename?: 'Note' }
      & NoteDetailsFragment
    )> }
  )> }
);

export type PinNoteMutationVariables = Exact<{
  input: PinNoteInput;
}>;


export type PinNoteMutation = (
  { __typename?: 'Mutation' }
  & { pinNote: Maybe<(
    { __typename?: 'PinNotePayload' }
    & { note: (
      { __typename?: 'Note' }
      & NoteDetailsFragment
    ) }
  )> }
);

export type RemoveNoteMutationVariables = Exact<{
  input: RemoveNotesInput;
}>;


export type RemoveNoteMutation = (
  { __typename?: 'Mutation' }
  & { removeNotes: Maybe<(
    { __typename?: 'RemoveNotesPayload' }
    & Pick<RemoveNotesPayload, 'success'>
  )> }
);

export type UnpinNoteMutationVariables = Exact<{
  input: UnpinNoteInput;
}>;


export type UnpinNoteMutation = (
  { __typename?: 'Mutation' }
  & { unpinNote: Maybe<(
    { __typename?: 'UnpinNotePayload' }
    & { note: (
      { __typename?: 'Note' }
      & NoteDetailsFragment
    ) }
  )> }
);

export type UpdateNoteMutationVariables = Exact<{
  input: UpdateNoteInput;
}>;


export type UpdateNoteMutation = (
  { __typename?: 'Mutation' }
  & { updateNote: Maybe<(
    { __typename?: 'UpdateNotePayload' }
    & { note: (
      { __typename?: 'Note' }
      & NoteDetailsFragment
    ) }
  )> }
);

export type UpdateOrganizationMfaEnforcementMutationVariables = Exact<{
  input: UpdateOrganizationMfaEnforcementInput;
}>;


export type UpdateOrganizationMfaEnforcementMutation = (
  { __typename?: 'Mutation' }
  & { updateOrganizationMfaEnforcement: Maybe<(
    { __typename?: 'UpdateOrganizationMfaEnforcementPayload' }
    & { organization: Maybe<(
      { __typename?: 'Organization' }
      & OrganizationDetailsFragment
    )> }
  )> }
);

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = (
  { __typename?: 'Mutation' }
  & { updateOrganization: Maybe<(
    { __typename?: 'UpdateOrganizationPayload' }
    & { organization: Maybe<(
      { __typename?: 'Organization' }
      & OrganizationDetailsFragment
    )> }
  )> }
);

export type ApplyMassOperationMutationVariables = Exact<{
  input: ApplyMassOperationInput;
}>;


export type ApplyMassOperationMutation = (
  { __typename?: 'Mutation' }
  & { applyMassOperation: Maybe<(
    { __typename?: 'ApplyMassOperationPayload' }
    & Pick<ApplyMassOperationPayload, 'targetCount'>
  )> }
);

export type RestoreOriginalAddressMutationVariables = Exact<{
  input: RevertAddressInput;
}>;


export type RestoreOriginalAddressMutation = (
  { __typename?: 'Mutation' }
  & { revertAddress: Maybe<(
    { __typename?: 'RevertAddressPayload' }
    & { address: Maybe<(
      { __typename?: 'Address' }
      & AddressDetailsFragment
    )> }
  )> }
);

export type CreateSavedQueryMutationVariables = Exact<{
  input: CreateSavedQueryInput;
}>;


export type CreateSavedQueryMutation = (
  { __typename?: 'Mutation' }
  & { createSavedQuery: Maybe<(
    { __typename?: 'CreateSavedQueryPayload' }
    & { query: (
      { __typename?: 'SavedQuery' }
      & SavedQueryDetailsFragment
    ) }
  )> }
);

export type DeleteSavedQueryMutationVariables = Exact<{
  input: DeleteSavedQueryInput;
}>;


export type DeleteSavedQueryMutation = (
  { __typename?: 'Mutation' }
  & { deleteSavedQuery: Maybe<(
    { __typename?: 'DeleteSavedQueryPayload' }
    & Pick<DeleteSavedQueryPayload, 'success'>
  )> }
);

export type UpdateSavedQueryMutationVariables = Exact<{
  input: UpdateSavedQueryInput;
}>;


export type UpdateSavedQueryMutation = (
  { __typename?: 'Mutation' }
  & { updateSavedQuery: Maybe<(
    { __typename?: 'UpdateSavedQueryPayload' }
    & { query: (
      { __typename?: 'SavedQuery' }
      & SavedQueryDetailsFragment
    ) }
  )> }
);

export type AddTagCategoryToCampaignMutationVariables = Exact<{
  input: AddTagCategoryToCampaignInput;
  isInCampaignId?: Maybe<Scalars['ID']>;
}>;


export type AddTagCategoryToCampaignMutation = (
  { __typename?: 'Mutation' }
  & { addTagCategoryToCampaign: Maybe<(
    { __typename?: 'AddTagCategoryToCampaignPayload' }
    & { tagCategory: Maybe<(
      { __typename?: 'TagCategory' }
      & Pick<TagCategory, 'id' | 'isInCampaign'>
      & { group: (
        { __typename?: 'TagGroup' }
        & Pick<TagGroup, 'id' | 'name' | 'isInCampaign'>
      ) }
    )> }
  )> }
);

export type ApplyTagMutationVariables = Exact<{
  input: ApplyTagInput;
}>;


export type ApplyTagMutation = (
  { __typename?: 'Mutation' }
  & { applyTag: Maybe<(
    { __typename?: 'ApplyTagPayload' }
    & { taggableLogbook: Maybe<(
      { __typename?: 'TaggableLogbook' }
      & TaggableLogbookDetailsFragment
    )> }
  )> }
);

export type ArchiveTagCategoryMutationVariables = Exact<{
  input: UpdateTagStatusByCategoryInput;
}>;


export type ArchiveTagCategoryMutation = (
  { __typename?: 'Mutation' }
  & { updateTagStatusByCategory: Maybe<(
    { __typename?: 'UpdateTagStatusByCategoryPayload' }
    & { tagCategory: Maybe<(
      { __typename?: 'TagCategory' }
      & TagCategoryInfoFragment
    )> }
  )> }
);

export type AssociateTagToCampaignMutationVariables = Exact<{
  input: AssociateTagToCampaignInput;
  isInCampaignId?: Maybe<Scalars['ID']>;
}>;


export type AssociateTagToCampaignMutation = (
  { __typename?: 'Mutation' }
  & { associateTagToCampaign: Maybe<(
    { __typename?: 'AssociateTagToCampaignPayload' }
    & { tag: Maybe<(
      { __typename?: 'AddressTag' }
      & Pick<AddressTag, 'isInCampaign'>
      & { category: (
        { __typename?: 'TagCategory' }
        & Pick<TagCategory, 'id' | 'isInCampaign'>
        & { group: (
          { __typename?: 'TagGroup' }
          & Pick<TagGroup, 'id' | 'isInCampaign'>
        ) }
      ) }
      & TagInfo_AddressTag_Fragment
    ) | (
      { __typename?: 'DateTag' }
      & Pick<DateTag, 'isInCampaign'>
      & { category: (
        { __typename?: 'TagCategory' }
        & Pick<TagCategory, 'id' | 'isInCampaign'>
        & { group: (
          { __typename?: 'TagGroup' }
          & Pick<TagGroup, 'id' | 'isInCampaign'>
        ) }
      ) }
      & TagInfo_DateTag_Fragment
    ) | (
      { __typename?: 'NotesTag' }
      & Pick<NotesTag, 'isInCampaign'>
      & { category: (
        { __typename?: 'TagCategory' }
        & Pick<TagCategory, 'id' | 'isInCampaign'>
        & { group: (
          { __typename?: 'TagGroup' }
          & Pick<TagGroup, 'id' | 'isInCampaign'>
        ) }
      ) }
      & TagInfo_NotesTag_Fragment
    ) | (
      { __typename?: 'NumberTag' }
      & Pick<NumberTag, 'isInCampaign'>
      & { category: (
        { __typename?: 'TagCategory' }
        & Pick<TagCategory, 'id' | 'isInCampaign'>
        & { group: (
          { __typename?: 'TagGroup' }
          & Pick<TagGroup, 'id' | 'isInCampaign'>
        ) }
      ) }
      & TagInfo_NumberTag_Fragment
    ) | (
      { __typename?: 'ShiftTag' }
      & Pick<ShiftTag, 'isInCampaign'>
      & { category: (
        { __typename?: 'TagCategory' }
        & Pick<TagCategory, 'id' | 'isInCampaign'>
        & { group: (
          { __typename?: 'TagGroup' }
          & Pick<TagGroup, 'id' | 'isInCampaign'>
        ) }
      ) }
      & TagInfo_ShiftTag_Fragment
    ) | (
      { __typename?: 'StandardTag' }
      & Pick<StandardTag, 'isInCampaign'>
      & { category: (
        { __typename?: 'TagCategory' }
        & Pick<TagCategory, 'id' | 'isInCampaign'>
        & { group: (
          { __typename?: 'TagGroup' }
          & Pick<TagGroup, 'id' | 'isInCampaign'>
        ) }
      ) }
      & TagInfo_StandardTag_Fragment
    )> }
  )> }
);

export type ChangeTagCategoryGroupMutationVariables = Exact<{
  input: ChangeTagCategoryGroupInput;
}>;


export type ChangeTagCategoryGroupMutation = (
  { __typename?: 'Mutation' }
  & { changeTagCategoryGroup: Maybe<(
    { __typename?: 'ChangeTagCategoryGroupPayload' }
    & { tagCategory: Maybe<(
      { __typename?: 'TagCategory' }
      & Pick<TagCategory, 'isInCampaign'>
      & TagCategoryInfoFragment
    )> }
  )> }
);

export type CreateTagCategoryMutationVariables = Exact<{
  input: CreateTagCategoryInput;
}>;


export type CreateTagCategoryMutation = (
  { __typename?: 'Mutation' }
  & { createTagCategory: Maybe<(
    { __typename?: 'CreateTagCategoryPayload' }
    & { tagCategory: Maybe<(
      { __typename?: 'TagCategory' }
      & Pick<TagCategory, 'isInCampaign'>
      & TagCategoryInfoFragment
    )> }
  )> }
);

export type CreateTagGroupMutationVariables = Exact<{
  input: CreateTagGroupInput;
}>;


export type CreateTagGroupMutation = (
  { __typename?: 'Mutation' }
  & { createTagGroup: Maybe<(
    { __typename?: 'CreateTagGroupPayload' }
    & { tagGroup: Maybe<(
      { __typename?: 'TagGroup' }
      & Pick<TagGroup, 'isInCampaign'>
      & TagGroupInfoFragment
    )> }
  )> }
);

export type CreateTagMutationVariables = Exact<{
  input: CreateTagInput;
  isInCampaignId?: Maybe<Scalars['ID']>;
}>;


export type CreateTagMutation = (
  { __typename?: 'Mutation' }
  & { createTag: Maybe<(
    { __typename?: 'CreateTagPayload' }
    & { tag: Maybe<(
      { __typename?: 'AddressTag' }
      & TagInfo_AddressTag_Fragment
      & TagWithIsInCampaign_AddressTag_Fragment
    ) | (
      { __typename?: 'DateTag' }
      & TagInfo_DateTag_Fragment
      & TagWithIsInCampaign_DateTag_Fragment
    ) | (
      { __typename?: 'NotesTag' }
      & TagInfo_NotesTag_Fragment
      & TagWithIsInCampaign_NotesTag_Fragment
    ) | (
      { __typename?: 'NumberTag' }
      & TagInfo_NumberTag_Fragment
      & TagWithIsInCampaign_NumberTag_Fragment
    ) | (
      { __typename?: 'ShiftTag' }
      & TagInfo_ShiftTag_Fragment
      & TagWithIsInCampaign_ShiftTag_Fragment
    ) | (
      { __typename?: 'StandardTag' }
      & TagInfo_StandardTag_Fragment
      & TagWithIsInCampaign_StandardTag_Fragment
    )> }
  )> }
);

export type RemoveTagCategoryFromCampaignMutationVariables = Exact<{
  input: RemoveTagCategoryFromCampaignInput;
  isInCampaignId?: Maybe<Scalars['ID']>;
}>;


export type RemoveTagCategoryFromCampaignMutation = (
  { __typename?: 'Mutation' }
  & { removeTagCategoryFromCampaign: Maybe<(
    { __typename?: 'RemoveTagCategoryFromCampaignPayload' }
    & { tagCategory: Maybe<(
      { __typename?: 'TagCategory' }
      & Pick<TagCategory, 'id' | 'isInCampaign'>
      & { group: (
        { __typename?: 'TagGroup' }
        & Pick<TagGroup, 'id' | 'isInCampaign'>
      ) }
    )> }
  )> }
);

export type RenameTagGroupMutationVariables = Exact<{
  input: RenameTagGroupInput;
}>;


export type RenameTagGroupMutation = (
  { __typename?: 'Mutation' }
  & { renameTagGroup: Maybe<(
    { __typename?: 'RenameTagGroupPayload' }
    & { tagGroup: Maybe<(
      { __typename?: 'TagGroup' }
      & Pick<TagGroup, 'id' | 'name' | 'campaignContextId'>
    )> }
  )> }
);

export type UnassociateTagFromCampaignMutationVariables = Exact<{
  input: UnassociateTagFromCampaignInput;
  isInCampaignId?: Maybe<Scalars['ID']>;
}>;


export type UnassociateTagFromCampaignMutation = (
  { __typename?: 'Mutation' }
  & { unassociateTagFromCampaign: Maybe<(
    { __typename?: 'UnassociateTagFromCampaignPayload' }
    & { tag: Maybe<(
      { __typename?: 'AddressTag' }
      & Pick<AddressTag, 'isInCampaign'>
      & { category: (
        { __typename?: 'TagCategory' }
        & Pick<TagCategory, 'id' | 'isInCampaign'>
        & { group: (
          { __typename?: 'TagGroup' }
          & Pick<TagGroup, 'id' | 'isInCampaign'>
        ) }
      ) }
      & TagInfo_AddressTag_Fragment
    ) | (
      { __typename?: 'DateTag' }
      & Pick<DateTag, 'isInCampaign'>
      & { category: (
        { __typename?: 'TagCategory' }
        & Pick<TagCategory, 'id' | 'isInCampaign'>
        & { group: (
          { __typename?: 'TagGroup' }
          & Pick<TagGroup, 'id' | 'isInCampaign'>
        ) }
      ) }
      & TagInfo_DateTag_Fragment
    ) | (
      { __typename?: 'NotesTag' }
      & Pick<NotesTag, 'isInCampaign'>
      & { category: (
        { __typename?: 'TagCategory' }
        & Pick<TagCategory, 'id' | 'isInCampaign'>
        & { group: (
          { __typename?: 'TagGroup' }
          & Pick<TagGroup, 'id' | 'isInCampaign'>
        ) }
      ) }
      & TagInfo_NotesTag_Fragment
    ) | (
      { __typename?: 'NumberTag' }
      & Pick<NumberTag, 'isInCampaign'>
      & { category: (
        { __typename?: 'TagCategory' }
        & Pick<TagCategory, 'id' | 'isInCampaign'>
        & { group: (
          { __typename?: 'TagGroup' }
          & Pick<TagGroup, 'id' | 'isInCampaign'>
        ) }
      ) }
      & TagInfo_NumberTag_Fragment
    ) | (
      { __typename?: 'ShiftTag' }
      & Pick<ShiftTag, 'isInCampaign'>
      & { category: (
        { __typename?: 'TagCategory' }
        & Pick<TagCategory, 'id' | 'isInCampaign'>
        & { group: (
          { __typename?: 'TagGroup' }
          & Pick<TagGroup, 'id' | 'isInCampaign'>
        ) }
      ) }
      & TagInfo_ShiftTag_Fragment
    ) | (
      { __typename?: 'StandardTag' }
      & Pick<StandardTag, 'isInCampaign'>
      & { category: (
        { __typename?: 'TagCategory' }
        & Pick<TagCategory, 'id' | 'isInCampaign'>
        & { group: (
          { __typename?: 'TagGroup' }
          & Pick<TagGroup, 'id' | 'isInCampaign'>
        ) }
      ) }
      & TagInfo_StandardTag_Fragment
    )> }
  )> }
);

export type UpdateAddressTagMutationVariables = Exact<{
  input: UpdateAddressTagInput;
}>;


export type UpdateAddressTagMutation = (
  { __typename?: 'Mutation' }
  & { updateAddressTag: Maybe<(
    { __typename?: 'UpdateAddressTagPayload' }
    & { tag: Maybe<(
      { __typename?: 'AddressTag' }
      & TagInfo_AddressTag_Fragment
    )> }
  )> }
);

export type UpdateShiftMutationVariables = Exact<{
  input: UpdateShiftInput;
}>;


export type UpdateShiftMutation = (
  { __typename?: 'Mutation' }
  & { updateShift: Maybe<(
    { __typename?: 'UpdateShiftPayload' }
    & { shift: Maybe<(
      { __typename?: 'Shift' }
      & ShiftInfoFragment
    )> }
  )> }
);

export type UpdateTagCategoryMutationVariables = Exact<{
  input: UpdateTagCategoryInput;
}>;


export type UpdateTagCategoryMutation = (
  { __typename?: 'Mutation' }
  & { updateTagCategory: Maybe<(
    { __typename?: 'UpdateTagCategoryPayload' }
    & { tagCategory: Maybe<(
      { __typename?: 'TagCategory' }
      & TagCategoryInfoFragment
    )> }
  )> }
);

export type UpdateTagMutationVariables = Exact<{
  input: UpdateTagInput;
}>;


export type UpdateTagMutation = (
  { __typename?: 'Mutation' }
  & { updateTag: Maybe<(
    { __typename?: 'UpdateTagPayload' }
    & { tag: Maybe<(
      { __typename?: 'AddressTag' }
      & TagInfo_AddressTag_Fragment
    ) | (
      { __typename?: 'DateTag' }
      & TagInfo_DateTag_Fragment
    ) | (
      { __typename?: 'NotesTag' }
      & TagInfo_NotesTag_Fragment
    ) | (
      { __typename?: 'NumberTag' }
      & TagInfo_NumberTag_Fragment
    ) | (
      { __typename?: 'ShiftTag' }
      & TagInfo_ShiftTag_Fragment
    ) | (
      { __typename?: 'StandardTag' }
      & TagInfo_StandardTag_Fragment
    )> }
  )> }
);

export type UpdateCustomIdTypeMutationVariables = Exact<{
  input: UpdateCustomIdInput;
}>;


export type UpdateCustomIdTypeMutation = (
  { __typename?: 'Mutation' }
  & { updateCustomId: Maybe<(
    { __typename?: 'UpdateCustomIdPayload' }
    & { customIdType: (
      { __typename?: 'CustomIdType' }
      & CustomIdTypeDetailsFragment
    ) }
  )> }
);

export type UpdateGeocodeMutationVariables = Exact<{
  input: UpdateAddressGeolocationInput;
}>;


export type UpdateGeocodeMutation = (
  { __typename?: 'Mutation' }
  & { updateAddressGeolocation: Maybe<(
    { __typename?: 'UpdateAddressGeolocationPayload' }
    & { address: Maybe<(
      { __typename?: 'Address' }
      & AddressDetailsFragment
    )> }
  )> }
);

export type AcceptInviteMutationVariables = Exact<{
  input: AcceptInvitationInput;
}>;


export type AcceptInviteMutation = (
  { __typename?: 'Mutation' }
  & { acceptInvitation: Maybe<(
    { __typename?: 'AcceptInvitationPayload' }
    & { user: Maybe<(
      { __typename?: 'User' }
      & UserDetailsFragment
    )> }
  )> }
);

export type AddUserToCampaignMutationVariables = Exact<{
  input: AddCampaignParticipantInput;
}>;


export type AddUserToCampaignMutation = (
  { __typename?: 'Mutation' }
  & { addCampaignParticipant: Maybe<(
    { __typename?: 'AddCampaignParticipantPayload' }
    & { user: Maybe<(
      { __typename?: 'User' }
      & UserDetailsFragment
      & UserWithTurfAssignmentsFragment
    )> }
  )> }
);

export type CancelInviteMutationVariables = Exact<{
  input: CancelInvitationInput;
}>;


export type CancelInviteMutation = (
  { __typename?: 'Mutation' }
  & { cancelInvitation: Maybe<(
    { __typename?: 'CancelInvitationPayload' }
    & { user: Maybe<(
      { __typename?: 'User' }
      & UserDetailsFragment
    )> }
  )> }
);

export type CreateUserMutationVariables = Exact<{
  input: CreateInvitationInput;
}>;


export type CreateUserMutation = (
  { __typename?: 'Mutation' }
  & { createInvitation: Maybe<(
    { __typename?: 'CreateInvitationPayload' }
    & { user: Maybe<(
      { __typename?: 'User' }
      & UserDetailsFragment
      & UserWithTurfAssignmentsFragment
    )> }
  )> }
);

export type DisableUserMutationVariables = Exact<{
  input: DisableUserInput;
}>;


export type DisableUserMutation = (
  { __typename?: 'Mutation' }
  & { disableUser: Maybe<(
    { __typename?: 'DisableUserPayload' }
    & { user: Maybe<(
      { __typename?: 'User' }
      & UserDetailsFragment
      & UserWithTurfAssignmentsFragment
    )> }
  )> }
);

export type SetUsersDisableOnDateMutationVariables = Exact<{
  input: SetUsersDisableOnDateInput;
}>;


export type SetUsersDisableOnDateMutation = (
  { __typename?: 'Mutation' }
  & { setUsersDisableOnDate: Maybe<(
    { __typename?: 'SetUsersDisableOnDatePayload' }
    & { users: Array<(
      { __typename?: 'User' }
      & UserDetailsFragment
      & UserWithTurfAssignmentsFragment
    )> }
  )> }
);

export type EnableUserMutationVariables = Exact<{
  input: EnableUserInput;
}>;


export type EnableUserMutation = (
  { __typename?: 'Mutation' }
  & { enableUser: Maybe<(
    { __typename?: 'EnableUserPayload' }
    & { user: Maybe<(
      { __typename?: 'User' }
      & UserDetailsFragment
      & UserWithTurfAssignmentsFragment
    )> }
  )> }
);

export type RemoveMfaMutationVariables = Exact<{
  input: RemoveMfaInput;
}>;


export type RemoveMfaMutation = (
  { __typename?: 'Mutation' }
  & { removeMfa: Maybe<(
    { __typename?: 'RemoveMfaPayload' }
    & { user: Maybe<(
      { __typename?: 'User' }
      & UserDetailsFragment
    )> }
  )> }
);

export type ResendMfaCodeMutationVariables = Exact<{
  input: ResendMfaCodeInput;
}>;


export type ResendMfaCodeMutation = (
  { __typename?: 'Mutation' }
  & { resendMfaCode: Maybe<(
    { __typename?: 'ResendMfaCodePayload' }
    & { user: Maybe<(
      { __typename?: 'User' }
      & UserDetailsFragment
    )> }
  )> }
);

export type ResendUserInviteMutationVariables = Exact<{
  input: ResendInvitationInput;
}>;


export type ResendUserInviteMutation = (
  { __typename?: 'Mutation' }
  & { resendInvitation: Maybe<(
    { __typename?: 'ResendInvitationPayload' }
    & { user: Maybe<(
      { __typename?: 'User' }
      & UserDetailsFragment
    )> }
  )> }
);

export type StartMfaSetupMutationVariables = Exact<{
  input: StartMfaSetupInput;
}>;


export type StartMfaSetupMutation = (
  { __typename?: 'Mutation' }
  & { startMfaSetup: Maybe<(
    { __typename?: 'StartMfaSetupPayload' }
    & { user: Maybe<(
      { __typename?: 'User' }
      & UserDetailsFragment
    )>, mfaFactor: Maybe<(
      { __typename?: 'MfaFactor' }
      & Pick<MfaFactor, 'id' | 'factorType' | 'status' | 'phoneLastFour' | 'qrCodeSvg' | 'qrCodeUrl' | 'secret' | 'provisioningUri'>
    )> }
  )> }
);

export type UpdateCurrentUserMutationVariables = Exact<{
  input: UpdateCurrentUserInput;
}>;


export type UpdateCurrentUserMutation = (
  { __typename?: 'Mutation' }
  & { updateCurrentUser: Maybe<(
    { __typename?: 'UpdateCurrentUserPayload' }
    & { user: Maybe<(
      { __typename?: 'User' }
      & UserDetailsFragment
      & UserWithTurfAssignmentsFragment
    )> }
  )> }
);

export type UpdateUserByIdMutationVariables = Exact<{
  input: UpdateUserByIdInput;
}>;


export type UpdateUserByIdMutation = (
  { __typename?: 'Mutation' }
  & { updateUserById: Maybe<(
    { __typename?: 'UpdateUserByIdPayload' }
    & { user: Maybe<(
      { __typename?: 'User' }
      & UserDetailsFragment
      & UserWithTurfAssignmentsFragment
    )> }
  )> }
);

export type VerifyMfaLoginMutationVariables = Exact<{
  input: VerifyMfaLoginInput;
}>;


export type VerifyMfaLoginMutation = (
  { __typename?: 'Mutation' }
  & { verifyMfaLogin: Maybe<(
    { __typename?: 'VerifyMfaLoginPayload' }
    & { user: Maybe<(
      { __typename?: 'User' }
      & UserDetailsFragment
    )> }
  )> }
);

export type VerifyMfaSetupMutationVariables = Exact<{
  input: VerifyMfaSetupInput;
}>;


export type VerifyMfaSetupMutation = (
  { __typename?: 'Mutation' }
  & { verifyMfaSetup: Maybe<(
    { __typename?: 'VerifyMfaSetupPayload' }
    & { mfaFactor: Maybe<(
      { __typename?: 'MfaFactor' }
      & Pick<MfaFactor, 'id' | 'factorType' | 'status' | 'verifiedAt'>
    )>, user: Maybe<(
      { __typename?: 'User' }
      & UserDetailsFragment
    )> }
  )> }
);

export type GetCampaignEntityTypeConfigurationQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  entityTypeId: Scalars['ID'];
}>;


export type GetCampaignEntityTypeConfigurationQuery = (
  { __typename?: 'Query' }
  & { getCampaignEntityTypeConfiguration: Maybe<(
    { __typename?: 'CampaignEntityTypeConfiguration' }
    & CampaignEntityTypeConfigDetailsFragment
  )> }
);

export type GetCampaignEntityTypeConfigurationsQueryVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type GetCampaignEntityTypeConfigurationsQuery = (
  { __typename?: 'Query' }
  & { getCampaignEntityTypeConfigurations: Maybe<Array<(
    { __typename?: 'CampaignEntityTypeConfiguration' }
    & CampaignEntityTypeConfigDetailsFragment
  )>> }
);

export type SearchCampaignObjectVisibilityQueryVariables = Exact<{
  objectTypeId: Scalars['ID'];
  objectType: CampaignObjectVisibilityTypesType;
  visibility: Scalars['String'];
  keyword?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type SearchCampaignObjectVisibilityQuery = (
  { __typename?: 'Query' }
  & { searchCampaignObjectVisibility: Maybe<(
    { __typename?: 'CampaignObjectVisibilityResultConnection' }
    & Pick<CampaignObjectVisibilityResultConnection, 'totalCount'>
    & { edges: Maybe<Array<Maybe<(
      { __typename?: 'CampaignObjectVisibilityResultEdge' }
      & Pick<CampaignObjectVisibilityResultEdge, 'cursor'>
      & { node: Maybe<(
        { __typename?: 'CampaignObjectVisibilityResult' }
        & Pick<CampaignObjectVisibilityResult, 'campaignId' | 'campaignName' | 'visibleInCampaign'>
      )> }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ) }
  )> }
);

export type CampaignHasEntitiesQueryVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type CampaignHasEntitiesQuery = (
  { __typename?: 'Query' }
  & { getEntities: Maybe<(
    { __typename?: 'EntityConnectionWithTotalCount' }
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'Entity' }
      & Pick<Entity, 'id'>
    )>>> }
  )> }
);

export type GetCampaignByIdNoTagsQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  withEntitiesCount?: Maybe<Scalars['Boolean']>;
}>;


export type GetCampaignByIdNoTagsQuery = (
  { __typename?: 'Query' }
  & { getCampaign: Maybe<(
    { __typename?: 'Campaign' }
    & MakeMaybe<Pick<Campaign, 'entitiesCount'>, 'entitiesCount'>
    & CampaignWithoutTagsFragment
  )> }
);

export type GetCampaignDefaultCountryQueryVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type GetCampaignDefaultCountryQuery = (
  { __typename?: 'Query' }
  & { getCampaign: Maybe<(
    { __typename?: 'Campaign' }
    & Pick<Campaign, 'id' | 'name' | 'defaultCountry'>
  )> }
);

export type GetCampaignIdsQueryVariables = Exact<{
  status?: Maybe<CampaignStatusType>;
}>;


export type GetCampaignIdsQuery = (
  { __typename?: 'Query' }
  & { searchCampaigns: Maybe<(
    { __typename?: 'CampaignConnectionWithTotalCount' }
    & Pick<CampaignConnectionWithTotalCount, 'matchingIds'>
  )> }
);

export type GetCampaignIntegrationsQueryVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type GetCampaignIntegrationsQuery = (
  { __typename?: 'Query' }
  & { getCampaign: Maybe<(
    { __typename?: 'Campaign' }
    & Pick<Campaign, 'id' | 'name'>
    & { integrations: Maybe<Array<Maybe<(
      { __typename?: 'Integration' }
      & Pick<Integration, 'id' | 'externalServiceId'>
    )>>>, campaignIntegrations: Maybe<(
      { __typename?: 'CampaignIntegrations' }
      & { actionNetwork: Maybe<(
        { __typename?: 'ActionNetworkIntegration' }
        & AnCampaignIntegrationFragment
      )> }
    )> }
  )> }
);

export type GetCampaignPublicByIdQueryVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type GetCampaignPublicByIdQuery = (
  { __typename?: 'Query' }
  & { getCampaignPublic: Maybe<(
    { __typename?: 'CampaignPublic' }
    & Pick<CampaignPublic, 'id' | 'name'>
  )> }
);

export type GetCampaignSupportQueryVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type GetCampaignSupportQuery = (
  { __typename?: 'Query' }
  & { getCampaign: Maybe<(
    { __typename?: 'Campaign' }
    & Pick<Campaign, 'id' | 'name'>
    & { supportUser: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'linkedEntityId' | 'firstName' | 'lastName' | 'email' | 'phoneNumber' | 'role' | 'disabled'>
    )> }
  )> }
);

export type GetCampaignsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCampaignsCountQuery = (
  { __typename?: 'Query' }
  & { searchCampaigns: Maybe<(
    { __typename?: 'CampaignConnectionWithTotalCount' }
    & Pick<CampaignConnectionWithTotalCount, 'totalCount'>
  )> }
);

export type SearchCampaignsQueryVariables = Exact<{
  keyword?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  status?: Maybe<CampaignStatusType>;
  withEntitiesCount?: Maybe<Scalars['Boolean']>;
  withMatchingIds?: Maybe<Scalars['Boolean']>;
}>;


export type SearchCampaignsQuery = (
  { __typename?: 'Query' }
  & { searchCampaigns: Maybe<(
    { __typename?: 'CampaignConnectionWithTotalCount' }
    & MakeMaybe<Pick<CampaignConnectionWithTotalCount, 'matchingIds' | 'totalCount'>, 'matchingIds'>
    & { edges: Maybe<Array<Maybe<(
      { __typename?: 'CampaignEdge' }
      & Pick<CampaignEdge, 'cursor'>
      & { node: Maybe<(
        { __typename?: 'Campaign' }
        & MakeMaybe<Pick<Campaign, 'entitiesCount' | 'participantsCount'>, 'entitiesCount' | 'participantsCount'>
        & CampaignWithoutTagsFragment
      )> }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ) }
  )> }
);

export type GetCampaignConnectionTypeConfigurationsQueryVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type GetCampaignConnectionTypeConfigurationsQuery = (
  { __typename?: 'Query' }
  & { getCampaignEntityConnectionTypeConfigurations: Maybe<Array<(
    { __typename?: 'CampaignEntityConnectionTypeConfiguration' }
    & CampaignConnectionTypeConfigDetailsFragment
  )>> }
);

export type GetEntityConnectionTypeQueryVariables = Exact<{
  id: Scalars['ID'];
  campaignId?: Maybe<Scalars['ID']>;
}>;


export type GetEntityConnectionTypeQuery = (
  { __typename?: 'Query' }
  & { getEntityConnectionType: Maybe<(
    { __typename?: 'EntityConnectionType' }
    & EntityConnectionTypeDetailsFragment
  )> }
);

export type GetEntityConnectionTypesQueryVariables = Exact<{
  campaignId?: Maybe<Scalars['ID']>;
  entityTypeId?: Maybe<Scalars['ID']>;
}>;


export type GetEntityConnectionTypesQuery = (
  { __typename?: 'Query' }
  & { getEntityConnectionTypes: Maybe<Array<(
    { __typename?: 'EntityConnectionType' }
    & EntityConnectionTypeDetailsFragment
  )>> }
);

export type GetEntityConnectionQueryVariables = Exact<{
  entityConnectionId: Scalars['ID'];
  campaignId: Scalars['ID'];
  withTags?: Maybe<Scalars['Boolean']>;
  withToplines?: Maybe<Scalars['Boolean']>;
  withNotes?: Maybe<Scalars['Boolean']>;
}>;


export type GetEntityConnectionQuery = (
  { __typename?: 'Query' }
  & { getEntityConnection: Maybe<(
    { __typename?: 'EntityConnection' }
    & EntityConnectionCoreFragment
    & EntityConnectionWithToplinesFragment
    & EntityConnectionWithTagsFragment
    & EntityConnectionWithNotesFragment
  )> }
);

export type GetEntityConnectionsQueryVariables = Exact<{
  entityId: Scalars['ID'];
  campaignId: Scalars['ID'];
  entityConnectionTypeId: Scalars['ID'];
  includeInactive?: Maybe<Scalars['Boolean']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type GetEntityConnectionsQuery = (
  { __typename?: 'Query' }
  & { getEntityConnections: Maybe<(
    { __typename?: 'EntityConnectionConnection' }
    & Pick<EntityConnectionConnection, 'totalCount'>
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'EntityConnection' }
      & Pick<EntityConnection, 'tagsCount'>
      & EntityConnectionCoreFragment
      & EntityConnectionWithHighlightedToplineFragment
      & EntityConnectionWithNotesFragment
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ) }
  )> }
);

export type GetEntityTypeQueryVariables = Exact<{
  entityTypeId: Scalars['ID'];
}>;


export type GetEntityTypeQuery = (
  { __typename?: 'Query' }
  & { getEntityType: Maybe<(
    { __typename?: 'EntityType' }
    & EntityTypeDetailsFragment
  )> }
);

export type GetEntityTypesQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type GetEntityTypesQuery = (
  { __typename?: 'Query' }
  & { getEntityTypes: Maybe<(
    { __typename?: 'EntityTypeConnectionWithTotalCount' }
    & Pick<EntityTypeConnectionWithTotalCount, 'totalCount'>
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'EntityType' }
      & EntityTypeDetailsFragment
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  )> }
);

export type GetEntitiesForWallChartQueryQueryVariables = Exact<{
  entityIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  campaignId: Scalars['ID'];
  withToplines?: Maybe<Scalars['Boolean']>;
}>;


export type GetEntitiesForWallChartQueryQuery = (
  { __typename?: 'Query' }
  & { getEntitiesByIds: Maybe<Array<(
    { __typename?: 'Entity' }
    & EntityCoreFragment
    & EntityWithHighlightedToplineFragment
    & EntityWithToplinesFragment
    & EntityWithEntityTypeFragment
    & EntityWithBasicInfoFragment
    & EntityWithContactIconsFragment
  )>> }
);

export type GetWallChartQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  groupBy?: Maybe<AggregatorEntry>;
  thenBy?: Maybe<AggregatorEntry>;
  splitMatchesBy?: Maybe<AggregatorSplitMatchType>;
  splitMatchesByTagIds?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  queryBody?: Maybe<Scalars['String']>;
  queryName?: Maybe<Scalars['String']>;
}>;


export type GetWallChartQuery = (
  { __typename?: 'Query' }
  & { wallchart3: Maybe<Array<(
    { __typename?: 'AggregationResult' }
    & Pick<AggregationResult, 'label' | 'labelId'>
    & { groupBy: Maybe<Array<(
      { __typename?: 'AggregationResult' }
      & Pick<AggregationResult, 'label' | 'labelId'>
      & { matches: Array<(
        { __typename?: 'AggregationMatched' }
        & Pick<AggregationMatched, 'entities' | 'matchGroupId' | 'matchGroupLabel' | 'matchGroupMatched'>
      )> }
    )>>, matches: Array<(
      { __typename?: 'AggregationMatched' }
      & Pick<AggregationMatched, 'entities' | 'matchGroupId' | 'matchGroupLabel' | 'matchGroupMatched'>
    )> }
  )>> }
);

export type GetEntitiesForMapViewQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  orderBy?: Maybe<Scalars['String']>;
}>;


export type GetEntitiesForMapViewQuery = (
  { __typename?: 'Query' }
  & { entitiesQuery: Maybe<(
    { __typename?: 'EntityConnectionWithTotalCount' }
    & Pick<EntityConnectionWithTotalCount, 'limitedCount'>
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'Entity' }
      & EntityWithMapViewDetailsFragment
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ) }
  )> }
);

export type EntitiesQueryQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  body: Scalars['String'];
  withToplines?: Maybe<Scalars['Boolean']>;
  withFollowUpDetails?: Maybe<Scalars['Boolean']>;
  keyword?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
}>;


export type EntitiesQueryQuery = (
  { __typename?: 'Query' }
  & { entitiesQuery: Maybe<(
    { __typename?: 'EntityConnectionWithTotalCount' }
    & Pick<EntityConnectionWithTotalCount, 'limitedCount' | 'totalCount'>
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'Entity' }
      & EntityCoreFragment
      & EntityWithBasicInfoFragment
      & EntityWithEntityTypeFragment
      & EntityWithBestAddressFragment
      & EntityWithBestPhoneFragment
      & EntityWithBestEmailFragment
      & EntityWithHighlightedToplineFragment
      & EntityWithToplinesFragment
      & EntityWithFollowUpDetailsFragment
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ) }
  )> }
);

export type EntitiesTotalCountQueryQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  body: Scalars['String'];
  keyword?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
}>;


export type EntitiesTotalCountQueryQuery = (
  { __typename?: 'Query' }
  & { entitiesQuery: Maybe<(
    { __typename?: 'EntityConnectionWithTotalCount' }
    & Pick<EntityConnectionWithTotalCount, 'totalCount'>
  )> }
);

export type GetCurrentAssessmentsForEntitiesQueryVariables = Exact<{
  entityIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  campaignId: Scalars['ID'];
}>;


export type GetCurrentAssessmentsForEntitiesQuery = (
  { __typename?: 'Query' }
  & { getEntitiesByIds: Maybe<Array<(
    { __typename?: 'Entity' }
    & Pick<Entity, 'campaignContextId' | 'id' | 'currentAssessmentLevel'>
  )>> }
);

export type GetEntityAssessmentsQueryVariables = Exact<{
  entityId: Scalars['ID'];
  campaignId: Scalars['ID'];
}>;


export type GetEntityAssessmentsQuery = (
  { __typename?: 'Query' }
  & { getEntity: Maybe<(
    { __typename?: 'Entity' }
    & EntityWithAssessmentsFragment
  )> }
);

export type GetEntityBasicQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  entityId: Scalars['ID'];
}>;


export type GetEntityBasicQuery = (
  { __typename?: 'Query' }
  & { getEntity: Maybe<(
    { __typename?: 'Entity' }
    & EntityCoreFragment
    & EntityWithBasicInfoFragment
    & EntityWithEntityTypeFragment
  )> }
);

export type GetEntityById2QueryVariables = Exact<{
  entityId: Scalars['ID'];
  campaignId: Scalars['ID'];
  withHighligtedTopline?: Maybe<Scalars['Boolean']>;
  withToplines?: Maybe<Scalars['Boolean']>;
  withEntityType?: Maybe<Scalars['Boolean']>;
  withIds?: Maybe<Scalars['Boolean']>;
  withBestAddress?: Maybe<Scalars['Boolean']>;
  withBestEmail?: Maybe<Scalars['Boolean']>;
  withBestPhone?: Maybe<Scalars['Boolean']>;
  withEmails?: Maybe<Scalars['Boolean']>;
  withPhones?: Maybe<Scalars['Boolean']>;
  withSocials?: Maybe<Scalars['Boolean']>;
  withAddresses?: Maybe<Scalars['Boolean']>;
  withTags?: Maybe<Scalars['Boolean']>;
  withConnectionCounts?: Maybe<Scalars['Boolean']>;
  withFollowUpDetails?: Maybe<Scalars['Boolean']>;
  withAssessments?: Maybe<Scalars['Boolean']>;
  withCalendarResponses?: Maybe<Scalars['Boolean']>;
  withCalendarEventCounts?: Maybe<Scalars['Boolean']>;
}>;


export type GetEntityById2Query = (
  { __typename?: 'Query' }
  & { getEntity: Maybe<(
    { __typename?: 'Entity' }
    & EntityCoreFragment
    & EntityWithBasicInfoFragment
    & EntityWithHighlightedToplineFragment
    & EntityWithFollowUpDetailsFragment
    & EntityWithEntityTypeFragment
    & EntityWithBestAddressFragment
    & EntityWithBestPhoneFragment
    & EntityWithSocialProfilesFragment
    & EntityWithBestEmailFragment
    & EntityWithToplinesFragment
    & EntityWithEmailsFragment
    & EntityWithPhonesFragment
    & EntityWithAddressesFragment
    & EntityWithTagsFragment
    & EntityWithConnectionCountsFragment
    & EntityWithIdsFragment
    & EntityWithAssessmentsFragment
    & EntityWithCalendarResponsesFragment
    & EntityWithCalendarEventCountsFragment
  )> }
);

export type GetEntityNameQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  entityId: Scalars['ID'];
}>;


export type GetEntityNameQuery = (
  { __typename?: 'Query' }
  & { getEntity: Maybe<(
    { __typename?: 'Entity' }
    & Pick<Entity, 'id' | 'campaignContextId' | 'firstName' | 'lastName' | 'middleName' | 'nickname' | 'pronouns' | 'suffix'>
  )> }
);

export type GetEntityNotesQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  entityId: Scalars['ID'];
}>;


export type GetEntityNotesQuery = (
  { __typename?: 'Query' }
  & { getEntity: Maybe<(
    { __typename?: 'Entity' }
    & EntityWithNotesFragment
  )> }
);

export type GetEntityPublicQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  entityId: Scalars['ID'];
}>;


export type GetEntityPublicQuery = (
  { __typename?: 'Query' }
  & { getEntityPublic: Maybe<(
    { __typename?: 'EntityPublic' }
    & EntityPublicInfoFragment
  )> }
);

export type GetPotentialDuplicatesQueryVariables = Exact<{
  entityId: Scalars['ID'];
  campaignId: Scalars['ID'];
}>;


export type GetPotentialDuplicatesQuery = (
  { __typename?: 'Query' }
  & { getPotentialEntityDuplicates: Maybe<(
    { __typename?: 'EntityDuplicates' }
    & Pick<EntityDuplicates, 'duplicateReferenceId'>
    & { emailMatches: Maybe<Array<(
      { __typename?: 'DuplicateMatch' }
      & Pick<DuplicateMatch, 'key'>
      & { entities: Array<(
        { __typename?: 'Entity' }
        & EntityWithHighlightedToplineFragment
        & EntityWithBasicInfoFragment
        & EntityCoreFragment
      )> }
    )>>, phoneMatches: Maybe<Array<(
      { __typename?: 'DuplicateMatch' }
      & Pick<DuplicateMatch, 'key'>
      & { entities: Array<(
        { __typename?: 'Entity' }
        & EntityWithHighlightedToplineFragment
        & EntityWithBasicInfoFragment
        & EntityCoreFragment
      )> }
    )>> }
  )> }
);

export type GetSocialNetworksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSocialNetworksQuery = (
  { __typename?: 'Query' }
  & { getSocialNetworks: Maybe<Array<(
    { __typename?: 'SocialNetwork' }
    & SocialNetworkDetailsFragment
  )>> }
);

export type SearchEntitiesPublicQueryVariables = Exact<{
  keyword: Scalars['String'];
  campaignId?: Maybe<Scalars['ID']>;
  assessmentCampaignId?: Maybe<Scalars['ID']>;
  entityTypeIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  accessibleEntitiesOnly?: Maybe<Scalars['Boolean']>;
  turfOnly?: Maybe<Scalars['Boolean']>;
}>;


export type SearchEntitiesPublicQuery = (
  { __typename?: 'Query' }
  & { searchEntitiesPublic: Maybe<(
    { __typename?: 'EntityPublicConnectionWithTotalCount' }
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'EntityPublic' }
      & EntityPublicInfoFragment
      & EntityPublicWithCampaignsFragment
    )>>> }
  )> }
);

export type SearchEntitiesQueryVariables = Exact<{
  keyword: Scalars['String'];
  assessmentCampaignId?: Maybe<Scalars['ID']>;
  entityTypeId?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
}>;


export type SearchEntitiesQuery = (
  { __typename?: 'Query' }
  & { searchEntities: Maybe<(
    { __typename?: 'EntityConnectionWithTotalCount' }
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'Entity' }
      & { campaigns: Maybe<Array<Maybe<(
        { __typename?: 'CampaignPublic' }
        & Pick<CampaignPublic, 'id' | 'name'>
      )>>> }
      & EntityCoreFragment
      & EntityWithBasicInfoFragment
      & EntityWithEntityTypeFragment
      & EntityWithBestAddressFragment
      & EntityWithBestEmailFragment
      & EntityWithBestPhoneFragment
    )>>> }
  )> }
);

export type GetCalendarEventResponseForEntityQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  entityId: Scalars['ID'];
  calendarEventId: Scalars['ID'];
}>;


export type GetCalendarEventResponseForEntityQuery = (
  { __typename?: 'Query' }
  & { getCalendarEventResponseForEntity: Maybe<(
    { __typename?: 'CalendarEventResponse' }
    & CalendarEventResponseCoreFragment
  )> }
);

export type GetCalendarEventResponseQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetCalendarEventResponseQuery = (
  { __typename?: 'Query' }
  & { getCalendarEventResponse: Maybe<(
    { __typename?: 'CalendarEventResponse' }
    & CalendarEventResponseCoreFragment
  )> }
);

export type GetCalendarEventQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetCalendarEventQuery = (
  { __typename?: 'Query' }
  & { getCalendarEvent: Maybe<(
    { __typename?: 'CalendarEvent' }
    & CalendarEventDetailsFragment
  )> }
);

export type SearchCalendarEventResponsesQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  calendarEventId?: Maybe<Scalars['ID']>;
  entityId?: Maybe<Scalars['ID']>;
  keyword?: Maybe<Scalars['String']>;
  dateRange?: Maybe<DateRangeInput>;
}>;


export type SearchCalendarEventResponsesQuery = (
  { __typename?: 'Query' }
  & { searchCalendarEventResponses: Maybe<(
    { __typename?: 'CalendarEventResponseCollectionWithTotalCount' }
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'CalendarEventResponse' }
      & CalendarEventResponseCoreFragment
    )>>> }
  )> }
);

export type SearchCalendarEventsQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  keyword?: Maybe<Scalars['String']>;
  dateRange?: Maybe<DateRangeInput>;
  entityId?: Maybe<Scalars['ID']>;
}>;


export type SearchCalendarEventsQuery = (
  { __typename?: 'Query' }
  & { searchCalendarEvents: Maybe<(
    { __typename?: 'CalendarEventCollectionWithTotalCount' }
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'CalendarEvent' }
      & { entityResponse: Maybe<(
        { __typename?: 'CalendarEventResponse' }
        & CalendarEventResponseCoreFragment
      )> }
      & CalendarEventDetailsFragment
    )>>> }
  )> }
);

export type GetAddressForEntityQueryVariables = Exact<{
  addressId: Scalars['ID'];
  entityId: Scalars['ID'];
  campaignId: Scalars['ID'];
}>;


export type GetAddressForEntityQuery = (
  { __typename?: 'Query' }
  & { getAddress: Maybe<(
    { __typename?: 'Address' }
    & AddressDetailsFragment
  )> }
);

export type GetCustomIdTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomIdTypesQuery = (
  { __typename?: 'Query' }
  & { getCustomIdTypes: Maybe<Array<(
    { __typename?: 'CustomIdType' }
    & Pick<CustomIdType, 'id' | 'active' | 'internalName' | 'label'>
  )>> }
);

export type GetExternalServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExternalServicesQuery = (
  { __typename?: 'Query' }
  & { getExternalServices: Maybe<Array<(
    { __typename?: 'ExternalService' }
    & Pick<ExternalService, 'id' | 'serviceName' | 'clientId' | 'workflowId'>
  )>> }
);

export type GetOrganizationDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationDetailsQuery = (
  { __typename?: 'Query' }
  & { getOrganization: Maybe<(
    { __typename?: 'Organization' }
    & OrganizationDetailsFragment
  )> }
);

export type GetDefaultSavedQueryQueryVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type GetDefaultSavedQueryQuery = (
  { __typename?: 'Query' }
  & { getDefaultSavedQuery: Maybe<(
    { __typename?: 'SavedQuery' }
    & SavedQueryDetailsFragment
  )> }
);

export type GetSavedQueriesQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  keyword?: Maybe<Scalars['String']>;
}>;


export type GetSavedQueriesQuery = (
  { __typename?: 'Query' }
  & { getSavedQueries: Maybe<(
    { __typename?: 'SavedQueryConnection' }
    & { edges: Maybe<Array<Maybe<(
      { __typename?: 'SavedQueryEdge' }
      & { node: Maybe<(
        { __typename?: 'SavedQuery' }
        & SavedQueryDetailsFragment
      )> }
    )>>> }
  )> }
);

export type GetSavedQueryQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  queryId: Scalars['ID'];
}>;


export type GetSavedQueryQuery = (
  { __typename?: 'Query' }
  & { getSavedQuery: Maybe<(
    { __typename?: 'SavedQuery' }
    & SavedQueryDetailsFragment
  )> }
);

export type SearchSavedQueriesQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  keyword?: Maybe<Scalars['String']>;
  queryType?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type SearchSavedQueriesQuery = (
  { __typename?: 'Query' }
  & { getSavedQueries: Maybe<(
    { __typename?: 'SavedQueryConnection' }
    & Pick<SavedQueryConnection, 'totalCount'>
    & { edges: Maybe<Array<Maybe<(
      { __typename?: 'SavedQueryEdge' }
      & Pick<SavedQueryEdge, 'cursor'>
      & { node: Maybe<(
        { __typename?: 'SavedQuery' }
        & SavedQueryDetailsFragment
      )> }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ) }
  )> }
);

export type SearchElectoralDistrictsQueryVariables = Exact<{
  keyword?: Maybe<Scalars['String']>;
}>;


export type SearchElectoralDistrictsQuery = (
  { __typename?: 'Query' }
  & { searchElectoralDistricts: Maybe<(
    { __typename?: 'ElectoralDistrictConnection' }
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'ElectoralDistrict' }
      & Pick<ElectoralDistrict, 'id' | 'name' | 'longName'>
    )>>> }
  )> }
);

export type SearchLocationsQueryVariables = Exact<{
  keyword: Scalars['String'];
  campaignId: Scalars['ID'];
  type: Scalars['String'];
}>;


export type SearchLocationsQuery = (
  { __typename?: 'Query' }
  & { searchLocations: Maybe<Array<(
    { __typename?: 'SearchLocationResultItem' }
    & Pick<SearchLocationResultItem, 'text' | 'type' | 'value'>
  )>> }
);

export type GetTagByIdForQueryQueryVariables = Exact<{
  tagId: Scalars['ID'];
}>;


export type GetTagByIdForQueryQuery = (
  { __typename?: 'Query' }
  & { getTagById: Maybe<(
    { __typename?: 'AddressTag' }
    & TagInfo_AddressTag_Fragment
  ) | (
    { __typename?: 'DateTag' }
    & TagInfo_DateTag_Fragment
  ) | (
    { __typename?: 'NotesTag' }
    & TagInfo_NotesTag_Fragment
  ) | (
    { __typename?: 'NumberTag' }
    & TagInfo_NumberTag_Fragment
  ) | (
    { __typename?: 'ShiftTag' }
    & TagInfo_ShiftTag_Fragment
  ) | (
    { __typename?: 'StandardTag' }
    & TagInfo_StandardTag_Fragment
  )> }
);

export type GetTagCategoriesOnlyQueryVariables = Exact<{
  campaignId?: Maybe<Scalars['ID']>;
  targetTypeId?: Maybe<Scalars['ID']>;
  targetType?: Maybe<Scalars['String']>;
}>;


export type GetTagCategoriesOnlyQuery = (
  { __typename?: 'Query' }
  & { getTagCategories: Maybe<(
    { __typename?: 'TagCategoryConnection' }
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'TagCategory' }
      & TagCategoryOnlyFragment
    )>>> }
  )> }
);

export type GetTagCategoriesQueryVariables = Exact<{
  campaignId?: Maybe<Scalars['ID']>;
  targetTypeId?: Maybe<Scalars['ID']>;
  targetType?: Maybe<Scalars['String']>;
}>;


export type GetTagCategoriesQuery = (
  { __typename?: 'Query' }
  & { getTagCategories: Maybe<(
    { __typename?: 'TagCategoryConnection' }
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'TagCategory' }
      & TagCategoryInfoFragment
    )>>> }
  )> }
);

export type GetTagCategoryByIdQueryVariables = Exact<{
  tagCategoryId: Scalars['ID'];
  campaignId?: Maybe<Scalars['ID']>;
}>;


export type GetTagCategoryByIdQuery = (
  { __typename?: 'Query' }
  & { getTagCategoryById: Maybe<(
    { __typename?: 'TagCategory' }
    & TagCategoryInfoFragment
  )> }
);

export type GetTagGroups2QueryVariables = Exact<{
  campaignId?: Maybe<Scalars['ID']>;
  targetTypeId?: Maybe<Scalars['ID']>;
  targetType?: Maybe<Scalars['String']>;
  isInCampaignId?: Maybe<Scalars['ID']>;
  includeNotInCampaign?: Maybe<Scalars['Boolean']>;
}>;


export type GetTagGroups2Query = (
  { __typename?: 'Query' }
  & { getTagGroups: Maybe<(
    { __typename?: 'TagGroupConnection' }
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'TagGroup' }
      & Pick<TagGroup, 'isInCampaign'>
      & { categories: Maybe<Array<Maybe<(
        { __typename?: 'TagCategory' }
        & Pick<TagCategory, 'id' | 'campaignContextId' | 'isInCampaign'>
      )>>> }
      & TagGroupInfoFragment
    )>>> }
  )> }
);

export type GetTaggableLogbookByIdQueryVariables = Exact<{
  taggableLogbookId: Scalars['ID'];
}>;


export type GetTaggableLogbookByIdQuery = (
  { __typename?: 'Query' }
  & { getTaggableLogbookById: Maybe<(
    { __typename?: 'TaggableLogbook' }
    & TaggableLogbookDetailsFragment
  )> }
);

export type GetTagsByIdsForQueryQueryVariables = Exact<{
  tagIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetTagsByIdsForQueryQuery = (
  { __typename?: 'Query' }
  & { getTagsByIds: Maybe<Array<(
    { __typename?: 'AddressTag' }
    & TagInfo_AddressTag_Fragment
  ) | (
    { __typename?: 'DateTag' }
    & TagInfo_DateTag_Fragment
  ) | (
    { __typename?: 'NotesTag' }
    & TagInfo_NotesTag_Fragment
  ) | (
    { __typename?: 'NumberTag' }
    & TagInfo_NumberTag_Fragment
  ) | (
    { __typename?: 'ShiftTag' }
    & TagInfo_ShiftTag_Fragment
  ) | (
    { __typename?: 'StandardTag' }
    & TagInfo_StandardTag_Fragment
  )>> }
);

export type GetTagsForCategoryQueryVariables = Exact<{
  tagCategoryId: Scalars['ID'];
  campaignId?: Maybe<Scalars['ID']>;
}>;


export type GetTagsForCategoryQuery = (
  { __typename?: 'Query' }
  & { getTags: Maybe<(
    { __typename?: 'TagConnection' }
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'AddressTag' }
      & Pick<AddressTag, 'id' | 'name' | 'tagType' | 'archived'>
      & { address: Maybe<(
        { __typename?: 'Address' }
        & AddressDetailsFragment
      )> }
    ) | (
      { __typename?: 'DateTag' }
      & Pick<DateTag, 'id' | 'name' | 'tagType' | 'archived'>
    ) | (
      { __typename?: 'NotesTag' }
      & Pick<NotesTag, 'id' | 'name' | 'tagType' | 'archived'>
    ) | (
      { __typename?: 'NumberTag' }
      & Pick<NumberTag, 'id' | 'name' | 'tagType' | 'archived'>
    ) | (
      { __typename?: 'ShiftTag' }
      & Pick<ShiftTag, 'id' | 'name' | 'tagType' | 'archived'>
    ) | (
      { __typename?: 'StandardTag' }
      & Pick<StandardTag, 'id' | 'name' | 'tagType' | 'archived'>
    )>>> }
  )> }
);

export type SearchTagsAndCategoriesQueryVariables = Exact<{
  keyword: Scalars['String'];
  status?: Maybe<TagStatus>;
  targetType?: Maybe<Scalars['String']>;
  targetTypeId?: Maybe<Scalars['ID']>;
  campaignId?: Maybe<Scalars['ID']>;
}>;


export type SearchTagsAndCategoriesQuery = (
  { __typename?: 'Query' }
  & { tags: Maybe<(
    { __typename?: 'TagConnection' }
    & Pick<TagConnection, 'totalCount'>
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'AddressTag' }
      & Pick<AddressTag, 'id' | 'name' | 'archived'>
      & { category: (
        { __typename?: 'TagCategory' }
        & Pick<TagCategory, 'id' | 'campaignContextId' | 'name' | 'groupName'>
      ) }
    ) | (
      { __typename?: 'DateTag' }
      & Pick<DateTag, 'id' | 'name' | 'archived'>
      & { category: (
        { __typename?: 'TagCategory' }
        & Pick<TagCategory, 'id' | 'campaignContextId' | 'name' | 'groupName'>
      ) }
    ) | (
      { __typename?: 'NotesTag' }
      & Pick<NotesTag, 'id' | 'name' | 'archived'>
      & { category: (
        { __typename?: 'TagCategory' }
        & Pick<TagCategory, 'id' | 'campaignContextId' | 'name' | 'groupName'>
      ) }
    ) | (
      { __typename?: 'NumberTag' }
      & Pick<NumberTag, 'id' | 'name' | 'archived'>
      & { category: (
        { __typename?: 'TagCategory' }
        & Pick<TagCategory, 'id' | 'campaignContextId' | 'name' | 'groupName'>
      ) }
    ) | (
      { __typename?: 'ShiftTag' }
      & Pick<ShiftTag, 'id' | 'name' | 'archived'>
      & { category: (
        { __typename?: 'TagCategory' }
        & Pick<TagCategory, 'id' | 'campaignContextId' | 'name' | 'groupName'>
      ) }
    ) | (
      { __typename?: 'StandardTag' }
      & Pick<StandardTag, 'id' | 'name' | 'archived'>
      & { category: (
        { __typename?: 'TagCategory' }
        & Pick<TagCategory, 'id' | 'campaignContextId' | 'name' | 'groupName'>
      ) }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage'>
    ) }
  )>, categories: Maybe<(
    { __typename?: 'TagCategoryConnection' }
    & Pick<TagCategoryConnection, 'totalCount'>
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'TagCategory' }
      & Pick<TagCategory, 'id' | 'name' | 'campaignContextId' | 'groupName' | 'hasActiveTags' | 'hasAssociatedTags' | 'hasArchivedTags'>
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage'>
    ) }
  )> }
);

export type SearchTagsGetAllIdsQueryVariables = Exact<{
  keyword?: Maybe<Scalars['String']>;
  status?: Maybe<TagStatus>;
  tagTypes?: Maybe<Array<Maybe<TagType>> | Maybe<TagType>>;
  tagCategoryIds?: Maybe<Array<Maybe<Scalars['ID']>> | Maybe<Scalars['ID']>>;
  targetTypeId?: Maybe<Scalars['ID']>;
  targetType?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['ID']>;
  includeNotInCampaign?: Maybe<Scalars['Boolean']>;
  orderBy?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type SearchTagsGetAllIdsQuery = (
  { __typename?: 'Query' }
  & { searchTags: Maybe<(
    { __typename?: 'TagConnection' }
    & Pick<TagConnection, 'matchingIds' | 'totalCount'>
  )> }
);

export type SearchTagsQueryVariables = Exact<{
  keyword?: Maybe<Scalars['String']>;
  isInCampaignId?: Maybe<Scalars['ID']>;
  tagTypes?: Maybe<Array<Maybe<TagType>> | Maybe<TagType>>;
  status?: Maybe<TagStatus>;
  tagCategoryIds?: Maybe<Array<Maybe<Scalars['ID']>> | Maybe<Scalars['ID']>>;
  targetTypeId?: Maybe<Scalars['ID']>;
  targetType?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['ID']>;
  includeNotInCampaign?: Maybe<Scalars['Boolean']>;
  orderBy?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type SearchTagsQuery = (
  { __typename?: 'Query' }
  & { searchTags: Maybe<(
    { __typename?: 'TagConnection' }
    & Pick<TagConnection, 'totalCount'>
    & { edges: Maybe<Array<Maybe<(
      { __typename?: 'TagEdge' }
      & Pick<TagEdge, 'cursor'>
      & { node: Maybe<(
        { __typename?: 'AddressTag' }
        & Pick<AddressTag, 'isInCampaign'>
        & TagInfo_AddressTag_Fragment
      ) | (
        { __typename?: 'DateTag' }
        & Pick<DateTag, 'isInCampaign'>
        & TagInfo_DateTag_Fragment
      ) | (
        { __typename?: 'NotesTag' }
        & Pick<NotesTag, 'isInCampaign'>
        & TagInfo_NotesTag_Fragment
      ) | (
        { __typename?: 'NumberTag' }
        & Pick<NumberTag, 'isInCampaign'>
        & TagInfo_NumberTag_Fragment
      ) | (
        { __typename?: 'ShiftTag' }
        & Pick<ShiftTag, 'isInCampaign'>
        & TagInfo_ShiftTag_Fragment
      ) | (
        { __typename?: 'StandardTag' }
        & Pick<StandardTag, 'isInCampaign'>
        & TagInfo_StandardTag_Fragment
      )> }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ) }
  )> }
);

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = (
  { __typename?: 'Query' }
  & { getCurrentUser: Maybe<(
    { __typename?: 'User' }
    & UserDetailsFragment
    & UserWithTurfAssignmentsFragment
  )> }
);

export type GetUserByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetUserByIdQuery = (
  { __typename?: 'Query' }
  & { getUserById: Maybe<(
    { __typename?: 'User' }
    & UserDetailsFragment
    & UserWithTurfAssignmentsFragment
  )> }
);

export type GetUserByInviteTokenQueryVariables = Exact<{
  invitationToken: Scalars['String'];
}>;


export type GetUserByInviteTokenQuery = (
  { __typename?: 'Query' }
  & { getUserByInvitationToken: (
    { __typename?: 'User' }
    & Pick<User, 'id' | 'email' | 'firstName' | 'lastName' | 'phoneNumber'>
  ) }
);

export type GetUsersQueryVariables = Exact<{
  disabled?: Maybe<Scalars['Boolean']>;
}>;


export type GetUsersQuery = (
  { __typename?: 'Query' }
  & { getUsers: Maybe<(
    { __typename?: 'UserConnectionWithTotalCount' }
    & { edges: Maybe<Array<Maybe<(
      { __typename?: 'UserEdge' }
      & { node: Maybe<(
        { __typename?: 'User' }
        & UserDetailsFragment
      )> }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ) }
  )> }
);

export type GetAllUsersQueryVariables = Exact<{
  disabled?: Maybe<Scalars['Boolean']>;
  withTurfAssignments?: Maybe<Scalars['Boolean']>;
}>;


export type GetAllUsersQuery = (
  { __typename?: 'Query' }
  & { getUsers: Maybe<(
    { __typename?: 'UserConnectionWithTotalCount' }
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'User' }
      & UserDetailsFragment
      & UserWithTurfAssignmentsFragment
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ) }
  )> }
);

export type SearchUserQueryQueryVariables = Exact<{
  keyword?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  activeOnly?: Maybe<Scalars['Boolean']>;
  pendingOnly?: Maybe<Scalars['Boolean']>;
  disabledOnly?: Maybe<Scalars['Boolean']>;
}>;


export type SearchUserQueryQuery = (
  { __typename?: 'Query' }
  & { searchUsers: Maybe<(
    { __typename?: 'UserConnectionWithTotalCount' }
    & Pick<UserConnectionWithTotalCount, 'totalCount'>
    & { edges: Maybe<Array<Maybe<(
      { __typename?: 'UserEdge' }
      & Pick<UserEdge, 'cursor'>
      & { node: Maybe<(
        { __typename?: 'User' }
        & UserDetailsFragment
      )> }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ) }
  )> }
);

export type ActionAssignmentGroupInfoFragment = (
  { __typename?: 'ActionAssignmentGroup' }
  & Pick<ActionAssignmentGroup, 'isRoutable'>
  & { action: (
    { __typename?: 'Action' }
    & Pick<Action, 'canvassingType' | 'id' | 'name' | 'dueDate'>
    & { createdBy: Maybe<(
      { __typename?: 'UserPublic' }
      & UserPublicDetailsFragment
    )>, actionFields: Maybe<Array<Maybe<(
      { __typename?: 'ActionField' }
      & { calendarEventAction: Maybe<(
        { __typename?: 'CalendarEventAction' }
        & { calendarEvent: (
          { __typename?: 'CalendarEvent' }
          & Pick<CalendarEvent, 'startDate' | 'endDate'>
        ) }
      )> }
    )>>> }
  ), users: Maybe<Array<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName' | 'email'>
  )>> }
  & ActionAssignmentGroupCountsFragment
);

export type ActionAssignmentGroupCountsFragment = (
  { __typename?: 'ActionAssignmentGroup' }
  & Pick<ActionAssignmentGroup, 'id' | 'name' | 'targetsCount' | 'uniqueGeocodesForBestAddressesCount' | 'targetsWithAllTasksCompletedCount' | 'targetsWithSomeTasksCompletedCount' | 'targetsWithNoTasksCompletedCount' | 'contactAttemptsContactedCount' | 'contactAttemptsCount'>
);

export type ActionAssignmentGroupTargetIdsFragment = (
  { __typename?: 'ActionAssignmentGroup' }
  & Pick<ActionAssignmentGroup, 'targetIds'>
);

export type ActionCountsFragment = (
  { __typename?: 'Action' }
  & Pick<Action, 'id' | 'targetsCount' | 'targetsCompleted' | 'targetsPending' | 'targetsAllPendingCount' | 'contactAttemptsContactedCount' | 'contactAttemptsCount'>
);

export type ActionFieldDetailsFragment = (
  { __typename?: 'ActionField' }
  & Pick<ActionField, 'id' | 'objectType' | 'objectAttribute' | 'relatedObjectId' | 'relatedObjectType' | 'defaultResponseId' | 'position' | 'isOptional' | 'createdAt' | 'updatedAt' | 'quickCheckIn'>
  & { tagCategory: Maybe<(
    { __typename?: 'TagCategory' }
    & TagCategoryInfoFragment
  )>, entityConnectionType: Maybe<(
    { __typename?: 'EntityConnectionType' }
    & EntityConnectionTypeDetailsFragment
  )>, defaultResponse: Maybe<(
    { __typename?: 'AddressTag' }
    & Pick<AddressTag, 'id' | 'name' | 'tagType'>
    & { category: (
      { __typename?: 'TagCategory' }
      & Pick<TagCategory, 'id' | 'name'>
    ) }
  ) | (
    { __typename?: 'DateTag' }
    & Pick<DateTag, 'id' | 'name' | 'tagType'>
    & { category: (
      { __typename?: 'TagCategory' }
      & Pick<TagCategory, 'id' | 'name'>
    ) }
  ) | (
    { __typename?: 'NotesTag' }
    & Pick<NotesTag, 'id' | 'name' | 'tagType'>
    & { category: (
      { __typename?: 'TagCategory' }
      & Pick<TagCategory, 'id' | 'name'>
    ) }
  ) | (
    { __typename?: 'NumberTag' }
    & Pick<NumberTag, 'id' | 'name' | 'tagType'>
    & { category: (
      { __typename?: 'TagCategory' }
      & Pick<TagCategory, 'id' | 'name'>
    ) }
  ) | (
    { __typename?: 'ShiftTag' }
    & Pick<ShiftTag, 'id' | 'name' | 'tagType'>
    & { category: (
      { __typename?: 'TagCategory' }
      & Pick<TagCategory, 'id' | 'name'>
    ) }
  ) | (
    { __typename?: 'StandardTag' }
    & Pick<StandardTag, 'id' | 'name' | 'tagType'>
    & { category: (
      { __typename?: 'TagCategory' }
      & Pick<TagCategory, 'id' | 'name'>
    ) }
  )>, calendarEventAction: Maybe<(
    { __typename?: 'CalendarEventAction' }
    & CalendarEventActionCoreFragment
  )>, calendarEvent: Maybe<(
    { __typename?: 'CalendarEvent' }
    & CalendarEventBaseFragment
  )> }
);

export type ActionDetailsFragment = (
  { __typename?: 'Action' }
  & Pick<Action, 'id' | 'name' | 'text' | 'dueDate' | 'active' | 'targetsQueryJson' | 'canvassingType' | 'householdingEnabled' | 'notificationEnabled'>
  & { entityType: (
    { __typename?: 'EntityType' }
    & EntityTypeDetailsFragment
  ), actionFields: Maybe<Array<Maybe<(
    { __typename?: 'ActionField' }
    & ActionFieldDetailsFragment
  )>>>, actionAssignmentGroups: Maybe<Array<Maybe<(
    { __typename?: 'ActionAssignmentGroup' }
    & Pick<ActionAssignmentGroup, 'id' | 'name'>
    & { users: Maybe<Array<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName' | 'email'>
    )>> }
    & ActionAssignmentGroupCountsFragment
  )>>>, campaign: Maybe<(
    { __typename?: 'CampaignPublic' }
    & Pick<CampaignPublic, 'id'>
  )>, createdBy: Maybe<(
    { __typename?: 'UserPublic' }
    & UserPublicDetailsFragment
  )> }
  & ActionCountsFragment
);

export type AssignmentRoutingOptionsDetailsFragment = (
  { __typename?: 'AssignmentRoutingOptions' }
  & Pick<AssignmentRoutingOptions, 'id' | 'excludeCompletedActions'>
  & { startAddress: Maybe<(
    { __typename?: 'Address' }
    & AddressDetailsFragment
  )>, endAddress: Maybe<(
    { __typename?: 'Address' }
    & AddressDetailsFragment
  )>, actionEntityRoutePairs: Maybe<Array<Maybe<(
    { __typename?: 'ActionHouseholdMatchResult' }
    & { address: (
      { __typename?: 'Address' }
      & AddressDetailsFragment
    ), matches: Maybe<Array<(
      { __typename?: 'ActionEntityAddressMatchResult' }
      & Pick<ActionEntityAddressMatchResult, 'firstMatchedAddressId'>
      & { actionEntity: Maybe<(
        { __typename?: 'ActionEntity' }
        & Pick<ActionEntity, 'id' | 'completed'>
      )> }
    )>> }
  )>>> }
);

export type ContactAttemptBasicFragment = (
  { __typename?: 'ContactAttempt' }
  & Pick<ContactAttempt, 'id' | 'createdAt' | 'disposition' | 'contactInfoId' | 'contactInfoType'>
);

export type ContactAttemptDetailsFragment = (
  { __typename?: 'ContactAttempt' }
  & { phoneNumber: Maybe<(
    { __typename?: 'PhoneNumber' }
    & PhoneDetailsFragment
  )>, address: Maybe<(
    { __typename?: 'Address' }
    & AddressDetailsFragment
  )> }
  & ContactAttemptBasicFragment
);

export type SmallActionEntityFragment = (
  { __typename?: 'ActionEntity' }
  & Pick<ActionEntity, 'id'>
  & { entity: Maybe<(
    { __typename?: 'Entity' }
    & Pick<Entity, 'campaignContextId' | 'id'>
  )> }
);

export type AddActionFieldMutationVariables = Exact<{
  input: AddActionFieldInput;
}>;


export type AddActionFieldMutation = (
  { __typename?: 'Mutation' }
  & { addActionField: Maybe<(
    { __typename?: 'AddActionFieldPayload' }
    & { action: Maybe<(
      { __typename?: 'Action' }
      & Pick<Action, 'id'>
      & { actionFields: Maybe<Array<Maybe<(
        { __typename?: 'ActionField' }
        & ActionFieldDetailsFragment
      )>>> }
      & ActionCountsFragment
    )> }
  )> }
);

export type AddAllEntitiesToActionMutationVariables = Exact<{
  input: AddAllCampaignEntitiesToActionInput;
}>;


export type AddAllEntitiesToActionMutation = (
  { __typename?: 'Mutation' }
  & { addAllCampaignEntitiesToAction: Maybe<(
    { __typename?: 'AddAllCampaignEntitiesToActionPayload' }
    & { action: Maybe<(
      { __typename?: 'Action' }
      & ActionDetailsFragment
    )> }
  )> }
);

export type AddEntitiesToActionAssignmentGroupMutationVariables = Exact<{
  input: AddEntitiesToActionAssignmentGroupInput;
}>;


export type AddEntitiesToActionAssignmentGroupMutation = (
  { __typename?: 'Mutation' }
  & { addEntitiesToActionAssignmentGroup: Maybe<(
    { __typename?: 'AddEntitiesToActionAssignmentGroupPayload' }
    & { actionAssignmentGroup: Maybe<(
      { __typename?: 'ActionAssignmentGroup' }
      & Pick<ActionAssignmentGroup, 'id' | 'name'>
    )> }
  )> }
);

export type AddEntitiesToActionMutationVariables = Exact<{
  input: AddEntitiesToActionInput;
}>;


export type AddEntitiesToActionMutation = (
  { __typename?: 'Mutation' }
  & { addEntitiesToAction: Maybe<(
    { __typename?: 'AddEntitiesToActionPayload' }
    & { action: Maybe<(
      { __typename?: 'Action' }
      & ActionDetailsFragment
    )> }
  )> }
);

export type AddUsersToAssignmentGroupMutationVariables = Exact<{
  input: AddUsersToActionAssignmentGroupInput;
}>;


export type AddUsersToAssignmentGroupMutation = (
  { __typename?: 'Mutation' }
  & { addUsersToActionAssignmentGroup: Maybe<(
    { __typename?: 'AddUsersToActionAssignmentGroupPayload' }
    & { actionAssignmentGroup: Maybe<(
      { __typename?: 'ActionAssignmentGroup' }
      & ActionAssignmentGroupInfoFragment
    )> }
  )> }
);

export type AssignActionTargetMutationVariables = Exact<{
  input: AddEntityToActionAssignmentGroupInput;
}>;


export type AssignActionTargetMutation = (
  { __typename?: 'Mutation' }
  & { addEntityToActionAssignmentGroup: Maybe<(
    { __typename?: 'AddEntityToActionAssignmentGroupPayload' }
    & { actionEntity: Maybe<(
      { __typename?: 'ActionEntity' }
      & Pick<ActionEntity, 'id' | 'hasContactInfo'>
      & { action: Maybe<(
        { __typename?: 'Action' }
        & Pick<Action, 'id'>
        & { campaign: Maybe<(
          { __typename?: 'CampaignPublic' }
          & Pick<CampaignPublic, 'id' | 'name'>
        )> }
      )>, entity: Maybe<(
        { __typename?: 'Entity' }
        & Pick<Entity, 'id' | 'campaignContextId'>
      )> }
    )> }
  )> }
);

export type CreateActionAssignmentGroupMutationVariables = Exact<{
  input: CreateActionAssignmentGroupInput;
}>;


export type CreateActionAssignmentGroupMutation = (
  { __typename?: 'Mutation' }
  & { createActionAssignmentGroup: Maybe<(
    { __typename?: 'CreateActionAssignmentGroupPayload' }
    & { actionAssignmentGroup: Maybe<(
      { __typename?: 'ActionAssignmentGroup' }
      & Pick<ActionAssignmentGroup, 'id' | 'name'>
      & { action: (
        { __typename?: 'Action' }
        & Pick<Action, 'id'>
      ) }
    )> }
  )> }
);

export type CreateActionMutationVariables = Exact<{
  input: CreateActionInput;
}>;


export type CreateActionMutation = (
  { __typename?: 'Mutation' }
  & { createAction: Maybe<(
    { __typename?: 'CreateActionPayload' }
    & { action: Maybe<(
      { __typename?: 'Action' }
      & ActionDetailsFragment
    )> }
  )> }
);

export type DeleteAllActionAssignmentGroupsMutationVariables = Exact<{
  input: DeleteAllActionAssignmentGroupsInput;
}>;


export type DeleteAllActionAssignmentGroupsMutation = (
  { __typename?: 'Mutation' }
  & { deleteAllActionAssignmentGroups: Maybe<(
    { __typename?: 'DeleteAllActionAssignmentGroupsPayload' }
    & { action: Maybe<(
      { __typename?: 'Action' }
      & ActionDetailsFragment
    )> }
  )> }
);

export type DuplicateActionMutationVariables = Exact<{
  input: DuplicateActionInput;
}>;


export type DuplicateActionMutation = (
  { __typename?: 'Mutation' }
  & { duplicateAction: Maybe<(
    { __typename?: 'DuplicateActionPayload' }
    & { action: Maybe<(
      { __typename?: 'Action' }
      & ActionDetailsFragment
    )> }
  )> }
);

export type GenerateActionAssignmentGroupsByStrategyMutationVariables = Exact<{
  input: GenerateActionAssignmentGroupsByStrategyInput;
}>;


export type GenerateActionAssignmentGroupsByStrategyMutation = (
  { __typename?: 'Mutation' }
  & { generateActionAssignmentGroupsByStrategy: Maybe<(
    { __typename?: 'GenerateActionAssignmentGroupsByStrategyPayload' }
    & { action: Maybe<(
      { __typename?: 'Action' }
      & ActionDetailsFragment
    )> }
  )> }
);

export type RemoveActionAssignmentGroupMutationVariables = Exact<{
  input: RemoveActionAssignmentGroupInput;
}>;


export type RemoveActionAssignmentGroupMutation = (
  { __typename?: 'Mutation' }
  & { removeActionAssignmentGroup: Maybe<(
    { __typename?: 'RemoveActionAssignmentGroupPayload' }
    & { action: Maybe<(
      { __typename?: 'Action' }
      & ActionDetailsFragment
    )> }
  )> }
);

export type RemoveActionFieldByIdMutationVariables = Exact<{
  input: RemoveActionFieldByIdInput;
}>;


export type RemoveActionFieldByIdMutation = (
  { __typename?: 'Mutation' }
  & { removeActionFieldById: Maybe<(
    { __typename?: 'RemoveActionFieldByIdPayload' }
    & { action: Maybe<(
      { __typename?: 'Action' }
      & Pick<Action, 'id'>
      & { actionFields: Maybe<Array<Maybe<(
        { __typename?: 'ActionField' }
        & ActionFieldDetailsFragment
      )>>> }
      & ActionCountsFragment
    )> }
  )> }
);

export type RemoveAssignmentGroupRoutingMutationVariables = Exact<{
  input: RemoveAssignmentGroupUserRoutingInput;
}>;


export type RemoveAssignmentGroupRoutingMutation = (
  { __typename?: 'Mutation' }
  & { removeAssignmentGroupUserRouting: Maybe<(
    { __typename?: 'RemoveAssignmentGroupUserRoutingPayload' }
    & { assignmentRoutingOptions: Maybe<(
      { __typename?: 'AssignmentRoutingOptions' }
      & AssignmentRoutingOptionsDetailsFragment
    )> }
  )> }
);

export type RemoveEntitiesFromActionAssignmentGroupMutationVariables = Exact<{
  input: RemoveEntitiesFromActionAssignmentGroupInput;
}>;


export type RemoveEntitiesFromActionAssignmentGroupMutation = (
  { __typename?: 'Mutation' }
  & { removeEntitiesFromActionAssignmentGroup: Maybe<(
    { __typename?: 'RemoveEntitiesFromActionAssignmentGroupPayload' }
    & { actionAssignmentGroup: Maybe<(
      { __typename?: 'ActionAssignmentGroup' }
      & Pick<ActionAssignmentGroup, 'id' | 'name'>
    )> }
  )> }
);

export type RemoveEntitiesFromActionMutationVariables = Exact<{
  input: RemoveEntitiesFromActionInput;
}>;


export type RemoveEntitiesFromActionMutation = (
  { __typename?: 'Mutation' }
  & { removeEntitiesFromAction: Maybe<(
    { __typename?: 'RemoveEntitiesFromActionPayload' }
    & { action: Maybe<(
      { __typename?: 'Action' }
      & ActionDetailsFragment
    )> }
  )> }
);

export type RemoveUsersFromAssignmentGroupMutationVariables = Exact<{
  input: RemoveUsersFromActionAssignmentGroupInput;
}>;


export type RemoveUsersFromAssignmentGroupMutation = (
  { __typename?: 'Mutation' }
  & { removeUsersFromActionAssignmentGroup: Maybe<(
    { __typename?: 'RemoveUsersFromActionAssignmentGroupPayload' }
    & { actionAssignmentGroup: Maybe<(
      { __typename?: 'ActionAssignmentGroup' }
      & ActionAssignmentGroupInfoFragment
    )> }
  )> }
);

export type UpdateActionEntitiesByQueryMutationVariables = Exact<{
  input: UpdateEntitiesOnActionByQueryInput;
}>;


export type UpdateActionEntitiesByQueryMutation = (
  { __typename?: 'Mutation' }
  & { updateEntitiesOnActionByQuery: Maybe<(
    { __typename?: 'UpdateEntitiesOnActionByQueryPayload' }
    & { action: Maybe<(
      { __typename?: 'Action' }
      & ActionDetailsFragment
    )> }
  )> }
);

export type UpdateActionFieldMutationVariables = Exact<{
  input: UpdateActionFieldInput;
}>;


export type UpdateActionFieldMutation = (
  { __typename?: 'Mutation' }
  & { updateActionField: Maybe<(
    { __typename?: 'UpdateActionFieldPayload' }
    & { action: Maybe<(
      { __typename?: 'Action' }
      & Pick<Action, 'id' | 'dueDate' | 'text' | 'name' | 'canvassingType'>
      & { actionFields: Maybe<Array<Maybe<(
        { __typename?: 'ActionField' }
        & ActionFieldDetailsFragment
      )>>>, actionAssignmentGroups: Maybe<Array<Maybe<(
        { __typename?: 'ActionAssignmentGroup' }
        & ActionAssignmentGroupCountsFragment
      )>>> }
      & ActionCountsFragment
    )> }
  )> }
);

export type UpdateActionFieldsPositionsMutationVariables = Exact<{
  input: UpdateActionFieldsPositionsInput;
}>;


export type UpdateActionFieldsPositionsMutation = (
  { __typename?: 'Mutation' }
  & { updateActionFieldsPositions: Maybe<(
    { __typename?: 'UpdateActionFieldsPositionsPayload' }
    & { actionFields: Maybe<Array<(
      { __typename?: 'ActionField' }
      & ActionFieldDetailsFragment
    )>> }
  )> }
);

export type UpdateActionMutationVariables = Exact<{
  input: UpdateActionInput;
}>;


export type UpdateActionMutation = (
  { __typename?: 'Mutation' }
  & { updateAction: Maybe<(
    { __typename?: 'UpdateActionPayload' }
    & { action: Maybe<(
      { __typename?: 'Action' }
      & ActionDetailsFragment
    )> }
  )> }
);

export type UpdateActionAssignmentGroupNameMutationVariables = Exact<{
  input: UpdateActionAssignmentGroupInput;
}>;


export type UpdateActionAssignmentGroupNameMutation = (
  { __typename?: 'Mutation' }
  & { updateActionAssignmentGroup: Maybe<(
    { __typename?: 'UpdateActionAssignmentGroupPayload' }
    & { actionAssignmentGroup: Maybe<(
      { __typename?: 'ActionAssignmentGroup' }
      & Pick<ActionAssignmentGroup, 'id' | 'name'>
    )> }
  )> }
);

export type UpdateAssignmentGroupEntitiesByQueryMutationVariables = Exact<{
  input: UpdateAssignmentGroupEntitiesByQueryInput;
}>;


export type UpdateAssignmentGroupEntitiesByQueryMutation = (
  { __typename?: 'Mutation' }
  & { updateAssignmentGroupEntitiesByQuery: Maybe<(
    { __typename?: 'UpdateAssignmentGroupEntitiesByQueryPayload' }
    & { actionAssignmentGroup: Maybe<(
      { __typename?: 'ActionAssignmentGroup' }
      & Pick<ActionAssignmentGroup, 'id' | 'name' | 'targetsCount'>
    )> }
  )> }
);

export type UpdateAssignmentGroupUserRoutingMutationVariables = Exact<{
  input: UpdateAssignmentGroupUserRoutingInput;
}>;


export type UpdateAssignmentGroupUserRoutingMutation = (
  { __typename?: 'Mutation' }
  & { updateAssignmentGroupUserRouting: Maybe<(
    { __typename?: 'UpdateAssignmentGroupUserRoutingPayload' }
    & { assignmentRoutingOptions: Maybe<(
      { __typename?: 'AssignmentRoutingOptions' }
      & AssignmentRoutingOptionsDetailsFragment
    )> }
  )> }
);

export type ActionTurfCuttingMapQueryQueryVariables = Exact<{
  actionId: Scalars['ID'];
  campaignId: Scalars['ID'];
}>;


export type ActionTurfCuttingMapQueryQuery = (
  { __typename?: 'Query' }
  & { getAction: Maybe<(
    { __typename?: 'Action' }
    & Pick<Action, 'id' | 'canvassingType' | 'targetIdsWithMappableAddresses'>
  )> }
);

export type GetActionAndGroupCountsQueryVariables = Exact<{
  actionId: Scalars['ID'];
  campaignId: Scalars['ID'];
}>;


export type GetActionAndGroupCountsQuery = (
  { __typename?: 'Query' }
  & { getAction: Maybe<(
    { __typename?: 'Action' }
    & { actionAssignmentGroups: Maybe<Array<Maybe<(
      { __typename?: 'ActionAssignmentGroup' }
      & ActionAssignmentGroupCountsFragment
    )>>> }
    & ActionCountsFragment
  )> }
);

export type GetActionAssignmentGroupBasicQueryVariables = Exact<{
  actionId: Scalars['ID'];
  actionAssignmentGroupId: Scalars['ID'];
}>;


export type GetActionAssignmentGroupBasicQuery = (
  { __typename?: 'Query' }
  & { getActionAssignmentGroup: Maybe<(
    { __typename?: 'ActionAssignmentGroup' }
    & Pick<ActionAssignmentGroup, 'id' | 'name' | 'uniqueGeocodesForBestAddressesCount'>
    & { action: (
      { __typename?: 'Action' }
      & Pick<Action, 'name' | 'id' | 'dueDate' | 'text' | 'canvassingType'>
      & { entityType: (
        { __typename?: 'EntityType' }
        & EntityTypeDetailsFragment
      ) }
    ) }
    & ActionAssignmentGroupCountsFragment
  )> }
);

export type GetActionAssignmentGroupQueryVariables = Exact<{
  actionId: Scalars['ID'];
  actionAssignmentGroupId: Scalars['ID'];
  withTargetIds: Scalars['Boolean'];
  withActionEntities: Scalars['Boolean'];
  withMappableAddresses: Scalars['Boolean'];
  withRouting?: Maybe<Scalars['Boolean']>;
}>;


export type GetActionAssignmentGroupQuery = (
  { __typename?: 'Query' }
  & { getActionAssignmentGroup: Maybe<(
    { __typename?: 'ActionAssignmentGroup' }
    & { action: (
      { __typename?: 'Action' }
      & MakeMaybe<Pick<Action, 'name' | 'id' | 'targetIdsWithMappableAddresses' | 'dueDate' | 'text' | 'targetsQueryJson' | 'canvassingType'>, 'targetIdsWithMappableAddresses'>
      & { entityType: (
        { __typename?: 'EntityType' }
        & EntityTypeDetailsFragment
      ) }
    ), routingInfo?: Maybe<(
      { __typename?: 'AssignmentRoutingOptions' }
      & AssignmentRoutingOptionsDetailsFragment
    )>, users: Maybe<Array<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName' | 'email'>
    )>>, actionEntities?: Maybe<Array<Maybe<(
      { __typename?: 'ActionEntity' }
      & Pick<ActionEntity, 'id' | 'status' | 'pendingCount' | 'completedCount' | 'completed'>
      & { mostRecentContactAttempt: Maybe<(
        { __typename?: 'ContactAttempt' }
        & ContactAttemptBasicFragment
      )>, entity: Maybe<(
        { __typename?: 'Entity' }
        & { mappableAddresses?: Maybe<Array<(
          { __typename?: 'Address' }
          & AddressDetailsFragment
        )>> }
        & EntityCoreFragment
        & EntityWithBasicInfoFragment
        & EntityWithHighlightedToplineFragment
      )> }
    )>>> }
    & ActionAssignmentGroupCountsFragment
    & ActionAssignmentGroupTargetIdsFragment
  )> }
);

export type GetAssignmentGroupsForCurrentUserQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
}>;


export type GetAssignmentGroupsForCurrentUserQuery = (
  { __typename?: 'Query' }
  & { getActionAssignmentGroupsForCurrentUser: Maybe<Array<(
    { __typename?: 'ActionAssignmentGroup' }
    & ActionAssignmentGroupInfoFragment
  )>> }
);

export type GetActionAssignmentGroupsQueryVariables = Exact<{
  actionId: Scalars['ID'];
  campaignId: Scalars['ID'];
}>;


export type GetActionAssignmentGroupsQuery = (
  { __typename?: 'Query' }
  & { getAction: Maybe<(
    { __typename?: 'Action' }
    & Pick<Action, 'id' | 'name' | 'targetsCount' | 'canvassingType'>
    & { entityType: (
      { __typename?: 'EntityType' }
      & EntityTypeDetailsFragment
    ), actionAssignmentGroups: Maybe<Array<Maybe<(
      { __typename?: 'ActionAssignmentGroup' }
      & { users: Maybe<Array<(
        { __typename?: 'User' }
        & Pick<User, 'id' | 'firstName' | 'lastName' | 'email'>
      )>> }
      & ActionAssignmentGroupCountsFragment
    )>>> }
  )> }
);

export type GetActionHouseholdMatchesQueryVariables = Exact<{
  actionEntityId: Scalars['ID'];
  actionAssignmentGroupId: Scalars['ID'];
  addressId: Scalars['ID'];
}>;


export type GetActionHouseholdMatchesQuery = (
  { __typename?: 'Query' }
  & { getActionHouseholdMatches: Maybe<(
    { __typename?: 'ActionHouseholdMatchResult' }
    & { address: (
      { __typename?: 'Address' }
      & Pick<Address, 'id' | 'streetAddress'>
    ), matches: Maybe<Array<(
      { __typename?: 'ActionEntityAddressMatchResult' }
      & Pick<ActionEntityAddressMatchResult, 'matchedAddressIds'>
      & { actionEntity: Maybe<(
        { __typename?: 'ActionEntity' }
        & Pick<ActionEntity, 'id' | 'status' | 'completed' | 'completedCount' | 'pendingCount' | 'hasContactInfo'>
        & { mostRecentContactAttempt: Maybe<(
          { __typename?: 'ContactAttempt' }
          & ContactAttemptDetailsFragment
        )>, entity: Maybe<(
          { __typename?: 'Entity' }
          & EntityCoreFragment
          & EntityWithBasicInfoFragment
        )> }
      )> }
    )>> }
  )> }
);

export type GetActionEntityQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  actionId: Scalars['ID'];
  entityId: Scalars['ID'];
}>;


export type GetActionEntityQuery = (
  { __typename?: 'Query' }
  & { getActionEntity: Maybe<(
    { __typename?: 'ActionEntity' }
    & Pick<ActionEntity, 'id' | 'status' | 'completed' | 'completedCount' | 'pendingCount' | 'hasContactInfo'>
    & { mostRecentContactAttempt: Maybe<(
      { __typename?: 'ContactAttempt' }
      & ContactAttemptDetailsFragment
    )>, entity: Maybe<(
      { __typename?: 'Entity' }
      & EntityCoreFragment
      & EntityWithEntityTypeFragment
      & EntityWithBasicInfoFragment
    )>, action: Maybe<(
      { __typename?: 'Action' }
      & Pick<Action, 'id' | 'name' | 'text' | 'householdingEnabled' | 'canvassingType'>
      & { actionFields: Maybe<Array<Maybe<(
        { __typename?: 'ActionField' }
        & ActionFieldDetailsFragment
      )>>> }
    )>, tasks: Maybe<Array<Maybe<(
      { __typename?: 'Task' }
      & Pick<Task, 'id' | 'resolved'>
      & { actionField: Maybe<(
        { __typename?: 'ActionField' }
        & ActionFieldDetailsFragment
      )> }
    )>>> }
  )> }
);

export type GetActionFieldsQueryVariables = Exact<{
  actionId: Scalars['ID'];
  campaignId: Scalars['ID'];
}>;


export type GetActionFieldsQuery = (
  { __typename?: 'Query' }
  & { getAction: Maybe<(
    { __typename?: 'Action' }
    & Pick<Action, 'id'>
    & { entityType: (
      { __typename?: 'EntityType' }
      & EntityTypeDetailsFragment
    ), actionFields: Maybe<Array<Maybe<(
      { __typename?: 'ActionField' }
      & ActionFieldDetailsFragment
    )>>> }
  )> }
);

export type GetActionEntityAssignmentOrderingQueryVariables = Exact<{
  actionId: Scalars['ID'];
  actionAssignmentGroupId: Scalars['ID'];
}>;


export type GetActionEntityAssignmentOrderingQuery = (
  { __typename?: 'Query' }
  & { getActionEntityAssignmentOrdering: Maybe<(
    { __typename?: 'ActionEntityAssignmentOrdering' }
    & Pick<ActionEntityAssignmentOrdering, 'actionId' | 'actionAssignmentGroupId' | 'actionEntityIds'>
  )> }
);

export type GetActionTypeQueryQueryVariables = Exact<{
  actionId: Scalars['ID'];
  campaignId: Scalars['ID'];
}>;


export type GetActionTypeQueryQuery = (
  { __typename?: 'Query' }
  & { getAction: Maybe<(
    { __typename?: 'Action' }
    & Pick<Action, 'id' | 'canvassingType'>
    & { entityType: (
      { __typename?: 'EntityType' }
      & EntityTypeDetailsFragment
    ) }
  )> }
);

export type GetActionDetailsQueryVariables = Exact<{
  actionId: Scalars['ID'];
  campaignId: Scalars['ID'];
}>;


export type GetActionDetailsQuery = (
  { __typename?: 'Query' }
  & { getAction: Maybe<(
    { __typename?: 'Action' }
    & ActionDetailsFragment
  )> }
);

export type GetActionsCountsQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  endDate?: Maybe<Scalars['Date']>;
  startDate?: Maybe<Scalars['Date']>;
}>;


export type GetActionsCountsQuery = (
  { __typename?: 'Query' }
  & { getActions: Maybe<Array<(
    { __typename?: 'Action' }
    & Pick<Action, 'id' | 'active' | 'name' | 'dueDate' | 'completed' | 'targetsCount'>
    & { campaign: Maybe<(
      { __typename?: 'CampaignPublic' }
      & Pick<CampaignPublic, 'id' | 'name'>
    )>, createdBy: Maybe<(
      { __typename?: 'UserPublic' }
      & UserPublicDetailsFragment
    )>, actionFields: Maybe<Array<Maybe<(
      { __typename?: 'ActionField' }
      & { calendarEventAction: Maybe<(
        { __typename?: 'CalendarEventAction' }
        & { calendarEvent: (
          { __typename?: 'CalendarEvent' }
          & Pick<CalendarEvent, 'startDate' | 'endDate'>
        ) }
      )> }
    )>>> }
  )>> }
);

export type GetContactAttemptsQueryVariables = Exact<{
  actionEntityId: Scalars['ID'];
  contactInfoType?: Maybe<ContactAttemptInfoType>;
}>;


export type GetContactAttemptsQuery = (
  { __typename?: 'Query' }
  & { getContactAttempts: Maybe<Array<(
    { __typename?: 'ContactAttempt' }
    & ContactAttemptBasicFragment
  )>> }
);

export type GetEntityAddressGeocodesQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  entityIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetEntityAddressGeocodesQuery = (
  { __typename?: 'Query' }
  & { getEntitiesByIds: Maybe<Array<(
    { __typename?: 'Entity' }
    & Pick<Entity, 'id' | 'campaignContextId'>
    & { mappableAddresses: Maybe<Array<(
      { __typename?: 'Address' }
      & Pick<Address, 'id' | 'latitude' | 'longitude' | 'status' | 'geocodeBad' | 'accuracyType' | 'updatedAt'>
    )>> }
  )>> }
);

export type GetEntityQueryCountsQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  body: Scalars['String'];
}>;


export type GetEntityQueryCountsQuery = (
  { __typename?: 'Query' }
  & { entitiesQuery: Maybe<(
    { __typename?: 'EntityConnectionWithTotalCount' }
    & Pick<EntityConnectionWithTotalCount, 'totalCount'>
  )> }
);

export type GetSmallActionEntityQueryVariables = Exact<{
  actionEntityId: Scalars['ID'];
}>;


export type GetSmallActionEntityQuery = (
  { __typename?: 'Query' }
  & { getActionEntityById: Maybe<(
    { __typename?: 'ActionEntity' }
    & SmallActionEntityFragment
  )> }
);

export type GetTargetsAssignedToOtherGroupsQueryVariables = Exact<{
  actionId: Scalars['ID'];
  actionAssignmentGroupId: Scalars['ID'];
  withTargetIds?: Maybe<Scalars['Boolean']>;
}>;


export type GetTargetsAssignedToOtherGroupsQuery = (
  { __typename?: 'Query' }
  & { getActionAssignmentGroup: Maybe<(
    { __typename?: 'ActionAssignmentGroup' }
    & MakeMaybe<Pick<ActionAssignmentGroup, 'id' | 'name' | 'targetIdsAssignedToOtherGroups' | 'targetIds'>, 'targetIds'>
  )> }
);

export type SearchActionEntitiesQueryVariables = Exact<{
  actionId: Scalars['ID'];
  campaignId: Scalars['ID'];
  actionAssignmentGroupId?: Maybe<Scalars['ID']>;
  keyword: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  excludeCompleted?: Maybe<Scalars['Boolean']>;
}>;


export type SearchActionEntitiesQuery = (
  { __typename?: 'Query' }
  & { searchActionEntities: Maybe<(
    { __typename?: 'ActionEntityConnectionWithTotalCount' }
    & Pick<ActionEntityConnectionWithTotalCount, 'limitedCount'>
    & { edges: Maybe<Array<Maybe<(
      { __typename?: 'ActionEntityEdge' }
      & { node: Maybe<(
        { __typename?: 'ActionEntity' }
        & Pick<ActionEntity, 'id' | 'status' | 'completed' | 'completedCount' | 'pendingCount' | 'hasContactInfo'>
        & { mostRecentContactAttempt: Maybe<(
          { __typename?: 'ContactAttempt' }
          & ContactAttemptBasicFragment
        )>, entity: Maybe<(
          { __typename?: 'Entity' }
          & EntityCoreFragment
          & EntityWithBasicInfoFragment
          & EntityWithHighlightedToplineFragment
        )> }
      )> }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ) }
  )> }
);

export type GetActionNameQueryVariables = Exact<{
  actionId: Scalars['ID'];
  campaignId: Scalars['ID'];
}>;


export type GetActionNameQuery = (
  { __typename?: 'Query' }
  & { getAction: Maybe<(
    { __typename?: 'Action' }
    & Pick<Action, 'id' | 'name'>
  )> }
);

export type SearchActivityEventsQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  startDate?: Maybe<Scalars['Date']>;
  userIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  tagIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  connectionTagIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  entityTypeIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  names?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  userRoles?: Maybe<Array<UserRole> | UserRole>;
  entityId?: Maybe<Scalars['ID']>;
  noteText?: Maybe<Scalars['String']>;
  calendarEventIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  calendarEventResponseTagIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type SearchActivityEventsQuery = (
  { __typename?: 'Query' }
  & { searchActivityEvents: Maybe<(
    { __typename?: 'ActivityEventConnection' }
    & Pick<ActivityEventConnection, 'limitedCount' | 'entityCount'>
    & { edges: Maybe<Array<Maybe<(
      { __typename?: 'ActivityEventEdge' }
      & { node: Maybe<(
        { __typename?: 'ActivityEvent' }
        & Pick<ActivityEvent, 'id' | 'name' | 'eventType' | 'payload' | 'itemId' | 'itemType' | 'createdAt'>
        & { user: (
          { __typename?: 'UserPublic' }
          & Pick<UserPublic, 'id' | 'name'>
        ), target: Maybe<(
          { __typename?: 'CalendarEventResponse' }
          & Pick<CalendarEventResponse, 'status'>
          & { calendarEvent: (
            { __typename?: 'CalendarEvent' }
            & CalendarEventWithUsersAndCountsFragment
          ), entity: (
            { __typename?: 'Entity' }
            & Pick<Entity, 'id' | 'campaignContextId' | 'firstName' | 'middleName' | 'nickname' | 'lastName'>
          ) }
        ) | (
          { __typename?: 'Entity' }
          & Pick<Entity, 'id' | 'campaignContextId' | 'firstName' | 'middleName' | 'nickname' | 'lastName'>
          & { entityType: Maybe<(
            { __typename?: 'EntityType' }
            & EntityTypeDetailsFragment
          )> }
        ) | (
          { __typename?: 'EntityConnection' }
          & EntityConnectionCoreFragment
        )> }
      )> }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  )> }
);

export type GetMergeConflictsQueryVariables = Exact<{
  targetId: Scalars['ID'];
  sourceId: Scalars['ID'];
  campaignId: Scalars['ID'];
}>;


export type GetMergeConflictsQuery = (
  { __typename?: 'Query' }
  & { getMergeConflicts: Maybe<(
    { __typename?: 'MergeConflictData' }
    & Pick<MergeConflictData, 'sourceId' | 'targetId' | 'campaignId' | 'coreConflicts' | 'preferredLanguageConflict'>
    & { entityCustomIdsConflicts: Maybe<Array<(
      { __typename?: 'EntityCustomIdConflict' }
      & Pick<EntityCustomIdConflict, 'property'>
    )>>, connectionConflicts: Maybe<Array<(
      { __typename?: 'MergeConflictData' }
      & Pick<MergeConflictData, 'sourceId' | 'targetId' | 'campaignId'>
      & { taggableConflicts: Maybe<Array<(
        { __typename?: 'TaggableConflicts' }
        & Pick<TaggableConflicts, 'tagCategoryId' | 'targetTaggableLogbookId' | 'sourceTaggableLogbookId'>
      )>> }
    )>>, taggableConflicts: Maybe<Array<(
      { __typename?: 'TaggableConflicts' }
      & Pick<TaggableConflicts, 'tagCategoryId' | 'targetTaggableLogbookId' | 'sourceTaggableLogbookId'>
    )>>, calendarEventResponseConflicts: Maybe<Array<(
      { __typename?: 'MergeConflictData' }
      & Pick<MergeConflictData, 'sourceId' | 'targetId' | 'campaignId'>
      & { taggableConflicts: Maybe<Array<(
        { __typename?: 'TaggableConflicts' }
        & Pick<TaggableConflicts, 'tagCategoryId' | 'targetTaggableLogbookId' | 'sourceTaggableLogbookId'>
      )>> }
    )>> }
  )> }
);

export type MergeEntitiesMutationVariables = Exact<{
  input: MergeEntitiesInput;
}>;


export type MergeEntitiesMutation = (
  { __typename?: 'Mutation' }
  & { mergeEntities: Maybe<(
    { __typename?: 'MergeEntitiesPayload' }
    & { entity: Maybe<(
      { __typename?: 'Entity' }
      & Pick<Entity, 'campaignContextId' | 'id'>
    )> }
  )> }
);

export type GetCountsForEntityChartQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  queryJson: Scalars['String'];
  startDate: Scalars['ISO8601DateTime'];
  endDate: Scalars['ISO8601DateTime'];
  period: ChartPeriodType;
  aggregationMethod: ChartAggregationMethodEnumType;
}>;


export type GetCountsForEntityChartQuery = (
  { __typename?: 'Query' }
  & { getCountsForEntityChart: (
    { __typename?: 'EntityChartCounts' }
    & Pick<EntityChartCounts, 'entitiesCount' | 'aggregationMethod' | 'period' | 'rangeEnd' | 'rangeStart'>
    & { results: Array<(
      { __typename?: 'EntityChartPeriod' }
      & Pick<EntityChartPeriod, 'periodEnd' | 'periodStart'>
      & { counts: Array<(
        { __typename?: 'EntityChartCount' }
        & Pick<EntityChartCount, 'groupLabel' | 'count'>
      )> }
    )> }
  ) }
);

export type ActionNetworkGroupInfoFragment = (
  { __typename?: 'ActionNetworkGroup' }
  & Pick<ActionNetworkGroup, 'id' | 'name' | 'groupId'>
);

export type ActionNetworkTagMappingInfoFragment = (
  { __typename?: 'ActionNetworkTagMapping' }
  & { actionBuilder: (
    { __typename?: 'AddressTag' }
    & Pick<AddressTag, 'id' | 'name' | 'archived'>
    & { category: (
      { __typename?: 'TagCategory' }
      & Pick<TagCategory, 'id' | 'name'>
    ), group: (
      { __typename?: 'TagGroup' }
      & Pick<TagGroup, 'id' | 'name'>
    ) }
  ) | (
    { __typename?: 'DateTag' }
    & Pick<DateTag, 'id' | 'name' | 'archived'>
    & { category: (
      { __typename?: 'TagCategory' }
      & Pick<TagCategory, 'id' | 'name'>
    ), group: (
      { __typename?: 'TagGroup' }
      & Pick<TagGroup, 'id' | 'name'>
    ) }
  ) | (
    { __typename?: 'NotesTag' }
    & Pick<NotesTag, 'id' | 'name' | 'archived'>
    & { category: (
      { __typename?: 'TagCategory' }
      & Pick<TagCategory, 'id' | 'name'>
    ), group: (
      { __typename?: 'TagGroup' }
      & Pick<TagGroup, 'id' | 'name'>
    ) }
  ) | (
    { __typename?: 'NumberTag' }
    & Pick<NumberTag, 'id' | 'name' | 'archived'>
    & { category: (
      { __typename?: 'TagCategory' }
      & Pick<TagCategory, 'id' | 'name'>
    ), group: (
      { __typename?: 'TagGroup' }
      & Pick<TagGroup, 'id' | 'name'>
    ) }
  ) | (
    { __typename?: 'ShiftTag' }
    & Pick<ShiftTag, 'id' | 'name' | 'archived'>
    & { category: (
      { __typename?: 'TagCategory' }
      & Pick<TagCategory, 'id' | 'name'>
    ), group: (
      { __typename?: 'TagGroup' }
      & Pick<TagGroup, 'id' | 'name'>
    ) }
  ) | (
    { __typename?: 'StandardTag' }
    & Pick<StandardTag, 'id' | 'name' | 'archived'>
    & { category: (
      { __typename?: 'TagCategory' }
      & Pick<TagCategory, 'id' | 'name'>
    ), group: (
      { __typename?: 'TagGroup' }
      & Pick<TagGroup, 'id' | 'name'>
    ) }
  ), actionNetwork: (
    { __typename?: 'ActionNetworkTagMappingConfig' }
    & Pick<ActionNetworkTagMappingConfig, 'customField' | 'tagId'>
  ) }
);

export type AddActionNetworkGroupMutationVariables = Exact<{
  input: ActionNetworkAddGroupInput;
}>;


export type AddActionNetworkGroupMutation = (
  { __typename?: 'Mutation' }
  & { addActionNetworkGroup: Maybe<(
    { __typename?: 'ActionNetworkAddGroupPayload' }
    & { actionNetworkGroup: Maybe<(
      { __typename?: 'ActionNetworkGroup' }
      & ActionNetworkGroupInfoFragment
    )> }
  )> }
);

export type AddAnIntegrationToCampaignMutationVariables = Exact<{
  input: ActionNetworkAddIntegrationToCampaignInput;
}>;


export type AddAnIntegrationToCampaignMutation = (
  { __typename?: 'Mutation' }
  & { addActionNetworkIntegrationToCampaign: Maybe<(
    { __typename?: 'ActionNetworkAddIntegrationToCampaignPayload' }
    & { campaign: Maybe<(
      { __typename?: 'Campaign' }
      & Pick<Campaign, 'id'>
      & { campaignIntegrations: Maybe<(
        { __typename?: 'CampaignIntegrations' }
        & { actionNetwork: Maybe<(
          { __typename?: 'ActionNetworkIntegration' }
          & AnCampaignIntegrationFragment
        )> }
      )> }
    )> }
  )> }
);

export type AddActionNetworkTagMappingMutationVariables = Exact<{
  input: ActionNetworkAddCampaignTagMappingInput;
}>;


export type AddActionNetworkTagMappingMutation = (
  { __typename?: 'Mutation' }
  & { addActionNetworkCampaignTagMapping: Maybe<(
    { __typename?: 'ActionNetworkAddCampaignTagMappingPayload' }
    & { actionNetworkTagMapping: (
      { __typename?: 'ActionNetworkTagMapping' }
      & ActionNetworkTagMappingInfoFragment
    ) }
  )> }
);

export type AnCampaignIntegrationFragment = (
  { __typename?: 'ActionNetworkIntegration' }
  & Pick<ActionNetworkIntegration, 'id' | 'eventSyncEnabled'>
  & { group: (
    { __typename?: 'ActionNetworkGroup' }
    & ActionNetworkGroupInfoFragment
  ), magicTag: (
    { __typename?: 'ActionNetworkTag' }
    & Pick<ActionNetworkTag, 'name' | 'uuid'>
  ), mappings: Array<(
    { __typename?: 'ActionNetworkTagMapping' }
    & ActionNetworkTagMappingInfoFragment
  )>, defaultEntityType: Maybe<(
    { __typename?: 'EntityType' }
    & EntityTypeDetailsFragment
  )> }
);

export type GetActionNetworkCustomFieldsQueryVariables = Exact<{
  groupId: Scalars['String'];
}>;


export type GetActionNetworkCustomFieldsQuery = (
  { __typename?: 'Query' }
  & { getActionNetworkCustomFields: Maybe<Array<(
    { __typename?: 'ActionNetworkCustomField' }
    & Pick<ActionNetworkCustomField, 'name'>
    & { uuid: ActionNetworkCustomField['name'] }
  )>> }
);

export type GetActionNetworkEventQueryVariables = Exact<{
  calendarEventId: Scalars['ID'];
}>;


export type GetActionNetworkEventQuery = (
  { __typename?: 'Query' }
  & { getActionNetworkEvent: Maybe<(
    { __typename?: 'ActionNetworkEvent' }
    & Pick<ActionNetworkEvent, 'administrativeTitle' | 'id' | 'permalink' | 'timezone' | 'title'>
    & { startDate: ActionNetworkEvent['startAt'] }
  )> }
);

export type GetActionNetworkEventsQueryVariables = Exact<{
  groupId: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
}>;


export type GetActionNetworkEventsQuery = (
  { __typename?: 'Query' }
  & { getActionNetworkEvents: Maybe<(
    { __typename?: 'EventConnection' }
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'ActionNetworkEvent' }
      & Pick<ActionNetworkEvent, 'id' | 'administrativeTitle' | 'title' | 'timezone' | 'permalink'>
      & { startDate: ActionNetworkEvent['startAt'] }
    )>>> }
  )> }
);

export type GetActionNetworkGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActionNetworkGroupsQuery = (
  { __typename?: 'Query' }
  & { getActionNetworkGroups: Maybe<Array<(
    { __typename?: 'ActionNetworkGroup' }
    & ActionNetworkGroupInfoFragment
  )>> }
);

export type GetActionNetworkTagsQueryVariables = Exact<{
  groupId: Scalars['String'];
}>;


export type GetActionNetworkTagsQuery = (
  { __typename?: 'Query' }
  & { getActionNetworkTags: Maybe<Array<(
    { __typename?: 'ActionNetworkTag' }
    & Pick<ActionNetworkTag, 'name' | 'uuid'>
  )>> }
);

export type GetAnCampaignIntegrationQueryVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type GetAnCampaignIntegrationQuery = (
  { __typename?: 'Query' }
  & { getCampaign: Maybe<(
    { __typename?: 'Campaign' }
    & Pick<Campaign, 'id' | 'name'>
    & { campaignIntegrations: Maybe<(
      { __typename?: 'CampaignIntegrations' }
      & { actionNetwork: Maybe<(
        { __typename?: 'ActionNetworkIntegration' }
        & AnCampaignIntegrationFragment
      )> }
    )>, entityTypes: Maybe<Array<(
      { __typename?: 'EntityType' }
      & EntityTypeDetailsFragment
    )>> }
  )> }
);

export type RemoveAnIntegrationFromCampaignMutationVariables = Exact<{
  input: ActionNetworkRemoveCampaignIntegrationInput;
}>;


export type RemoveAnIntegrationFromCampaignMutation = (
  { __typename?: 'Mutation' }
  & { removeActionNetworkIntegrationFromCampaign: Maybe<(
    { __typename?: 'ActionNetworkRemoveCampaignIntegrationPayload' }
    & { campaign: Maybe<(
      { __typename?: 'Campaign' }
      & Pick<Campaign, 'id'>
      & { campaignIntegrations: Maybe<(
        { __typename?: 'CampaignIntegrations' }
        & { actionNetwork: Maybe<(
          { __typename?: 'ActionNetworkIntegration' }
          & AnCampaignIntegrationFragment
        )> }
      )> }
    )> }
  )> }
);

export type RemoveAnTagMappingMutationVariables = Exact<{
  input: ActionNetworkRemoveCampaignTagMappingInput;
}>;


export type RemoveAnTagMappingMutation = (
  { __typename?: 'Mutation' }
  & { removeActionNetworkCampaignTagMapping: Maybe<(
    { __typename?: 'ActionNetworkRemoveCampaignTagMappingPayload' }
    & { actionNetworkTagMapping: (
      { __typename?: 'ActionNetworkTagMapping' }
      & ActionNetworkTagMappingInfoFragment
    ) }
  )> }
);

export type UpdateAnCampaignIntegrationMutationVariables = Exact<{
  input: ActionNetworkUpdateIntegrationInput;
}>;


export type UpdateAnCampaignIntegrationMutation = (
  { __typename?: 'Mutation' }
  & { updateActionNetworkIntegration: Maybe<(
    { __typename?: 'ActionNetworkUpdateIntegrationPayload' }
    & { integration: (
      { __typename?: 'ActionNetworkIntegration' }
      & AnCampaignIntegrationFragment
    ) }
  )> }
);

export type AddApiKeyMutationVariables = Exact<{
  input: AddApiKeyInput;
}>;


export type AddApiKeyMutation = (
  { __typename?: 'Mutation' }
  & { addApiKey: Maybe<(
    { __typename?: 'AddAPIKeyPayload' }
    & { apiKey: (
      { __typename?: 'APIKey' }
      & ApiKeyDetailsFragment
    ) }
  )> }
);

export type ApiKeyDetailsFragment = (
  { __typename?: 'APIKey' }
  & Pick<ApiKey, 'id' | 'apiKey' | 'target'>
);

export type GetApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApiKeysQuery = (
  { __typename?: 'Query' }
  & { getApiKeys: Maybe<Array<(
    { __typename?: 'APIKey' }
    & ApiKeyDetailsFragment
  )>> }
);

export type RevokeApiKeyMutationVariables = Exact<{
  input: RevokeApiKeyInput;
}>;


export type RevokeApiKeyMutation = (
  { __typename?: 'Mutation' }
  & { revokeApiKey: Maybe<(
    { __typename?: 'RevokeAPIKeyPayload' }
    & { apiKey: (
      { __typename?: 'APIKey' }
      & ApiKeyDetailsFragment
    ) }
  )> }
);

export type ActionEntityPrintViewDetailsFragment = (
  { __typename?: 'ActionEntity' }
  & Pick<ActionEntity, 'id' | 'status'>
  & { entity: Maybe<(
    { __typename?: 'Entity' }
    & { tagsInCategories: Maybe<Array<Maybe<(
      { __typename?: 'TaggableLogbook' }
      & TaggableLogbookPrintInfoFragment
    )>>>, entityConnectionCount: Maybe<Array<(
      { __typename?: 'EntityConnectionCount' }
      & EntityConnectionCountMapViewFragment
    )>> }
    & EntityPrintBaseFragment
  )>, tasks: Maybe<Array<Maybe<(
    { __typename?: 'Task' }
    & Pick<Task, 'id' | 'resolved'>
    & { actionField: Maybe<(
      { __typename?: 'ActionField' }
      & Pick<ActionField, 'id'>
    )> }
  )>>> }
);

export type GetActionEntitiesByIdPrintQueryVariables = Exact<{
  entityIds: Array<Scalars['ID']> | Scalars['ID'];
  campaignId: Scalars['ID'];
  actionId: Scalars['ID'];
  tagCategoryIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetActionEntitiesByIdPrintQuery = (
  { __typename?: 'Query' }
  & { getActionEntities: Maybe<Array<(
    { __typename?: 'ActionEntity' }
    & ActionEntityPrintViewDetailsFragment
  )>> }
);

export type GetEntitiesByIdsPrintQueryVariables = Exact<{
  entityIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  campaignId: Scalars['ID'];
}>;


export type GetEntitiesByIdsPrintQuery = (
  { __typename?: 'Query' }
  & { getEntitiesByIds: Maybe<Array<(
    { __typename?: 'Entity' }
    & EntityPrintDetailsFragment
  )>> }
);

export type EntityPrintDetailsFragment = (
  { __typename?: 'Entity' }
  & { appliedToplines: Maybe<(
    { __typename?: 'AppliedToplines' }
    & Pick<AppliedToplines, 'id'>
    & { item0: Maybe<(
      { __typename?: 'AppliedToplineItem' }
      & CompactedToplineInfoFragment
    )>, item1: Maybe<(
      { __typename?: 'AppliedToplineItem' }
      & CompactedToplineInfoFragment
      & WithConnectionTagsFragment
    )>, item2: Maybe<(
      { __typename?: 'AppliedToplineItem' }
      & CompactedToplineInfoFragment
      & WithConnectionTagsFragment
    )>, item3: Maybe<(
      { __typename?: 'AppliedToplineItem' }
      & CompactedToplineInfoFragment
      & WithConnectionTagsFragment
    )>, item4: Maybe<(
      { __typename?: 'AppliedToplineItem' }
      & CompactedToplineInfoFragment
      & WithConnectionTagsFragment
    )>, item5: Maybe<(
      { __typename?: 'AppliedToplineItem' }
      & CompactedToplineInfoFragment
      & WithConnectionTagsFragment
    )> }
  )> }
  & EntityPrintBaseFragment
);

export type CompactedToplineInfoFragment = (
  { __typename?: 'AppliedToplineItem' }
  & { appliedToplineValue: Maybe<{ __typename?: 'Address' } | { __typename?: 'Email' } | { __typename?: 'EntityLanguage' } | { __typename?: 'Note' } | { __typename?: 'PhoneNumber' } | { __typename?: 'SocialProfile' } | { __typename?: 'ToplineAge' } | (
    { __typename?: 'ToplineAppliedEntityConnections' }
    & { entityConnections: Maybe<Array<Maybe<(
      { __typename?: 'EntityConnection' }
      & Pick<EntityConnection, 'id'>
      & { entity1: (
        { __typename?: 'EntityPublic' }
        & Pick<EntityPublic, 'id' | 'firstName' | 'middleName' | 'lastName' | 'nickname' | 'pronouns' | 'suffix'>
      ), entity2: (
        { __typename?: 'EntityPublic' }
        & Pick<EntityPublic, 'id' | 'firstName' | 'middleName' | 'lastName' | 'nickname' | 'pronouns' | 'suffix'>
      ), appliedToplines: Maybe<(
        { __typename?: 'AppliedToplines' }
        & Pick<AppliedToplines, 'id'>
        & { item0: Maybe<(
          { __typename?: 'AppliedToplineItem' }
          & AppliedTagToplineValuePrintFragment
        )> }
      )> }
    )>>> }
  ) | (
    { __typename?: 'ToplineAppliedTags' }
    & { appliedTags: Maybe<Array<(
      { __typename?: 'TaggableLogbook' }
      & TaggableLogbookPrintInfoFragment
    )>> }
  ) | { __typename?: 'ToplinePreferredLanguage' }> }
);

export type AppliedTagToplineValuePrintFragment = (
  { __typename?: 'AppliedToplineItem' }
  & { appliedToplineValue: Maybe<{ __typename?: 'Address' } | { __typename?: 'Email' } | { __typename?: 'EntityLanguage' } | { __typename?: 'Note' } | { __typename?: 'PhoneNumber' } | { __typename?: 'SocialProfile' } | { __typename?: 'ToplineAge' } | { __typename?: 'ToplineAppliedEntityConnections' } | (
    { __typename?: 'ToplineAppliedTags' }
    & { appliedTags: Maybe<Array<(
      { __typename?: 'TaggableLogbook' }
      & TaggableLogbookPrintInfoFragment
    )>> }
  ) | { __typename?: 'ToplinePreferredLanguage' }> }
);

export type WithConnectionTagsFragment = (
  { __typename?: 'AppliedToplineItem' }
  & { appliedToplineValue: Maybe<{ __typename?: 'Address' } | { __typename?: 'Email' } | { __typename?: 'EntityLanguage' } | { __typename?: 'Note' } | { __typename?: 'PhoneNumber' } | { __typename?: 'SocialProfile' } | { __typename?: 'ToplineAge' } | (
    { __typename?: 'ToplineAppliedEntityConnections' }
    & { entityConnections: Maybe<Array<Maybe<(
      { __typename?: 'EntityConnection' }
      & Pick<EntityConnection, 'id'>
      & { entity1: (
        { __typename?: 'EntityPublic' }
        & Pick<EntityPublic, 'id' | 'firstName' | 'middleName' | 'lastName' | 'nickname'>
      ), entity2: (
        { __typename?: 'EntityPublic' }
        & Pick<EntityPublic, 'id' | 'firstName' | 'middleName' | 'lastName' | 'nickname'>
      ), appliedToplines: Maybe<(
        { __typename?: 'AppliedToplines' }
        & Pick<AppliedToplines, 'id'>
        & { item1: Maybe<(
          { __typename?: 'AppliedToplineItem' }
          & AppliedTagToplineValuePrintFragment
        )>, item2: Maybe<(
          { __typename?: 'AppliedToplineItem' }
          & AppliedTagToplineValuePrintFragment
        )>, item3: Maybe<(
          { __typename?: 'AppliedToplineItem' }
          & AppliedTagToplineValuePrintFragment
        )>, item4: Maybe<(
          { __typename?: 'AppliedToplineItem' }
          & AppliedTagToplineValuePrintFragment
        )>, item5: Maybe<(
          { __typename?: 'AppliedToplineItem' }
          & AppliedTagToplineValuePrintFragment
        )> }
      )> }
    )>>> }
  ) | { __typename?: 'ToplineAppliedTags' } | { __typename?: 'ToplinePreferredLanguage' }> }
);

export type EntityPrintBaseFragment = (
  { __typename?: 'Entity' }
  & Pick<Entity, 'id' | 'campaignContextId' | 'entityTypeId' | 'firstName' | 'middleName' | 'lastName' | 'nickname' | 'suffix' | 'currentAssessmentLevel' | 'dateOfBirth' | 'age' | 'pronouns' | 'calculatedBirthDate'>
  & { entityLanguages: Maybe<Array<(
    { __typename?: 'EntityLanguage' }
    & Pick<EntityLanguage, 'languageCode' | 'preferred'>
  )>>, activeFollowUp: Maybe<(
    { __typename?: 'FollowUp' }
    & FollowUpPrintInfoFragment
  )>, mostRecentNote: Maybe<(
    { __typename?: 'Note' }
    & Pick<Note, 'id' | 'text' | 'createdAt'>
    & { createdBy: (
      { __typename?: 'UserPublic' }
      & Pick<UserPublic, 'id' | 'firstName' | 'lastName'>
    ) }
  )>, appliedToplines: Maybe<(
    { __typename?: 'AppliedToplines' }
    & Pick<AppliedToplines, 'id'>
    & { item0: Maybe<(
      { __typename?: 'AppliedToplineItem' }
      & CompactedToplineInfoFragment
    )> }
  )>, bestAddress: Maybe<(
    { __typename?: 'Address' }
    & AddressPrintInfoFragment
  )>, bestPhoneNumber: Maybe<(
    { __typename?: 'PhoneNumber' }
    & PhonePrintInfoFragment
  )>, bestEmail: Maybe<(
    { __typename?: 'Email' }
    & EmailPrintInfoFragment
  )> }
);

export type FollowUpPrintInfoFragment = (
  { __typename?: 'FollowUp' }
  & Pick<FollowUp, 'id' | 'active' | 'createdAt'>
  & { createdBy: Maybe<(
    { __typename?: 'UserPublic' }
    & Pick<UserPublic, 'id' | 'name'>
  )>, note: Maybe<(
    { __typename?: 'Note' }
    & Pick<Note, 'id' | 'text'>
  )> }
);

type TagPrintInfo_AddressTag_Fragment = (
  { __typename?: 'AddressTag' }
  & Pick<AddressTag, 'id' | 'tagType' | 'name'>
  & { address: Maybe<(
    { __typename?: 'Address' }
    & AddressPrintInfoFragment
  )>, category: (
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'id' | 'name'>
  ) }
);

type TagPrintInfo_DateTag_Fragment = (
  { __typename?: 'DateTag' }
  & Pick<DateTag, 'id' | 'tagType' | 'name'>
  & { category: (
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'id' | 'name'>
  ) }
);

type TagPrintInfo_NotesTag_Fragment = (
  { __typename?: 'NotesTag' }
  & Pick<NotesTag, 'id' | 'tagType' | 'name'>
  & { category: (
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'id' | 'name'>
  ) }
);

type TagPrintInfo_NumberTag_Fragment = (
  { __typename?: 'NumberTag' }
  & Pick<NumberTag, 'id' | 'tagType' | 'name'>
  & { category: (
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'id' | 'name'>
  ) }
);

type TagPrintInfo_ShiftTag_Fragment = (
  { __typename?: 'ShiftTag' }
  & Pick<ShiftTag, 'id' | 'tagType' | 'name'>
  & { category: (
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'id' | 'name'>
  ) }
);

type TagPrintInfo_StandardTag_Fragment = (
  { __typename?: 'StandardTag' }
  & Pick<StandardTag, 'id' | 'tagType' | 'name'>
  & { category: (
    { __typename?: 'TagCategory' }
    & Pick<TagCategory, 'id' | 'name'>
  ) }
);

export type TagPrintInfoFragment = TagPrintInfo_AddressTag_Fragment | TagPrintInfo_DateTag_Fragment | TagPrintInfo_NotesTag_Fragment | TagPrintInfo_NumberTag_Fragment | TagPrintInfo_ShiftTag_Fragment | TagPrintInfo_StandardTag_Fragment;

export type TaggableLogbookPrintInfoFragment = (
  { __typename?: 'TaggableLogbook' }
  & Pick<TaggableLogbook, 'id'>
  & { tag: (
    { __typename?: 'AddressTag' }
    & TagPrintInfo_AddressTag_Fragment
  ) | (
    { __typename?: 'DateTag' }
    & TagPrintInfo_DateTag_Fragment
  ) | (
    { __typename?: 'NotesTag' }
    & TagPrintInfo_NotesTag_Fragment
  ) | (
    { __typename?: 'NumberTag' }
    & TagPrintInfo_NumberTag_Fragment
  ) | (
    { __typename?: 'ShiftTag' }
    & TagPrintInfo_ShiftTag_Fragment
  ) | (
    { __typename?: 'StandardTag' }
    & TagPrintInfo_StandardTag_Fragment
  ), notes: Maybe<Array<(
    { __typename?: 'Note' }
    & Pick<Note, 'id' | 'text'>
  )>> }
);

export type AddressPrintInfoFragment = (
  { __typename?: 'Address' }
  & Pick<Address, 'id' | 'status' | 'streetAddress' | 'addressType' | 'city' | 'state' | 'zip' | 'updatedAt' | 'country'>
);

export type PhonePrintInfoFragment = (
  { __typename?: 'PhoneNumber' }
  & Pick<PhoneNumber, 'id' | 'numberType' | 'number' | 'ext' | 'status' | 'subscribed' | 'updatedAt'>
);

export type EmailPrintInfoFragment = (
  { __typename?: 'Email' }
  & Pick<Email, 'id' | 'subscribed' | 'status' | 'email' | 'updatedAt' | 'emailType'>
);

export type GetEntityConnectionsPrintViewQueryVariables = Exact<{
  entityId: Scalars['ID'];
  campaignId: Scalars['ID'];
  entityConnectionTypeId: Scalars['ID'];
}>;


export type GetEntityConnectionsPrintViewQuery = (
  { __typename?: 'Query' }
  & { getEntityConnections: Maybe<(
    { __typename?: 'EntityConnectionConnection' }
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'EntityConnection' }
      & Pick<EntityConnection, 'id' | 'active'>
      & { entity1: (
        { __typename?: 'EntityPublic' }
        & Pick<EntityPublic, 'id' | 'firstName' | 'middleName' | 'lastName' | 'nickname' | 'pronouns' | 'suffix'>
      ), entity2: (
        { __typename?: 'EntityPublic' }
        & Pick<EntityPublic, 'id' | 'firstName' | 'middleName' | 'lastName' | 'nickname' | 'pronouns' | 'suffix'>
      ), appliedToplines: Maybe<(
        { __typename?: 'AppliedToplines' }
        & Pick<AppliedToplines, 'id'>
        & { item0: Maybe<(
          { __typename?: 'AppliedToplineItem' }
          & AppliedTagToplineValuePrintFragment
        )>, item1: Maybe<(
          { __typename?: 'AppliedToplineItem' }
          & AppliedTagToplineValuePrintFragment
        )>, item2: Maybe<(
          { __typename?: 'AppliedToplineItem' }
          & AppliedTagToplineValuePrintFragment
        )>, item3: Maybe<(
          { __typename?: 'AppliedToplineItem' }
          & AppliedTagToplineValuePrintFragment
        )>, item4: Maybe<(
          { __typename?: 'AppliedToplineItem' }
          & AppliedTagToplineValuePrintFragment
        )>, item5: Maybe<(
          { __typename?: 'AppliedToplineItem' }
          & AppliedTagToplineValuePrintFragment
        )> }
      )> }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ) }
  )> }
);

export type UploadDetailsFragment = (
  { __typename?: 'Upload' }
  & Pick<Upload, 'id' | 'createdAt' | 'uploadType' | 'status' | 'visibilityStatus' | 'name'>
  & { createdBy: (
    { __typename?: 'UserPublic' }
    & Pick<UserPublic, 'id' | 'firstName' | 'lastName' | 'email'>
  ), campaign: Maybe<(
    { __typename?: 'CampaignPublic' }
    & Pick<CampaignPublic, 'id' | 'name'>
  )>, summary: (
    { __typename?: 'UploadSummary' }
    & Pick<UploadSummary, 'total' | 'addToCampaign' | 'new' | 'updates' | 'errors' | 'deleted'>
  ) }
);

export type GetUploadsQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  visibilityStatus?: Maybe<UploadVisibilityStatusType>;
}>;


export type GetUploadsQuery = (
  { __typename?: 'Query' }
  & { getUploads: Maybe<(
    { __typename?: 'UploadConnection' }
    & Pick<UploadConnection, 'totalCount'>
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'Upload' }
      & UploadDetailsFragment
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ) }
  )> }
);

export type GetUploadByIdQueryQueryVariables = Exact<{
  uploadId: Scalars['ID'];
}>;


export type GetUploadByIdQueryQuery = (
  { __typename?: 'Query' }
  & { getUploadById: Maybe<(
    { __typename?: 'Upload' }
    & UploadDetailsFragment
  )> }
);

export type GetEntityImportFieldsQueryQueryVariables = Exact<{
  entityTypeId: Scalars['ID'];
}>;


export type GetEntityImportFieldsQueryQuery = (
  { __typename?: 'Query' }
  & { getEntityImportFields: Maybe<Array<(
    { __typename?: 'EntityImportField' }
    & Pick<EntityImportField, 'displayName' | 'field'>
  )>> }
);

export type GetUploadDownloadUrlQueryVariables = Exact<{
  uploadId: Scalars['ID'];
}>;


export type GetUploadDownloadUrlQuery = (
  { __typename?: 'Query' }
  & { getUploadDownloadUrl: Maybe<(
    { __typename?: 'UploadDownloadUrl' }
    & Pick<UploadDownloadUrl, 'url'>
  )> }
);

export type GetUploadErrorsUrlQueryVariables = Exact<{
  uploadId: Scalars['ID'];
}>;


export type GetUploadErrorsUrlQuery = (
  { __typename?: 'Query' }
  & { getUploadErrorsUrl: Maybe<(
    { __typename?: 'UploadDownloadUrl' }
    & Pick<UploadDownloadUrl, 'url'>
  )> }
);

export type ImportDetailsFragment = (
  { __typename?: 'Import' }
  & Pick<Import, 'id' | 'createdAt' | 'status' | 'visibilityStatus' | 'name'>
  & { createdBy: (
    { __typename?: 'UserPublic' }
    & Pick<UserPublic, 'id' | 'firstName' | 'lastName' | 'email'>
  ), entityType: Maybe<(
    { __typename?: 'EntityType' }
    & Pick<EntityType, 'id' | 'namePlural' | 'nameSingular'>
  )>, campaign: Maybe<(
    { __typename?: 'CampaignPublic' }
    & Pick<CampaignPublic, 'id' | 'name'>
  )>, summary: (
    { __typename?: 'ImportSummary' }
    & Pick<ImportSummary, 'entitiesAddedToCampaignCount' | 'entitiesCreatedCount' | 'entitiesMatchedCount' | 'errorCount' | 'processedCount' | 'rowsCount'>
  ) }
);

export type CreateImportMutationVariables = Exact<{
  input: CreateImportInput;
}>;


export type CreateImportMutation = (
  { __typename?: 'Mutation' }
  & { createImport: Maybe<(
    { __typename?: 'CreateImportPayload' }
    & { import: Maybe<(
      { __typename?: 'Import' }
      & ImportDetailsFragment
    )> }
  )> }
);

export type DeleteEntitiesMutationVariables = Exact<{
  input: DeleteEntitiesInput;
}>;


export type DeleteEntitiesMutation = (
  { __typename?: 'Mutation' }
  & { deleteEntities: Maybe<(
    { __typename?: 'DeleteEntitiesPayload' }
    & Pick<DeleteEntitiesPayload, 'success'>
  )> }
);

export type RemoveEntitiesFromCampaignsMutationVariables = Exact<{
  input: RemoveEntitiesFromCampaignsInput;
}>;


export type RemoveEntitiesFromCampaignsMutation = (
  { __typename?: 'Mutation' }
  & { removeEntitiesFromCampaigns: Maybe<(
    { __typename?: 'RemoveEntitiesFromCampaignsPayload' }
    & Pick<RemoveEntitiesFromCampaignsPayload, 'success'>
  )> }
);

export type UpdateImportMutationVariables = Exact<{
  input: UpdateImportInput;
}>;


export type UpdateImportMutation = (
  { __typename?: 'Mutation' }
  & { updateImport: Maybe<(
    { __typename?: 'UpdateImportPayload' }
    & { import: Maybe<(
      { __typename?: 'Import' }
      & ImportDetailsFragment
    )> }
  )> }
);

export type GetDeleteEntitiesOperationQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type GetDeleteEntitiesOperationQuery = (
  { __typename?: 'Query' }
  & { getDeleteEntitiesOperations: Maybe<(
    { __typename?: 'DeleteEntitiesOperationConnection' }
    & Pick<DeleteEntitiesOperationConnection, 'totalCount'>
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'DeleteEntitiesOperation' }
      & Pick<DeleteEntitiesOperation, 'completedAt' | 'createdAt' | 'id' | 'notFound' | 'status' | 'totalDeleted' | 'totalSent' | 'updatedAt'>
      & { createdBy: (
        { __typename?: 'UserPublic' }
        & Pick<UserPublic, 'email' | 'name'>
      ) }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  )> }
);

export type GetImportErrorsUrlQueryVariables = Exact<{
  importId: Scalars['ID'];
}>;


export type GetImportErrorsUrlQuery = (
  { __typename?: 'Query' }
  & { getImportErrorsUrl: Maybe<(
    { __typename?: 'Url' }
    & Pick<Url, 'url'>
  )> }
);

export type GetImportDownloadUrlQueryVariables = Exact<{
  importId: Scalars['ID'];
}>;


export type GetImportDownloadUrlQuery = (
  { __typename?: 'Query' }
  & { getImportDownloadUrl: Maybe<(
    { __typename?: 'Url' }
    & Pick<Url, 'url'>
  )> }
);

export type GetImportsQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  visibilityStatus?: Maybe<ImportVisibilityStatusType>;
  orderBy?: Maybe<Scalars['String']>;
}>;


export type GetImportsQuery = (
  { __typename?: 'Query' }
  & { getImports: Maybe<(
    { __typename?: 'ImportConnection' }
    & Pick<ImportConnection, 'totalCount'>
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'Import' }
      & ImportDetailsFragment
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ) }
  )> }
);

export type GetRemoveEntitiesFromCampaignsOperationsQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type GetRemoveEntitiesFromCampaignsOperationsQuery = (
  { __typename?: 'Query' }
  & { getRemoveEntitiesFromCampaignsOperations: Maybe<(
    { __typename?: 'RemoveEntitiesFromCampaignsOperationConnection' }
    & Pick<RemoveEntitiesFromCampaignsOperationConnection, 'totalCount'>
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'RemoveEntitiesFromCampaignsOperation' }
      & Pick<RemoveEntitiesFromCampaignsOperation, 'completedAt' | 'createdAt' | 'id' | 'notFoundIds' | 'status' | 'totalProcessed' | 'totalSent' | 'updatedAt'>
      & { createdBy: (
        { __typename?: 'UserPublic' }
        & Pick<UserPublic, 'email' | 'name'>
      ), removalCounts: Array<(
        { __typename?: 'RemoveEntitiesFromCampaignsOperationRemovalCounts' }
        & Pick<RemoveEntitiesFromCampaignsOperationRemovalCounts, 'entitiesRemoved'>
        & { campaign: (
          { __typename?: 'Campaign' }
          & Pick<Campaign, 'id' | 'name'>
        ) }
      )> }
    )>>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>
    ) }
  )> }
);

export type GetTagCategoriesFastQueryVariables = Exact<{
  campaignId?: Maybe<Scalars['ID']>;
  targetTypeId?: Maybe<Scalars['ID']>;
  targetType?: Maybe<Scalars['String']>;
}>;


export type GetTagCategoriesFastQuery = (
  { __typename?: 'Query' }
  & { getTagCategories: Maybe<(
    { __typename?: 'TagCategoryConnection' }
    & Pick<TagCategoryConnection, 'totalCount'>
    & { nodes: Maybe<Array<Maybe<(
      { __typename?: 'TagCategory' }
      & Pick<TagCategory, 'id' | 'name' | 'groupName' | 'allowToCreateTagType' | 'isUniversal'>
    )>>> }
  )> }
);

type DiscriminateUnion<T, U> = T extends U ? T : never;

export namespace AddressDetails {
  export type Fragment = AddressDetailsFragment;
  export type ElectoralDistricts = AddressDetailsFragment['electoralDistricts'][number];
  export type Original = AddressDetailsFragment['original'];
}

export namespace AssessmentSettings {
  export type Fragment = AssessmentSettingsFragment;
  export type EntityTypeOverrides = AssessmentSettingsFragment['entityTypeOverrides'][number];
}

export namespace AttachmentDetails {
  export type Fragment = AttachmentDetailsFragment;
}

export namespace CampaignConnectionTypeConfigDetails {
  export type Fragment = CampaignConnectionTypeConfigDetailsFragment;
  export type EntityConnectionType = CampaignConnectionTypeConfigDetailsFragment['entityConnectionType'];
  export type Campaign = CampaignConnectionTypeConfigDetailsFragment['campaign'];
  export type ToplineSettingItems = CampaignConnectionTypeConfigDetailsFragment['toplineSettingItems'][number];
}

export namespace CampaignEntityTypeConfigDetails {
  export type Fragment = CampaignEntityTypeConfigDetailsFragment;
  export type EntityType = CampaignEntityTypeConfigDetailsFragment['entityType'];
  export type Campaign = CampaignEntityTypeConfigDetailsFragment['campaign'];
  export type ToplineSettingItems = CampaignEntityTypeConfigDetailsFragment['toplineSettingItems'][number];
  export type DefaultTagCategories = CampaignEntityTypeConfigDetailsFragment['defaultTagCategories'][number];
  export type CreationCustomForm = CampaignEntityTypeConfigDetailsFragment['creationCustomForm'];
  export type CustomForm = CampaignEntityTypeConfigDetailsFragment['customForm'];
  export type SpotlightTags = CampaignEntityTypeConfigDetailsFragment['spotlightTags'][number];
}

export namespace CampaignWithoutTags {
  export type Fragment = CampaignWithoutTagsFragment;
  export type RestrictedExportingSettings = CampaignWithoutTagsFragment['restrictedExportingSettings'];
  export type EntityTypes = CampaignWithoutTagsFragment['entityTypes'][number];
  export type EntityConnectionTypes = CampaignWithoutTagsFragment['entityConnectionTypes'][number];
  export type DefaultEntityType = CampaignWithoutTagsFragment['defaultEntityType'];
  export type SupportUser = CampaignWithoutTagsFragment['supportUser'];
  export type CreatedBy = CampaignWithoutTagsFragment['createdBy'];
  export type Notes = CampaignWithoutTagsFragment['notes'];
  export type Nodes = CampaignWithoutTagsFragment['notes']['nodes'][number];
}

export namespace CustomFormDetails {
  export type Fragment = CustomFormDetailsFragment;
  export type Fields = CustomFormDetailsFragment['fields'][number];
}

export namespace CustomFormFieldDetails {
  export type Fragment = CustomFormFieldDetailsFragment;
  export type TagCategory = CustomFormFieldDetailsFragment['tagCategory'];
  export type EntityConnectionType = CustomFormFieldDetailsFragment['entityConnectionType'];
}

export namespace EntityConnectionTypeDetails {
  export type Fragment = EntityConnectionTypeDetailsFragment;
  export type EntityType1 = EntityConnectionTypeDetailsFragment['entityType1'];
  export type EntityType2 = EntityConnectionTypeDetailsFragment['entityType2'];
}

export namespace EntityConnectionCore {
  export type Fragment = EntityConnectionCoreFragment;
  export type Entity1 = EntityConnectionCoreFragment['entity1'];
  export type Entity2 = EntityConnectionCoreFragment['entity2'];
}

export namespace EntityConnectionCountMapView {
  export type Fragment = EntityConnectionCountMapViewFragment;
  export type EntityConnectionType = EntityConnectionCountMapViewFragment['entityConnectionType'];
}

export namespace EntityConnectionWithHighlightedTopline {
  export type Fragment = EntityConnectionWithHighlightedToplineFragment;
  export type AppliedToplines = EntityConnectionWithHighlightedToplineFragment['appliedToplines'];
}

export namespace EntityConnectionWithNotes {
  export type Fragment = EntityConnectionWithNotesFragment;
  export type Notes = EntityConnectionWithNotesFragment['notes'][number];
}

export namespace EntityConnectionWithTags {
  export type Fragment = EntityConnectionWithTagsFragment;
  export type Tags = EntityConnectionWithTagsFragment['tags'][number];
}

export namespace EntityConnectionWithToplines {
  export type Fragment = EntityConnectionWithToplinesFragment;
  export type AppliedToplines = EntityConnectionWithToplinesFragment['appliedToplines'];
}

export namespace EntityTypeDetails {
  export type Fragment = EntityTypeDetailsFragment;
}

export namespace EmailDetails {
  export type Fragment = EmailDetailsFragment;
}

export namespace EntityWithToplines {
  export type Fragment = EntityWithToplinesFragment;
  export type AppliedToplines = EntityWithToplinesFragment['appliedToplines'];
  export type Item1 = EntityWithToplinesFragment['appliedToplines']['item1'];
  export type Item2 = EntityWithToplinesFragment['appliedToplines']['item2'];
  export type Item3 = EntityWithToplinesFragment['appliedToplines']['item3'];
  export type Item4 = EntityWithToplinesFragment['appliedToplines']['item4'];
  export type Item5 = EntityWithToplinesFragment['appliedToplines']['item5'];
}

export namespace EntityWithContactIcons {
  export type Fragment = EntityWithContactIconsFragment;
}

export namespace EntityCore {
  export type Fragment = EntityCoreFragment;
}

export namespace EntityCustomIdDetails {
  export type Fragment = EntityCustomIdDetailsFragment;
  export type CustomIdType = EntityCustomIdDetailsFragment['customIdType'];
}

export namespace CustomIdTypeDetails {
  export type Fragment = CustomIdTypeDetailsFragment;
}

export namespace EntityWithLinkedUserId {
  export type Fragment = EntityWithLinkedUserIdFragment;
}

export namespace EntityPublicInfo {
  export type Fragment = EntityPublicInfoFragment;
  export type BestAddress = EntityPublicInfoFragment['bestAddress'];
  export type BestPhoneNumber = EntityPublicInfoFragment['bestPhoneNumber'];
  export type BestEmail = EntityPublicInfoFragment['bestEmail'];
}

export namespace EntityPublicWithCampaigns {
  export type Fragment = EntityPublicWithCampaignsFragment;
  export type Campaigns = EntityPublicWithCampaignsFragment['campaigns'][number];
}

export namespace EntityWithAddresses {
  export type Fragment = EntityWithAddressesFragment;
  export type Addresses = EntityWithAddressesFragment['addresses'][number];
}

export namespace EntityWithAssessments {
  export type Fragment = EntityWithAssessmentsFragment;
  export type Assessments = EntityWithAssessmentsFragment['assessments'][number];
  export type CreatedBy = EntityWithAssessmentsFragment['assessments'][number]['createdBy'];
}

export namespace EntityWithBasicInfo {
  export type Fragment = EntityWithBasicInfoFragment;
  export type EntityLanguages = EntityWithBasicInfoFragment['entityLanguages'][number];
}

export namespace EntityWithBestAddress {
  export type Fragment = EntityWithBestAddressFragment;
  export type BestAddress = EntityWithBestAddressFragment['bestAddress'];
}

export namespace EntityWithBestEmail {
  export type Fragment = EntityWithBestEmailFragment;
  export type BestEmail = EntityWithBestEmailFragment['bestEmail'];
}

export namespace EntityWithBestPhone {
  export type Fragment = EntityWithBestPhoneFragment;
  export type BestPhoneNumber = EntityWithBestPhoneFragment['bestPhoneNumber'];
}

export namespace EntityWithCalendarEventCounts {
  export type Fragment = EntityWithCalendarEventCountsFragment;
  export type CalendarEventResponseCounts = EntityWithCalendarEventCountsFragment['calendarEventResponseCounts'];
  export type Past = EntityWithCalendarEventCountsFragment['calendarEventResponseCounts']['past'];
  export type Upcoming = EntityWithCalendarEventCountsFragment['calendarEventResponseCounts']['upcoming'];
}

export namespace EntityWithCalendarResponses {
  export type Fragment = EntityWithCalendarResponsesFragment;
  export type CalendarEventResponses = EntityWithCalendarResponsesFragment['calendarEventResponses'][number];
}

export namespace EntityWithCampaigns {
  export type Fragment = EntityWithCampaignsFragment;
  export type Campaigns = EntityWithCampaignsFragment['campaigns'][number];
}

export namespace EntityWithConnectionCounts {
  export type Fragment = EntityWithConnectionCountsFragment;
  export type EntityConnectionCount = EntityWithConnectionCountsFragment['entityConnectionCount'][number];
}

export namespace EntityWithEmails {
  export type Fragment = EntityWithEmailsFragment;
  export type Emails = EntityWithEmailsFragment['emails'][number];
}

export namespace EntityWithEntityType {
  export type Fragment = EntityWithEntityTypeFragment;
  export type EntityType = EntityWithEntityTypeFragment['entityType'];
}

export namespace EntityWithFollowUpDetails {
  export type Fragment = EntityWithFollowUpDetailsFragment;
  export type ActiveFollowUp = EntityWithFollowUpDetailsFragment['activeFollowUp'];
}

export namespace EntityWithHighlightedTopline {
  export type Fragment = EntityWithHighlightedToplineFragment;
  export type AppliedToplines = EntityWithHighlightedToplineFragment['appliedToplines'];
}

export namespace EntityWithIds {
  export type Fragment = EntityWithIdsFragment;
  export type EntityCustomIds = EntityWithIdsFragment['entityCustomIds'][number];
}

export namespace EntityWithMapViewDetails {
  export type Fragment = EntityWithMapViewDetailsFragment;
  export type EntityType = EntityWithMapViewDetailsFragment['entityType'];
}

export namespace EntityWithNotes {
  export type Fragment = EntityWithNotesFragment;
  export type Notes = EntityWithNotesFragment['notes'][number];
}

export namespace EntityWithPhones {
  export type Fragment = EntityWithPhonesFragment;
  export type PhoneNumbers = EntityWithPhonesFragment['phoneNumbers'][number];
}

export namespace EntityWithSocialProfiles {
  export type Fragment = EntityWithSocialProfilesFragment;
  export type SocialProfiles = EntityWithSocialProfilesFragment['socialProfiles'][number];
}

export namespace EntityWithTags {
  export type Fragment = EntityWithTagsFragment;
  export type Tags = EntityWithTagsFragment['tags'][number];
}

export namespace FollowUpDetails {
  export type Fragment = FollowUpDetailsFragment;
  export type AssignedUser = FollowUpDetailsFragment['assignedUser'];
  export type CreatedBy = FollowUpDetailsFragment['createdBy'];
  export type CompletedBy = FollowUpDetailsFragment['completedBy'];
  export type Note = FollowUpDetailsFragment['note'];
}

export namespace SocialNetworkDetails {
  export type Fragment = SocialNetworkDetailsFragment;
}

export namespace SocialProfileDetails {
  export type Fragment = SocialProfileDetailsFragment;
  export type SocialNetwork = SocialProfileDetailsFragment['socialNetwork'];
  export type CreatedBy = SocialProfileDetailsFragment['createdBy'];
  export type UpdatedBy = SocialProfileDetailsFragment['updatedBy'];
}

export namespace CalendarEventBase {
  export type Fragment = CalendarEventBaseFragment;
  export type CreatedBy = CalendarEventBaseFragment['createdBy'];
  export type EntityType = CalendarEventBaseFragment['entityType'];
  export type Address = CalendarEventBaseFragment['address'];
}

export namespace CalendarEventWithUsersAndCounts {
  export type Fragment = CalendarEventWithUsersAndCountsFragment;
  export type AssignedUsers = CalendarEventWithUsersAndCountsFragment['assignedUsers'];
  export type Nodes = CalendarEventWithUsersAndCountsFragment['assignedUsers']['nodes'][number];
  export type ResponseCounts = CalendarEventWithUsersAndCountsFragment['responseCounts'];
}

export namespace CalendarEventActionCore {
  export type Fragment = CalendarEventActionCoreFragment;
  export type CalendarEvent = CalendarEventActionCoreFragment['calendarEvent'];
}

export namespace CalendarEventDetails {
  export type Fragment = CalendarEventDetailsFragment;
  export type CalendarEventActions = CalendarEventDetailsFragment['calendarEventActions'][number];
}

export namespace CalendarEventResponseCore {
  export type Fragment = CalendarEventResponseCoreFragment;
  export type AppliedTags = CalendarEventResponseCoreFragment['appliedTags'][number];
  export type CalendarEvent = CalendarEventResponseCoreFragment['calendarEvent'];
  export type Campaign = CalendarEventResponseCoreFragment['campaign'];
  export type CreatedBy = CalendarEventResponseCoreFragment['createdBy'];
  export type UpdatedBy = CalendarEventResponseCoreFragment['updatedBy'];
}

export namespace CalendarEventActionDetails {
  export type Fragment = CalendarEventActionDetailsFragment;
  export type Action = CalendarEventActionDetailsFragment['action'];
}

export namespace EventWithEntityResponse {
  export type Fragment = EventWithEntityResponseFragment;
  export type EntityResponse = EventWithEntityResponseFragment['entityResponse'];
}

export namespace NoteDetails {
  export type Fragment = NoteDetailsFragment;
  export type CreatedBy = NoteDetailsFragment['createdBy'];
  export type UpdatedBy = NoteDetailsFragment['updatedBy'];
}

export namespace OrganizationDetails {
  export type Fragment = OrganizationDetailsFragment;
  export type AdministratorUser = OrganizationDetailsFragment['administratorUser'];
}

export namespace PhoneDetails {
  export type Fragment = PhoneDetailsFragment;
}

export namespace RestrictedExportingSettingTypeDetails {
  export type Fragment = RestrictedExportingSettingTypeDetailsFragment;
}

export namespace SavedQueryDetails {
  export type Fragment = SavedQueryDetailsFragment;
  export type User = SavedQueryDetailsFragment['user'];
}

export namespace ShiftInfo {
  export type Fragment = ShiftInfoFragment;
  export type ShiftTimes = ShiftInfoFragment['shiftTimes'][number];
}

export namespace TagCategoryInfo {
  export type Fragment = TagCategoryInfoFragment;
}

export namespace TagCategoryOnly {
  export type Fragment = TagCategoryOnlyFragment;
}

export namespace TagCategoryTagInfo {
  export type Fragment = TagCategoryTagInfoFragment;
}

export namespace TagGroupInfo {
  export type Fragment = TagGroupInfoFragment;
  export type TargetType = TagGroupInfoFragment['targetType'];
  export type EntityTypeInlineFragment = (DiscriminateUnion<TagGroupInfoFragment['targetType'], { __typename?: 'EntityType' }>);
  export type EntityConnectionTypeInlineFragment = (DiscriminateUnion<TagGroupInfoFragment['targetType'], { __typename?: 'EntityConnectionType' }>);
  export type EntityType1 = (DiscriminateUnion<TagGroupInfoFragment['targetType'], { __typename?: 'EntityConnectionType' }>)['entityType1'];
  export type EntityType2 = (DiscriminateUnion<TagGroupInfoFragment['targetType'], { __typename?: 'EntityConnectionType' }>)['entityType2'];
  export type Categories = TagGroupInfoFragment['categories'][number];
}

export namespace TagInfoForQueryBuilder {
  export type Fragment = TagInfoForQueryBuilderFragment;
  export type TargetType = TagInfoForQueryBuilderFragment['targetType'];
  export type EntityTypeInlineFragment = (DiscriminateUnion<TagInfoForQueryBuilderFragment['targetType'], { __typename?: 'EntityType' }>);
  export type EntityConnectionTypeInlineFragment = (DiscriminateUnion<TagInfoForQueryBuilderFragment['targetType'], { __typename?: 'EntityConnectionType' }>);
  export type EntityType1 = (DiscriminateUnion<TagInfoForQueryBuilderFragment['targetType'], { __typename?: 'EntityConnectionType' }>)['entityType1'];
  export type EntityType2 = (DiscriminateUnion<TagInfoForQueryBuilderFragment['targetType'], { __typename?: 'EntityConnectionType' }>)['entityType2'];
  export type Category = TagInfoForQueryBuilderFragment['category'];
  export type Group = TagInfoForQueryBuilderFragment['category']['group'];
}

export namespace TagInfoNoTargetType {
  export type Fragment = TagInfoNoTargetTypeFragment;
  export type AddressTagInlineFragment = (DiscriminateUnion<TagInfoNoTargetTypeFragment, { __typename?: 'AddressTag' }>);
  export type Address = (DiscriminateUnion<TagInfoNoTargetTypeFragment, { __typename?: 'AddressTag' }>)['address'];
  export type Category = TagInfoNoTargetTypeFragment['category'];
}

export namespace TagInfo {
  export type Fragment = TagInfoFragment;
  export type TargetType = TagInfoFragment['targetType'];
  export type EntityTypeInlineFragment = (DiscriminateUnion<TagInfoFragment['targetType'], { __typename?: 'EntityType' }>);
  export type EntityConnectionTypeInlineFragment = (DiscriminateUnion<TagInfoFragment['targetType'], { __typename?: 'EntityConnectionType' }>);
  export type EntityType1 = (DiscriminateUnion<TagInfoFragment['targetType'], { __typename?: 'EntityConnectionType' }>)['entityType1'];
  export type EntityType2 = (DiscriminateUnion<TagInfoFragment['targetType'], { __typename?: 'EntityConnectionType' }>)['entityType2'];
}

export namespace TagWithIsInCampaign {
  export type Fragment = TagWithIsInCampaignFragment;
  export type Category = TagWithIsInCampaignFragment['category'];
  export type Group = TagWithIsInCampaignFragment['category']['group'];
}

export namespace TaggableLogbookDetails {
  export type Fragment = TaggableLogbookDetailsFragment;
  export type Campaign = TaggableLogbookDetailsFragment['campaign'];
  export type Attachments = TaggableLogbookDetailsFragment['attachments'][number];
  export type Notes = TaggableLogbookDetailsFragment['notes'][number];
  export type Shift = TaggableLogbookDetailsFragment['shift'];
  export type Tag = TaggableLogbookDetailsFragment['tag'];
}

export namespace ToplineSettingItemDetails {
  export type Fragment = ToplineSettingItemDetailsFragment;
  export type TagCategory = ToplineSettingItemDetailsFragment['tagCategory'];
  export type EntityConnectionType = ToplineSettingItemDetailsFragment['entityConnectionType'];
  export type EntityType1 = ToplineSettingItemDetailsFragment['entityConnectionType']['entityType1'];
  export type EntityType2 = ToplineSettingItemDetailsFragment['entityConnectionType']['entityType2'];
}

export namespace ToplineSettingItemBasic {
  export type Fragment = ToplineSettingItemBasicFragment;
}

export namespace AppliedToplinesFragment {
  export type Fragment = AppliedToplinesFragmentFragment;
  export type Item1 = AppliedToplinesFragmentFragment['item1'];
  export type Item2 = AppliedToplinesFragmentFragment['item2'];
  export type Item3 = AppliedToplinesFragmentFragment['item3'];
  export type Item4 = AppliedToplinesFragmentFragment['item4'];
  export type Item5 = AppliedToplinesFragmentFragment['item5'];
}

export namespace AppliedToplineItemFragment {
  export type Fragment = AppliedToplineItemFragmentFragment;
  export type ToplineItem = AppliedToplineItemFragmentFragment['toplineItem'];
  export type AppliedToplineValue = AppliedToplineItemFragmentFragment['appliedToplineValue'];
}

export namespace AppliedToplineItemWithConnectionToplines {
  export type Fragment = AppliedToplineItemWithConnectionToplinesFragment;
  export type ToplineItem = AppliedToplineItemWithConnectionToplinesFragment['toplineItem'];
  export type AppliedToplineValue = AppliedToplineItemWithConnectionToplinesFragment['appliedToplineValue'];
}

export namespace AppliedToplineValueWithConnectionHighlightedTopline {
  export type Fragment = AppliedToplineValueWithConnectionHighlightedToplineFragment;
  export type ToplineAppliedEntityConnectionsInlineFragment = (DiscriminateUnion<AppliedToplineValueWithConnectionHighlightedToplineFragment, { __typename?: 'ToplineAppliedEntityConnections' }>);
  export type EntityConnections = (DiscriminateUnion<AppliedToplineValueWithConnectionHighlightedToplineFragment, { __typename?: 'ToplineAppliedEntityConnections' }>)['entityConnections'][number];
}

export namespace AppliedToplineValueWithConnectionToplines {
  export type Fragment = AppliedToplineValueWithConnectionToplinesFragment;
  export type ToplineAppliedEntityConnectionsInlineFragment = (DiscriminateUnion<AppliedToplineValueWithConnectionToplinesFragment, { __typename?: 'ToplineAppliedEntityConnections' }>);
  export type EntityConnections = (DiscriminateUnion<AppliedToplineValueWithConnectionToplinesFragment, { __typename?: 'ToplineAppliedEntityConnections' }>)['entityConnections'][number];
}

export namespace AppliedToplineItemValueFragment {
  export type Fragment = AppliedToplineItemValueFragmentFragment;
  export type ToplinePreferredLanguageInlineFragment = (DiscriminateUnion<AppliedToplineItemValueFragmentFragment, { __typename?: 'ToplinePreferredLanguage' }>);
  export type EntityLanguages = (DiscriminateUnion<AppliedToplineItemValueFragmentFragment, { __typename?: 'ToplinePreferredLanguage' }>)['entityLanguages'][number];
  export type ToplineAgeInlineFragment = (DiscriminateUnion<AppliedToplineItemValueFragmentFragment, { __typename?: 'ToplineAge' }>);
  export type EmailInlineFragment = (DiscriminateUnion<AppliedToplineItemValueFragmentFragment, { __typename?: 'Email' }>);
  export type AddressInlineFragment = (DiscriminateUnion<AppliedToplineItemValueFragmentFragment, { __typename?: 'Address' }>);
  export type PhoneNumberInlineFragment = (DiscriminateUnion<AppliedToplineItemValueFragmentFragment, { __typename?: 'PhoneNumber' }>);
  export type NoteInlineFragment = (DiscriminateUnion<AppliedToplineItemValueFragmentFragment, { __typename?: 'Note' }>);
  export type SocialProfileInlineFragment = (DiscriminateUnion<AppliedToplineItemValueFragmentFragment, { __typename?: 'SocialProfile' }>);
  export type ToplineAppliedTagsInlineFragment = (DiscriminateUnion<AppliedToplineItemValueFragmentFragment, { __typename?: 'ToplineAppliedTags' }>);
  export type AppliedTags = (DiscriminateUnion<AppliedToplineItemValueFragmentFragment, { __typename?: 'ToplineAppliedTags' }>)['appliedTags'][number];
  export type ToplineAppliedEntityConnectionsInlineFragment = (DiscriminateUnion<AppliedToplineItemValueFragmentFragment, { __typename?: 'ToplineAppliedEntityConnections' }>);
  export type EntityConnections = (DiscriminateUnion<AppliedToplineItemValueFragmentFragment, { __typename?: 'ToplineAppliedEntityConnections' }>)['entityConnections'][number];
}

export namespace HighlightedToplineForEntity {
  export type Fragment = HighlightedToplineForEntityFragment;
  export type Item0 = HighlightedToplineForEntityFragment['item0'];
  export type AppliedToplineValue = HighlightedToplineForEntityFragment['item0']['appliedToplineValue'];
}

export namespace HighlightedToplineForConnection {
  export type Fragment = HighlightedToplineForConnectionFragment;
  export type Item0 = HighlightedToplineForConnectionFragment['item0'];
}

export namespace UserDetails {
  export type Fragment = UserDetailsFragment;
  export type MfaFactor = UserDetailsFragment['mfaFactor'];
  export type Campaigns = UserDetailsFragment['campaigns'][number];
}

export namespace UserPublicDetails {
  export type Fragment = UserPublicDetailsFragment;
}

export namespace UserWithTurfAssignments {
  export type Fragment = UserWithTurfAssignmentsFragment;
  export type TurfAssignments = UserWithTurfAssignmentsFragment['turfAssignments'][number];
  export type Campaign = UserWithTurfAssignmentsFragment['turfAssignments'][number]['campaign'];
  export type TurfTags = UserWithTurfAssignmentsFragment['turfAssignments'][number]['turfTags'][number];
  export type Tag = UserWithTurfAssignmentsFragment['turfAssignments'][number]['turfTags'][number]['tag'];
}

export namespace GetAssessmentInfoQuery {
  export type Variables = GetAssessmentInfoQueryQueryVariables;
  export type Query = GetAssessmentInfoQueryQuery;
  export type GetAssessmentInfo = GetAssessmentInfoQueryQuery['getAssessmentInfo'];
}

export namespace GetCampaignParticipants {
  export type Variables = GetCampaignParticipantsQueryVariables;
  export type Query = GetCampaignParticipantsQuery;
  export type GetCampaign = GetCampaignParticipantsQuery['getCampaign'];
  export type Participants = GetCampaignParticipantsQuery['getCampaign']['participants'];
  export type Edges = GetCampaignParticipantsQuery['getCampaign']['participants']['edges'][number];
  export type Node = GetCampaignParticipantsQuery['getCampaign']['participants']['edges'][number]['node'];
}

export namespace SetAssessmentInfo {
  export type Variables = SetAssessmentInfoMutationVariables;
  export type Mutation = SetAssessmentInfoMutation;
  export type SetAssessmentInfo = SetAssessmentInfoMutation['setAssessmentInfo'];
  export type AssessmentInfo = SetAssessmentInfoMutation['setAssessmentInfo']['assessmentInfo'];
}

export namespace SetAssessmentOverrides {
  export type Variables = SetAssessmentOverridesMutationVariables;
  export type Mutation = SetAssessmentOverridesMutation;
  export type SetAssessmentOverrides = SetAssessmentOverridesMutation['setAssessmentOverrides'];
  export type AssessmentInfo = SetAssessmentOverridesMutation['setAssessmentOverrides']['assessmentInfo'];
}

export namespace CreateCampaignCopy {
  export type Variables = CreateCampaignCopyMutationVariables;
  export type Mutation = CreateCampaignCopyMutation;
  export type CreateCampaignCopy = CreateCampaignCopyMutation['createCampaignCopy'];
  export type Campaign = CreateCampaignCopyMutation['createCampaignCopy']['campaign'];
}

export namespace CreateCampaign {
  export type Variables = CreateCampaignMutationVariables;
  export type Mutation = CreateCampaignMutation;
  export type CreateCampaign = CreateCampaignMutation['createCampaign'];
  export type Campaign = CreateCampaignMutation['createCampaign']['campaign'];
}

export namespace UpdateCampaignConnectionTypeConfig {
  export type Variables = UpdateCampaignConnectionTypeConfigMutationVariables;
  export type Mutation = UpdateCampaignConnectionTypeConfigMutation;
  export type UpdateCampaignEntityConnectionTypeConfiguration = UpdateCampaignConnectionTypeConfigMutation['updateCampaignEntityConnectionTypeConfiguration'];
  export type CampaignEntityConnectionTypeConfiguration = UpdateCampaignConnectionTypeConfigMutation['updateCampaignEntityConnectionTypeConfiguration']['campaignEntityConnectionTypeConfiguration'];
}

export namespace UpdateCampaignEntityTypeConfig {
  export type Variables = UpdateCampaignEntityTypeConfigMutationVariables;
  export type Mutation = UpdateCampaignEntityTypeConfigMutation;
  export type UpdateCampaignEntityTypeConfiguration = UpdateCampaignEntityTypeConfigMutation['updateCampaignEntityTypeConfiguration'];
  export type CampaignEntityTypeConfiguration = UpdateCampaignEntityTypeConfigMutation['updateCampaignEntityTypeConfiguration']['campaignEntityTypeConfiguration'];
}

export namespace UpdateCampaignExportRestrictions {
  export type Variables = UpdateCampaignExportRestrictionsMutationVariables;
  export type Mutation = UpdateCampaignExportRestrictionsMutation;
  export type UpdateCampaignExportRestrictions = UpdateCampaignExportRestrictionsMutation['updateCampaignExportRestrictions'];
  export type Campaign = UpdateCampaignExportRestrictionsMutation['updateCampaignExportRestrictions']['campaign'];
}

export namespace UpdateCampaignDetails {
  export type Variables = UpdateCampaignDetailsMutationVariables;
  export type Mutation = UpdateCampaignDetailsMutation;
  export type UpdateCampaign = UpdateCampaignDetailsMutation['updateCampaign'];
  export type Campaign = UpdateCampaignDetailsMutation['updateCampaign']['campaign'];
}

export namespace CreateEntityConnectionType {
  export type Variables = CreateEntityConnectionTypeMutationVariables;
  export type Mutation = CreateEntityConnectionTypeMutation;
  export type CreateEntityConnectionType = CreateEntityConnectionTypeMutation['createEntityConnectionType'];
  export type EntityConnectionType = CreateEntityConnectionTypeMutation['createEntityConnectionType']['entityConnectionType'];
}

export namespace UpdateEntityConnectionType {
  export type Variables = UpdateEntityConnectionTypeMutationVariables;
  export type Mutation = UpdateEntityConnectionTypeMutation;
  export type UpdateEntityConnectionType = UpdateEntityConnectionTypeMutation['updateEntityConnectionType'];
  export type EntityConnectionType = UpdateEntityConnectionTypeMutation['updateEntityConnectionType']['entityConnectionType'];
}

export namespace CreateContactAttempt {
  export type Variables = CreateContactAttemptMutationVariables;
  export type Mutation = CreateContactAttemptMutation;
  export type CreateContactAttempt = CreateContactAttemptMutation['createContactAttempt'];
  export type ContactAttempt = CreateContactAttemptMutation['createContactAttempt']['contactAttempt'];
  export type CreatedBy = CreateContactAttemptMutation['createContactAttempt']['contactAttempt']['createdBy'];
}

export namespace CreateCustomId {
  export type Variables = CreateCustomIdMutationVariables;
  export type Mutation = CreateCustomIdMutation;
  export type CreateCustomId = CreateCustomIdMutation['createCustomId'];
  export type CustomIdType = CreateCustomIdMutation['createCustomId']['customIdType'];
}

export namespace CreateCustomForm {
  export type Variables = CreateCustomFormMutationVariables;
  export type Mutation = CreateCustomFormMutation;
  export type CreateCustomForm = CreateCustomFormMutation['createCustomForm'];
  export type CustomForm = CreateCustomFormMutation['createCustomForm']['customForm'];
}

export namespace UpdateCustomFormFields {
  export type Variables = UpdateCustomFormFieldsMutationVariables;
  export type Mutation = UpdateCustomFormFieldsMutation;
  export type UpdateCustomFormFields = UpdateCustomFormFieldsMutation['updateCustomFormFields'];
  export type CustomForm = UpdateCustomFormFieldsMutation['updateCustomFormFields']['customForm'];
}

export namespace DeleteAttachment {
  export type Variables = DeleteAttachmentMutationVariables;
  export type Mutation = DeleteAttachmentMutation;
  export type DeleteAttachment = DeleteAttachmentMutation['deleteAttachment'];
}

export namespace ApplyEntityConnectionTag {
  export type Variables = ApplyEntityConnectionTagMutationVariables;
  export type Mutation = ApplyEntityConnectionTagMutation;
  export type ApplyTagToEntityConnection = ApplyEntityConnectionTagMutation['applyTagToEntityConnection'];
  export type EntityConnection = ApplyEntityConnectionTagMutation['applyTagToEntityConnection']['entityConnection'];
}

export namespace CreateEntityConnection {
  export type Variables = CreateEntityConnectionMutationVariables;
  export type Mutation = CreateEntityConnectionMutation;
  export type CreateEntityConnection = CreateEntityConnectionMutation['createEntityConnection'];
  export type EntityConnection = CreateEntityConnectionMutation['createEntityConnection']['entityConnection'];
}

export namespace DeleteEntityConnection {
  export type Variables = DeleteEntityConnectionMutationVariables;
  export type Mutation = DeleteEntityConnectionMutation;
  export type DeleteEntityConnection = DeleteEntityConnectionMutation['deleteEntityConnection'];
  export type EntityConnection = DeleteEntityConnectionMutation['deleteEntityConnection']['entityConnection'];
}

export namespace UnapplyEntityConnectionTag {
  export type Variables = UnapplyEntityConnectionTagMutationVariables;
  export type Mutation = UnapplyEntityConnectionTagMutation;
  export type UnapplyEntityConnectionTag = UnapplyEntityConnectionTagMutation['unapplyEntityConnectionTag'];
  export type EntityConnection = UnapplyEntityConnectionTagMutation['unapplyEntityConnectionTag']['entityConnection'];
}

export namespace UpdateEntityConnection {
  export type Variables = UpdateEntityConnectionMutationVariables;
  export type Mutation = UpdateEntityConnectionMutation;
  export type UpdateEntityConnection = UpdateEntityConnectionMutation['updateEntityConnection'];
  export type EntityConnection = UpdateEntityConnectionMutation['updateEntityConnection']['entityConnection'];
}

export namespace CreateEntityType {
  export type Variables = CreateEntityTypeMutationVariables;
  export type Mutation = CreateEntityTypeMutation;
  export type CreateEntityType = CreateEntityTypeMutation['createEntityType'];
  export type EntityType = CreateEntityTypeMutation['createEntityType']['entityType'];
}

export namespace UpdateEntityType {
  export type Variables = UpdateEntityTypeMutationVariables;
  export type Mutation = UpdateEntityTypeMutation;
  export type UpdateEntityType = UpdateEntityTypeMutation['updateEntityType'];
  export type EntityType = UpdateEntityTypeMutation['updateEntityType']['entityType'];
}

export namespace AddEntityToCampaign {
  export type Variables = AddEntityToCampaignMutationVariables;
  export type Mutation = AddEntityToCampaignMutation;
  export type AddEntityToCampaign = AddEntityToCampaignMutation['addEntityToCampaign'];
  export type Entity = AddEntityToCampaignMutation['addEntityToCampaign']['entity'];
}

export namespace AddSocialProfile {
  export type Variables = AddSocialProfileMutationVariables;
  export type Mutation = AddSocialProfileMutation;
  export type AddSocialProfile = AddSocialProfileMutation['addSocialProfile'];
  export type Entity = AddSocialProfileMutation['addSocialProfile']['entity'];
}

export namespace ApplyEntityTag {
  export type Variables = ApplyEntityTagMutationVariables;
  export type Mutation = ApplyEntityTagMutation;
  export type ApplyTagToEntity = ApplyEntityTagMutation['applyTagToEntity'];
  export type Entity = ApplyEntityTagMutation['applyTagToEntity']['entity'];
}

export namespace AssignFollowUp {
  export type Variables = AssignFollowUpMutationVariables;
  export type Mutation = AssignFollowUpMutation;
  export type AssignFollowUp = AssignFollowUpMutation['assignFollowUp'];
  export type FollowUp = AssignFollowUpMutation['assignFollowUp']['followUp'];
}

export namespace CompleteActiveFollowUps {
  export type Variables = CompleteActiveFollowUpsMutationVariables;
  export type Mutation = CompleteActiveFollowUpsMutation;
  export type CompleteActiveFollowUps = CompleteActiveFollowUpsMutation['completeActiveFollowUps'];
  export type Entity = CompleteActiveFollowUpsMutation['completeActiveFollowUps']['entity'];
}

export namespace CreateAddress {
  export type Variables = CreateAddressMutationVariables;
  export type Mutation = CreateAddressMutation;
  export type CreateAddresses = CreateAddressMutation['createAddresses'];
  export type Entity = CreateAddressMutation['createAddresses']['entity'];
}

export namespace CreateAssessment {
  export type Variables = CreateAssessmentMutationVariables;
  export type Mutation = CreateAssessmentMutation;
  export type CreateAssessments = CreateAssessmentMutation['createAssessments'];
  export type Entity = CreateAssessmentMutation['createAssessments']['entity'];
}

export namespace CreateEmail {
  export type Variables = CreateEmailMutationVariables;
  export type Mutation = CreateEmailMutation;
  export type CreateEmails = CreateEmailMutation['createEmails'];
  export type Entity = CreateEmailMutation['createEmails']['entity'];
  export type Emails = CreateEmailMutation['createEmails']['entity']['emails'][number];
}

export namespace CreateEntity {
  export type Variables = CreateEntityMutationVariables;
  export type Mutation = CreateEntityMutation;
  export type CreateEntity = CreateEntityMutation['createEntity'];
  export type Entity = CreateEntityMutation['createEntity']['entity'];
}

export namespace CreateFollowUp {
  export type Variables = CreateFollowUpMutationVariables;
  export type Mutation = CreateFollowUpMutation;
  export type CreateFollowUp = CreateFollowUpMutation['createFollowUp'];
  export type Entity = CreateFollowUpMutation['createFollowUp']['entity'];
}

export namespace CreatePhone {
  export type Variables = CreatePhoneMutationVariables;
  export type Mutation = CreatePhoneMutation;
  export type CreatePhoneNumbers = CreatePhoneMutation['createPhoneNumbers'];
  export type Entity = CreatePhoneMutation['createPhoneNumbers']['entity'];
}

export namespace ExportEntities {
  export type Variables = ExportEntitiesMutationVariables;
  export type Mutation = ExportEntitiesMutation;
  export type EntitiesReport = ExportEntitiesMutation['entitiesReport'];
}

export namespace RemoveEntityCustomId {
  export type Variables = RemoveEntityCustomIdMutationVariables;
  export type Mutation = RemoveEntityCustomIdMutation;
  export type RemoveEntityCustomId = RemoveEntityCustomIdMutation['removeEntityCustomId'];
}

export namespace RemoveEntityFromCampaign {
  export type Variables = RemoveEntityFromCampaignMutationVariables;
  export type Mutation = RemoveEntityFromCampaignMutation;
  export type RemoveEntityFromCampaign = RemoveEntityFromCampaignMutation['removeEntityFromCampaign'];
  export type Entity = RemoveEntityFromCampaignMutation['removeEntityFromCampaign']['entity'];
  export type Campaigns = RemoveEntityFromCampaignMutation['removeEntityFromCampaign']['entity']['campaigns'][number];
}

export namespace RemoveSocialProfile {
  export type Variables = RemoveSocialProfileMutationVariables;
  export type Mutation = RemoveSocialProfileMutation;
  export type RemoveSocialProfile = RemoveSocialProfileMutation['removeSocialProfile'];
  export type Entity = RemoveSocialProfileMutation['removeSocialProfile']['entity'];
}

export namespace UnapplyEntityTag {
  export type Variables = UnapplyEntityTagMutationVariables;
  export type Mutation = UnapplyEntityTagMutation;
  export type UnapplyTag = UnapplyEntityTagMutation['unapplyTag'];
  export type Entity = UnapplyEntityTagMutation['unapplyTag']['entity'];
}

export namespace UpdateAddress {
  export type Variables = UpdateAddressMutationVariables;
  export type Mutation = UpdateAddressMutation;
  export type UpdateAddress = UpdateAddressMutation['updateAddress'];
  export type Entity = UpdateAddressMutation['updateAddress']['entity'];
}

export namespace UpdateEntityCustomId {
  export type Variables = UpdateEntityCustomIdMutationVariables;
  export type Mutation = UpdateEntityCustomIdMutation;
  export type UpdateEntityCustomId = UpdateEntityCustomIdMutation['updateEntityCustomId'];
  export type EntityCustomId = UpdateEntityCustomIdMutation['updateEntityCustomId']['entityCustomId'];
}

export namespace UpdateEmail {
  export type Variables = UpdateEmailMutationVariables;
  export type Mutation = UpdateEmailMutation;
  export type UpdateEmail = UpdateEmailMutation['updateEmail'];
  export type Entity = UpdateEmailMutation['updateEmail']['entity'];
}

export namespace UpdateEntityBasicInfo {
  export type Variables = UpdateEntityBasicInfoMutationVariables;
  export type Mutation = UpdateEntityBasicInfoMutation;
  export type UpdateEntity = UpdateEntityBasicInfoMutation['updateEntity'];
  export type Entity = UpdateEntityBasicInfoMutation['updateEntity']['entity'];
}

export namespace UpdateFollowUp {
  export type Variables = UpdateFollowUpMutationVariables;
  export type Mutation = UpdateFollowUpMutation;
  export type UpdateFollowUp = UpdateFollowUpMutation['updateFollowUp'];
  export type FollowUp = UpdateFollowUpMutation['updateFollowUp']['followUp'];
}

export namespace UpdatePhone {
  export type Variables = UpdatePhoneMutationVariables;
  export type Mutation = UpdatePhoneMutation;
  export type UpdatePhoneNumber = UpdatePhoneMutation['updatePhoneNumber'];
  export type Entity = UpdatePhoneMutation['updatePhoneNumber']['entity'];
}

export namespace UpdateSocialProfile {
  export type Variables = UpdateSocialProfileMutationVariables;
  export type Mutation = UpdateSocialProfileMutation;
  export type UpdateSocialProfile = UpdateSocialProfileMutation['updateSocialProfile'];
  export type Entity = UpdateSocialProfileMutation['updateSocialProfile']['entity'];
}

export namespace AddCalendarEventUsers {
  export type Variables = AddCalendarEventUsersMutationVariables;
  export type Mutation = AddCalendarEventUsersMutation;
  export type AddCalendarEventUsers = AddCalendarEventUsersMutation['addCalendarEventUsers'];
  export type CalendarEvent = AddCalendarEventUsersMutation['addCalendarEventUsers']['calendarEvent'];
}

export namespace CreateActionForCalendarEventAction {
  export type Variables = CreateActionForCalendarEventActionMutationVariables;
  export type Mutation = CreateActionForCalendarEventActionMutation;
  export type CreateActionForCalendarEventAction = CreateActionForCalendarEventActionMutation['createActionForCalendarEventAction'];
  export type CalendarEventAction = CreateActionForCalendarEventActionMutation['createActionForCalendarEventAction']['calendarEventAction'];
}

export namespace CreateCalendarEvent {
  export type Variables = CreateCalendarEventMutationVariables;
  export type Mutation = CreateCalendarEventMutation;
  export type CreateCalendarEvent = CreateCalendarEventMutation['createCalendarEvent'];
  export type CalendarEvent = CreateCalendarEventMutation['createCalendarEvent']['calendarEvent'];
}

export namespace CreateCalendarEvents {
  export type Variables = CreateCalendarEventsMutationVariables;
  export type Mutation = CreateCalendarEventsMutation;
  export type CreateCalendarEvents = CreateCalendarEventsMutation['createCalendarEvents'];
  export type CalendarEvents = CreateCalendarEventsMutation['createCalendarEvents']['calendarEvents'][number];
}

export namespace DeleteCalendarEvent {
  export type Variables = DeleteCalendarEventMutationVariables;
  export type Mutation = DeleteCalendarEventMutation;
  export type DeleteCalendarEvent = DeleteCalendarEventMutation['deleteCalendarEvent'];
  export type CalendarEvent = DeleteCalendarEventMutation['deleteCalendarEvent']['calendarEvent'];
}

export namespace EditEventComposite {
  export type Variables = EditEventCompositeMutationVariables;
  export type Mutation = EditEventCompositeMutation;
  export type RemoveUsers = EditEventCompositeMutation['removeUsers'];
  export type CalendarEvent = EditEventCompositeMutation['removeUsers']['calendarEvent'];
  export type AddUsers = EditEventCompositeMutation['addUsers'];
  export type _CalendarEvent = EditEventCompositeMutation['addUsers']['calendarEvent'];
  export type UpdateDetails = EditEventCompositeMutation['updateDetails'];
  export type __CalendarEvent = EditEventCompositeMutation['updateDetails']['calendarEvent'];
  export type LinkAn = EditEventCompositeMutation['linkAN'];
  export type ___CalendarEvent = EditEventCompositeMutation['linkAN']['calendarEvent'];
  export type UnlinkAn = EditEventCompositeMutation['unlinkAN'];
  export type ____CalendarEvent = EditEventCompositeMutation['unlinkAN']['calendarEvent'];
}

export namespace LinkEventToActionNetwork {
  export type Variables = LinkEventToActionNetworkMutationVariables;
  export type Mutation = LinkEventToActionNetworkMutation;
  export type LinkEventToActionNetwork = LinkEventToActionNetworkMutation['linkEventToActionNetwork'];
  export type CalendarEvent = LinkEventToActionNetworkMutation['linkEventToActionNetwork']['calendarEvent'];
}

export namespace RemoveCalendarEventUsers {
  export type Variables = RemoveCalendarEventUsersMutationVariables;
  export type Mutation = RemoveCalendarEventUsersMutation;
  export type RemoveCalendarEventUsers = RemoveCalendarEventUsersMutation['removeCalendarEventUsers'];
  export type CalendarEvent = RemoveCalendarEventUsersMutation['removeCalendarEventUsers']['calendarEvent'];
}

export namespace SetCalendarEventResponse {
  export type Variables = SetCalendarEventResponseMutationVariables;
  export type Mutation = SetCalendarEventResponseMutation;
  export type SetCalendarEventResponse = SetCalendarEventResponseMutation['setCalendarEventResponse'];
  export type CalendarEventResponse = SetCalendarEventResponseMutation['setCalendarEventResponse']['calendarEventResponse'];
}

export namespace UnapplyCalendarEventResponseTag {
  export type Variables = UnapplyCalendarEventResponseTagMutationVariables;
  export type Mutation = UnapplyCalendarEventResponseTagMutation;
  export type UnapplyCalendarEventResponseTag = UnapplyCalendarEventResponseTagMutation['unapplyCalendarEventResponseTag'];
  export type CalendarEventResponse = UnapplyCalendarEventResponseTagMutation['unapplyCalendarEventResponseTag']['calendarEventResponse'];
}

export namespace UnlinkEventFromActionNetwork {
  export type Variables = UnlinkEventFromActionNetworkMutationVariables;
  export type Mutation = UnlinkEventFromActionNetworkMutation;
  export type UnlinkEventFromActionNetwork = UnlinkEventFromActionNetworkMutation['unlinkEventFromActionNetwork'];
  export type CalendarEvent = UnlinkEventFromActionNetworkMutation['unlinkEventFromActionNetwork']['calendarEvent'];
}

export namespace UpdateCalendarEventActionScheduledDays {
  export type Variables = UpdateCalendarEventActionScheduledDaysMutationVariables;
  export type Mutation = UpdateCalendarEventActionScheduledDaysMutation;
  export type UpdateCalendarEventActionScheduledDays = UpdateCalendarEventActionScheduledDaysMutation['updateCalendarEventActionScheduledDays'];
  export type CalendarEventAction = UpdateCalendarEventActionScheduledDaysMutation['updateCalendarEventActionScheduledDays']['calendarEventAction'];
}

export namespace UpdateCalendarEvent {
  export type Variables = UpdateCalendarEventMutationVariables;
  export type Mutation = UpdateCalendarEventMutation;
  export type UpdateCalendarEvent = UpdateCalendarEventMutation['updateCalendarEvent'];
  export type CalendarEvent = UpdateCalendarEventMutation['updateCalendarEvent']['calendarEvent'];
}

export namespace CreateExternalService {
  export type Variables = CreateExternalServiceMutationVariables;
  export type Mutation = CreateExternalServiceMutation;
  export type CreateExternalService = CreateExternalServiceMutation['createExternalService'];
  export type ExternalService = CreateExternalServiceMutation['createExternalService']['externalService'];
}

export namespace UpdateCampaignIntegrations {
  export type Variables = UpdateCampaignIntegrationsMutationVariables;
  export type Mutation = UpdateCampaignIntegrationsMutation;
  export type UpdateIntegrations = UpdateCampaignIntegrationsMutation['updateIntegrations'];
  export type Campaign = UpdateCampaignIntegrationsMutation['updateIntegrations']['campaign'];
  export type Integrations = UpdateCampaignIntegrationsMutation['updateIntegrations']['campaign']['integrations'][number];
}

export namespace UpdateExternalService {
  export type Variables = UpdateExternalServiceMutationVariables;
  export type Mutation = UpdateExternalServiceMutation;
  export type UpdateExternalService = UpdateExternalServiceMutation['updateExternalService'];
  export type ExternalService = UpdateExternalServiceMutation['updateExternalService']['externalService'];
}

export namespace CreateNote {
  export type Variables = CreateNoteMutationVariables;
  export type Mutation = CreateNoteMutation;
  export type CreateNotes = CreateNoteMutation['createNotes'];
  export type Notes = CreateNoteMutation['createNotes']['notes'][number];
}

export namespace PinNote {
  export type Variables = PinNoteMutationVariables;
  export type Mutation = PinNoteMutation;
  export type PinNote = PinNoteMutation['pinNote'];
  export type Note = PinNoteMutation['pinNote']['note'];
}

export namespace RemoveNote {
  export type Variables = RemoveNoteMutationVariables;
  export type Mutation = RemoveNoteMutation;
  export type RemoveNotes = RemoveNoteMutation['removeNotes'];
}

export namespace UnpinNote {
  export type Variables = UnpinNoteMutationVariables;
  export type Mutation = UnpinNoteMutation;
  export type UnpinNote = UnpinNoteMutation['unpinNote'];
  export type Note = UnpinNoteMutation['unpinNote']['note'];
}

export namespace UpdateNote {
  export type Variables = UpdateNoteMutationVariables;
  export type Mutation = UpdateNoteMutation;
  export type UpdateNote = UpdateNoteMutation['updateNote'];
  export type Note = UpdateNoteMutation['updateNote']['note'];
}

export namespace UpdateOrganizationMfaEnforcement {
  export type Variables = UpdateOrganizationMfaEnforcementMutationVariables;
  export type Mutation = UpdateOrganizationMfaEnforcementMutation;
  export type UpdateOrganizationMfaEnforcement = UpdateOrganizationMfaEnforcementMutation['updateOrganizationMfaEnforcement'];
  export type Organization = UpdateOrganizationMfaEnforcementMutation['updateOrganizationMfaEnforcement']['organization'];
}

export namespace UpdateOrganization {
  export type Variables = UpdateOrganizationMutationVariables;
  export type Mutation = UpdateOrganizationMutation;
  export type UpdateOrganization = UpdateOrganizationMutation['updateOrganization'];
  export type Organization = UpdateOrganizationMutation['updateOrganization']['organization'];
}

export namespace ApplyMassOperation {
  export type Variables = ApplyMassOperationMutationVariables;
  export type Mutation = ApplyMassOperationMutation;
  export type ApplyMassOperation = ApplyMassOperationMutation['applyMassOperation'];
}

export namespace RestoreOriginalAddress {
  export type Variables = RestoreOriginalAddressMutationVariables;
  export type Mutation = RestoreOriginalAddressMutation;
  export type RevertAddress = RestoreOriginalAddressMutation['revertAddress'];
  export type Address = RestoreOriginalAddressMutation['revertAddress']['address'];
}

export namespace CreateSavedQuery {
  export type Variables = CreateSavedQueryMutationVariables;
  export type Mutation = CreateSavedQueryMutation;
  export type CreateSavedQuery = CreateSavedQueryMutation['createSavedQuery'];
  export type Query = CreateSavedQueryMutation['createSavedQuery']['query'];
}

export namespace DeleteSavedQuery {
  export type Variables = DeleteSavedQueryMutationVariables;
  export type Mutation = DeleteSavedQueryMutation;
  export type DeleteSavedQuery = DeleteSavedQueryMutation['deleteSavedQuery'];
}

export namespace UpdateSavedQuery {
  export type Variables = UpdateSavedQueryMutationVariables;
  export type Mutation = UpdateSavedQueryMutation;
  export type UpdateSavedQuery = UpdateSavedQueryMutation['updateSavedQuery'];
  export type Query = UpdateSavedQueryMutation['updateSavedQuery']['query'];
}

export namespace AddTagCategoryToCampaign {
  export type Variables = AddTagCategoryToCampaignMutationVariables;
  export type Mutation = AddTagCategoryToCampaignMutation;
  export type AddTagCategoryToCampaign = AddTagCategoryToCampaignMutation['addTagCategoryToCampaign'];
  export type TagCategory = AddTagCategoryToCampaignMutation['addTagCategoryToCampaign']['tagCategory'];
  export type Group = AddTagCategoryToCampaignMutation['addTagCategoryToCampaign']['tagCategory']['group'];
}

export namespace ApplyTag {
  export type Variables = ApplyTagMutationVariables;
  export type Mutation = ApplyTagMutation;
  export type ApplyTag = ApplyTagMutation['applyTag'];
  export type TaggableLogbook = ApplyTagMutation['applyTag']['taggableLogbook'];
}

export namespace ArchiveTagCategory {
  export type Variables = ArchiveTagCategoryMutationVariables;
  export type Mutation = ArchiveTagCategoryMutation;
  export type UpdateTagStatusByCategory = ArchiveTagCategoryMutation['updateTagStatusByCategory'];
  export type TagCategory = ArchiveTagCategoryMutation['updateTagStatusByCategory']['tagCategory'];
}

export namespace AssociateTagToCampaign {
  export type Variables = AssociateTagToCampaignMutationVariables;
  export type Mutation = AssociateTagToCampaignMutation;
  export type AssociateTagToCampaign = AssociateTagToCampaignMutation['associateTagToCampaign'];
  export type Tag = AssociateTagToCampaignMutation['associateTagToCampaign']['tag'];
  export type Category = AssociateTagToCampaignMutation['associateTagToCampaign']['tag']['category'];
  export type Group = AssociateTagToCampaignMutation['associateTagToCampaign']['tag']['category']['group'];
}

export namespace ChangeTagCategoryGroup {
  export type Variables = ChangeTagCategoryGroupMutationVariables;
  export type Mutation = ChangeTagCategoryGroupMutation;
  export type ChangeTagCategoryGroup = ChangeTagCategoryGroupMutation['changeTagCategoryGroup'];
  export type TagCategory = ChangeTagCategoryGroupMutation['changeTagCategoryGroup']['tagCategory'];
}

export namespace CreateTagCategory {
  export type Variables = CreateTagCategoryMutationVariables;
  export type Mutation = CreateTagCategoryMutation;
  export type CreateTagCategory = CreateTagCategoryMutation['createTagCategory'];
  export type TagCategory = CreateTagCategoryMutation['createTagCategory']['tagCategory'];
}

export namespace CreateTagGroup {
  export type Variables = CreateTagGroupMutationVariables;
  export type Mutation = CreateTagGroupMutation;
  export type CreateTagGroup = CreateTagGroupMutation['createTagGroup'];
  export type TagGroup = CreateTagGroupMutation['createTagGroup']['tagGroup'];
}

export namespace CreateTag {
  export type Variables = CreateTagMutationVariables;
  export type Mutation = CreateTagMutation;
  export type CreateTag = CreateTagMutation['createTag'];
  export type Tag = CreateTagMutation['createTag']['tag'];
}

export namespace RemoveTagCategoryFromCampaign {
  export type Variables = RemoveTagCategoryFromCampaignMutationVariables;
  export type Mutation = RemoveTagCategoryFromCampaignMutation;
  export type RemoveTagCategoryFromCampaign = RemoveTagCategoryFromCampaignMutation['removeTagCategoryFromCampaign'];
  export type TagCategory = RemoveTagCategoryFromCampaignMutation['removeTagCategoryFromCampaign']['tagCategory'];
  export type Group = RemoveTagCategoryFromCampaignMutation['removeTagCategoryFromCampaign']['tagCategory']['group'];
}

export namespace RenameTagGroup {
  export type Variables = RenameTagGroupMutationVariables;
  export type Mutation = RenameTagGroupMutation;
  export type RenameTagGroup = RenameTagGroupMutation['renameTagGroup'];
  export type TagGroup = RenameTagGroupMutation['renameTagGroup']['tagGroup'];
}

export namespace UnassociateTagFromCampaign {
  export type Variables = UnassociateTagFromCampaignMutationVariables;
  export type Mutation = UnassociateTagFromCampaignMutation;
  export type UnassociateTagFromCampaign = UnassociateTagFromCampaignMutation['unassociateTagFromCampaign'];
  export type Tag = UnassociateTagFromCampaignMutation['unassociateTagFromCampaign']['tag'];
  export type Category = UnassociateTagFromCampaignMutation['unassociateTagFromCampaign']['tag']['category'];
  export type Group = UnassociateTagFromCampaignMutation['unassociateTagFromCampaign']['tag']['category']['group'];
}

export namespace UpdateAddressTag {
  export type Variables = UpdateAddressTagMutationVariables;
  export type Mutation = UpdateAddressTagMutation;
  export type UpdateAddressTag = UpdateAddressTagMutation['updateAddressTag'];
  export type Tag = UpdateAddressTagMutation['updateAddressTag']['tag'];
}

export namespace UpdateShift {
  export type Variables = UpdateShiftMutationVariables;
  export type Mutation = UpdateShiftMutation;
  export type UpdateShift = UpdateShiftMutation['updateShift'];
  export type Shift = UpdateShiftMutation['updateShift']['shift'];
}

export namespace UpdateTagCategory {
  export type Variables = UpdateTagCategoryMutationVariables;
  export type Mutation = UpdateTagCategoryMutation;
  export type UpdateTagCategory = UpdateTagCategoryMutation['updateTagCategory'];
  export type TagCategory = UpdateTagCategoryMutation['updateTagCategory']['tagCategory'];
}

export namespace UpdateTag {
  export type Variables = UpdateTagMutationVariables;
  export type Mutation = UpdateTagMutation;
  export type UpdateTag = UpdateTagMutation['updateTag'];
  export type Tag = UpdateTagMutation['updateTag']['tag'];
}

export namespace UpdateCustomIdType {
  export type Variables = UpdateCustomIdTypeMutationVariables;
  export type Mutation = UpdateCustomIdTypeMutation;
  export type UpdateCustomId = UpdateCustomIdTypeMutation['updateCustomId'];
  export type CustomIdType = UpdateCustomIdTypeMutation['updateCustomId']['customIdType'];
}

export namespace UpdateGeocode {
  export type Variables = UpdateGeocodeMutationVariables;
  export type Mutation = UpdateGeocodeMutation;
  export type UpdateAddressGeolocation = UpdateGeocodeMutation['updateAddressGeolocation'];
  export type Address = UpdateGeocodeMutation['updateAddressGeolocation']['address'];
}

export namespace AcceptInvite {
  export type Variables = AcceptInviteMutationVariables;
  export type Mutation = AcceptInviteMutation;
  export type AcceptInvitation = AcceptInviteMutation['acceptInvitation'];
  export type User = AcceptInviteMutation['acceptInvitation']['user'];
}

export namespace AddUserToCampaign {
  export type Variables = AddUserToCampaignMutationVariables;
  export type Mutation = AddUserToCampaignMutation;
  export type AddCampaignParticipant = AddUserToCampaignMutation['addCampaignParticipant'];
  export type User = AddUserToCampaignMutation['addCampaignParticipant']['user'];
}

export namespace CancelInvite {
  export type Variables = CancelInviteMutationVariables;
  export type Mutation = CancelInviteMutation;
  export type CancelInvitation = CancelInviteMutation['cancelInvitation'];
  export type User = CancelInviteMutation['cancelInvitation']['user'];
}

export namespace CreateUser {
  export type Variables = CreateUserMutationVariables;
  export type Mutation = CreateUserMutation;
  export type CreateInvitation = CreateUserMutation['createInvitation'];
  export type User = CreateUserMutation['createInvitation']['user'];
}

export namespace DisableUser {
  export type Variables = DisableUserMutationVariables;
  export type Mutation = DisableUserMutation;
  export type DisableUser = DisableUserMutation['disableUser'];
  export type User = DisableUserMutation['disableUser']['user'];
}

export namespace SetUsersDisableOnDate {
  export type Variables = SetUsersDisableOnDateMutationVariables;
  export type Mutation = SetUsersDisableOnDateMutation;
  export type SetUsersDisableOnDate = SetUsersDisableOnDateMutation['setUsersDisableOnDate'];
  export type Users = SetUsersDisableOnDateMutation['setUsersDisableOnDate']['users'][number];
}

export namespace EnableUser {
  export type Variables = EnableUserMutationVariables;
  export type Mutation = EnableUserMutation;
  export type EnableUser = EnableUserMutation['enableUser'];
  export type User = EnableUserMutation['enableUser']['user'];
}

export namespace RemoveMfa {
  export type Variables = RemoveMfaMutationVariables;
  export type Mutation = RemoveMfaMutation;
  export type RemoveMfa = RemoveMfaMutation['removeMfa'];
  export type User = RemoveMfaMutation['removeMfa']['user'];
}

export namespace ResendMfaCode {
  export type Variables = ResendMfaCodeMutationVariables;
  export type Mutation = ResendMfaCodeMutation;
  export type ResendMfaCode = ResendMfaCodeMutation['resendMfaCode'];
  export type User = ResendMfaCodeMutation['resendMfaCode']['user'];
}

export namespace ResendUserInvite {
  export type Variables = ResendUserInviteMutationVariables;
  export type Mutation = ResendUserInviteMutation;
  export type ResendInvitation = ResendUserInviteMutation['resendInvitation'];
  export type User = ResendUserInviteMutation['resendInvitation']['user'];
}

export namespace StartMfaSetup {
  export type Variables = StartMfaSetupMutationVariables;
  export type Mutation = StartMfaSetupMutation;
  export type StartMfaSetup = StartMfaSetupMutation['startMfaSetup'];
  export type User = StartMfaSetupMutation['startMfaSetup']['user'];
  export type MfaFactor = StartMfaSetupMutation['startMfaSetup']['mfaFactor'];
}

export namespace UpdateCurrentUser {
  export type Variables = UpdateCurrentUserMutationVariables;
  export type Mutation = UpdateCurrentUserMutation;
  export type UpdateCurrentUser = UpdateCurrentUserMutation['updateCurrentUser'];
  export type User = UpdateCurrentUserMutation['updateCurrentUser']['user'];
}

export namespace UpdateUserById {
  export type Variables = UpdateUserByIdMutationVariables;
  export type Mutation = UpdateUserByIdMutation;
  export type UpdateUserById = UpdateUserByIdMutation['updateUserById'];
  export type User = UpdateUserByIdMutation['updateUserById']['user'];
}

export namespace VerifyMfaLogin {
  export type Variables = VerifyMfaLoginMutationVariables;
  export type Mutation = VerifyMfaLoginMutation;
  export type VerifyMfaLogin = VerifyMfaLoginMutation['verifyMfaLogin'];
  export type User = VerifyMfaLoginMutation['verifyMfaLogin']['user'];
}

export namespace VerifyMfaSetup {
  export type Variables = VerifyMfaSetupMutationVariables;
  export type Mutation = VerifyMfaSetupMutation;
  export type VerifyMfaSetup = VerifyMfaSetupMutation['verifyMfaSetup'];
  export type MfaFactor = VerifyMfaSetupMutation['verifyMfaSetup']['mfaFactor'];
  export type User = VerifyMfaSetupMutation['verifyMfaSetup']['user'];
}

export namespace GetCampaignEntityTypeConfiguration {
  export type Variables = GetCampaignEntityTypeConfigurationQueryVariables;
  export type Query = GetCampaignEntityTypeConfigurationQuery;
  export type GetCampaignEntityTypeConfiguration = GetCampaignEntityTypeConfigurationQuery['getCampaignEntityTypeConfiguration'];
}

export namespace GetCampaignEntityTypeConfigurations {
  export type Variables = GetCampaignEntityTypeConfigurationsQueryVariables;
  export type Query = GetCampaignEntityTypeConfigurationsQuery;
  export type GetCampaignEntityTypeConfigurations = GetCampaignEntityTypeConfigurationsQuery['getCampaignEntityTypeConfigurations'][number];
}

export namespace SearchCampaignObjectVisibility {
  export type Variables = SearchCampaignObjectVisibilityQueryVariables;
  export type Query = SearchCampaignObjectVisibilityQuery;
  export type SearchCampaignObjectVisibility = SearchCampaignObjectVisibilityQuery['searchCampaignObjectVisibility'];
  export type Edges = SearchCampaignObjectVisibilityQuery['searchCampaignObjectVisibility']['edges'][number];
  export type Node = SearchCampaignObjectVisibilityQuery['searchCampaignObjectVisibility']['edges'][number]['node'];
  export type PageInfo = SearchCampaignObjectVisibilityQuery['searchCampaignObjectVisibility']['pageInfo'];
}

export namespace CampaignHasEntities {
  export type Variables = CampaignHasEntitiesQueryVariables;
  export type Query = CampaignHasEntitiesQuery;
  export type GetEntities = CampaignHasEntitiesQuery['getEntities'];
  export type Nodes = CampaignHasEntitiesQuery['getEntities']['nodes'][number];
}

export namespace GetCampaignByIdNoTags {
  export type Variables = GetCampaignByIdNoTagsQueryVariables;
  export type Query = GetCampaignByIdNoTagsQuery;
  export type GetCampaign = GetCampaignByIdNoTagsQuery['getCampaign'];
}

export namespace GetCampaignDefaultCountry {
  export type Variables = GetCampaignDefaultCountryQueryVariables;
  export type Query = GetCampaignDefaultCountryQuery;
  export type GetCampaign = GetCampaignDefaultCountryQuery['getCampaign'];
}

export namespace GetCampaignIds {
  export type Variables = GetCampaignIdsQueryVariables;
  export type Query = GetCampaignIdsQuery;
  export type SearchCampaigns = GetCampaignIdsQuery['searchCampaigns'];
}

export namespace GetCampaignIntegrations {
  export type Variables = GetCampaignIntegrationsQueryVariables;
  export type Query = GetCampaignIntegrationsQuery;
  export type GetCampaign = GetCampaignIntegrationsQuery['getCampaign'];
  export type Integrations = GetCampaignIntegrationsQuery['getCampaign']['integrations'][number];
  export type CampaignIntegrations = GetCampaignIntegrationsQuery['getCampaign']['campaignIntegrations'];
  export type ActionNetwork = GetCampaignIntegrationsQuery['getCampaign']['campaignIntegrations']['actionNetwork'];
}

export namespace GetCampaignPublicById {
  export type Variables = GetCampaignPublicByIdQueryVariables;
  export type Query = GetCampaignPublicByIdQuery;
  export type GetCampaignPublic = GetCampaignPublicByIdQuery['getCampaignPublic'];
}

export namespace GetCampaignSupport {
  export type Variables = GetCampaignSupportQueryVariables;
  export type Query = GetCampaignSupportQuery;
  export type GetCampaign = GetCampaignSupportQuery['getCampaign'];
  export type SupportUser = GetCampaignSupportQuery['getCampaign']['supportUser'];
}

export namespace GetCampaignsCount {
  export type Variables = GetCampaignsCountQueryVariables;
  export type Query = GetCampaignsCountQuery;
  export type SearchCampaigns = GetCampaignsCountQuery['searchCampaigns'];
}

export namespace SearchCampaigns {
  export type Variables = SearchCampaignsQueryVariables;
  export type Query = SearchCampaignsQuery;
  export type SearchCampaigns = SearchCampaignsQuery['searchCampaigns'];
  export type Edges = SearchCampaignsQuery['searchCampaigns']['edges'][number];
  export type Node = SearchCampaignsQuery['searchCampaigns']['edges'][number]['node'];
  export type PageInfo = SearchCampaignsQuery['searchCampaigns']['pageInfo'];
}

export namespace GetCampaignConnectionTypeConfigurations {
  export type Variables = GetCampaignConnectionTypeConfigurationsQueryVariables;
  export type Query = GetCampaignConnectionTypeConfigurationsQuery;
  export type GetCampaignEntityConnectionTypeConfigurations = GetCampaignConnectionTypeConfigurationsQuery['getCampaignEntityConnectionTypeConfigurations'][number];
}

export namespace GetEntityConnectionType {
  export type Variables = GetEntityConnectionTypeQueryVariables;
  export type Query = GetEntityConnectionTypeQuery;
  export type GetEntityConnectionType = GetEntityConnectionTypeQuery['getEntityConnectionType'];
}

export namespace GetEntityConnectionTypes {
  export type Variables = GetEntityConnectionTypesQueryVariables;
  export type Query = GetEntityConnectionTypesQuery;
  export type GetEntityConnectionTypes = GetEntityConnectionTypesQuery['getEntityConnectionTypes'][number];
}

export namespace GetEntityConnection {
  export type Variables = GetEntityConnectionQueryVariables;
  export type Query = GetEntityConnectionQuery;
  export type GetEntityConnection = GetEntityConnectionQuery['getEntityConnection'];
}

export namespace GetEntityConnections {
  export type Variables = GetEntityConnectionsQueryVariables;
  export type Query = GetEntityConnectionsQuery;
  export type GetEntityConnections = GetEntityConnectionsQuery['getEntityConnections'];
  export type Nodes = GetEntityConnectionsQuery['getEntityConnections']['nodes'][number];
  export type PageInfo = GetEntityConnectionsQuery['getEntityConnections']['pageInfo'];
}

export namespace GetEntityType {
  export type Variables = GetEntityTypeQueryVariables;
  export type Query = GetEntityTypeQuery;
  export type GetEntityType = GetEntityTypeQuery['getEntityType'];
}

export namespace GetEntityTypes {
  export type Variables = GetEntityTypesQueryVariables;
  export type Query = GetEntityTypesQuery;
  export type GetEntityTypes = GetEntityTypesQuery['getEntityTypes'];
  export type Nodes = GetEntityTypesQuery['getEntityTypes']['nodes'][number];
  export type PageInfo = GetEntityTypesQuery['getEntityTypes']['pageInfo'];
}

export namespace GetEntitiesForWallChartQuery {
  export type Variables = GetEntitiesForWallChartQueryQueryVariables;
  export type Query = GetEntitiesForWallChartQueryQuery;
  export type GetEntitiesByIds = GetEntitiesForWallChartQueryQuery['getEntitiesByIds'][number];
}

export namespace GetWallChart {
  export type Variables = GetWallChartQueryVariables;
  export type Query = GetWallChartQuery;
  export type Wallchart3 = GetWallChartQuery['wallchart3'][number];
  export type GroupBy = GetWallChartQuery['wallchart3'][number]['groupBy'][number];
  export type Matches = GetWallChartQuery['wallchart3'][number]['groupBy'][number]['matches'][number];
  export type _Matches = GetWallChartQuery['wallchart3'][number]['matches'][number];
}

export namespace GetEntitiesForMapView {
  export type Variables = GetEntitiesForMapViewQueryVariables;
  export type Query = GetEntitiesForMapViewQuery;
  export type EntitiesQuery = GetEntitiesForMapViewQuery['entitiesQuery'];
  export type Nodes = GetEntitiesForMapViewQuery['entitiesQuery']['nodes'][number];
  export type PageInfo = GetEntitiesForMapViewQuery['entitiesQuery']['pageInfo'];
}

export namespace EntitiesQuery {
  export type Variables = EntitiesQueryQueryVariables;
  export type Query = EntitiesQueryQuery;
  export type EntitiesQuery = EntitiesQueryQuery['entitiesQuery'];
  export type Nodes = EntitiesQueryQuery['entitiesQuery']['nodes'][number];
  export type PageInfo = EntitiesQueryQuery['entitiesQuery']['pageInfo'];
}

export namespace EntitiesTotalCountQuery {
  export type Variables = EntitiesTotalCountQueryQueryVariables;
  export type Query = EntitiesTotalCountQueryQuery;
  export type EntitiesQuery = EntitiesTotalCountQueryQuery['entitiesQuery'];
}

export namespace GetCurrentAssessmentsForEntities {
  export type Variables = GetCurrentAssessmentsForEntitiesQueryVariables;
  export type Query = GetCurrentAssessmentsForEntitiesQuery;
  export type GetEntitiesByIds = GetCurrentAssessmentsForEntitiesQuery['getEntitiesByIds'][number];
}

export namespace GetEntityAssessments {
  export type Variables = GetEntityAssessmentsQueryVariables;
  export type Query = GetEntityAssessmentsQuery;
  export type GetEntity = GetEntityAssessmentsQuery['getEntity'];
}

export namespace GetEntityBasic {
  export type Variables = GetEntityBasicQueryVariables;
  export type Query = GetEntityBasicQuery;
  export type GetEntity = GetEntityBasicQuery['getEntity'];
}

export namespace GetEntityById2 {
  export type Variables = GetEntityById2QueryVariables;
  export type Query = GetEntityById2Query;
  export type GetEntity = GetEntityById2Query['getEntity'];
}

export namespace GetEntityName {
  export type Variables = GetEntityNameQueryVariables;
  export type Query = GetEntityNameQuery;
  export type GetEntity = GetEntityNameQuery['getEntity'];
}

export namespace GetEntityNotes {
  export type Variables = GetEntityNotesQueryVariables;
  export type Query = GetEntityNotesQuery;
  export type GetEntity = GetEntityNotesQuery['getEntity'];
}

export namespace GetEntityPublic {
  export type Variables = GetEntityPublicQueryVariables;
  export type Query = GetEntityPublicQuery;
  export type GetEntityPublic = GetEntityPublicQuery['getEntityPublic'];
}

export namespace GetPotentialDuplicates {
  export type Variables = GetPotentialDuplicatesQueryVariables;
  export type Query = GetPotentialDuplicatesQuery;
  export type GetPotentialEntityDuplicates = GetPotentialDuplicatesQuery['getPotentialEntityDuplicates'];
  export type EmailMatches = GetPotentialDuplicatesQuery['getPotentialEntityDuplicates']['emailMatches'][number];
  export type Entities = GetPotentialDuplicatesQuery['getPotentialEntityDuplicates']['emailMatches'][number]['entities'][number];
  export type PhoneMatches = GetPotentialDuplicatesQuery['getPotentialEntityDuplicates']['phoneMatches'][number];
  export type _Entities = GetPotentialDuplicatesQuery['getPotentialEntityDuplicates']['phoneMatches'][number]['entities'][number];
}

export namespace GetSocialNetworks {
  export type Variables = GetSocialNetworksQueryVariables;
  export type Query = GetSocialNetworksQuery;
  export type GetSocialNetworks = GetSocialNetworksQuery['getSocialNetworks'][number];
}

export namespace SearchEntitiesPublic {
  export type Variables = SearchEntitiesPublicQueryVariables;
  export type Query = SearchEntitiesPublicQuery;
  export type SearchEntitiesPublic = SearchEntitiesPublicQuery['searchEntitiesPublic'];
  export type Nodes = SearchEntitiesPublicQuery['searchEntitiesPublic']['nodes'][number];
}

export namespace SearchEntities {
  export type Variables = SearchEntitiesQueryVariables;
  export type Query = SearchEntitiesQuery;
  export type SearchEntities = SearchEntitiesQuery['searchEntities'];
  export type Nodes = SearchEntitiesQuery['searchEntities']['nodes'][number];
  export type Campaigns = SearchEntitiesQuery['searchEntities']['nodes'][number]['campaigns'][number];
}

export namespace GetCalendarEventResponseForEntity {
  export type Variables = GetCalendarEventResponseForEntityQueryVariables;
  export type Query = GetCalendarEventResponseForEntityQuery;
  export type GetCalendarEventResponseForEntity = GetCalendarEventResponseForEntityQuery['getCalendarEventResponseForEntity'];
}

export namespace GetCalendarEventResponse {
  export type Variables = GetCalendarEventResponseQueryVariables;
  export type Query = GetCalendarEventResponseQuery;
  export type GetCalendarEventResponse = GetCalendarEventResponseQuery['getCalendarEventResponse'];
}

export namespace GetCalendarEvent {
  export type Variables = GetCalendarEventQueryVariables;
  export type Query = GetCalendarEventQuery;
  export type GetCalendarEvent = GetCalendarEventQuery['getCalendarEvent'];
}

export namespace SearchCalendarEventResponses {
  export type Variables = SearchCalendarEventResponsesQueryVariables;
  export type Query = SearchCalendarEventResponsesQuery;
  export type SearchCalendarEventResponses = SearchCalendarEventResponsesQuery['searchCalendarEventResponses'];
  export type Nodes = SearchCalendarEventResponsesQuery['searchCalendarEventResponses']['nodes'][number];
}

export namespace SearchCalendarEvents {
  export type Variables = SearchCalendarEventsQueryVariables;
  export type Query = SearchCalendarEventsQuery;
  export type SearchCalendarEvents = SearchCalendarEventsQuery['searchCalendarEvents'];
  export type Nodes = SearchCalendarEventsQuery['searchCalendarEvents']['nodes'][number];
  export type EntityResponse = SearchCalendarEventsQuery['searchCalendarEvents']['nodes'][number]['entityResponse'];
}

export namespace GetAddressForEntity {
  export type Variables = GetAddressForEntityQueryVariables;
  export type Query = GetAddressForEntityQuery;
  export type GetAddress = GetAddressForEntityQuery['getAddress'];
}

export namespace GetCustomIdTypes {
  export type Variables = GetCustomIdTypesQueryVariables;
  export type Query = GetCustomIdTypesQuery;
  export type GetCustomIdTypes = GetCustomIdTypesQuery['getCustomIdTypes'][number];
}

export namespace GetExternalServices {
  export type Variables = GetExternalServicesQueryVariables;
  export type Query = GetExternalServicesQuery;
  export type GetExternalServices = GetExternalServicesQuery['getExternalServices'][number];
}

export namespace GetOrganizationDetails {
  export type Variables = GetOrganizationDetailsQueryVariables;
  export type Query = GetOrganizationDetailsQuery;
  export type GetOrganization = GetOrganizationDetailsQuery['getOrganization'];
}

export namespace GetDefaultSavedQuery {
  export type Variables = GetDefaultSavedQueryQueryVariables;
  export type Query = GetDefaultSavedQueryQuery;
  export type GetDefaultSavedQuery = GetDefaultSavedQueryQuery['getDefaultSavedQuery'];
}

export namespace GetSavedQueries {
  export type Variables = GetSavedQueriesQueryVariables;
  export type Query = GetSavedQueriesQuery;
  export type GetSavedQueries = GetSavedQueriesQuery['getSavedQueries'];
  export type Edges = GetSavedQueriesQuery['getSavedQueries']['edges'][number];
  export type Node = GetSavedQueriesQuery['getSavedQueries']['edges'][number]['node'];
}

export namespace GetSavedQuery {
  export type Variables = GetSavedQueryQueryVariables;
  export type Query = GetSavedQueryQuery;
  export type GetSavedQuery = GetSavedQueryQuery['getSavedQuery'];
}

export namespace SearchSavedQueries {
  export type Variables = SearchSavedQueriesQueryVariables;
  export type Query = SearchSavedQueriesQuery;
  export type GetSavedQueries = SearchSavedQueriesQuery['getSavedQueries'];
  export type Edges = SearchSavedQueriesQuery['getSavedQueries']['edges'][number];
  export type Node = SearchSavedQueriesQuery['getSavedQueries']['edges'][number]['node'];
  export type PageInfo = SearchSavedQueriesQuery['getSavedQueries']['pageInfo'];
}

export namespace SearchElectoralDistricts {
  export type Variables = SearchElectoralDistrictsQueryVariables;
  export type Query = SearchElectoralDistrictsQuery;
  export type SearchElectoralDistricts = SearchElectoralDistrictsQuery['searchElectoralDistricts'];
  export type Nodes = SearchElectoralDistrictsQuery['searchElectoralDistricts']['nodes'][number];
}

export namespace SearchLocations {
  export type Variables = SearchLocationsQueryVariables;
  export type Query = SearchLocationsQuery;
  export type SearchLocations = SearchLocationsQuery['searchLocations'][number];
}

export namespace GetTagByIdForQuery {
  export type Variables = GetTagByIdForQueryQueryVariables;
  export type Query = GetTagByIdForQueryQuery;
  export type GetTagById = GetTagByIdForQueryQuery['getTagById'];
}

export namespace GetTagCategoriesOnly {
  export type Variables = GetTagCategoriesOnlyQueryVariables;
  export type Query = GetTagCategoriesOnlyQuery;
  export type GetTagCategories = GetTagCategoriesOnlyQuery['getTagCategories'];
  export type Nodes = GetTagCategoriesOnlyQuery['getTagCategories']['nodes'][number];
}

export namespace GetTagCategories {
  export type Variables = GetTagCategoriesQueryVariables;
  export type Query = GetTagCategoriesQuery;
  export type GetTagCategories = GetTagCategoriesQuery['getTagCategories'];
  export type Nodes = GetTagCategoriesQuery['getTagCategories']['nodes'][number];
}

export namespace GetTagCategoryById {
  export type Variables = GetTagCategoryByIdQueryVariables;
  export type Query = GetTagCategoryByIdQuery;
  export type GetTagCategoryById = GetTagCategoryByIdQuery['getTagCategoryById'];
}

export namespace GetTagGroups2 {
  export type Variables = GetTagGroups2QueryVariables;
  export type Query = GetTagGroups2Query;
  export type GetTagGroups = GetTagGroups2Query['getTagGroups'];
  export type Nodes = GetTagGroups2Query['getTagGroups']['nodes'][number];
  export type Categories = GetTagGroups2Query['getTagGroups']['nodes'][number]['categories'][number];
}

export namespace GetTaggableLogbookById {
  export type Variables = GetTaggableLogbookByIdQueryVariables;
  export type Query = GetTaggableLogbookByIdQuery;
  export type GetTaggableLogbookById = GetTaggableLogbookByIdQuery['getTaggableLogbookById'];
}

export namespace GetTagsByIdsForQuery {
  export type Variables = GetTagsByIdsForQueryQueryVariables;
  export type Query = GetTagsByIdsForQueryQuery;
  export type GetTagsByIds = GetTagsByIdsForQueryQuery['getTagsByIds'][number];
}

export namespace GetTagsForCategory {
  export type Variables = GetTagsForCategoryQueryVariables;
  export type Query = GetTagsForCategoryQuery;
  export type GetTags = GetTagsForCategoryQuery['getTags'];
  export type Nodes = GetTagsForCategoryQuery['getTags']['nodes'][number];
  export type AddressTagInlineFragment = (DiscriminateUnion<GetTagsForCategoryQuery['getTags']['nodes'][number], { __typename?: 'AddressTag' }>);
  export type Address = (DiscriminateUnion<GetTagsForCategoryQuery['getTags']['nodes'][number], { __typename?: 'AddressTag' }>)['address'];
}

export namespace SearchTagsAndCategories {
  export type Variables = SearchTagsAndCategoriesQueryVariables;
  export type Query = SearchTagsAndCategoriesQuery;
  export type Tags = SearchTagsAndCategoriesQuery['tags'];
  export type Nodes = SearchTagsAndCategoriesQuery['tags']['nodes'][number];
  export type Category = SearchTagsAndCategoriesQuery['tags']['nodes'][number]['category'];
  export type PageInfo = SearchTagsAndCategoriesQuery['tags']['pageInfo'];
  export type Categories = SearchTagsAndCategoriesQuery['categories'];
  export type _Nodes = SearchTagsAndCategoriesQuery['categories']['nodes'][number];
  export type _PageInfo = SearchTagsAndCategoriesQuery['categories']['pageInfo'];
}

export namespace SearchTagsGetAllIds {
  export type Variables = SearchTagsGetAllIdsQueryVariables;
  export type Query = SearchTagsGetAllIdsQuery;
  export type SearchTags = SearchTagsGetAllIdsQuery['searchTags'];
}

export namespace SearchTags {
  export type Variables = SearchTagsQueryVariables;
  export type Query = SearchTagsQuery;
  export type SearchTags = SearchTagsQuery['searchTags'];
  export type Edges = SearchTagsQuery['searchTags']['edges'][number];
  export type Node = SearchTagsQuery['searchTags']['edges'][number]['node'];
  export type PageInfo = SearchTagsQuery['searchTags']['pageInfo'];
}

export namespace GetCurrentUser {
  export type Variables = GetCurrentUserQueryVariables;
  export type Query = GetCurrentUserQuery;
  export type GetCurrentUser = GetCurrentUserQuery['getCurrentUser'];
}

export namespace GetUserById {
  export type Variables = GetUserByIdQueryVariables;
  export type Query = GetUserByIdQuery;
  export type GetUserById = GetUserByIdQuery['getUserById'];
}

export namespace GetUserByInviteToken {
  export type Variables = GetUserByInviteTokenQueryVariables;
  export type Query = GetUserByInviteTokenQuery;
  export type GetUserByInvitationToken = GetUserByInviteTokenQuery['getUserByInvitationToken'];
}

export namespace GetUsers {
  export type Variables = GetUsersQueryVariables;
  export type Query = GetUsersQuery;
  export type GetUsers = GetUsersQuery['getUsers'];
  export type Edges = GetUsersQuery['getUsers']['edges'][number];
  export type Node = GetUsersQuery['getUsers']['edges'][number]['node'];
  export type PageInfo = GetUsersQuery['getUsers']['pageInfo'];
}

export namespace GetAllUsers {
  export type Variables = GetAllUsersQueryVariables;
  export type Query = GetAllUsersQuery;
  export type GetUsers = GetAllUsersQuery['getUsers'];
  export type Nodes = GetAllUsersQuery['getUsers']['nodes'][number];
  export type PageInfo = GetAllUsersQuery['getUsers']['pageInfo'];
}

export namespace SearchUserQuery {
  export type Variables = SearchUserQueryQueryVariables;
  export type Query = SearchUserQueryQuery;
  export type SearchUsers = SearchUserQueryQuery['searchUsers'];
  export type Edges = SearchUserQueryQuery['searchUsers']['edges'][number];
  export type Node = SearchUserQueryQuery['searchUsers']['edges'][number]['node'];
  export type PageInfo = SearchUserQueryQuery['searchUsers']['pageInfo'];
}

export namespace ActionAssignmentGroupInfo {
  export type Fragment = ActionAssignmentGroupInfoFragment;
  export type Action = ActionAssignmentGroupInfoFragment['action'];
  export type CreatedBy = ActionAssignmentGroupInfoFragment['action']['createdBy'];
  export type ActionFields = ActionAssignmentGroupInfoFragment['action']['actionFields'][number];
  export type CalendarEventAction = ActionAssignmentGroupInfoFragment['action']['actionFields'][number]['calendarEventAction'];
  export type CalendarEvent = ActionAssignmentGroupInfoFragment['action']['actionFields'][number]['calendarEventAction']['calendarEvent'];
  export type Users = ActionAssignmentGroupInfoFragment['users'][number];
}

export namespace ActionAssignmentGroupCounts {
  export type Fragment = ActionAssignmentGroupCountsFragment;
}

export namespace ActionAssignmentGroupTargetIds {
  export type Fragment = ActionAssignmentGroupTargetIdsFragment;
}

export namespace ActionCounts {
  export type Fragment = ActionCountsFragment;
}

export namespace ActionFieldDetails {
  export type Fragment = ActionFieldDetailsFragment;
  export type TagCategory = ActionFieldDetailsFragment['tagCategory'];
  export type EntityConnectionType = ActionFieldDetailsFragment['entityConnectionType'];
  export type DefaultResponse = ActionFieldDetailsFragment['defaultResponse'];
  export type Category = ActionFieldDetailsFragment['defaultResponse']['category'];
  export type CalendarEventAction = ActionFieldDetailsFragment['calendarEventAction'];
  export type CalendarEvent = ActionFieldDetailsFragment['calendarEvent'];
}

export namespace ActionDetails {
  export type Fragment = ActionDetailsFragment;
  export type EntityType = ActionDetailsFragment['entityType'];
  export type ActionFields = ActionDetailsFragment['actionFields'][number];
  export type ActionAssignmentGroups = ActionDetailsFragment['actionAssignmentGroups'][number];
  export type Users = ActionDetailsFragment['actionAssignmentGroups'][number]['users'][number];
  export type Campaign = ActionDetailsFragment['campaign'];
  export type CreatedBy = ActionDetailsFragment['createdBy'];
}

export namespace AssignmentRoutingOptionsDetails {
  export type Fragment = AssignmentRoutingOptionsDetailsFragment;
  export type StartAddress = AssignmentRoutingOptionsDetailsFragment['startAddress'];
  export type EndAddress = AssignmentRoutingOptionsDetailsFragment['endAddress'];
  export type ActionEntityRoutePairs = AssignmentRoutingOptionsDetailsFragment['actionEntityRoutePairs'][number];
  export type Address = AssignmentRoutingOptionsDetailsFragment['actionEntityRoutePairs'][number]['address'];
  export type Matches = AssignmentRoutingOptionsDetailsFragment['actionEntityRoutePairs'][number]['matches'][number];
  export type ActionEntity = AssignmentRoutingOptionsDetailsFragment['actionEntityRoutePairs'][number]['matches'][number]['actionEntity'];
}

export namespace ContactAttemptBasic {
  export type Fragment = ContactAttemptBasicFragment;
}

export namespace ContactAttemptDetails {
  export type Fragment = ContactAttemptDetailsFragment;
  export type PhoneNumber = ContactAttemptDetailsFragment['phoneNumber'];
  export type Address = ContactAttemptDetailsFragment['address'];
}

export namespace SmallActionEntity {
  export type Fragment = SmallActionEntityFragment;
  export type Entity = SmallActionEntityFragment['entity'];
}

export namespace AddActionField {
  export type Variables = AddActionFieldMutationVariables;
  export type Mutation = AddActionFieldMutation;
  export type AddActionField = AddActionFieldMutation['addActionField'];
  export type Action = AddActionFieldMutation['addActionField']['action'];
  export type ActionFields = AddActionFieldMutation['addActionField']['action']['actionFields'][number];
}

export namespace AddAllEntitiesToAction {
  export type Variables = AddAllEntitiesToActionMutationVariables;
  export type Mutation = AddAllEntitiesToActionMutation;
  export type AddAllCampaignEntitiesToAction = AddAllEntitiesToActionMutation['addAllCampaignEntitiesToAction'];
  export type Action = AddAllEntitiesToActionMutation['addAllCampaignEntitiesToAction']['action'];
}

export namespace AddEntitiesToActionAssignmentGroup {
  export type Variables = AddEntitiesToActionAssignmentGroupMutationVariables;
  export type Mutation = AddEntitiesToActionAssignmentGroupMutation;
  export type AddEntitiesToActionAssignmentGroup = AddEntitiesToActionAssignmentGroupMutation['addEntitiesToActionAssignmentGroup'];
  export type ActionAssignmentGroup = AddEntitiesToActionAssignmentGroupMutation['addEntitiesToActionAssignmentGroup']['actionAssignmentGroup'];
}

export namespace AddEntitiesToAction {
  export type Variables = AddEntitiesToActionMutationVariables;
  export type Mutation = AddEntitiesToActionMutation;
  export type AddEntitiesToAction = AddEntitiesToActionMutation['addEntitiesToAction'];
  export type Action = AddEntitiesToActionMutation['addEntitiesToAction']['action'];
}

export namespace AddUsersToAssignmentGroup {
  export type Variables = AddUsersToAssignmentGroupMutationVariables;
  export type Mutation = AddUsersToAssignmentGroupMutation;
  export type AddUsersToActionAssignmentGroup = AddUsersToAssignmentGroupMutation['addUsersToActionAssignmentGroup'];
  export type ActionAssignmentGroup = AddUsersToAssignmentGroupMutation['addUsersToActionAssignmentGroup']['actionAssignmentGroup'];
}

export namespace AssignActionTarget {
  export type Variables = AssignActionTargetMutationVariables;
  export type Mutation = AssignActionTargetMutation;
  export type AddEntityToActionAssignmentGroup = AssignActionTargetMutation['addEntityToActionAssignmentGroup'];
  export type ActionEntity = AssignActionTargetMutation['addEntityToActionAssignmentGroup']['actionEntity'];
  export type Action = AssignActionTargetMutation['addEntityToActionAssignmentGroup']['actionEntity']['action'];
  export type Campaign = AssignActionTargetMutation['addEntityToActionAssignmentGroup']['actionEntity']['action']['campaign'];
  export type Entity = AssignActionTargetMutation['addEntityToActionAssignmentGroup']['actionEntity']['entity'];
}

export namespace CreateActionAssignmentGroup {
  export type Variables = CreateActionAssignmentGroupMutationVariables;
  export type Mutation = CreateActionAssignmentGroupMutation;
  export type CreateActionAssignmentGroup = CreateActionAssignmentGroupMutation['createActionAssignmentGroup'];
  export type ActionAssignmentGroup = CreateActionAssignmentGroupMutation['createActionAssignmentGroup']['actionAssignmentGroup'];
  export type Action = CreateActionAssignmentGroupMutation['createActionAssignmentGroup']['actionAssignmentGroup']['action'];
}

export namespace CreateAction {
  export type Variables = CreateActionMutationVariables;
  export type Mutation = CreateActionMutation;
  export type CreateAction = CreateActionMutation['createAction'];
  export type Action = CreateActionMutation['createAction']['action'];
}

export namespace DeleteAllActionAssignmentGroups {
  export type Variables = DeleteAllActionAssignmentGroupsMutationVariables;
  export type Mutation = DeleteAllActionAssignmentGroupsMutation;
  export type DeleteAllActionAssignmentGroups = DeleteAllActionAssignmentGroupsMutation['deleteAllActionAssignmentGroups'];
  export type Action = DeleteAllActionAssignmentGroupsMutation['deleteAllActionAssignmentGroups']['action'];
}

export namespace DuplicateAction {
  export type Variables = DuplicateActionMutationVariables;
  export type Mutation = DuplicateActionMutation;
  export type DuplicateAction = DuplicateActionMutation['duplicateAction'];
  export type Action = DuplicateActionMutation['duplicateAction']['action'];
}

export namespace GenerateActionAssignmentGroupsByStrategy {
  export type Variables = GenerateActionAssignmentGroupsByStrategyMutationVariables;
  export type Mutation = GenerateActionAssignmentGroupsByStrategyMutation;
  export type GenerateActionAssignmentGroupsByStrategy = GenerateActionAssignmentGroupsByStrategyMutation['generateActionAssignmentGroupsByStrategy'];
  export type Action = GenerateActionAssignmentGroupsByStrategyMutation['generateActionAssignmentGroupsByStrategy']['action'];
}

export namespace RemoveActionAssignmentGroup {
  export type Variables = RemoveActionAssignmentGroupMutationVariables;
  export type Mutation = RemoveActionAssignmentGroupMutation;
  export type RemoveActionAssignmentGroup = RemoveActionAssignmentGroupMutation['removeActionAssignmentGroup'];
  export type Action = RemoveActionAssignmentGroupMutation['removeActionAssignmentGroup']['action'];
}

export namespace RemoveActionFieldById {
  export type Variables = RemoveActionFieldByIdMutationVariables;
  export type Mutation = RemoveActionFieldByIdMutation;
  export type RemoveActionFieldById = RemoveActionFieldByIdMutation['removeActionFieldById'];
  export type Action = RemoveActionFieldByIdMutation['removeActionFieldById']['action'];
  export type ActionFields = RemoveActionFieldByIdMutation['removeActionFieldById']['action']['actionFields'][number];
}

export namespace RemoveAssignmentGroupRouting {
  export type Variables = RemoveAssignmentGroupRoutingMutationVariables;
  export type Mutation = RemoveAssignmentGroupRoutingMutation;
  export type RemoveAssignmentGroupUserRouting = RemoveAssignmentGroupRoutingMutation['removeAssignmentGroupUserRouting'];
  export type AssignmentRoutingOptions = RemoveAssignmentGroupRoutingMutation['removeAssignmentGroupUserRouting']['assignmentRoutingOptions'];
}

export namespace RemoveEntitiesFromActionAssignmentGroup {
  export type Variables = RemoveEntitiesFromActionAssignmentGroupMutationVariables;
  export type Mutation = RemoveEntitiesFromActionAssignmentGroupMutation;
  export type RemoveEntitiesFromActionAssignmentGroup = RemoveEntitiesFromActionAssignmentGroupMutation['removeEntitiesFromActionAssignmentGroup'];
  export type ActionAssignmentGroup = RemoveEntitiesFromActionAssignmentGroupMutation['removeEntitiesFromActionAssignmentGroup']['actionAssignmentGroup'];
}

export namespace RemoveEntitiesFromAction {
  export type Variables = RemoveEntitiesFromActionMutationVariables;
  export type Mutation = RemoveEntitiesFromActionMutation;
  export type RemoveEntitiesFromAction = RemoveEntitiesFromActionMutation['removeEntitiesFromAction'];
  export type Action = RemoveEntitiesFromActionMutation['removeEntitiesFromAction']['action'];
}

export namespace RemoveUsersFromAssignmentGroup {
  export type Variables = RemoveUsersFromAssignmentGroupMutationVariables;
  export type Mutation = RemoveUsersFromAssignmentGroupMutation;
  export type RemoveUsersFromActionAssignmentGroup = RemoveUsersFromAssignmentGroupMutation['removeUsersFromActionAssignmentGroup'];
  export type ActionAssignmentGroup = RemoveUsersFromAssignmentGroupMutation['removeUsersFromActionAssignmentGroup']['actionAssignmentGroup'];
}

export namespace UpdateActionEntitiesByQuery {
  export type Variables = UpdateActionEntitiesByQueryMutationVariables;
  export type Mutation = UpdateActionEntitiesByQueryMutation;
  export type UpdateEntitiesOnActionByQuery = UpdateActionEntitiesByQueryMutation['updateEntitiesOnActionByQuery'];
  export type Action = UpdateActionEntitiesByQueryMutation['updateEntitiesOnActionByQuery']['action'];
}

export namespace UpdateActionField {
  export type Variables = UpdateActionFieldMutationVariables;
  export type Mutation = UpdateActionFieldMutation;
  export type UpdateActionField = UpdateActionFieldMutation['updateActionField'];
  export type Action = UpdateActionFieldMutation['updateActionField']['action'];
  export type ActionFields = UpdateActionFieldMutation['updateActionField']['action']['actionFields'][number];
  export type ActionAssignmentGroups = UpdateActionFieldMutation['updateActionField']['action']['actionAssignmentGroups'][number];
}

export namespace UpdateActionFieldsPositions {
  export type Variables = UpdateActionFieldsPositionsMutationVariables;
  export type Mutation = UpdateActionFieldsPositionsMutation;
  export type UpdateActionFieldsPositions = UpdateActionFieldsPositionsMutation['updateActionFieldsPositions'];
  export type ActionFields = UpdateActionFieldsPositionsMutation['updateActionFieldsPositions']['actionFields'][number];
}

export namespace UpdateAction {
  export type Variables = UpdateActionMutationVariables;
  export type Mutation = UpdateActionMutation;
  export type UpdateAction = UpdateActionMutation['updateAction'];
  export type Action = UpdateActionMutation['updateAction']['action'];
}

export namespace UpdateActionAssignmentGroupName {
  export type Variables = UpdateActionAssignmentGroupNameMutationVariables;
  export type Mutation = UpdateActionAssignmentGroupNameMutation;
  export type UpdateActionAssignmentGroup = UpdateActionAssignmentGroupNameMutation['updateActionAssignmentGroup'];
  export type ActionAssignmentGroup = UpdateActionAssignmentGroupNameMutation['updateActionAssignmentGroup']['actionAssignmentGroup'];
}

export namespace UpdateAssignmentGroupEntitiesByQuery {
  export type Variables = UpdateAssignmentGroupEntitiesByQueryMutationVariables;
  export type Mutation = UpdateAssignmentGroupEntitiesByQueryMutation;
  export type UpdateAssignmentGroupEntitiesByQuery = UpdateAssignmentGroupEntitiesByQueryMutation['updateAssignmentGroupEntitiesByQuery'];
  export type ActionAssignmentGroup = UpdateAssignmentGroupEntitiesByQueryMutation['updateAssignmentGroupEntitiesByQuery']['actionAssignmentGroup'];
}

export namespace UpdateAssignmentGroupUserRouting {
  export type Variables = UpdateAssignmentGroupUserRoutingMutationVariables;
  export type Mutation = UpdateAssignmentGroupUserRoutingMutation;
  export type UpdateAssignmentGroupUserRouting = UpdateAssignmentGroupUserRoutingMutation['updateAssignmentGroupUserRouting'];
  export type AssignmentRoutingOptions = UpdateAssignmentGroupUserRoutingMutation['updateAssignmentGroupUserRouting']['assignmentRoutingOptions'];
}

export namespace ActionTurfCuttingMapQuery {
  export type Variables = ActionTurfCuttingMapQueryQueryVariables;
  export type Query = ActionTurfCuttingMapQueryQuery;
  export type GetAction = ActionTurfCuttingMapQueryQuery['getAction'];
}

export namespace GetActionAndGroupCounts {
  export type Variables = GetActionAndGroupCountsQueryVariables;
  export type Query = GetActionAndGroupCountsQuery;
  export type GetAction = GetActionAndGroupCountsQuery['getAction'];
  export type ActionAssignmentGroups = GetActionAndGroupCountsQuery['getAction']['actionAssignmentGroups'][number];
}

export namespace GetActionAssignmentGroupBasic {
  export type Variables = GetActionAssignmentGroupBasicQueryVariables;
  export type Query = GetActionAssignmentGroupBasicQuery;
  export type GetActionAssignmentGroup = GetActionAssignmentGroupBasicQuery['getActionAssignmentGroup'];
  export type Action = GetActionAssignmentGroupBasicQuery['getActionAssignmentGroup']['action'];
  export type EntityType = GetActionAssignmentGroupBasicQuery['getActionAssignmentGroup']['action']['entityType'];
}

export namespace GetActionAssignmentGroup {
  export type Variables = GetActionAssignmentGroupQueryVariables;
  export type Query = GetActionAssignmentGroupQuery;
  export type GetActionAssignmentGroup = GetActionAssignmentGroupQuery['getActionAssignmentGroup'];
  export type Action = GetActionAssignmentGroupQuery['getActionAssignmentGroup']['action'];
  export type EntityType = GetActionAssignmentGroupQuery['getActionAssignmentGroup']['action']['entityType'];
  export type RoutingInfo = GetActionAssignmentGroupQuery['getActionAssignmentGroup']['routingInfo'];
  export type Users = GetActionAssignmentGroupQuery['getActionAssignmentGroup']['users'][number];
  export type ActionEntities = GetActionAssignmentGroupQuery['getActionAssignmentGroup']['actionEntities'][number];
  export type MostRecentContactAttempt = GetActionAssignmentGroupQuery['getActionAssignmentGroup']['actionEntities'][number]['mostRecentContactAttempt'];
  export type Entity = GetActionAssignmentGroupQuery['getActionAssignmentGroup']['actionEntities'][number]['entity'];
  export type MappableAddresses = GetActionAssignmentGroupQuery['getActionAssignmentGroup']['actionEntities'][number]['entity']['mappableAddresses'][number];
}

export namespace GetAssignmentGroupsForCurrentUser {
  export type Variables = GetAssignmentGroupsForCurrentUserQueryVariables;
  export type Query = GetAssignmentGroupsForCurrentUserQuery;
  export type GetActionAssignmentGroupsForCurrentUser = GetAssignmentGroupsForCurrentUserQuery['getActionAssignmentGroupsForCurrentUser'][number];
}

export namespace GetActionAssignmentGroups {
  export type Variables = GetActionAssignmentGroupsQueryVariables;
  export type Query = GetActionAssignmentGroupsQuery;
  export type GetAction = GetActionAssignmentGroupsQuery['getAction'];
  export type EntityType = GetActionAssignmentGroupsQuery['getAction']['entityType'];
  export type ActionAssignmentGroups = GetActionAssignmentGroupsQuery['getAction']['actionAssignmentGroups'][number];
  export type Users = GetActionAssignmentGroupsQuery['getAction']['actionAssignmentGroups'][number]['users'][number];
}

export namespace GetActionHouseholdMatches {
  export type Variables = GetActionHouseholdMatchesQueryVariables;
  export type Query = GetActionHouseholdMatchesQuery;
  export type GetActionHouseholdMatches = GetActionHouseholdMatchesQuery['getActionHouseholdMatches'];
  export type Address = GetActionHouseholdMatchesQuery['getActionHouseholdMatches']['address'];
  export type Matches = GetActionHouseholdMatchesQuery['getActionHouseholdMatches']['matches'][number];
  export type ActionEntity = GetActionHouseholdMatchesQuery['getActionHouseholdMatches']['matches'][number]['actionEntity'];
  export type MostRecentContactAttempt = GetActionHouseholdMatchesQuery['getActionHouseholdMatches']['matches'][number]['actionEntity']['mostRecentContactAttempt'];
  export type Entity = GetActionHouseholdMatchesQuery['getActionHouseholdMatches']['matches'][number]['actionEntity']['entity'];
}

export namespace GetActionEntity {
  export type Variables = GetActionEntityQueryVariables;
  export type Query = GetActionEntityQuery;
  export type GetActionEntity = GetActionEntityQuery['getActionEntity'];
  export type MostRecentContactAttempt = GetActionEntityQuery['getActionEntity']['mostRecentContactAttempt'];
  export type Entity = GetActionEntityQuery['getActionEntity']['entity'];
  export type Action = GetActionEntityQuery['getActionEntity']['action'];
  export type ActionFields = GetActionEntityQuery['getActionEntity']['action']['actionFields'][number];
  export type Tasks = GetActionEntityQuery['getActionEntity']['tasks'][number];
  export type ActionField = GetActionEntityQuery['getActionEntity']['tasks'][number]['actionField'];
}

export namespace GetActionFields {
  export type Variables = GetActionFieldsQueryVariables;
  export type Query = GetActionFieldsQuery;
  export type GetAction = GetActionFieldsQuery['getAction'];
  export type EntityType = GetActionFieldsQuery['getAction']['entityType'];
  export type ActionFields = GetActionFieldsQuery['getAction']['actionFields'][number];
}

export namespace GetActionEntityAssignmentOrdering {
  export type Variables = GetActionEntityAssignmentOrderingQueryVariables;
  export type Query = GetActionEntityAssignmentOrderingQuery;
  export type GetActionEntityAssignmentOrdering = GetActionEntityAssignmentOrderingQuery['getActionEntityAssignmentOrdering'];
}

export namespace GetActionTypeQuery {
  export type Variables = GetActionTypeQueryQueryVariables;
  export type Query = GetActionTypeQueryQuery;
  export type GetAction = GetActionTypeQueryQuery['getAction'];
  export type EntityType = GetActionTypeQueryQuery['getAction']['entityType'];
}

export namespace GetActionDetails {
  export type Variables = GetActionDetailsQueryVariables;
  export type Query = GetActionDetailsQuery;
  export type GetAction = GetActionDetailsQuery['getAction'];
}

export namespace GetActionsCounts {
  export type Variables = GetActionsCountsQueryVariables;
  export type Query = GetActionsCountsQuery;
  export type GetActions = GetActionsCountsQuery['getActions'][number];
  export type Campaign = GetActionsCountsQuery['getActions'][number]['campaign'];
  export type CreatedBy = GetActionsCountsQuery['getActions'][number]['createdBy'];
  export type ActionFields = GetActionsCountsQuery['getActions'][number]['actionFields'][number];
  export type CalendarEventAction = GetActionsCountsQuery['getActions'][number]['actionFields'][number]['calendarEventAction'];
  export type CalendarEvent = GetActionsCountsQuery['getActions'][number]['actionFields'][number]['calendarEventAction']['calendarEvent'];
}

export namespace GetContactAttempts {
  export type Variables = GetContactAttemptsQueryVariables;
  export type Query = GetContactAttemptsQuery;
  export type GetContactAttempts = GetContactAttemptsQuery['getContactAttempts'][number];
}

export namespace GetEntityAddressGeocodes {
  export type Variables = GetEntityAddressGeocodesQueryVariables;
  export type Query = GetEntityAddressGeocodesQuery;
  export type GetEntitiesByIds = GetEntityAddressGeocodesQuery['getEntitiesByIds'][number];
  export type MappableAddresses = GetEntityAddressGeocodesQuery['getEntitiesByIds'][number]['mappableAddresses'][number];
}

export namespace GetEntityQueryCounts {
  export type Variables = GetEntityQueryCountsQueryVariables;
  export type Query = GetEntityQueryCountsQuery;
  export type EntitiesQuery = GetEntityQueryCountsQuery['entitiesQuery'];
}

export namespace GetSmallActionEntity {
  export type Variables = GetSmallActionEntityQueryVariables;
  export type Query = GetSmallActionEntityQuery;
  export type GetActionEntityById = GetSmallActionEntityQuery['getActionEntityById'];
}

export namespace GetTargetsAssignedToOtherGroups {
  export type Variables = GetTargetsAssignedToOtherGroupsQueryVariables;
  export type Query = GetTargetsAssignedToOtherGroupsQuery;
  export type GetActionAssignmentGroup = GetTargetsAssignedToOtherGroupsQuery['getActionAssignmentGroup'];
}

export namespace SearchActionEntities {
  export type Variables = SearchActionEntitiesQueryVariables;
  export type Query = SearchActionEntitiesQuery;
  export type SearchActionEntities = SearchActionEntitiesQuery['searchActionEntities'];
  export type Edges = SearchActionEntitiesQuery['searchActionEntities']['edges'][number];
  export type Node = SearchActionEntitiesQuery['searchActionEntities']['edges'][number]['node'];
  export type MostRecentContactAttempt = SearchActionEntitiesQuery['searchActionEntities']['edges'][number]['node']['mostRecentContactAttempt'];
  export type Entity = SearchActionEntitiesQuery['searchActionEntities']['edges'][number]['node']['entity'];
  export type PageInfo = SearchActionEntitiesQuery['searchActionEntities']['pageInfo'];
}

export namespace GetActionName {
  export type Variables = GetActionNameQueryVariables;
  export type Query = GetActionNameQuery;
  export type GetAction = GetActionNameQuery['getAction'];
}

export namespace SearchActivityEvents {
  export type Variables = SearchActivityEventsQueryVariables;
  export type Query = SearchActivityEventsQuery;
  export type SearchActivityEvents = SearchActivityEventsQuery['searchActivityEvents'];
  export type Edges = SearchActivityEventsQuery['searchActivityEvents']['edges'][number];
  export type Node = SearchActivityEventsQuery['searchActivityEvents']['edges'][number]['node'];
  export type User = SearchActivityEventsQuery['searchActivityEvents']['edges'][number]['node']['user'];
  export type Target = SearchActivityEventsQuery['searchActivityEvents']['edges'][number]['node']['target'];
  export type CalendarEventResponseInlineFragment = (DiscriminateUnion<SearchActivityEventsQuery['searchActivityEvents']['edges'][number]['node']['target'], { __typename?: 'CalendarEventResponse' }>);
  export type CalendarEvent = (DiscriminateUnion<SearchActivityEventsQuery['searchActivityEvents']['edges'][number]['node']['target'], { __typename?: 'CalendarEventResponse' }>)['calendarEvent'];
  export type Entity = (DiscriminateUnion<SearchActivityEventsQuery['searchActivityEvents']['edges'][number]['node']['target'], { __typename?: 'CalendarEventResponse' }>)['entity'];
  export type EntityConnectionInlineFragment = (DiscriminateUnion<SearchActivityEventsQuery['searchActivityEvents']['edges'][number]['node']['target'], { __typename?: 'EntityConnection' }>);
  export type EntityInlineFragment = (DiscriminateUnion<SearchActivityEventsQuery['searchActivityEvents']['edges'][number]['node']['target'], { __typename?: 'Entity' }>);
  export type EntityType = (DiscriminateUnion<SearchActivityEventsQuery['searchActivityEvents']['edges'][number]['node']['target'], { __typename?: 'Entity' }>)['entityType'];
  export type PageInfo = SearchActivityEventsQuery['searchActivityEvents']['pageInfo'];
}

export namespace GetMergeConflicts {
  export type Variables = GetMergeConflictsQueryVariables;
  export type Query = GetMergeConflictsQuery;
  export type GetMergeConflicts = GetMergeConflictsQuery['getMergeConflicts'];
  export type EntityCustomIdsConflicts = GetMergeConflictsQuery['getMergeConflicts']['entityCustomIdsConflicts'][number];
  export type ConnectionConflicts = GetMergeConflictsQuery['getMergeConflicts']['connectionConflicts'][number];
  export type TaggableConflicts = GetMergeConflictsQuery['getMergeConflicts']['connectionConflicts'][number]['taggableConflicts'][number];
  export type _TaggableConflicts = GetMergeConflictsQuery['getMergeConflicts']['taggableConflicts'][number];
  export type CalendarEventResponseConflicts = GetMergeConflictsQuery['getMergeConflicts']['calendarEventResponseConflicts'][number];
  export type __TaggableConflicts = GetMergeConflictsQuery['getMergeConflicts']['calendarEventResponseConflicts'][number]['taggableConflicts'][number];
}

export namespace MergeEntities {
  export type Variables = MergeEntitiesMutationVariables;
  export type Mutation = MergeEntitiesMutation;
  export type MergeEntities = MergeEntitiesMutation['mergeEntities'];
  export type Entity = MergeEntitiesMutation['mergeEntities']['entity'];
}

export namespace GetCountsForEntityChart {
  export type Variables = GetCountsForEntityChartQueryVariables;
  export type Query = GetCountsForEntityChartQuery;
  export type GetCountsForEntityChart = GetCountsForEntityChartQuery['getCountsForEntityChart'];
  export type Results = GetCountsForEntityChartQuery['getCountsForEntityChart']['results'][number];
  export type Counts = GetCountsForEntityChartQuery['getCountsForEntityChart']['results'][number]['counts'][number];
}

export namespace ActionNetworkGroupInfo {
  export type Fragment = ActionNetworkGroupInfoFragment;
}

export namespace ActionNetworkTagMappingInfo {
  export type Fragment = ActionNetworkTagMappingInfoFragment;
  export type ActionBuilder = ActionNetworkTagMappingInfoFragment['actionBuilder'];
  export type Category = ActionNetworkTagMappingInfoFragment['actionBuilder']['category'];
  export type Group = ActionNetworkTagMappingInfoFragment['actionBuilder']['group'];
  export type ActionNetwork = ActionNetworkTagMappingInfoFragment['actionNetwork'];
}

export namespace AddActionNetworkGroup {
  export type Variables = AddActionNetworkGroupMutationVariables;
  export type Mutation = AddActionNetworkGroupMutation;
  export type AddActionNetworkGroup = AddActionNetworkGroupMutation['addActionNetworkGroup'];
  export type ActionNetworkGroup = AddActionNetworkGroupMutation['addActionNetworkGroup']['actionNetworkGroup'];
}

export namespace AddAnIntegrationToCampaign {
  export type Variables = AddAnIntegrationToCampaignMutationVariables;
  export type Mutation = AddAnIntegrationToCampaignMutation;
  export type AddActionNetworkIntegrationToCampaign = AddAnIntegrationToCampaignMutation['addActionNetworkIntegrationToCampaign'];
  export type Campaign = AddAnIntegrationToCampaignMutation['addActionNetworkIntegrationToCampaign']['campaign'];
  export type CampaignIntegrations = AddAnIntegrationToCampaignMutation['addActionNetworkIntegrationToCampaign']['campaign']['campaignIntegrations'];
  export type ActionNetwork = AddAnIntegrationToCampaignMutation['addActionNetworkIntegrationToCampaign']['campaign']['campaignIntegrations']['actionNetwork'];
}

export namespace AddActionNetworkTagMapping {
  export type Variables = AddActionNetworkTagMappingMutationVariables;
  export type Mutation = AddActionNetworkTagMappingMutation;
  export type AddActionNetworkCampaignTagMapping = AddActionNetworkTagMappingMutation['addActionNetworkCampaignTagMapping'];
  export type ActionNetworkTagMapping = AddActionNetworkTagMappingMutation['addActionNetworkCampaignTagMapping']['actionNetworkTagMapping'];
}

export namespace AnCampaignIntegration {
  export type Fragment = AnCampaignIntegrationFragment;
  export type Group = AnCampaignIntegrationFragment['group'];
  export type MagicTag = AnCampaignIntegrationFragment['magicTag'];
  export type Mappings = AnCampaignIntegrationFragment['mappings'][number];
  export type DefaultEntityType = AnCampaignIntegrationFragment['defaultEntityType'];
}

export namespace GetActionNetworkCustomFields {
  export type Variables = GetActionNetworkCustomFieldsQueryVariables;
  export type Query = GetActionNetworkCustomFieldsQuery;
  export type GetActionNetworkCustomFields = GetActionNetworkCustomFieldsQuery['getActionNetworkCustomFields'][number];
}

export namespace GetActionNetworkEvent {
  export type Variables = GetActionNetworkEventQueryVariables;
  export type Query = GetActionNetworkEventQuery;
  export type GetActionNetworkEvent = GetActionNetworkEventQuery['getActionNetworkEvent'];
}

export namespace GetActionNetworkEvents {
  export type Variables = GetActionNetworkEventsQueryVariables;
  export type Query = GetActionNetworkEventsQuery;
  export type GetActionNetworkEvents = GetActionNetworkEventsQuery['getActionNetworkEvents'];
  export type Nodes = GetActionNetworkEventsQuery['getActionNetworkEvents']['nodes'][number];
}

export namespace GetActionNetworkGroups {
  export type Variables = GetActionNetworkGroupsQueryVariables;
  export type Query = GetActionNetworkGroupsQuery;
  export type GetActionNetworkGroups = GetActionNetworkGroupsQuery['getActionNetworkGroups'][number];
}

export namespace GetActionNetworkTags {
  export type Variables = GetActionNetworkTagsQueryVariables;
  export type Query = GetActionNetworkTagsQuery;
  export type GetActionNetworkTags = GetActionNetworkTagsQuery['getActionNetworkTags'][number];
}

export namespace GetAnCampaignIntegration {
  export type Variables = GetAnCampaignIntegrationQueryVariables;
  export type Query = GetAnCampaignIntegrationQuery;
  export type GetCampaign = GetAnCampaignIntegrationQuery['getCampaign'];
  export type CampaignIntegrations = GetAnCampaignIntegrationQuery['getCampaign']['campaignIntegrations'];
  export type ActionNetwork = GetAnCampaignIntegrationQuery['getCampaign']['campaignIntegrations']['actionNetwork'];
  export type EntityTypes = GetAnCampaignIntegrationQuery['getCampaign']['entityTypes'][number];
}

export namespace RemoveAnIntegrationFromCampaign {
  export type Variables = RemoveAnIntegrationFromCampaignMutationVariables;
  export type Mutation = RemoveAnIntegrationFromCampaignMutation;
  export type RemoveActionNetworkIntegrationFromCampaign = RemoveAnIntegrationFromCampaignMutation['removeActionNetworkIntegrationFromCampaign'];
  export type Campaign = RemoveAnIntegrationFromCampaignMutation['removeActionNetworkIntegrationFromCampaign']['campaign'];
  export type CampaignIntegrations = RemoveAnIntegrationFromCampaignMutation['removeActionNetworkIntegrationFromCampaign']['campaign']['campaignIntegrations'];
  export type ActionNetwork = RemoveAnIntegrationFromCampaignMutation['removeActionNetworkIntegrationFromCampaign']['campaign']['campaignIntegrations']['actionNetwork'];
}

export namespace RemoveAnTagMapping {
  export type Variables = RemoveAnTagMappingMutationVariables;
  export type Mutation = RemoveAnTagMappingMutation;
  export type RemoveActionNetworkCampaignTagMapping = RemoveAnTagMappingMutation['removeActionNetworkCampaignTagMapping'];
  export type ActionNetworkTagMapping = RemoveAnTagMappingMutation['removeActionNetworkCampaignTagMapping']['actionNetworkTagMapping'];
}

export namespace UpdateAnCampaignIntegration {
  export type Variables = UpdateAnCampaignIntegrationMutationVariables;
  export type Mutation = UpdateAnCampaignIntegrationMutation;
  export type UpdateActionNetworkIntegration = UpdateAnCampaignIntegrationMutation['updateActionNetworkIntegration'];
  export type Integration = UpdateAnCampaignIntegrationMutation['updateActionNetworkIntegration']['integration'];
}

export namespace AddApiKey {
  export type Variables = AddApiKeyMutationVariables;
  export type Mutation = AddApiKeyMutation;
  export type AddApiKey = AddApiKeyMutation['addApiKey'];
  export type ApiKey = AddApiKeyMutation['addApiKey']['apiKey'];
}

export namespace ApiKeyDetails {
  export type Fragment = ApiKeyDetailsFragment;
}

export namespace GetApiKeys {
  export type Variables = GetApiKeysQueryVariables;
  export type Query = GetApiKeysQuery;
  export type GetApiKeys = GetApiKeysQuery['getApiKeys'][number];
}

export namespace RevokeApiKey {
  export type Variables = RevokeApiKeyMutationVariables;
  export type Mutation = RevokeApiKeyMutation;
  export type RevokeApiKey = RevokeApiKeyMutation['revokeApiKey'];
  export type ApiKey = RevokeApiKeyMutation['revokeApiKey']['apiKey'];
}

export namespace ActionEntityPrintViewDetails {
  export type Fragment = ActionEntityPrintViewDetailsFragment;
  export type Entity = ActionEntityPrintViewDetailsFragment['entity'];
  export type TagsInCategories = ActionEntityPrintViewDetailsFragment['entity']['tagsInCategories'][number];
  export type EntityConnectionCount = ActionEntityPrintViewDetailsFragment['entity']['entityConnectionCount'][number];
  export type Tasks = ActionEntityPrintViewDetailsFragment['tasks'][number];
  export type ActionField = ActionEntityPrintViewDetailsFragment['tasks'][number]['actionField'];
}

export namespace GetActionEntitiesByIdPrint {
  export type Variables = GetActionEntitiesByIdPrintQueryVariables;
  export type Query = GetActionEntitiesByIdPrintQuery;
  export type GetActionEntities = GetActionEntitiesByIdPrintQuery['getActionEntities'][number];
}

export namespace GetEntitiesByIdsPrint {
  export type Variables = GetEntitiesByIdsPrintQueryVariables;
  export type Query = GetEntitiesByIdsPrintQuery;
  export type GetEntitiesByIds = GetEntitiesByIdsPrintQuery['getEntitiesByIds'][number];
}

export namespace EntityPrintDetails {
  export type Fragment = EntityPrintDetailsFragment;
  export type AppliedToplines = EntityPrintDetailsFragment['appliedToplines'];
  export type Item0 = EntityPrintDetailsFragment['appliedToplines']['item0'];
  export type Item1 = EntityPrintDetailsFragment['appliedToplines']['item1'];
  export type Item2 = EntityPrintDetailsFragment['appliedToplines']['item2'];
  export type Item3 = EntityPrintDetailsFragment['appliedToplines']['item3'];
  export type Item4 = EntityPrintDetailsFragment['appliedToplines']['item4'];
  export type Item5 = EntityPrintDetailsFragment['appliedToplines']['item5'];
}

export namespace CompactedToplineInfo {
  export type Fragment = CompactedToplineInfoFragment;
  export type AppliedToplineValue = CompactedToplineInfoFragment['appliedToplineValue'];
  export type ToplineAppliedEntityConnectionsInlineFragment = (DiscriminateUnion<CompactedToplineInfoFragment['appliedToplineValue'], { __typename?: 'ToplineAppliedEntityConnections' }>);
  export type EntityConnections = (DiscriminateUnion<CompactedToplineInfoFragment['appliedToplineValue'], { __typename?: 'ToplineAppliedEntityConnections' }>)['entityConnections'][number];
  export type Entity1 = (DiscriminateUnion<CompactedToplineInfoFragment['appliedToplineValue'], { __typename?: 'ToplineAppliedEntityConnections' }>)['entityConnections'][number]['entity1'];
  export type Entity2 = (DiscriminateUnion<CompactedToplineInfoFragment['appliedToplineValue'], { __typename?: 'ToplineAppliedEntityConnections' }>)['entityConnections'][number]['entity2'];
  export type AppliedToplines = (DiscriminateUnion<CompactedToplineInfoFragment['appliedToplineValue'], { __typename?: 'ToplineAppliedEntityConnections' }>)['entityConnections'][number]['appliedToplines'];
  export type Item0 = (DiscriminateUnion<CompactedToplineInfoFragment['appliedToplineValue'], { __typename?: 'ToplineAppliedEntityConnections' }>)['entityConnections'][number]['appliedToplines']['item0'];
  export type ToplineAppliedTagsInlineFragment = (DiscriminateUnion<CompactedToplineInfoFragment['appliedToplineValue'], { __typename?: 'ToplineAppliedTags' }>);
  export type AppliedTags = (DiscriminateUnion<CompactedToplineInfoFragment['appliedToplineValue'], { __typename?: 'ToplineAppliedTags' }>)['appliedTags'][number];
}

export namespace AppliedTagToplineValuePrint {
  export type Fragment = AppliedTagToplineValuePrintFragment;
  export type AppliedToplineValue = AppliedTagToplineValuePrintFragment['appliedToplineValue'];
  export type ToplineAppliedTagsInlineFragment = (DiscriminateUnion<AppliedTagToplineValuePrintFragment['appliedToplineValue'], { __typename?: 'ToplineAppliedTags' }>);
  export type AppliedTags = (DiscriminateUnion<AppliedTagToplineValuePrintFragment['appliedToplineValue'], { __typename?: 'ToplineAppliedTags' }>)['appliedTags'][number];
}

export namespace WithConnectionTags {
  export type Fragment = WithConnectionTagsFragment;
  export type AppliedToplineValue = WithConnectionTagsFragment['appliedToplineValue'];
  export type ToplineAppliedEntityConnectionsInlineFragment = (DiscriminateUnion<WithConnectionTagsFragment['appliedToplineValue'], { __typename?: 'ToplineAppliedEntityConnections' }>);
  export type EntityConnections = (DiscriminateUnion<WithConnectionTagsFragment['appliedToplineValue'], { __typename?: 'ToplineAppliedEntityConnections' }>)['entityConnections'][number];
  export type Entity1 = (DiscriminateUnion<WithConnectionTagsFragment['appliedToplineValue'], { __typename?: 'ToplineAppliedEntityConnections' }>)['entityConnections'][number]['entity1'];
  export type Entity2 = (DiscriminateUnion<WithConnectionTagsFragment['appliedToplineValue'], { __typename?: 'ToplineAppliedEntityConnections' }>)['entityConnections'][number]['entity2'];
  export type AppliedToplines = (DiscriminateUnion<WithConnectionTagsFragment['appliedToplineValue'], { __typename?: 'ToplineAppliedEntityConnections' }>)['entityConnections'][number]['appliedToplines'];
  export type Item1 = (DiscriminateUnion<WithConnectionTagsFragment['appliedToplineValue'], { __typename?: 'ToplineAppliedEntityConnections' }>)['entityConnections'][number]['appliedToplines']['item1'];
  export type Item2 = (DiscriminateUnion<WithConnectionTagsFragment['appliedToplineValue'], { __typename?: 'ToplineAppliedEntityConnections' }>)['entityConnections'][number]['appliedToplines']['item2'];
  export type Item3 = (DiscriminateUnion<WithConnectionTagsFragment['appliedToplineValue'], { __typename?: 'ToplineAppliedEntityConnections' }>)['entityConnections'][number]['appliedToplines']['item3'];
  export type Item4 = (DiscriminateUnion<WithConnectionTagsFragment['appliedToplineValue'], { __typename?: 'ToplineAppliedEntityConnections' }>)['entityConnections'][number]['appliedToplines']['item4'];
  export type Item5 = (DiscriminateUnion<WithConnectionTagsFragment['appliedToplineValue'], { __typename?: 'ToplineAppliedEntityConnections' }>)['entityConnections'][number]['appliedToplines']['item5'];
}

export namespace EntityPrintBase {
  export type Fragment = EntityPrintBaseFragment;
  export type EntityLanguages = EntityPrintBaseFragment['entityLanguages'][number];
  export type ActiveFollowUp = EntityPrintBaseFragment['activeFollowUp'];
  export type MostRecentNote = EntityPrintBaseFragment['mostRecentNote'];
  export type CreatedBy = EntityPrintBaseFragment['mostRecentNote']['createdBy'];
  export type AppliedToplines = EntityPrintBaseFragment['appliedToplines'];
  export type Item0 = EntityPrintBaseFragment['appliedToplines']['item0'];
  export type BestAddress = EntityPrintBaseFragment['bestAddress'];
  export type BestPhoneNumber = EntityPrintBaseFragment['bestPhoneNumber'];
  export type BestEmail = EntityPrintBaseFragment['bestEmail'];
}

export namespace FollowUpPrintInfo {
  export type Fragment = FollowUpPrintInfoFragment;
  export type CreatedBy = FollowUpPrintInfoFragment['createdBy'];
  export type Note = FollowUpPrintInfoFragment['note'];
}

export namespace TagPrintInfo {
  export type Fragment = TagPrintInfoFragment;
  export type Category = TagPrintInfoFragment['category'];
  export type AddressTagInlineFragment = (DiscriminateUnion<TagPrintInfoFragment, { __typename?: 'AddressTag' }>);
  export type Address = (DiscriminateUnion<TagPrintInfoFragment, { __typename?: 'AddressTag' }>)['address'];
}

export namespace TaggableLogbookPrintInfo {
  export type Fragment = TaggableLogbookPrintInfoFragment;
  export type Tag = TaggableLogbookPrintInfoFragment['tag'];
  export type Notes = TaggableLogbookPrintInfoFragment['notes'][number];
}

export namespace AddressPrintInfo {
  export type Fragment = AddressPrintInfoFragment;
}

export namespace PhonePrintInfo {
  export type Fragment = PhonePrintInfoFragment;
}

export namespace EmailPrintInfo {
  export type Fragment = EmailPrintInfoFragment;
}

export namespace GetEntityConnectionsPrintView {
  export type Variables = GetEntityConnectionsPrintViewQueryVariables;
  export type Query = GetEntityConnectionsPrintViewQuery;
  export type GetEntityConnections = GetEntityConnectionsPrintViewQuery['getEntityConnections'];
  export type Nodes = GetEntityConnectionsPrintViewQuery['getEntityConnections']['nodes'][number];
  export type Entity1 = GetEntityConnectionsPrintViewQuery['getEntityConnections']['nodes'][number]['entity1'];
  export type Entity2 = GetEntityConnectionsPrintViewQuery['getEntityConnections']['nodes'][number]['entity2'];
  export type AppliedToplines = GetEntityConnectionsPrintViewQuery['getEntityConnections']['nodes'][number]['appliedToplines'];
  export type Item0 = GetEntityConnectionsPrintViewQuery['getEntityConnections']['nodes'][number]['appliedToplines']['item0'];
  export type Item1 = GetEntityConnectionsPrintViewQuery['getEntityConnections']['nodes'][number]['appliedToplines']['item1'];
  export type Item2 = GetEntityConnectionsPrintViewQuery['getEntityConnections']['nodes'][number]['appliedToplines']['item2'];
  export type Item3 = GetEntityConnectionsPrintViewQuery['getEntityConnections']['nodes'][number]['appliedToplines']['item3'];
  export type Item4 = GetEntityConnectionsPrintViewQuery['getEntityConnections']['nodes'][number]['appliedToplines']['item4'];
  export type Item5 = GetEntityConnectionsPrintViewQuery['getEntityConnections']['nodes'][number]['appliedToplines']['item5'];
  export type PageInfo = GetEntityConnectionsPrintViewQuery['getEntityConnections']['pageInfo'];
}

export namespace UploadDetails {
  export type Fragment = UploadDetailsFragment;
  export type CreatedBy = UploadDetailsFragment['createdBy'];
  export type Campaign = UploadDetailsFragment['campaign'];
  export type Summary = UploadDetailsFragment['summary'];
}

export namespace GetUploads {
  export type Variables = GetUploadsQueryVariables;
  export type Query = GetUploadsQuery;
  export type GetUploads = GetUploadsQuery['getUploads'];
  export type Nodes = GetUploadsQuery['getUploads']['nodes'][number];
  export type PageInfo = GetUploadsQuery['getUploads']['pageInfo'];
}

export namespace GetUploadByIdQuery {
  export type Variables = GetUploadByIdQueryQueryVariables;
  export type Query = GetUploadByIdQueryQuery;
  export type GetUploadById = GetUploadByIdQueryQuery['getUploadById'];
}

export namespace GetEntityImportFieldsQuery {
  export type Variables = GetEntityImportFieldsQueryQueryVariables;
  export type Query = GetEntityImportFieldsQueryQuery;
  export type GetEntityImportFields = GetEntityImportFieldsQueryQuery['getEntityImportFields'][number];
}

export namespace GetUploadDownloadUrl {
  export type Variables = GetUploadDownloadUrlQueryVariables;
  export type Query = GetUploadDownloadUrlQuery;
  export type GetUploadDownloadUrl = GetUploadDownloadUrlQuery['getUploadDownloadUrl'];
}

export namespace GetUploadErrorsUrl {
  export type Variables = GetUploadErrorsUrlQueryVariables;
  export type Query = GetUploadErrorsUrlQuery;
  export type GetUploadErrorsUrl = GetUploadErrorsUrlQuery['getUploadErrorsUrl'];
}

export namespace ImportDetails {
  export type Fragment = ImportDetailsFragment;
  export type CreatedBy = ImportDetailsFragment['createdBy'];
  export type EntityType = ImportDetailsFragment['entityType'];
  export type Campaign = ImportDetailsFragment['campaign'];
  export type Summary = ImportDetailsFragment['summary'];
}

export namespace CreateImport {
  export type Variables = CreateImportMutationVariables;
  export type Mutation = CreateImportMutation;
  export type CreateImport = CreateImportMutation['createImport'];
  export type Import = CreateImportMutation['createImport']['import'];
}

export namespace DeleteEntities {
  export type Variables = DeleteEntitiesMutationVariables;
  export type Mutation = DeleteEntitiesMutation;
  export type DeleteEntities = DeleteEntitiesMutation['deleteEntities'];
}

export namespace RemoveEntitiesFromCampaigns {
  export type Variables = RemoveEntitiesFromCampaignsMutationVariables;
  export type Mutation = RemoveEntitiesFromCampaignsMutation;
  export type RemoveEntitiesFromCampaigns = RemoveEntitiesFromCampaignsMutation['removeEntitiesFromCampaigns'];
}

export namespace UpdateImport {
  export type Variables = UpdateImportMutationVariables;
  export type Mutation = UpdateImportMutation;
  export type UpdateImport = UpdateImportMutation['updateImport'];
  export type Import = UpdateImportMutation['updateImport']['import'];
}

export namespace GetDeleteEntitiesOperation {
  export type Variables = GetDeleteEntitiesOperationQueryVariables;
  export type Query = GetDeleteEntitiesOperationQuery;
  export type GetDeleteEntitiesOperations = GetDeleteEntitiesOperationQuery['getDeleteEntitiesOperations'];
  export type Nodes = GetDeleteEntitiesOperationQuery['getDeleteEntitiesOperations']['nodes'][number];
  export type CreatedBy = GetDeleteEntitiesOperationQuery['getDeleteEntitiesOperations']['nodes'][number]['createdBy'];
  export type PageInfo = GetDeleteEntitiesOperationQuery['getDeleteEntitiesOperations']['pageInfo'];
}

export namespace GetImportErrorsUrl {
  export type Variables = GetImportErrorsUrlQueryVariables;
  export type Query = GetImportErrorsUrlQuery;
  export type GetImportErrorsUrl = GetImportErrorsUrlQuery['getImportErrorsUrl'];
}

export namespace GetImportDownloadUrl {
  export type Variables = GetImportDownloadUrlQueryVariables;
  export type Query = GetImportDownloadUrlQuery;
  export type GetImportDownloadUrl = GetImportDownloadUrlQuery['getImportDownloadUrl'];
}

export namespace GetImports {
  export type Variables = GetImportsQueryVariables;
  export type Query = GetImportsQuery;
  export type GetImports = GetImportsQuery['getImports'];
  export type Nodes = GetImportsQuery['getImports']['nodes'][number];
  export type PageInfo = GetImportsQuery['getImports']['pageInfo'];
}

export namespace GetRemoveEntitiesFromCampaignsOperations {
  export type Variables = GetRemoveEntitiesFromCampaignsOperationsQueryVariables;
  export type Query = GetRemoveEntitiesFromCampaignsOperationsQuery;
  export type GetRemoveEntitiesFromCampaignsOperations = GetRemoveEntitiesFromCampaignsOperationsQuery['getRemoveEntitiesFromCampaignsOperations'];
  export type Nodes = GetRemoveEntitiesFromCampaignsOperationsQuery['getRemoveEntitiesFromCampaignsOperations']['nodes'][number];
  export type CreatedBy = GetRemoveEntitiesFromCampaignsOperationsQuery['getRemoveEntitiesFromCampaignsOperations']['nodes'][number]['createdBy'];
  export type RemovalCounts = GetRemoveEntitiesFromCampaignsOperationsQuery['getRemoveEntitiesFromCampaignsOperations']['nodes'][number]['removalCounts'][number];
  export type Campaign = GetRemoveEntitiesFromCampaignsOperationsQuery['getRemoveEntitiesFromCampaignsOperations']['nodes'][number]['removalCounts'][number]['campaign'];
  export type PageInfo = GetRemoveEntitiesFromCampaignsOperationsQuery['getRemoveEntitiesFromCampaignsOperations']['pageInfo'];
}

export namespace GetTagCategoriesFast {
  export type Variables = GetTagCategoriesFastQueryVariables;
  export type Query = GetTagCategoriesFastQuery;
  export type GetTagCategories = GetTagCategoriesFastQuery['getTagCategories'];
  export type Nodes = GetTagCategoriesFastQuery['getTagCategories']['nodes'][number];
}

export const AssessmentSettingsFragmentDoc = gql`
    fragment AssessmentSettings on AssessmentInfo {
  isDefault
  numberOfLevels
  descriptions
  detailedDescriptions
  colors
  entityTypeOverrides {
    descriptions
    detailedDescriptions
    entityTypeId
  }
}
    `;
export const EntityTypeDetailsFragmentDoc = gql`
    fragment EntityTypeDetails on EntityType {
  id
  namePlural
  nameSingular
  nameType
  phoneNumberEnabled
  addressEnabled
  languageEnabled
  dateOfBirthEnabled
  socialEnabled
  emailEnabled
  pronounsEnabled
  icon
}
    `;
export const EntityConnectionTypeDetailsFragmentDoc = gql`
    fragment EntityConnectionTypeDetails on EntityConnectionType {
  id
  campaignContextId
  entityType1 {
    ...EntityTypeDetails
  }
  entityType2 {
    ...EntityTypeDetails
  }
  displayPosition
}
    ${EntityTypeDetailsFragmentDoc}`;
export const ToplineSettingItemBasicFragmentDoc = gql`
    fragment ToplineSettingItemBasic on ToplineSettingItem {
  position
  itemType
  itemId
}
    `;
export const ToplineSettingItemDetailsFragmentDoc = gql`
    fragment ToplineSettingItemDetails on ToplineSettingItem {
  ...ToplineSettingItemBasic
  tagCategory {
    id
    campaignContextId
    readonly
    name
    allowToCreateTagType
  }
  entityConnectionType {
    id
    entityType1 {
      id
      namePlural
      nameSingular
    }
    entityType2 {
      id
      namePlural
      nameSingular
    }
  }
}
    ${ToplineSettingItemBasicFragmentDoc}`;
export const CampaignConnectionTypeConfigDetailsFragmentDoc = gql`
    fragment CampaignConnectionTypeConfigDetails on CampaignEntityConnectionTypeConfiguration {
  id
  entityConnectionType {
    ...EntityConnectionTypeDetails
  }
  campaign {
    id
    name
  }
  toplineSettingItems {
    ...ToplineSettingItemDetails
  }
}
    ${EntityConnectionTypeDetailsFragmentDoc}
${ToplineSettingItemDetailsFragmentDoc}`;
export const TagCategoryTagInfoFragmentDoc = gql`
    fragment TagCategoryTagInfo on TagCategory {
  id
  name
  campaignContextId
  hasAssociatedTags
  hasActiveTags
  hasArchivedTags
}
    `;
export const TagCategoryInfoFragmentDoc = gql`
    fragment TagCategoryInfo on TagCategory {
  id
  name
  campaignContextId
  multiselectable
  groupName
  locked
  readonly
  allowToCreateTagType
  multiselectSameTagBehavior
  attachmentsEnabled
  isUniversal
  ...TagCategoryTagInfo
}
    ${TagCategoryTagInfoFragmentDoc}`;
export const CustomFormFieldDetailsFragmentDoc = gql`
    fragment CustomFormFieldDetails on CustomFormField {
  id
  position
  fieldObjectType
  fieldObjectId
  tagCategory {
    ...TagCategoryInfo
  }
  entityConnectionType {
    ...EntityConnectionTypeDetails
  }
  objectData
  objectAttribute
  required
}
    ${TagCategoryInfoFragmentDoc}
${EntityConnectionTypeDetailsFragmentDoc}`;
export const CustomFormDetailsFragmentDoc = gql`
    fragment CustomFormDetails on CustomForm {
  id
  name
  campaignId
  targetType
  targetTypeId
  createdAt
  fields {
    ...CustomFormFieldDetails
  }
}
    ${CustomFormFieldDetailsFragmentDoc}`;
export const CampaignEntityTypeConfigDetailsFragmentDoc = gql`
    fragment CampaignEntityTypeConfigDetails on CampaignEntityTypeConfiguration {
  id
  entityType {
    ...EntityTypeDetails
  }
  campaign {
    id
    name
  }
  toplineSettingItems {
    ...ToplineSettingItemDetails
  }
  defaultTagCategories {
    ...TagCategoryInfo
  }
  creationCustomForm {
    ...CustomFormDetails
  }
  customForm {
    ...CustomFormDetails
  }
  spotlightIcon
  spotlightTags {
    id
    name
  }
}
    ${EntityTypeDetailsFragmentDoc}
${ToplineSettingItemDetailsFragmentDoc}
${TagCategoryInfoFragmentDoc}
${CustomFormDetailsFragmentDoc}`;
export const RestrictedExportingSettingTypeDetailsFragmentDoc = gql`
    fragment RestrictedExportingSettingTypeDetails on RestrictedExportingSettings {
  specializedExportsDisabled
  properties
  tagCategoryIds
}
    `;
export const NoteDetailsFragmentDoc = gql`
    fragment NoteDetails on Note {
  id
  text
  createdAt
  noteType
  createdBy {
    id
    name
    linkedEntityId
  }
  updatedAt
  updatedBy {
    id
    name
    linkedEntityId
  }
  pinnedAt
}
    `;
export const CampaignWithoutTagsFragmentDoc = gql`
    fragment CampaignWithoutTags on Campaign {
  id
  name
  targetNumber
  defaultCountry
  showCustomIds
  showElectoralDistricts
  allowOrganizersToExport
  calendarEventsEnabled
  calendarEventCanvassingType
  defaultHomepage
  activityStreamAsInitialEntityView
  restrictedExportingSettings {
    ...RestrictedExportingSettingTypeDetails
  }
  status
  entityTypes {
    ...EntityTypeDetails
  }
  entityConnectionTypes {
    ...EntityConnectionTypeDetails
  }
  defaultEntityType {
    ...EntityTypeDetails
  }
  supportUser {
    firstName
    lastName
    email
    role
    disabled
    id
    linkedEntityId
  }
  createdBy {
    firstName
    lastName
    id
    linkedEntityId
  }
  notes {
    nodes {
      ...NoteDetails
    }
  }
}
    ${RestrictedExportingSettingTypeDetailsFragmentDoc}
${EntityTypeDetailsFragmentDoc}
${EntityConnectionTypeDetailsFragmentDoc}
${NoteDetailsFragmentDoc}`;
export const EntityConnectionWithNotesFragmentDoc = gql`
    fragment EntityConnectionWithNotes on EntityConnection {
  id
  active
  campaignId
  entityConnectionTypeId
  createdAt
  updatedAt
  notes {
    ...NoteDetails
  }
}
    ${NoteDetailsFragmentDoc}`;
export const EntityConnectionCoreFragmentDoc = gql`
    fragment EntityConnectionCore on EntityConnection {
  id
  active
  campaignId
  entityConnectionTypeId
  entityConnectionTypeName
  createdAt
  updatedAt
  entity1 {
    id
    campaignContextId
    entityTypeId
    currentAssessmentLevel
    spotlightIcon
    firstName
    nickname
    middleName
    lastName
    suffix
    pronouns
  }
  entity2 {
    id
    campaignContextId
    entityTypeId
    currentAssessmentLevel
    spotlightIcon
    firstName
    nickname
    middleName
    lastName
    suffix
    pronouns
  }
}
    `;
export const AttachmentDetailsFragmentDoc = gql`
    fragment AttachmentDetails on Attachment {
  createdAt
  downloadUrl
  id
  mimeType
  name
  size
  updatedAt
}
    `;
export const ShiftInfoFragmentDoc = gql`
    fragment ShiftInfo on Shift {
  id
  timezone
  shiftTimes {
    dayOfWeek
    endTime
    startTime
    timezone
  }
}
    `;
export const AddressDetailsFragmentDoc = gql`
    fragment AddressDetails on Address {
  id
  streetAddress
  country
  city
  state
  zip
  latitude
  longitude
  geocodeBad
  geocodeSource
  accuracy
  accuracyType
  addressType
  electoralDistricts {
    name
    longName
    id
  }
  normalized
  original {
    streetAddress
    city
    state
    zip
    country
  }
  status
  source
  createdAt
  updatedAt
}
    `;
export const TagInfoNoTargetTypeFragmentDoc = gql`
    fragment TagInfoNoTargetType on Tag {
  id
  name
  campaignContextId
  archived
  tagType
  createdAt
  updatedAt
  ... on AddressTag {
    address {
      ...AddressDetails
    }
  }
  category {
    id
    readonly
    name
    groupName
    attachmentsEnabled
  }
}
    ${AddressDetailsFragmentDoc}`;
export const TaggableLogbookDetailsFragmentDoc = gql`
    fragment TaggableLogbookDetails on TaggableLogbook {
  id
  deleted
  targetType
  campaign {
    id
  }
  createdAt
  updatedAt
  attachments {
    ...AttachmentDetails
  }
  notes {
    ...NoteDetails
  }
  shift {
    ...ShiftInfo
  }
  tag {
    ...TagInfoNoTargetType
  }
}
    ${AttachmentDetailsFragmentDoc}
${NoteDetailsFragmentDoc}
${ShiftInfoFragmentDoc}
${TagInfoNoTargetTypeFragmentDoc}`;
export const EntityConnectionWithTagsFragmentDoc = gql`
    fragment EntityConnectionWithTags on EntityConnection {
  ...EntityConnectionCore
  tagsCount
  tags {
    ...TaggableLogbookDetails
  }
}
    ${EntityConnectionCoreFragmentDoc}
${TaggableLogbookDetailsFragmentDoc}`;
export const EmailDetailsFragmentDoc = gql`
    fragment EmailDetails on Email {
  id
  email
  emailType
  status
  source
  subscribed
  createdAt
  updatedAt
}
    `;
export const PhoneDetailsFragmentDoc = gql`
    fragment PhoneDetails on PhoneNumber {
  id
  number
  ext
  numberType
  status
  source
  createdAt
  updatedAt
  subscribed
}
    `;
export const SocialNetworkDetailsFragmentDoc = gql`
    fragment SocialNetworkDetails on SocialNetwork {
  id
  label
  icon
  allowUrls
  labelRequired
}
    `;
export const UserPublicDetailsFragmentDoc = gql`
    fragment UserPublicDetails on UserPublic {
  firstName
  lastName
  email
  linkedEntityId
  id
  name
}
    `;
export const SocialProfileDetailsFragmentDoc = gql`
    fragment SocialProfileDetails on SocialProfile {
  id
  label
  profile
  socialNetwork {
    ...SocialNetworkDetails
  }
  source
  status
  createdBy {
    ...UserPublicDetails
  }
  updatedBy {
    ...UserPublicDetails
  }
  createdAt
  updatedAt
}
    ${SocialNetworkDetailsFragmentDoc}
${UserPublicDetailsFragmentDoc}`;
export const AppliedToplineItemValueFragmentFragmentDoc = gql`
    fragment AppliedToplineItemValueFragment on AppliedToplineItemValue {
  ... on ToplinePreferredLanguage {
    entityLanguages {
      languageCode
      preferred
    }
  }
  ... on ToplineAge {
    dateOfBirth
    age
  }
  ... on Email {
    ...EmailDetails
  }
  ... on Address {
    ...AddressDetails
  }
  ... on PhoneNumber {
    ...PhoneDetails
  }
  ... on Note {
    ...NoteDetails
  }
  ... on SocialProfile {
    ...SocialProfileDetails
  }
  ... on ToplineAppliedTags {
    appliedTags {
      ...TaggableLogbookDetails
    }
  }
  ... on ToplineAppliedEntityConnections {
    entityConnections {
      ...EntityConnectionCore
    }
  }
}
    ${EmailDetailsFragmentDoc}
${AddressDetailsFragmentDoc}
${PhoneDetailsFragmentDoc}
${NoteDetailsFragmentDoc}
${SocialProfileDetailsFragmentDoc}
${TaggableLogbookDetailsFragmentDoc}
${EntityConnectionCoreFragmentDoc}`;
export const AppliedToplineItemFragmentFragmentDoc = gql`
    fragment AppliedToplineItemFragment on AppliedToplineItem {
  toplineItem {
    ...ToplineSettingItemBasic
  }
  appliedToplineValue {
    ...AppliedToplineItemValueFragment
  }
}
    ${ToplineSettingItemBasicFragmentDoc}
${AppliedToplineItemValueFragmentFragmentDoc}`;
export const HighlightedToplineForConnectionFragmentDoc = gql`
    fragment HighlightedToplineForConnection on AppliedToplines {
  id
  campaignContextId
  item0 {
    ...AppliedToplineItemFragment
  }
}
    ${AppliedToplineItemFragmentFragmentDoc}`;
export const EntityConnectionWithHighlightedToplineFragmentDoc = gql`
    fragment EntityConnectionWithHighlightedTopline on EntityConnection {
  id
  appliedToplines {
    ...HighlightedToplineForConnection
  }
}
    ${HighlightedToplineForConnectionFragmentDoc}`;
export const AppliedToplineValueWithConnectionHighlightedToplineFragmentDoc = gql`
    fragment AppliedToplineValueWithConnectionHighlightedTopline on AppliedToplineItemValue {
  ... on ToplineAppliedEntityConnections {
    entityConnections {
      ...EntityConnectionWithHighlightedTopline
    }
  }
}
    ${EntityConnectionWithHighlightedToplineFragmentDoc}`;
export const HighlightedToplineForEntityFragmentDoc = gql`
    fragment HighlightedToplineForEntity on AppliedToplines {
  id
  campaignContextId
  item0 {
    ...AppliedToplineItemFragment
    appliedToplineValue {
      ...AppliedToplineValueWithConnectionHighlightedTopline
    }
  }
}
    ${AppliedToplineItemFragmentFragmentDoc}
${AppliedToplineValueWithConnectionHighlightedToplineFragmentDoc}`;
export const EntityWithHighlightedToplineFragmentDoc = gql`
    fragment EntityWithHighlightedTopline on Entity {
  campaignContextId
  id
  appliedToplines {
    ...HighlightedToplineForEntity
  }
}
    ${HighlightedToplineForEntityFragmentDoc}`;
export const AppliedToplinesFragmentFragmentDoc = gql`
    fragment AppliedToplinesFragment on AppliedToplines {
  id
  campaignContextId
  item1 {
    ...AppliedToplineItemFragment
  }
  item2 {
    ...AppliedToplineItemFragment
  }
  item3 {
    ...AppliedToplineItemFragment
  }
  item4 {
    ...AppliedToplineItemFragment
  }
  item5 {
    ...AppliedToplineItemFragment
  }
}
    ${AppliedToplineItemFragmentFragmentDoc}`;
export const EntityConnectionWithToplinesFragmentDoc = gql`
    fragment EntityConnectionWithToplines on EntityConnection {
  id
  ...EntityConnectionWithHighlightedTopline
  appliedToplines {
    ...AppliedToplinesFragment
  }
}
    ${EntityConnectionWithHighlightedToplineFragmentDoc}
${AppliedToplinesFragmentFragmentDoc}`;
export const AppliedToplineValueWithConnectionToplinesFragmentDoc = gql`
    fragment AppliedToplineValueWithConnectionToplines on AppliedToplineItemValue {
  ... on ToplineAppliedEntityConnections {
    entityConnections {
      ...EntityConnectionWithToplines
    }
  }
}
    ${EntityConnectionWithToplinesFragmentDoc}`;
export const AppliedToplineItemWithConnectionToplinesFragmentDoc = gql`
    fragment AppliedToplineItemWithConnectionToplines on AppliedToplineItem {
  toplineItem {
    ...ToplineSettingItemBasic
  }
  appliedToplineValue {
    ...AppliedToplineValueWithConnectionToplines
  }
}
    ${ToplineSettingItemBasicFragmentDoc}
${AppliedToplineValueWithConnectionToplinesFragmentDoc}`;
export const EntityWithToplinesFragmentDoc = gql`
    fragment EntityWithToplines on Entity {
  campaignContextId
  id
  ...EntityWithHighlightedTopline
  appliedToplines {
    ...AppliedToplinesFragment
    item1 {
      ...AppliedToplineItemWithConnectionToplines
    }
    item2 {
      ...AppliedToplineItemWithConnectionToplines
    }
    item3 {
      ...AppliedToplineItemWithConnectionToplines
    }
    item4 {
      ...AppliedToplineItemWithConnectionToplines
    }
    item5 {
      ...AppliedToplineItemWithConnectionToplines
    }
  }
}
    ${EntityWithHighlightedToplineFragmentDoc}
${AppliedToplinesFragmentFragmentDoc}
${AppliedToplineItemWithConnectionToplinesFragmentDoc}`;
export const EntityCoreFragmentDoc = gql`
    fragment EntityCore on Entity {
  campaignContextId
  id
  entityTypeId
  updatedAt
  spotlightIcon
}
    `;
export const EntityWithBestAddressFragmentDoc = gql`
    fragment EntityWithBestAddress on Entity {
  bestAddress {
    ...AddressDetails
  }
}
    ${AddressDetailsFragmentDoc}`;
export const EntityWithBestEmailFragmentDoc = gql`
    fragment EntityWithBestEmail on Entity {
  bestEmail {
    ...EmailDetails
  }
}
    ${EmailDetailsFragmentDoc}`;
export const EntityWithBestPhoneFragmentDoc = gql`
    fragment EntityWithBestPhone on Entity {
  bestPhoneNumber {
    ...PhoneDetails
  }
}
    ${PhoneDetailsFragmentDoc}`;
export const EntityWithContactIconsFragmentDoc = gql`
    fragment EntityWithContactIcons on Entity {
  ...EntityCore
  ...EntityWithBestAddress
  ...EntityWithBestEmail
  ...EntityWithBestPhone
}
    ${EntityCoreFragmentDoc}
${EntityWithBestAddressFragmentDoc}
${EntityWithBestEmailFragmentDoc}
${EntityWithBestPhoneFragmentDoc}`;
export const EntityWithLinkedUserIdFragmentDoc = gql`
    fragment EntityWithLinkedUserId on Entity {
  linkedUserId
}
    `;
export const EntityPublicInfoFragmentDoc = gql`
    fragment EntityPublicInfo on EntityPublic {
  id
  campaignContextId
  entityTypeId
  currentAssessmentLevel
  spotlightIcon
  firstName
  nickname
  middleName
  lastName
  pronouns
  suffix
  bestAddress {
    ...AddressDetails
  }
  bestPhoneNumber {
    ...PhoneDetails
  }
  bestEmail {
    ...EmailDetails
  }
}
    ${AddressDetailsFragmentDoc}
${PhoneDetailsFragmentDoc}
${EmailDetailsFragmentDoc}`;
export const EntityPublicWithCampaignsFragmentDoc = gql`
    fragment EntityPublicWithCampaigns on EntityPublic {
  id
  campaignContextId
  campaigns {
    id
    name
  }
}
    `;
export const EntityWithAssessmentsFragmentDoc = gql`
    fragment EntityWithAssessments on Entity {
  ...EntityCore
  currentAssessmentLevel
  assessments {
    id
    level
    createdAt
    createdBy {
      id
      name
    }
  }
}
    ${EntityCoreFragmentDoc}`;
export const EntityWithBasicInfoFragmentDoc = gql`
    fragment EntityWithBasicInfo on Entity {
  firstName
  middleName
  lastName
  nickname
  suffix
  currentAssessmentLevel
  followUp
  dateOfBirth
  age
  calculatedBirthDate
  entityLanguages {
    languageCode
    preferred
  }
  linkedUserId
  spotlightIcon
  pronouns
}
    `;
export const EntityWithCalendarEventCountsFragmentDoc = gql`
    fragment EntityWithCalendarEventCounts on Entity {
  calendarEventResponseCounts {
    past {
      attended
      doubleConfirmed
      confirmed
      rsvp
    }
    upcoming {
      attended
      doubleConfirmed
      confirmed
      rsvp
    }
  }
}
    `;
export const CalendarEventBaseFragmentDoc = gql`
    fragment CalendarEventBase on CalendarEvent {
  campaignId
  createdAt
  createdBy {
    ...UserPublicDetails
  }
  id
  name
  entityType {
    id
    namePlural
    nameSingular
  }
  startDate
  endDate
  locationType
  address {
    ...AddressDetails
  }
  timeZone
  locationNote
  description
  actionNetworkEventId
}
    ${UserPublicDetailsFragmentDoc}
${AddressDetailsFragmentDoc}`;
export const CalendarEventWithUsersAndCountsFragmentDoc = gql`
    fragment CalendarEventWithUsersAndCounts on CalendarEvent {
  ...CalendarEventBase
  assignedUsers {
    nodes {
      ...UserPublicDetails
    }
  }
  responseCounts {
    confirmed
    attended
    declined
    noShow
    doubleConfirmed
    rsvp
    tentative
  }
}
    ${CalendarEventBaseFragmentDoc}
${UserPublicDetailsFragmentDoc}`;
export const CalendarEventResponseCoreFragmentDoc = gql`
    fragment CalendarEventResponseCore on CalendarEventResponse {
  appliedTags {
    ...TaggableLogbookDetails
  }
  calendarEvent {
    ...CalendarEventWithUsersAndCounts
  }
  campaign {
    id
  }
  createdBy {
    ...UserPublicDetails
  }
  id
  respondedAt
  status
  updatedBy {
    ...UserPublicDetails
  }
}
    ${TaggableLogbookDetailsFragmentDoc}
${CalendarEventWithUsersAndCountsFragmentDoc}
${UserPublicDetailsFragmentDoc}`;
export const EntityWithCalendarResponsesFragmentDoc = gql`
    fragment EntityWithCalendarResponses on Entity {
  calendarEventResponses {
    ...CalendarEventResponseCore
  }
}
    ${CalendarEventResponseCoreFragmentDoc}`;
export const EntityWithCampaignsFragmentDoc = gql`
    fragment EntityWithCampaigns on Entity {
  campaigns {
    id
    name
  }
}
    `;
export const EntityWithEmailsFragmentDoc = gql`
    fragment EntityWithEmails on Entity {
  ...EntityCore
  emails {
    ...EmailDetails
  }
}
    ${EntityCoreFragmentDoc}
${EmailDetailsFragmentDoc}`;
export const EntityWithEntityTypeFragmentDoc = gql`
    fragment EntityWithEntityType on Entity {
  entityType {
    ...EntityTypeDetails
  }
}
    ${EntityTypeDetailsFragmentDoc}`;
export const FollowUpDetailsFragmentDoc = gql`
    fragment FollowUpDetails on FollowUp {
  active
  id
  campaignId
  createdAt
  assignedUser {
    ...UserPublicDetails
  }
  createdBy {
    ...UserPublicDetails
  }
  completedAt
  completedBy {
    ...UserPublicDetails
  }
  note {
    ...NoteDetails
  }
  dueDate
}
    ${UserPublicDetailsFragmentDoc}
${NoteDetailsFragmentDoc}`;
export const EntityWithFollowUpDetailsFragmentDoc = gql`
    fragment EntityWithFollowUpDetails on Entity {
  followUp
  activeFollowUp {
    ...FollowUpDetails
  }
}
    ${FollowUpDetailsFragmentDoc}`;
export const CustomIdTypeDetailsFragmentDoc = gql`
    fragment CustomIdTypeDetails on CustomIdType {
  id
  internalName
  label
  active
}
    `;
export const EntityCustomIdDetailsFragmentDoc = gql`
    fragment EntityCustomIdDetails on EntityCustomId {
  id
  value
  customIdType {
    ...CustomIdTypeDetails
  }
}
    ${CustomIdTypeDetailsFragmentDoc}`;
export const EntityWithIdsFragmentDoc = gql`
    fragment EntityWithIds on Entity {
  ...EntityCore
  actionBuilderId
  dwId
  voterbaseId
  customId
  customId1
  customId2
  customId3
  customId4
  entityCustomIds {
    ...EntityCustomIdDetails
  }
}
    ${EntityCoreFragmentDoc}
${EntityCustomIdDetailsFragmentDoc}`;
export const EntityWithAddressesFragmentDoc = gql`
    fragment EntityWithAddresses on Entity {
  ...EntityCore
  addresses {
    ...AddressDetails
  }
}
    ${EntityCoreFragmentDoc}
${AddressDetailsFragmentDoc}`;
export const EntityConnectionCountMapViewFragmentDoc = gql`
    fragment EntityConnectionCountMapView on EntityConnectionCount {
  activeConnectionsCount
  inactiveConnectionsCount
  entityConnectionType {
    id
    entityType1Id
    entityType2Id
  }
}
    `;
export const EntityWithConnectionCountsFragmentDoc = gql`
    fragment EntityWithConnectionCounts on Entity {
  ...EntityCore
  entityConnectionCount {
    ...EntityConnectionCountMapView
  }
}
    ${EntityCoreFragmentDoc}
${EntityConnectionCountMapViewFragmentDoc}`;
export const EntityWithMapViewDetailsFragmentDoc = gql`
    fragment EntityWithMapViewDetails on Entity {
  ...EntityCore
  currentAssessmentLevel
  entityType {
    id
    icon
  }
  ...EntityWithAddresses
  ...EntityWithConnectionCounts
}
    ${EntityCoreFragmentDoc}
${EntityWithAddressesFragmentDoc}
${EntityWithConnectionCountsFragmentDoc}`;
export const EntityWithNotesFragmentDoc = gql`
    fragment EntityWithNotes on Entity {
  ...EntityCore
  notes {
    ...NoteDetails
  }
}
    ${EntityCoreFragmentDoc}
${NoteDetailsFragmentDoc}`;
export const EntityWithPhonesFragmentDoc = gql`
    fragment EntityWithPhones on Entity {
  ...EntityCore
  phoneNumbers {
    ...PhoneDetails
  }
}
    ${EntityCoreFragmentDoc}
${PhoneDetailsFragmentDoc}`;
export const EntityWithSocialProfilesFragmentDoc = gql`
    fragment EntityWithSocialProfiles on Entity {
  ...EntityCore
  socialProfiles {
    ...SocialProfileDetails
  }
}
    ${EntityCoreFragmentDoc}
${SocialProfileDetailsFragmentDoc}`;
export const EntityWithTagsFragmentDoc = gql`
    fragment EntityWithTags on Entity {
  ...EntityCore
  tagsCount
  tags {
    ...TaggableLogbookDetails
  }
}
    ${EntityCoreFragmentDoc}
${TaggableLogbookDetailsFragmentDoc}`;
export const CalendarEventActionCoreFragmentDoc = gql`
    fragment CalendarEventActionCore on CalendarEventAction {
  id
  actionPurpose
  scheduleCreateDaysBeforeEventStart
  calendarEvent {
    ...CalendarEventWithUsersAndCounts
  }
}
    ${CalendarEventWithUsersAndCountsFragmentDoc}`;
export const ActionCountsFragmentDoc = gql`
    fragment ActionCounts on Action {
  id
  targetsCount
  targetsCompleted
  targetsPending
  targetsAllPendingCount
  contactAttemptsContactedCount
  contactAttemptsCount
}
    `;
export const ActionFieldDetailsFragmentDoc = gql`
    fragment ActionFieldDetails on ActionField {
  id
  objectType
  objectAttribute
  relatedObjectId
  relatedObjectType
  defaultResponseId
  position
  isOptional
  createdAt
  updatedAt
  quickCheckIn
  tagCategory {
    ...TagCategoryInfo
  }
  entityConnectionType {
    ...EntityConnectionTypeDetails
  }
  defaultResponse {
    id
    name
    tagType
    category {
      id
      name
    }
  }
  calendarEventAction {
    ...CalendarEventActionCore
  }
  calendarEvent {
    ...CalendarEventBase
  }
}
    ${TagCategoryInfoFragmentDoc}
${EntityConnectionTypeDetailsFragmentDoc}
${CalendarEventActionCoreFragmentDoc}
${CalendarEventBaseFragmentDoc}`;
export const ActionAssignmentGroupCountsFragmentDoc = gql`
    fragment ActionAssignmentGroupCounts on ActionAssignmentGroup {
  id
  name
  targetsCount
  uniqueGeocodesForBestAddressesCount
  targetsWithAllTasksCompletedCount
  targetsWithSomeTasksCompletedCount
  targetsWithNoTasksCompletedCount
  contactAttemptsContactedCount
  contactAttemptsCount
}
    `;
export const ActionDetailsFragmentDoc = gql`
    fragment ActionDetails on Action {
  id
  name
  text
  dueDate
  active
  targetsQueryJson
  canvassingType
  householdingEnabled
  notificationEnabled
  ...ActionCounts
  entityType {
    ...EntityTypeDetails
  }
  actionFields {
    ...ActionFieldDetails
  }
  actionAssignmentGroups {
    id
    name
    ...ActionAssignmentGroupCounts
    users {
      id
      firstName
      lastName
      email
    }
  }
  campaign {
    id
  }
  createdBy {
    ...UserPublicDetails
  }
}
    ${ActionCountsFragmentDoc}
${EntityTypeDetailsFragmentDoc}
${ActionFieldDetailsFragmentDoc}
${ActionAssignmentGroupCountsFragmentDoc}
${UserPublicDetailsFragmentDoc}`;
export const CalendarEventActionDetailsFragmentDoc = gql`
    fragment CalendarEventActionDetails on CalendarEventAction {
  ...CalendarEventActionCore
  action {
    ...ActionDetails
  }
}
    ${CalendarEventActionCoreFragmentDoc}
${ActionDetailsFragmentDoc}`;
export const CalendarEventDetailsFragmentDoc = gql`
    fragment CalendarEventDetails on CalendarEvent {
  ...CalendarEventWithUsersAndCounts
  calendarEventActions {
    ...CalendarEventActionDetails
  }
}
    ${CalendarEventWithUsersAndCountsFragmentDoc}
${CalendarEventActionDetailsFragmentDoc}`;
export const EventWithEntityResponseFragmentDoc = gql`
    fragment EventWithEntityResponse on CalendarEvent {
  entityResponse(entityId: $isInCampaignId) {
    id
    campaignContextId
    status
  }
}
    `;
export const OrganizationDetailsFragmentDoc = gql`
    fragment OrganizationDetails on Organization {
  name
  defaultCountry
  administratorUser {
    id
    firstName
    lastName
    email
    confirmed
    role
    disabled
  }
  mfaRequired
}
    `;
export const SavedQueryDetailsFragmentDoc = gql`
    fragment SavedQueryDetails on SavedQuery {
  id
  name
  body
  public
  createdAt
  updatedAt
  defaultQuery
  ownedByCurrentUser
  queryType
  canEdit
  user {
    id
    firstName
    lastName
    name
  }
}
    `;
export const TagCategoryOnlyFragmentDoc = gql`
    fragment TagCategoryOnly on TagCategory {
  id
  name
  campaignContextId
  multiselectable
  groupName
  locked
  readonly
  allowToCreateTagType
  multiselectSameTagBehavior
  attachmentsEnabled
  isUniversal
}
    `;
export const TagGroupInfoFragmentDoc = gql`
    fragment TagGroupInfo on TagGroup {
  id
  name
  campaignContextId
  isUniversal
  targetType {
    ... on EntityType {
      id
      namePlural
      nameSingular
    }
    ... on EntityConnectionType {
      id
      campaignContextId
      entityType1 {
        id
        namePlural
        nameSingular
      }
      entityType2 {
        id
        namePlural
        nameSingular
      }
    }
  }
  categories {
    ...TagCategoryInfo
  }
}
    ${TagCategoryInfoFragmentDoc}`;
export const TagInfoForQueryBuilderFragmentDoc = gql`
    fragment TagInfoForQueryBuilder on Tag {
  id
  campaignContextId
  tagType
  name
  targetType {
    ... on EntityType {
      id
      namePlural
      nameSingular
    }
    ... on EntityConnectionType {
      id
      campaignContextId
      entityType1 {
        id
        namePlural
        nameSingular
      }
      entityType2 {
        id
        namePlural
        nameSingular
      }
    }
  }
  category {
    campaignContextId
    id
    name
    readonly
    group {
      id
      name
    }
  }
}
    `;
export const TagInfoFragmentDoc = gql`
    fragment TagInfo on Tag {
  ...TagInfoNoTargetType
  isUniversal
  targetType {
    ... on EntityType {
      id
      namePlural
      nameSingular
    }
    ... on EntityConnectionType {
      id
      campaignContextId
      entityType1 {
        id
        namePlural
        nameSingular
      }
      entityType2 {
        id
        namePlural
        nameSingular
      }
    }
  }
}
    ${TagInfoNoTargetTypeFragmentDoc}`;
export const TagWithIsInCampaignFragmentDoc = gql`
    fragment TagWithIsInCampaign on Tag {
  isInCampaign(campaignId: $isInCampaignId)
  category {
    id
    isInCampaign(campaignId: $isInCampaignId)
    group {
      id
      isInCampaign(campaignId: $isInCampaignId)
    }
  }
}
    `;
export const UserDetailsFragmentDoc = gql`
    fragment UserDetails on User {
  id
  role
  disabled
  disableOn
  createdAt
  confirmed
  mfaRequired
  mfaFactor {
    factorType
    id
    status
  }
  campaigns {
    id
    name
  }
  email
  firstName
  lastName
  phoneNumber
  lastLogin
  linkedEntityId
}
    `;
export const UserWithTurfAssignmentsFragmentDoc = gql`
    fragment UserWithTurfAssignments on User {
  id
  turfAssignments {
    id
    restrictionEnabled
    campaign {
      id
    }
    turfTags {
      id
      tag {
        id
      }
    }
  }
}
    `;
export const ActionAssignmentGroupInfoFragmentDoc = gql`
    fragment ActionAssignmentGroupInfo on ActionAssignmentGroup {
  ...ActionAssignmentGroupCounts
  isRoutable
  action {
    canvassingType
    id
    name
    dueDate
    createdBy {
      ...UserPublicDetails
    }
    actionFields {
      calendarEventAction {
        calendarEvent {
          startDate
          endDate
        }
      }
    }
  }
  users {
    id
    firstName
    lastName
    email
  }
}
    ${ActionAssignmentGroupCountsFragmentDoc}
${UserPublicDetailsFragmentDoc}`;
export const ActionAssignmentGroupTargetIdsFragmentDoc = gql`
    fragment ActionAssignmentGroupTargetIds on ActionAssignmentGroup {
  targetIds(limit: 3000)
}
    `;
export const AssignmentRoutingOptionsDetailsFragmentDoc = gql`
    fragment AssignmentRoutingOptionsDetails on AssignmentRoutingOptions {
  id
  excludeCompletedActions
  startAddress {
    ...AddressDetails
  }
  endAddress {
    ...AddressDetails
  }
  actionEntityRoutePairs {
    address {
      ...AddressDetails
    }
    matches {
      actionEntity {
        id
        completed
      }
      firstMatchedAddressId
    }
  }
}
    ${AddressDetailsFragmentDoc}`;
export const ContactAttemptBasicFragmentDoc = gql`
    fragment ContactAttemptBasic on ContactAttempt {
  id
  createdAt
  disposition
  contactInfoId
  contactInfoType
}
    `;
export const ContactAttemptDetailsFragmentDoc = gql`
    fragment ContactAttemptDetails on ContactAttempt {
  ...ContactAttemptBasic
  phoneNumber {
    ...PhoneDetails
  }
  address {
    ...AddressDetails
  }
}
    ${ContactAttemptBasicFragmentDoc}
${PhoneDetailsFragmentDoc}
${AddressDetailsFragmentDoc}`;
export const SmallActionEntityFragmentDoc = gql`
    fragment SmallActionEntity on ActionEntity {
  id
  entity {
    campaignContextId
    id
  }
}
    `;
export const ActionNetworkGroupInfoFragmentDoc = gql`
    fragment ActionNetworkGroupInfo on ActionNetworkGroup {
  id
  name
  groupId
}
    `;
export const ActionNetworkTagMappingInfoFragmentDoc = gql`
    fragment ActionNetworkTagMappingInfo on ActionNetworkTagMapping {
  actionBuilder {
    id
    name
    archived
    category {
      id
      name
    }
    group {
      id
      name
    }
  }
  actionNetwork {
    customField
    tagId
  }
}
    `;
export const AnCampaignIntegrationFragmentDoc = gql`
    fragment ANCampaignIntegration on ActionNetworkIntegration {
  id
  group {
    ...ActionNetworkGroupInfo
  }
  magicTag {
    name
    uuid
  }
  mappings {
    ...ActionNetworkTagMappingInfo
  }
  defaultEntityType {
    ...EntityTypeDetails
  }
  eventSyncEnabled
}
    ${ActionNetworkGroupInfoFragmentDoc}
${ActionNetworkTagMappingInfoFragmentDoc}
${EntityTypeDetailsFragmentDoc}`;
export const ApiKeyDetailsFragmentDoc = gql`
    fragment ApiKeyDetails on APIKey {
  id
  apiKey
  target
}
    `;
export const FollowUpPrintInfoFragmentDoc = gql`
    fragment FollowUpPrintInfo on FollowUp {
  id
  active
  createdAt
  createdBy {
    id
    name
  }
  note {
    id
    text
  }
}
    `;
export const AddressPrintInfoFragmentDoc = gql`
    fragment AddressPrintInfo on Address {
  id
  status
  streetAddress
  addressType
  city
  state
  zip
  updatedAt
  country
}
    `;
export const TagPrintInfoFragmentDoc = gql`
    fragment TagPrintInfo on Tag {
  id
  tagType
  name
  category {
    id
    name
  }
  ... on AddressTag {
    address {
      ...AddressPrintInfo
    }
  }
}
    ${AddressPrintInfoFragmentDoc}`;
export const TaggableLogbookPrintInfoFragmentDoc = gql`
    fragment TaggableLogbookPrintInfo on TaggableLogbook {
  id
  tag {
    ...TagPrintInfo
  }
  notes {
    id
    text
  }
}
    ${TagPrintInfoFragmentDoc}`;
export const AppliedTagToplineValuePrintFragmentDoc = gql`
    fragment AppliedTagToplineValuePrint on AppliedToplineItem {
  appliedToplineValue {
    ... on ToplineAppliedTags {
      appliedTags {
        ...TaggableLogbookPrintInfo
      }
    }
  }
}
    ${TaggableLogbookPrintInfoFragmentDoc}`;
export const CompactedToplineInfoFragmentDoc = gql`
    fragment CompactedToplineInfo on AppliedToplineItem {
  appliedToplineValue {
    ... on ToplineAppliedEntityConnections {
      entityConnections {
        id
        entity1 {
          id
          firstName
          middleName
          lastName
          nickname
          pronouns
          suffix
        }
        entity2 {
          id
          firstName
          middleName
          lastName
          nickname
          pronouns
          suffix
        }
        appliedToplines {
          id
          item0 {
            ...AppliedTagToplineValuePrint
          }
        }
      }
    }
    ... on ToplineAppliedTags {
      appliedTags {
        ...TaggableLogbookPrintInfo
      }
    }
  }
}
    ${AppliedTagToplineValuePrintFragmentDoc}
${TaggableLogbookPrintInfoFragmentDoc}`;
export const PhonePrintInfoFragmentDoc = gql`
    fragment PhonePrintInfo on PhoneNumber {
  id
  numberType
  number
  ext
  status
  subscribed
  updatedAt
}
    `;
export const EmailPrintInfoFragmentDoc = gql`
    fragment EmailPrintInfo on Email {
  id
  subscribed
  status
  email
  updatedAt
  emailType
}
    `;
export const EntityPrintBaseFragmentDoc = gql`
    fragment EntityPrintBase on Entity {
  id
  campaignContextId
  entityTypeId
  firstName
  middleName
  lastName
  nickname
  suffix
  currentAssessmentLevel
  dateOfBirth
  age
  entityLanguages {
    languageCode
    preferred
  }
  pronouns
  calculatedBirthDate
  activeFollowUp {
    ...FollowUpPrintInfo
  }
  mostRecentNote {
    id
    text
    createdAt
    createdBy {
      id
      firstName
      lastName
    }
  }
  appliedToplines {
    id
    item0 {
      ...CompactedToplineInfo
    }
  }
  bestAddress {
    ...AddressPrintInfo
  }
  bestPhoneNumber {
    ...PhonePrintInfo
  }
  bestEmail {
    ...EmailPrintInfo
  }
}
    ${FollowUpPrintInfoFragmentDoc}
${CompactedToplineInfoFragmentDoc}
${AddressPrintInfoFragmentDoc}
${PhonePrintInfoFragmentDoc}
${EmailPrintInfoFragmentDoc}`;
export const ActionEntityPrintViewDetailsFragmentDoc = gql`
    fragment ActionEntityPrintViewDetails on ActionEntity {
  id
  entity {
    ...EntityPrintBase
    tagsInCategories(tagCategoryIds: $tagCategoryIds) {
      ...TaggableLogbookPrintInfo
    }
    entityConnectionCount {
      ...EntityConnectionCountMapView
    }
  }
  status
  tasks {
    id
    resolved
    actionField {
      id
    }
  }
}
    ${EntityPrintBaseFragmentDoc}
${TaggableLogbookPrintInfoFragmentDoc}
${EntityConnectionCountMapViewFragmentDoc}`;
export const WithConnectionTagsFragmentDoc = gql`
    fragment WithConnectionTags on AppliedToplineItem {
  appliedToplineValue {
    ... on ToplineAppliedEntityConnections {
      entityConnections {
        id
        entity1 {
          id
          firstName
          middleName
          lastName
          nickname
        }
        entity2 {
          id
          firstName
          middleName
          lastName
          nickname
        }
        appliedToplines {
          id
          item1 {
            ...AppliedTagToplineValuePrint
          }
          item2 {
            ...AppliedTagToplineValuePrint
          }
          item3 {
            ...AppliedTagToplineValuePrint
          }
          item4 {
            ...AppliedTagToplineValuePrint
          }
          item5 {
            ...AppliedTagToplineValuePrint
          }
        }
      }
    }
  }
}
    ${AppliedTagToplineValuePrintFragmentDoc}`;
export const EntityPrintDetailsFragmentDoc = gql`
    fragment EntityPrintDetails on Entity {
  ...EntityPrintBase
  appliedToplines {
    id
    item0 {
      ...CompactedToplineInfo
    }
    item1 {
      ...CompactedToplineInfo
      ...WithConnectionTags
    }
    item2 {
      ...CompactedToplineInfo
      ...WithConnectionTags
    }
    item3 {
      ...CompactedToplineInfo
      ...WithConnectionTags
    }
    item4 {
      ...CompactedToplineInfo
      ...WithConnectionTags
    }
    item5 {
      ...CompactedToplineInfo
      ...WithConnectionTags
    }
  }
}
    ${EntityPrintBaseFragmentDoc}
${CompactedToplineInfoFragmentDoc}
${WithConnectionTagsFragmentDoc}`;
export const UploadDetailsFragmentDoc = gql`
    fragment UploadDetails on Upload {
  id
  createdAt
  uploadType
  createdBy {
    id
    firstName
    lastName
    email
  }
  status
  visibilityStatus
  name
  campaign {
    id
    name
  }
  summary {
    total
    addToCampaign
    new
    updates
    errors
    deleted
  }
}
    `;
export const ImportDetailsFragmentDoc = gql`
    fragment ImportDetails on Import {
  id
  createdAt
  createdBy {
    id
    firstName
    lastName
    email
  }
  status
  visibilityStatus
  entityType {
    id
    namePlural
    nameSingular
  }
  name
  campaign {
    id
    name
  }
  summary {
    entitiesAddedToCampaignCount
    entitiesCreatedCount
    entitiesMatchedCount
    errorCount
    processedCount
    rowsCount
  }
}
    `;
export const GetAssessmentInfoQueryDocument = gql`
    query GetAssessmentInfoQuery {
  getAssessmentInfo {
    ...AssessmentSettings
  }
}
    ${AssessmentSettingsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssessmentInfoQueryGQL extends Apollo.Query<GetAssessmentInfoQueryQuery, GetAssessmentInfoQueryQueryVariables> {
    document = GetAssessmentInfoQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCampaignParticipantsDocument = gql`
    query GetCampaignParticipants($campaignId: ID!) {
  getCampaign(campaignId: $campaignId) {
    id
    participants {
      edges {
        node {
          id
          confirmed
          disabled
          firstName
          lastName
          email
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCampaignParticipantsGQL extends Apollo.Query<GetCampaignParticipantsQuery, GetCampaignParticipantsQueryVariables> {
    document = GetCampaignParticipantsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetAssessmentInfoDocument = gql`
    mutation SetAssessmentInfo($input: SetAssessmentInfoInput!) {
  setAssessmentInfo(input: $input) {
    assessmentInfo {
      ...AssessmentSettings
    }
  }
}
    ${AssessmentSettingsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SetAssessmentInfoGQL extends Apollo.Mutation<SetAssessmentInfoMutation, SetAssessmentInfoMutationVariables> {
    document = SetAssessmentInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetAssessmentOverridesDocument = gql`
    mutation SetAssessmentOverrides($input: SetAssessmentOverridesInput!) {
  setAssessmentOverrides(input: $input) {
    assessmentInfo {
      ...AssessmentSettings
    }
  }
}
    ${AssessmentSettingsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SetAssessmentOverridesGQL extends Apollo.Mutation<SetAssessmentOverridesMutation, SetAssessmentOverridesMutationVariables> {
    document = SetAssessmentOverridesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCampaignCopyDocument = gql`
    mutation CreateCampaignCopy($input: CreateCampaignCopyInput!) {
  createCampaignCopy(input: $input) {
    campaign {
      ...CampaignWithoutTags
      entitiesCount
    }
  }
}
    ${CampaignWithoutTagsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCampaignCopyGQL extends Apollo.Mutation<CreateCampaignCopyMutation, CreateCampaignCopyMutationVariables> {
    document = CreateCampaignCopyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCampaignDocument = gql`
    mutation CreateCampaign($input: CreateCampaignInput!) {
  createCampaign(input: $input) {
    campaign {
      ...CampaignWithoutTags
    }
  }
}
    ${CampaignWithoutTagsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCampaignGQL extends Apollo.Mutation<CreateCampaignMutation, CreateCampaignMutationVariables> {
    document = CreateCampaignDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCampaignConnectionTypeConfigDocument = gql`
    mutation UpdateCampaignConnectionTypeConfig($input: UpdateCampaignEntityConnectionTypeConfigurationInput!) {
  updateCampaignEntityConnectionTypeConfiguration(input: $input) {
    campaignEntityConnectionTypeConfiguration {
      ...CampaignConnectionTypeConfigDetails
    }
  }
}
    ${CampaignConnectionTypeConfigDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCampaignConnectionTypeConfigGQL extends Apollo.Mutation<UpdateCampaignConnectionTypeConfigMutation, UpdateCampaignConnectionTypeConfigMutationVariables> {
    document = UpdateCampaignConnectionTypeConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCampaignEntityTypeConfigDocument = gql`
    mutation UpdateCampaignEntityTypeConfig($input: UpdateCampaignEntityTypeConfigurationInput!) {
  updateCampaignEntityTypeConfiguration(input: $input) {
    campaignEntityTypeConfiguration {
      ...CampaignEntityTypeConfigDetails
    }
  }
}
    ${CampaignEntityTypeConfigDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCampaignEntityTypeConfigGQL extends Apollo.Mutation<UpdateCampaignEntityTypeConfigMutation, UpdateCampaignEntityTypeConfigMutationVariables> {
    document = UpdateCampaignEntityTypeConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCampaignExportRestrictionsDocument = gql`
    mutation UpdateCampaignExportRestrictions($input: UpdateCampaignExportRestrictionsInput!) {
  updateCampaignExportRestrictions(input: $input) {
    campaign {
      ...CampaignWithoutTags
    }
  }
}
    ${CampaignWithoutTagsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCampaignExportRestrictionsGQL extends Apollo.Mutation<UpdateCampaignExportRestrictionsMutation, UpdateCampaignExportRestrictionsMutationVariables> {
    document = UpdateCampaignExportRestrictionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCampaignDetailsDocument = gql`
    mutation UpdateCampaignDetails($input: UpdateCampaignInput!) {
  updateCampaign(input: $input) {
    campaign {
      ...CampaignWithoutTags
    }
  }
}
    ${CampaignWithoutTagsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCampaignDetailsGQL extends Apollo.Mutation<UpdateCampaignDetailsMutation, UpdateCampaignDetailsMutationVariables> {
    document = UpdateCampaignDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEntityConnectionTypeDocument = gql`
    mutation CreateEntityConnectionType($input: CreateEntityConnectionTypeInput!) {
  createEntityConnectionType(input: $input) {
    entityConnectionType {
      ...EntityConnectionTypeDetails
    }
  }
}
    ${EntityConnectionTypeDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEntityConnectionTypeGQL extends Apollo.Mutation<CreateEntityConnectionTypeMutation, CreateEntityConnectionTypeMutationVariables> {
    document = CreateEntityConnectionTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEntityConnectionTypeDocument = gql`
    mutation UpdateEntityConnectionType($input: UpdateEntityConnectionTypeInput!) {
  updateEntityConnectionType(input: $input) {
    entityConnectionType {
      ...EntityConnectionTypeDetails
    }
  }
}
    ${EntityConnectionTypeDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEntityConnectionTypeGQL extends Apollo.Mutation<UpdateEntityConnectionTypeMutation, UpdateEntityConnectionTypeMutationVariables> {
    document = UpdateEntityConnectionTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateContactAttemptDocument = gql`
    mutation CreateContactAttempt($input: CreateContactAttemptInput!) {
  createContactAttempt(input: $input) {
    contactAttempt {
      id
      contactInfoId
      contactInfoType
      createdAt
      createdBy {
        ...UserPublicDetails
      }
      disposition
      note
    }
  }
}
    ${UserPublicDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateContactAttemptGQL extends Apollo.Mutation<CreateContactAttemptMutation, CreateContactAttemptMutationVariables> {
    document = CreateContactAttemptDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCustomIdDocument = gql`
    mutation CreateCustomId($input: CreateCustomIdInput!) {
  createCustomId(input: $input) {
    customIdType {
      ...CustomIdTypeDetails
    }
  }
}
    ${CustomIdTypeDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCustomIdGQL extends Apollo.Mutation<CreateCustomIdMutation, CreateCustomIdMutationVariables> {
    document = CreateCustomIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCustomFormDocument = gql`
    mutation CreateCustomForm($input: CreateCustomFormInput!) {
  createCustomForm(input: $input) {
    customForm {
      ...CustomFormDetails
    }
  }
}
    ${CustomFormDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCustomFormGQL extends Apollo.Mutation<CreateCustomFormMutation, CreateCustomFormMutationVariables> {
    document = CreateCustomFormDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCustomFormFieldsDocument = gql`
    mutation UpdateCustomFormFields($input: UpdateCustomFormFieldsInput!) {
  updateCustomFormFields(input: $input) {
    customForm {
      ...CustomFormDetails
    }
  }
}
    ${CustomFormDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCustomFormFieldsGQL extends Apollo.Mutation<UpdateCustomFormFieldsMutation, UpdateCustomFormFieldsMutationVariables> {
    document = UpdateCustomFormFieldsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAttachmentDocument = gql`
    mutation DeleteAttachment($input: DeleteAttachmentInput!) {
  deleteAttachment(input: $input) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAttachmentGQL extends Apollo.Mutation<DeleteAttachmentMutation, DeleteAttachmentMutationVariables> {
    document = DeleteAttachmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ApplyEntityConnectionTagDocument = gql`
    mutation ApplyEntityConnectionTag($input: ApplyTagToEntityConnectionInput!) {
  applyTagToEntityConnection(input: $input) {
    entityConnection {
      ...EntityConnectionWithToplines
      ...EntityConnectionWithTags
      ...EntityConnectionWithNotes
    }
  }
}
    ${EntityConnectionWithToplinesFragmentDoc}
${EntityConnectionWithTagsFragmentDoc}
${EntityConnectionWithNotesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ApplyEntityConnectionTagGQL extends Apollo.Mutation<ApplyEntityConnectionTagMutation, ApplyEntityConnectionTagMutationVariables> {
    document = ApplyEntityConnectionTagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEntityConnectionDocument = gql`
    mutation CreateEntityConnection($input: CreateEntityConnectionInput!) {
  createEntityConnection(input: $input) {
    entityConnection {
      ...EntityConnectionWithTags
      ...EntityConnectionWithNotes
      ...EntityConnectionWithToplines
    }
  }
}
    ${EntityConnectionWithTagsFragmentDoc}
${EntityConnectionWithNotesFragmentDoc}
${EntityConnectionWithToplinesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEntityConnectionGQL extends Apollo.Mutation<CreateEntityConnectionMutation, CreateEntityConnectionMutationVariables> {
    document = CreateEntityConnectionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteEntityConnectionDocument = gql`
    mutation DeleteEntityConnection($input: DeleteEntityConnectionInput!) {
  deleteEntityConnection(input: $input) {
    entityConnection {
      ...EntityConnectionCore
      ...EntityConnectionWithNotes
    }
  }
}
    ${EntityConnectionCoreFragmentDoc}
${EntityConnectionWithNotesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteEntityConnectionGQL extends Apollo.Mutation<DeleteEntityConnectionMutation, DeleteEntityConnectionMutationVariables> {
    document = DeleteEntityConnectionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnapplyEntityConnectionTagDocument = gql`
    mutation UnapplyEntityConnectionTag($input: UnapplyEntityConnectionTagInput!) {
  unapplyEntityConnectionTag(input: $input) {
    entityConnection {
      ...EntityConnectionWithToplines
      ...EntityConnectionWithTags
      ...EntityConnectionWithNotes
    }
  }
}
    ${EntityConnectionWithToplinesFragmentDoc}
${EntityConnectionWithTagsFragmentDoc}
${EntityConnectionWithNotesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UnapplyEntityConnectionTagGQL extends Apollo.Mutation<UnapplyEntityConnectionTagMutation, UnapplyEntityConnectionTagMutationVariables> {
    document = UnapplyEntityConnectionTagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEntityConnectionDocument = gql`
    mutation UpdateEntityConnection($input: UpdateEntityConnectionInput!) {
  updateEntityConnection(input: $input) {
    entityConnection {
      ...EntityConnectionCore
      ...EntityConnectionWithNotes
    }
  }
}
    ${EntityConnectionCoreFragmentDoc}
${EntityConnectionWithNotesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEntityConnectionGQL extends Apollo.Mutation<UpdateEntityConnectionMutation, UpdateEntityConnectionMutationVariables> {
    document = UpdateEntityConnectionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEntityTypeDocument = gql`
    mutation CreateEntityType($input: CreateEntityTypeInput!) {
  createEntityType(input: $input) {
    entityType {
      ...EntityTypeDetails
    }
  }
}
    ${EntityTypeDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEntityTypeGQL extends Apollo.Mutation<CreateEntityTypeMutation, CreateEntityTypeMutationVariables> {
    document = CreateEntityTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEntityTypeDocument = gql`
    mutation UpdateEntityType($input: UpdateEntityTypeInput!) {
  updateEntityType(input: $input) {
    entityType {
      ...EntityTypeDetails
    }
  }
}
    ${EntityTypeDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEntityTypeGQL extends Apollo.Mutation<UpdateEntityTypeMutation, UpdateEntityTypeMutationVariables> {
    document = UpdateEntityTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddEntityToCampaignDocument = gql`
    mutation AddEntityToCampaign($input: AddEntityToCampaignInput!) {
  addEntityToCampaign(input: $input) {
    entity {
      ...EntityCore
      ...EntityWithCampaigns
      ...EntityWithBasicInfo
    }
  }
}
    ${EntityCoreFragmentDoc}
${EntityWithCampaignsFragmentDoc}
${EntityWithBasicInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddEntityToCampaignGQL extends Apollo.Mutation<AddEntityToCampaignMutation, AddEntityToCampaignMutationVariables> {
    document = AddEntityToCampaignDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddSocialProfileDocument = gql`
    mutation AddSocialProfile($input: AddSocialProfileInput!) {
  addSocialProfile(input: $input) {
    entity {
      ...EntityCore
      ...EntityWithToplines
      ...EntityWithSocialProfiles
    }
  }
}
    ${EntityCoreFragmentDoc}
${EntityWithToplinesFragmentDoc}
${EntityWithSocialProfilesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddSocialProfileGQL extends Apollo.Mutation<AddSocialProfileMutation, AddSocialProfileMutationVariables> {
    document = AddSocialProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ApplyEntityTagDocument = gql`
    mutation ApplyEntityTag($input: ApplyTagToEntityInput!) {
  applyTagToEntity(input: $input) {
    entity {
      ...EntityCore
      ...EntityWithToplines
      ...EntityWithTags
    }
  }
}
    ${EntityCoreFragmentDoc}
${EntityWithToplinesFragmentDoc}
${EntityWithTagsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ApplyEntityTagGQL extends Apollo.Mutation<ApplyEntityTagMutation, ApplyEntityTagMutationVariables> {
    document = ApplyEntityTagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AssignFollowUpDocument = gql`
    mutation AssignFollowUp($input: AssignFollowUpInput!) {
  assignFollowUp(input: $input) {
    followUp {
      ...FollowUpDetails
    }
  }
}
    ${FollowUpDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignFollowUpGQL extends Apollo.Mutation<AssignFollowUpMutation, AssignFollowUpMutationVariables> {
    document = AssignFollowUpDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompleteActiveFollowUpsDocument = gql`
    mutation CompleteActiveFollowUps($input: CompleteActiveFollowUpsInput!) {
  completeActiveFollowUps(input: $input) {
    entity {
      ...EntityCore
      ...EntityWithBasicInfo
      ...EntityWithFollowUpDetails
    }
  }
}
    ${EntityCoreFragmentDoc}
${EntityWithBasicInfoFragmentDoc}
${EntityWithFollowUpDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CompleteActiveFollowUpsGQL extends Apollo.Mutation<CompleteActiveFollowUpsMutation, CompleteActiveFollowUpsMutationVariables> {
    document = CompleteActiveFollowUpsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAddressDocument = gql`
    mutation CreateAddress($input: CreateAddressesInput!) {
  createAddresses(input: $input) {
    entity {
      ...EntityCore
      ...EntityWithToplines
      ...EntityWithBestAddress
      ...EntityWithAddresses
    }
  }
}
    ${EntityCoreFragmentDoc}
${EntityWithToplinesFragmentDoc}
${EntityWithBestAddressFragmentDoc}
${EntityWithAddressesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAddressGQL extends Apollo.Mutation<CreateAddressMutation, CreateAddressMutationVariables> {
    document = CreateAddressDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAssessmentDocument = gql`
    mutation CreateAssessment($input: CreateAssessmentsInput!) {
  createAssessments(input: $input) {
    entity {
      ...EntityWithAssessments
    }
  }
}
    ${EntityWithAssessmentsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAssessmentGQL extends Apollo.Mutation<CreateAssessmentMutation, CreateAssessmentMutationVariables> {
    document = CreateAssessmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEmailDocument = gql`
    mutation CreateEmail($input: CreateEmailsInput!) {
  createEmails(input: $input) {
    entity {
      ...EntityCore
      ...EntityWithToplines
      ...EntityWithBestEmail
      emails {
        ...EmailDetails
      }
    }
  }
}
    ${EntityCoreFragmentDoc}
${EntityWithToplinesFragmentDoc}
${EntityWithBestEmailFragmentDoc}
${EmailDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEmailGQL extends Apollo.Mutation<CreateEmailMutation, CreateEmailMutationVariables> {
    document = CreateEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEntityDocument = gql`
    mutation CreateEntity($input: CreateEntityInput!) {
  createEntity(input: $input) {
    entity {
      ...EntityCore
      ...EntityWithBasicInfo
      ...EntityWithEntityType
      ...EntityWithToplines
    }
  }
}
    ${EntityCoreFragmentDoc}
${EntityWithBasicInfoFragmentDoc}
${EntityWithEntityTypeFragmentDoc}
${EntityWithToplinesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEntityGQL extends Apollo.Mutation<CreateEntityMutation, CreateEntityMutationVariables> {
    document = CreateEntityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateFollowUpDocument = gql`
    mutation CreateFollowUp($input: CreateFollowUpInput!) {
  createFollowUp(input: $input) {
    entity {
      ...EntityCore
      ...EntityWithBasicInfo
      ...EntityWithFollowUpDetails
    }
  }
}
    ${EntityCoreFragmentDoc}
${EntityWithBasicInfoFragmentDoc}
${EntityWithFollowUpDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateFollowUpGQL extends Apollo.Mutation<CreateFollowUpMutation, CreateFollowUpMutationVariables> {
    document = CreateFollowUpDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePhoneDocument = gql`
    mutation CreatePhone($input: CreatePhoneNumbersInput!) {
  createPhoneNumbers(input: $input) {
    entity {
      ...EntityCore
      ...EntityWithToplines
      ...EntityWithBestPhone
      ...EntityWithPhones
    }
  }
}
    ${EntityCoreFragmentDoc}
${EntityWithToplinesFragmentDoc}
${EntityWithBestPhoneFragmentDoc}
${EntityWithPhonesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePhoneGQL extends Apollo.Mutation<CreatePhoneMutation, CreatePhoneMutationVariables> {
    document = CreatePhoneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportEntitiesDocument = gql`
    mutation ExportEntities($input: EntitiesReportInput!) {
  entitiesReport(input: $input) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportEntitiesGQL extends Apollo.Mutation<ExportEntitiesMutation, ExportEntitiesMutationVariables> {
    document = ExportEntitiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveEntityCustomIdDocument = gql`
    mutation RemoveEntityCustomId($input: RemoveEntityCustomIdInput!) {
  removeEntityCustomId(input: $input) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveEntityCustomIdGQL extends Apollo.Mutation<RemoveEntityCustomIdMutation, RemoveEntityCustomIdMutationVariables> {
    document = RemoveEntityCustomIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveEntityFromCampaignDocument = gql`
    mutation RemoveEntityFromCampaign($input: RemoveEntityFromCampaignInput!) {
  removeEntityFromCampaign(input: $input) {
    entity {
      id
      campaignContextId
      campaigns {
        id
        name
      }
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveEntityFromCampaignGQL extends Apollo.Mutation<RemoveEntityFromCampaignMutation, RemoveEntityFromCampaignMutationVariables> {
    document = RemoveEntityFromCampaignDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveSocialProfileDocument = gql`
    mutation RemoveSocialProfile($input: RemoveSocialProfileInput!) {
  removeSocialProfile(input: $input) {
    entity {
      ...EntityCore
      ...EntityWithToplines
      ...EntityWithSocialProfiles
    }
  }
}
    ${EntityCoreFragmentDoc}
${EntityWithToplinesFragmentDoc}
${EntityWithSocialProfilesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveSocialProfileGQL extends Apollo.Mutation<RemoveSocialProfileMutation, RemoveSocialProfileMutationVariables> {
    document = RemoveSocialProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnapplyEntityTagDocument = gql`
    mutation UnapplyEntityTag($input: UnapplyTagInput!) {
  unapplyTag(input: $input) {
    entity {
      ...EntityWithToplines
      ...EntityWithTags
    }
  }
}
    ${EntityWithToplinesFragmentDoc}
${EntityWithTagsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UnapplyEntityTagGQL extends Apollo.Mutation<UnapplyEntityTagMutation, UnapplyEntityTagMutationVariables> {
    document = UnapplyEntityTagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAddressDocument = gql`
    mutation UpdateAddress($input: UpdateAddressInput!) {
  updateAddress(input: $input) {
    entity {
      ...EntityCore
      ...EntityWithToplines
      ...EntityWithBestAddress
      ...EntityWithAddresses
    }
  }
}
    ${EntityCoreFragmentDoc}
${EntityWithToplinesFragmentDoc}
${EntityWithBestAddressFragmentDoc}
${EntityWithAddressesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAddressGQL extends Apollo.Mutation<UpdateAddressMutation, UpdateAddressMutationVariables> {
    document = UpdateAddressDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEntityCustomIdDocument = gql`
    mutation UpdateEntityCustomId($input: UpdateEntityCustomIdInput!) {
  updateEntityCustomId(input: $input) {
    entityCustomId {
      ...EntityCustomIdDetails
    }
  }
}
    ${EntityCustomIdDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEntityCustomIdGQL extends Apollo.Mutation<UpdateEntityCustomIdMutation, UpdateEntityCustomIdMutationVariables> {
    document = UpdateEntityCustomIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEmailDocument = gql`
    mutation UpdateEmail($input: UpdateEmailInput!) {
  updateEmail(input: $input) {
    entity {
      ...EntityCore
      ...EntityWithToplines
      ...EntityWithBestEmail
      ...EntityWithEmails
    }
  }
}
    ${EntityCoreFragmentDoc}
${EntityWithToplinesFragmentDoc}
${EntityWithBestEmailFragmentDoc}
${EntityWithEmailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEmailGQL extends Apollo.Mutation<UpdateEmailMutation, UpdateEmailMutationVariables> {
    document = UpdateEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEntityBasicInfoDocument = gql`
    mutation UpdateEntityBasicInfo($input: UpdateEntityInput!) {
  updateEntity(input: $input) {
    entity {
      ...EntityCore
      ...EntityWithEntityType
      ...EntityWithToplines
      ...EntityWithBasicInfo
    }
  }
}
    ${EntityCoreFragmentDoc}
${EntityWithEntityTypeFragmentDoc}
${EntityWithToplinesFragmentDoc}
${EntityWithBasicInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEntityBasicInfoGQL extends Apollo.Mutation<UpdateEntityBasicInfoMutation, UpdateEntityBasicInfoMutationVariables> {
    document = UpdateEntityBasicInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFollowUpDocument = gql`
    mutation UpdateFollowUp($input: UpdateFollowUpInput!) {
  updateFollowUp(input: $input) {
    followUp {
      id
      dueDate
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFollowUpGQL extends Apollo.Mutation<UpdateFollowUpMutation, UpdateFollowUpMutationVariables> {
    document = UpdateFollowUpDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePhoneDocument = gql`
    mutation UpdatePhone($input: UpdatePhoneNumberInput!) {
  updatePhoneNumber(input: $input) {
    entity {
      ...EntityCore
      ...EntityWithToplines
      ...EntityWithBestPhone
      ...EntityWithPhones
    }
  }
}
    ${EntityCoreFragmentDoc}
${EntityWithToplinesFragmentDoc}
${EntityWithBestPhoneFragmentDoc}
${EntityWithPhonesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePhoneGQL extends Apollo.Mutation<UpdatePhoneMutation, UpdatePhoneMutationVariables> {
    document = UpdatePhoneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSocialProfileDocument = gql`
    mutation UpdateSocialProfile($input: UpdateSocialProfileInput!) {
  updateSocialProfile(input: $input) {
    entity {
      ...EntityCore
      ...EntityWithToplines
      ...EntityWithSocialProfiles
    }
  }
}
    ${EntityCoreFragmentDoc}
${EntityWithToplinesFragmentDoc}
${EntityWithSocialProfilesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSocialProfileGQL extends Apollo.Mutation<UpdateSocialProfileMutation, UpdateSocialProfileMutationVariables> {
    document = UpdateSocialProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddCalendarEventUsersDocument = gql`
    mutation AddCalendarEventUsers($input: AddCalendarEventUsersInput!) {
  addCalendarEventUsers(input: $input) {
    calendarEvent {
      ...CalendarEventDetails
    }
  }
}
    ${CalendarEventDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddCalendarEventUsersGQL extends Apollo.Mutation<AddCalendarEventUsersMutation, AddCalendarEventUsersMutationVariables> {
    document = AddCalendarEventUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateActionForCalendarEventActionDocument = gql`
    mutation CreateActionForCalendarEventAction($input: CreateActionForCalendarEventActionInput!) {
  createActionForCalendarEventAction(input: $input) {
    calendarEventAction {
      ...CalendarEventActionDetails
    }
  }
}
    ${CalendarEventActionDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateActionForCalendarEventActionGQL extends Apollo.Mutation<CreateActionForCalendarEventActionMutation, CreateActionForCalendarEventActionMutationVariables> {
    document = CreateActionForCalendarEventActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCalendarEventDocument = gql`
    mutation CreateCalendarEvent($input: CreateCalendarEventInput!) {
  createCalendarEvent(input: $input) {
    calendarEvent {
      ...CalendarEventDetails
    }
  }
}
    ${CalendarEventDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCalendarEventGQL extends Apollo.Mutation<CreateCalendarEventMutation, CreateCalendarEventMutationVariables> {
    document = CreateCalendarEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCalendarEventsDocument = gql`
    mutation CreateCalendarEvents($input: CreateCalendarEventsInput!) {
  createCalendarEvents(input: $input) {
    calendarEvents {
      ...CalendarEventDetails
    }
  }
}
    ${CalendarEventDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCalendarEventsGQL extends Apollo.Mutation<CreateCalendarEventsMutation, CreateCalendarEventsMutationVariables> {
    document = CreateCalendarEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCalendarEventDocument = gql`
    mutation DeleteCalendarEvent($input: DeleteCalendarEventInput!) {
  deleteCalendarEvent(input: $input) {
    calendarEvent {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCalendarEventGQL extends Apollo.Mutation<DeleteCalendarEventMutation, DeleteCalendarEventMutationVariables> {
    document = DeleteCalendarEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EditEventCompositeDocument = gql`
    mutation EditEventComposite($calendarEventId: ID!, $updateEventInput: UpdateCalendarEventInput!, $removeCalendarEventUsersInput: RemoveCalendarEventUsersInput!, $addCalendarEventUsersInput: AddCalendarEventUsersInput!, $linkToActionNetworkEvent: Boolean!, $actionNetworkEventId: Int = 0) {
  removeUsers: removeCalendarEventUsers(input: $removeCalendarEventUsersInput) {
    calendarEvent {
      id
    }
  }
  addUsers: addCalendarEventUsers(input: $addCalendarEventUsersInput) {
    calendarEvent {
      id
    }
  }
  updateDetails: updateCalendarEvent(input: $updateEventInput) {
    calendarEvent {
      ...CalendarEventDetails
    }
  }
  linkAN: linkEventToActionNetwork(
    input: {calendarEventId: $calendarEventId, actionNetworkEventId: $actionNetworkEventId}
  ) @include(if: $linkToActionNetworkEvent) {
    calendarEvent {
      id
      actionNetworkEventId
    }
  }
  unlinkAN: unlinkEventFromActionNetwork(
    input: {calendarEventId: $calendarEventId}
  ) @skip(if: $linkToActionNetworkEvent) {
    calendarEvent {
      id
      actionNetworkEventId
    }
  }
}
    ${CalendarEventDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EditEventCompositeGQL extends Apollo.Mutation<EditEventCompositeMutation, EditEventCompositeMutationVariables> {
    document = EditEventCompositeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LinkEventToActionNetworkDocument = gql`
    mutation LinkEventToActionNetwork($actionNetworkEventId: Int!, $calendarEventId: ID!) {
  linkEventToActionNetwork(
    input: {actionNetworkEventId: $actionNetworkEventId, calendarEventId: $calendarEventId}
  ) {
    calendarEvent {
      id
      actionNetworkEventId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LinkEventToActionNetworkGQL extends Apollo.Mutation<LinkEventToActionNetworkMutation, LinkEventToActionNetworkMutationVariables> {
    document = LinkEventToActionNetworkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveCalendarEventUsersDocument = gql`
    mutation RemoveCalendarEventUsers($input: RemoveCalendarEventUsersInput!) {
  removeCalendarEventUsers(input: $input) {
    calendarEvent {
      ...CalendarEventDetails
    }
  }
}
    ${CalendarEventDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveCalendarEventUsersGQL extends Apollo.Mutation<RemoveCalendarEventUsersMutation, RemoveCalendarEventUsersMutationVariables> {
    document = RemoveCalendarEventUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetCalendarEventResponseDocument = gql`
    mutation SetCalendarEventResponse($input: SetCalendarEventResponseInput!) {
  setCalendarEventResponse(input: $input) {
    calendarEventResponse {
      ...CalendarEventResponseCore
    }
  }
}
    ${CalendarEventResponseCoreFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SetCalendarEventResponseGQL extends Apollo.Mutation<SetCalendarEventResponseMutation, SetCalendarEventResponseMutationVariables> {
    document = SetCalendarEventResponseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnapplyCalendarEventResponseTagDocument = gql`
    mutation UnapplyCalendarEventResponseTag($input: UnapplyCalendarEventResponseTagInput!) {
  unapplyCalendarEventResponseTag(input: $input) {
    calendarEventResponse {
      ...CalendarEventResponseCore
    }
  }
}
    ${CalendarEventResponseCoreFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UnapplyCalendarEventResponseTagGQL extends Apollo.Mutation<UnapplyCalendarEventResponseTagMutation, UnapplyCalendarEventResponseTagMutationVariables> {
    document = UnapplyCalendarEventResponseTagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnlinkEventFromActionNetworkDocument = gql`
    mutation UnlinkEventFromActionNetwork($calendarEventId: ID!) {
  unlinkEventFromActionNetwork(input: {calendarEventId: $calendarEventId}) {
    calendarEvent {
      id
      actionNetworkEventId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnlinkEventFromActionNetworkGQL extends Apollo.Mutation<UnlinkEventFromActionNetworkMutation, UnlinkEventFromActionNetworkMutationVariables> {
    document = UnlinkEventFromActionNetworkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCalendarEventActionScheduledDaysDocument = gql`
    mutation UpdateCalendarEventActionScheduledDays($input: UpdateCalendarEventActionScheduledDaysInput!) {
  updateCalendarEventActionScheduledDays(input: $input) {
    calendarEventAction {
      ...CalendarEventActionDetails
    }
  }
}
    ${CalendarEventActionDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCalendarEventActionScheduledDaysGQL extends Apollo.Mutation<UpdateCalendarEventActionScheduledDaysMutation, UpdateCalendarEventActionScheduledDaysMutationVariables> {
    document = UpdateCalendarEventActionScheduledDaysDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCalendarEventDocument = gql`
    mutation UpdateCalendarEvent($input: UpdateCalendarEventInput!) {
  updateCalendarEvent(input: $input) {
    calendarEvent {
      ...CalendarEventDetails
    }
  }
}
    ${CalendarEventDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCalendarEventGQL extends Apollo.Mutation<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables> {
    document = UpdateCalendarEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateExternalServiceDocument = gql`
    mutation CreateExternalService($input: CreateExternalServiceInput!) {
  createExternalService(input: $input) {
    externalService {
      id
      serviceName
      clientId
      workflowId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateExternalServiceGQL extends Apollo.Mutation<CreateExternalServiceMutation, CreateExternalServiceMutationVariables> {
    document = CreateExternalServiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCampaignIntegrationsDocument = gql`
    mutation UpdateCampaignIntegrations($input: UpdateIntegrationsInput!) {
  updateIntegrations(input: $input) {
    campaign {
      id
      name
      integrations {
        id
        externalServiceId
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCampaignIntegrationsGQL extends Apollo.Mutation<UpdateCampaignIntegrationsMutation, UpdateCampaignIntegrationsMutationVariables> {
    document = UpdateCampaignIntegrationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateExternalServiceDocument = gql`
    mutation UpdateExternalService($input: UpdateExternalServiceInput!) {
  updateExternalService(input: $input) {
    externalService {
      id
      serviceName
      clientId
      workflowId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateExternalServiceGQL extends Apollo.Mutation<UpdateExternalServiceMutation, UpdateExternalServiceMutationVariables> {
    document = UpdateExternalServiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateNoteDocument = gql`
    mutation CreateNote($input: CreateNotesInput!) {
  createNotes(input: $input) {
    notes {
      ...NoteDetails
    }
  }
}
    ${NoteDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateNoteGQL extends Apollo.Mutation<CreateNoteMutation, CreateNoteMutationVariables> {
    document = CreateNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PinNoteDocument = gql`
    mutation PinNote($input: PinNoteInput!) {
  pinNote(input: $input) {
    note {
      ...NoteDetails
    }
  }
}
    ${NoteDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PinNoteGQL extends Apollo.Mutation<PinNoteMutation, PinNoteMutationVariables> {
    document = PinNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveNoteDocument = gql`
    mutation RemoveNote($input: RemoveNotesInput!) {
  removeNotes(input: $input) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveNoteGQL extends Apollo.Mutation<RemoveNoteMutation, RemoveNoteMutationVariables> {
    document = RemoveNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnpinNoteDocument = gql`
    mutation UnpinNote($input: UnpinNoteInput!) {
  unpinNote(input: $input) {
    note {
      ...NoteDetails
    }
  }
}
    ${NoteDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UnpinNoteGQL extends Apollo.Mutation<UnpinNoteMutation, UnpinNoteMutationVariables> {
    document = UnpinNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateNoteDocument = gql`
    mutation UpdateNote($input: UpdateNoteInput!) {
  updateNote(input: $input) {
    note {
      ...NoteDetails
    }
  }
}
    ${NoteDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateNoteGQL extends Apollo.Mutation<UpdateNoteMutation, UpdateNoteMutationVariables> {
    document = UpdateNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOrganizationMfaEnforcementDocument = gql`
    mutation UpdateOrganizationMfaEnforcement($input: UpdateOrganizationMfaEnforcementInput!) {
  updateOrganizationMfaEnforcement(input: $input) {
    organization {
      ...OrganizationDetails
    }
  }
}
    ${OrganizationDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOrganizationMfaEnforcementGQL extends Apollo.Mutation<UpdateOrganizationMfaEnforcementMutation, UpdateOrganizationMfaEnforcementMutationVariables> {
    document = UpdateOrganizationMfaEnforcementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOrganizationDocument = gql`
    mutation UpdateOrganization($input: UpdateOrganizationInput!) {
  updateOrganization(input: $input) {
    organization {
      ...OrganizationDetails
    }
  }
}
    ${OrganizationDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOrganizationGQL extends Apollo.Mutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables> {
    document = UpdateOrganizationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ApplyMassOperationDocument = gql`
    mutation ApplyMassOperation($input: ApplyMassOperationInput!) {
  applyMassOperation(input: $input) {
    targetCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ApplyMassOperationGQL extends Apollo.Mutation<ApplyMassOperationMutation, ApplyMassOperationMutationVariables> {
    document = ApplyMassOperationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RestoreOriginalAddressDocument = gql`
    mutation RestoreOriginalAddress($input: RevertAddressInput!) {
  revertAddress(input: $input) {
    address {
      ...AddressDetails
    }
  }
}
    ${AddressDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RestoreOriginalAddressGQL extends Apollo.Mutation<RestoreOriginalAddressMutation, RestoreOriginalAddressMutationVariables> {
    document = RestoreOriginalAddressDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSavedQueryDocument = gql`
    mutation CreateSavedQuery($input: CreateSavedQueryInput!) {
  createSavedQuery(input: $input) {
    query {
      ...SavedQueryDetails
    }
  }
}
    ${SavedQueryDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSavedQueryGQL extends Apollo.Mutation<CreateSavedQueryMutation, CreateSavedQueryMutationVariables> {
    document = CreateSavedQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteSavedQueryDocument = gql`
    mutation DeleteSavedQuery($input: DeleteSavedQueryInput!) {
  deleteSavedQuery(input: $input) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteSavedQueryGQL extends Apollo.Mutation<DeleteSavedQueryMutation, DeleteSavedQueryMutationVariables> {
    document = DeleteSavedQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSavedQueryDocument = gql`
    mutation UpdateSavedQuery($input: UpdateSavedQueryInput!) {
  updateSavedQuery(input: $input) {
    query {
      ...SavedQueryDetails
    }
  }
}
    ${SavedQueryDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSavedQueryGQL extends Apollo.Mutation<UpdateSavedQueryMutation, UpdateSavedQueryMutationVariables> {
    document = UpdateSavedQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddTagCategoryToCampaignDocument = gql`
    mutation AddTagCategoryToCampaign($input: AddTagCategoryToCampaignInput!, $isInCampaignId: ID = null) {
  addTagCategoryToCampaign(input: $input) {
    tagCategory {
      id
      isInCampaign(campaignId: $isInCampaignId)
      group {
        id
        name
        isInCampaign(campaignId: $isInCampaignId)
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddTagCategoryToCampaignGQL extends Apollo.Mutation<AddTagCategoryToCampaignMutation, AddTagCategoryToCampaignMutationVariables> {
    document = AddTagCategoryToCampaignDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ApplyTagDocument = gql`
    mutation ApplyTag($input: ApplyTagInput!) {
  applyTag(input: $input) {
    taggableLogbook {
      ...TaggableLogbookDetails
    }
  }
}
    ${TaggableLogbookDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ApplyTagGQL extends Apollo.Mutation<ApplyTagMutation, ApplyTagMutationVariables> {
    document = ApplyTagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveTagCategoryDocument = gql`
    mutation ArchiveTagCategory($input: UpdateTagStatusByCategoryInput!) {
  updateTagStatusByCategory(input: $input) {
    tagCategory {
      ...TagCategoryInfo
    }
  }
}
    ${TagCategoryInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveTagCategoryGQL extends Apollo.Mutation<ArchiveTagCategoryMutation, ArchiveTagCategoryMutationVariables> {
    document = ArchiveTagCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AssociateTagToCampaignDocument = gql`
    mutation AssociateTagToCampaign($input: AssociateTagToCampaignInput!, $isInCampaignId: ID = null) {
  associateTagToCampaign(input: $input) {
    tag {
      ...TagInfo
      isInCampaign(campaignId: $isInCampaignId)
      category {
        id
        isInCampaign(campaignId: $isInCampaignId)
        group {
          id
          isInCampaign(campaignId: $isInCampaignId)
        }
      }
    }
  }
}
    ${TagInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AssociateTagToCampaignGQL extends Apollo.Mutation<AssociateTagToCampaignMutation, AssociateTagToCampaignMutationVariables> {
    document = AssociateTagToCampaignDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeTagCategoryGroupDocument = gql`
    mutation ChangeTagCategoryGroup($input: ChangeTagCategoryGroupInput!) {
  changeTagCategoryGroup(input: $input) {
    tagCategory {
      ...TagCategoryInfo
      isInCampaign(campaignId: null)
    }
  }
}
    ${TagCategoryInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeTagCategoryGroupGQL extends Apollo.Mutation<ChangeTagCategoryGroupMutation, ChangeTagCategoryGroupMutationVariables> {
    document = ChangeTagCategoryGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTagCategoryDocument = gql`
    mutation CreateTagCategory($input: CreateTagCategoryInput!) {
  createTagCategory(input: $input) {
    tagCategory {
      ...TagCategoryInfo
      isInCampaign(campaignId: null)
    }
  }
}
    ${TagCategoryInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTagCategoryGQL extends Apollo.Mutation<CreateTagCategoryMutation, CreateTagCategoryMutationVariables> {
    document = CreateTagCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTagGroupDocument = gql`
    mutation CreateTagGroup($input: CreateTagGroupInput!) {
  createTagGroup(input: $input) {
    tagGroup {
      ...TagGroupInfo
      isInCampaign(campaignId: null)
    }
  }
}
    ${TagGroupInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTagGroupGQL extends Apollo.Mutation<CreateTagGroupMutation, CreateTagGroupMutationVariables> {
    document = CreateTagGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTagDocument = gql`
    mutation CreateTag($input: CreateTagInput!, $isInCampaignId: ID = null) {
  createTag(input: $input) {
    tag {
      ...TagInfo
      ...TagWithIsInCampaign
    }
  }
}
    ${TagInfoFragmentDoc}
${TagWithIsInCampaignFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTagGQL extends Apollo.Mutation<CreateTagMutation, CreateTagMutationVariables> {
    document = CreateTagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveTagCategoryFromCampaignDocument = gql`
    mutation RemoveTagCategoryFromCampaign($input: RemoveTagCategoryFromCampaignInput!, $isInCampaignId: ID = null) {
  removeTagCategoryFromCampaign(input: $input) {
    tagCategory {
      id
      isInCampaign(campaignId: $isInCampaignId)
      group {
        id
        isInCampaign(campaignId: $isInCampaignId)
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveTagCategoryFromCampaignGQL extends Apollo.Mutation<RemoveTagCategoryFromCampaignMutation, RemoveTagCategoryFromCampaignMutationVariables> {
    document = RemoveTagCategoryFromCampaignDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RenameTagGroupDocument = gql`
    mutation RenameTagGroup($input: RenameTagGroupInput!) {
  renameTagGroup(input: $input) {
    tagGroup {
      id
      name
      campaignContextId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RenameTagGroupGQL extends Apollo.Mutation<RenameTagGroupMutation, RenameTagGroupMutationVariables> {
    document = RenameTagGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnassociateTagFromCampaignDocument = gql`
    mutation UnassociateTagFromCampaign($input: UnassociateTagFromCampaignInput!, $isInCampaignId: ID = null) {
  unassociateTagFromCampaign(input: $input) {
    tag {
      ...TagInfo
      isInCampaign(campaignId: $isInCampaignId)
      category {
        id
        isInCampaign(campaignId: $isInCampaignId)
        group {
          id
          isInCampaign(campaignId: $isInCampaignId)
        }
      }
    }
  }
}
    ${TagInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UnassociateTagFromCampaignGQL extends Apollo.Mutation<UnassociateTagFromCampaignMutation, UnassociateTagFromCampaignMutationVariables> {
    document = UnassociateTagFromCampaignDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAddressTagDocument = gql`
    mutation UpdateAddressTag($input: UpdateAddressTagInput!) {
  updateAddressTag(input: $input) {
    tag {
      ...TagInfo
    }
  }
}
    ${TagInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAddressTagGQL extends Apollo.Mutation<UpdateAddressTagMutation, UpdateAddressTagMutationVariables> {
    document = UpdateAddressTagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateShiftDocument = gql`
    mutation UpdateShift($input: UpdateShiftInput!) {
  updateShift(input: $input) {
    shift {
      ...ShiftInfo
    }
  }
}
    ${ShiftInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateShiftGQL extends Apollo.Mutation<UpdateShiftMutation, UpdateShiftMutationVariables> {
    document = UpdateShiftDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTagCategoryDocument = gql`
    mutation UpdateTagCategory($input: UpdateTagCategoryInput!) {
  updateTagCategory(input: $input) {
    tagCategory {
      ...TagCategoryInfo
    }
  }
}
    ${TagCategoryInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTagCategoryGQL extends Apollo.Mutation<UpdateTagCategoryMutation, UpdateTagCategoryMutationVariables> {
    document = UpdateTagCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTagDocument = gql`
    mutation UpdateTag($input: UpdateTagInput!) {
  updateTag(input: $input) {
    tag {
      ...TagInfo
    }
  }
}
    ${TagInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTagGQL extends Apollo.Mutation<UpdateTagMutation, UpdateTagMutationVariables> {
    document = UpdateTagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCustomIdTypeDocument = gql`
    mutation UpdateCustomIdType($input: UpdateCustomIdInput!) {
  updateCustomId(input: $input) {
    customIdType {
      ...CustomIdTypeDetails
    }
  }
}
    ${CustomIdTypeDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCustomIdTypeGQL extends Apollo.Mutation<UpdateCustomIdTypeMutation, UpdateCustomIdTypeMutationVariables> {
    document = UpdateCustomIdTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateGeocodeDocument = gql`
    mutation UpdateGeocode($input: UpdateAddressGeolocationInput!) {
  updateAddressGeolocation(input: $input) {
    address {
      ...AddressDetails
    }
  }
}
    ${AddressDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateGeocodeGQL extends Apollo.Mutation<UpdateGeocodeMutation, UpdateGeocodeMutationVariables> {
    document = UpdateGeocodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AcceptInviteDocument = gql`
    mutation AcceptInvite($input: AcceptInvitationInput!) {
  acceptInvitation(input: $input) {
    user {
      ...UserDetails
    }
  }
}
    ${UserDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AcceptInviteGQL extends Apollo.Mutation<AcceptInviteMutation, AcceptInviteMutationVariables> {
    document = AcceptInviteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddUserToCampaignDocument = gql`
    mutation AddUserToCampaign($input: AddCampaignParticipantInput!) {
  addCampaignParticipant(input: $input) {
    user {
      ...UserDetails
      ...UserWithTurfAssignments
    }
  }
}
    ${UserDetailsFragmentDoc}
${UserWithTurfAssignmentsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddUserToCampaignGQL extends Apollo.Mutation<AddUserToCampaignMutation, AddUserToCampaignMutationVariables> {
    document = AddUserToCampaignDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelInviteDocument = gql`
    mutation CancelInvite($input: CancelInvitationInput!) {
  cancelInvitation(input: $input) {
    user {
      ...UserDetails
    }
  }
}
    ${UserDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelInviteGQL extends Apollo.Mutation<CancelInviteMutation, CancelInviteMutationVariables> {
    document = CancelInviteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserDocument = gql`
    mutation CreateUser($input: CreateInvitationInput!) {
  createInvitation(input: $input) {
    user {
      ...UserDetails
      ...UserWithTurfAssignments
    }
  }
}
    ${UserDetailsFragmentDoc}
${UserWithTurfAssignmentsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserGQL extends Apollo.Mutation<CreateUserMutation, CreateUserMutationVariables> {
    document = CreateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisableUserDocument = gql`
    mutation DisableUser($input: DisableUserInput!) {
  disableUser(input: $input) {
    user {
      ...UserDetails
      ...UserWithTurfAssignments
    }
  }
}
    ${UserDetailsFragmentDoc}
${UserWithTurfAssignmentsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DisableUserGQL extends Apollo.Mutation<DisableUserMutation, DisableUserMutationVariables> {
    document = DisableUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetUsersDisableOnDateDocument = gql`
    mutation SetUsersDisableOnDate($input: SetUsersDisableOnDateInput!) {
  setUsersDisableOnDate(input: $input) {
    users {
      ...UserDetails
      ...UserWithTurfAssignments
    }
  }
}
    ${UserDetailsFragmentDoc}
${UserWithTurfAssignmentsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SetUsersDisableOnDateGQL extends Apollo.Mutation<SetUsersDisableOnDateMutation, SetUsersDisableOnDateMutationVariables> {
    document = SetUsersDisableOnDateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnableUserDocument = gql`
    mutation EnableUser($input: EnableUserInput!) {
  enableUser(input: $input) {
    user {
      ...UserDetails
      ...UserWithTurfAssignments
    }
  }
}
    ${UserDetailsFragmentDoc}
${UserWithTurfAssignmentsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EnableUserGQL extends Apollo.Mutation<EnableUserMutation, EnableUserMutationVariables> {
    document = EnableUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveMfaDocument = gql`
    mutation RemoveMfa($input: RemoveMfaInput!) {
  removeMfa(input: $input) {
    user {
      ...UserDetails
    }
  }
}
    ${UserDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveMfaGQL extends Apollo.Mutation<RemoveMfaMutation, RemoveMfaMutationVariables> {
    document = RemoveMfaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResendMfaCodeDocument = gql`
    mutation ResendMfaCode($input: ResendMfaCodeInput!) {
  resendMfaCode(input: $input) {
    user {
      ...UserDetails
    }
  }
}
    ${UserDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendMfaCodeGQL extends Apollo.Mutation<ResendMfaCodeMutation, ResendMfaCodeMutationVariables> {
    document = ResendMfaCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResendUserInviteDocument = gql`
    mutation ResendUserInvite($input: ResendInvitationInput!) {
  resendInvitation(input: $input) {
    user {
      ...UserDetails
    }
  }
}
    ${UserDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendUserInviteGQL extends Apollo.Mutation<ResendUserInviteMutation, ResendUserInviteMutationVariables> {
    document = ResendUserInviteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StartMfaSetupDocument = gql`
    mutation StartMfaSetup($input: StartMfaSetupInput!) {
  startMfaSetup(input: $input) {
    user {
      ...UserDetails
    }
    mfaFactor {
      id
      factorType
      status
      phoneLastFour
      qrCodeSvg
      qrCodeUrl
      secret
      provisioningUri
    }
  }
}
    ${UserDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class StartMfaSetupGQL extends Apollo.Mutation<StartMfaSetupMutation, StartMfaSetupMutationVariables> {
    document = StartMfaSetupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCurrentUserDocument = gql`
    mutation UpdateCurrentUser($input: UpdateCurrentUserInput!) {
  updateCurrentUser(input: $input) {
    user {
      ...UserDetails
      ...UserWithTurfAssignments
    }
  }
}
    ${UserDetailsFragmentDoc}
${UserWithTurfAssignmentsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCurrentUserGQL extends Apollo.Mutation<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables> {
    document = UpdateCurrentUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserByIdDocument = gql`
    mutation UpdateUserById($input: UpdateUserByIdInput!) {
  updateUserById(input: $input) {
    user {
      ...UserDetails
      ...UserWithTurfAssignments
    }
  }
}
    ${UserDetailsFragmentDoc}
${UserWithTurfAssignmentsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserByIdGQL extends Apollo.Mutation<UpdateUserByIdMutation, UpdateUserByIdMutationVariables> {
    document = UpdateUserByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const VerifyMfaLoginDocument = gql`
    mutation VerifyMfaLogin($input: VerifyMfaLoginInput!) {
  verifyMfaLogin(input: $input) {
    user {
      ...UserDetails
    }
  }
}
    ${UserDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class VerifyMfaLoginGQL extends Apollo.Mutation<VerifyMfaLoginMutation, VerifyMfaLoginMutationVariables> {
    document = VerifyMfaLoginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const VerifyMfaSetupDocument = gql`
    mutation VerifyMfaSetup($input: VerifyMfaSetupInput!) {
  verifyMfaSetup(input: $input) {
    mfaFactor {
      id
      factorType
      status
      verifiedAt
    }
    user {
      ...UserDetails
    }
  }
}
    ${UserDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class VerifyMfaSetupGQL extends Apollo.Mutation<VerifyMfaSetupMutation, VerifyMfaSetupMutationVariables> {
    document = VerifyMfaSetupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCampaignEntityTypeConfigurationDocument = gql`
    query GetCampaignEntityTypeConfiguration($campaignId: ID!, $entityTypeId: ID!) {
  getCampaignEntityTypeConfiguration(
    campaignId: $campaignId
    entityTypeId: $entityTypeId
  ) {
    ...CampaignEntityTypeConfigDetails
  }
}
    ${CampaignEntityTypeConfigDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCampaignEntityTypeConfigurationGQL extends Apollo.Query<GetCampaignEntityTypeConfigurationQuery, GetCampaignEntityTypeConfigurationQueryVariables> {
    document = GetCampaignEntityTypeConfigurationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCampaignEntityTypeConfigurationsDocument = gql`
    query GetCampaignEntityTypeConfigurations($campaignId: ID!) {
  getCampaignEntityTypeConfigurations(campaignId: $campaignId) {
    ...CampaignEntityTypeConfigDetails
  }
}
    ${CampaignEntityTypeConfigDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCampaignEntityTypeConfigurationsGQL extends Apollo.Query<GetCampaignEntityTypeConfigurationsQuery, GetCampaignEntityTypeConfigurationsQueryVariables> {
    document = GetCampaignEntityTypeConfigurationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchCampaignObjectVisibilityDocument = gql`
    query SearchCampaignObjectVisibility($objectTypeId: ID!, $objectType: CampaignObjectVisibilityTypesType!, $visibility: String!, $keyword: String, $first: Int, $after: String) {
  searchCampaignObjectVisibility(
    objectTypeId: $objectTypeId
    objectType: $objectType
    visibility: $visibility
    keyword: $keyword
    first: $first
    after: $after
  ) {
    edges {
      node {
        campaignId
        campaignName
        visibleInCampaign
      }
      cursor
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchCampaignObjectVisibilityGQL extends Apollo.Query<SearchCampaignObjectVisibilityQuery, SearchCampaignObjectVisibilityQueryVariables> {
    document = SearchCampaignObjectVisibilityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CampaignHasEntitiesDocument = gql`
    query CampaignHasEntities($campaignId: ID!) {
  getEntities(campaignId: $campaignId, first: 1) {
    nodes {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CampaignHasEntitiesGQL extends Apollo.Query<CampaignHasEntitiesQuery, CampaignHasEntitiesQueryVariables> {
    document = CampaignHasEntitiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCampaignByIdNoTagsDocument = gql`
    query GetCampaignByIdNoTags($campaignId: ID!, $withEntitiesCount: Boolean = false) {
  getCampaign(campaignId: $campaignId) {
    ...CampaignWithoutTags
    entitiesCount @include(if: $withEntitiesCount)
  }
}
    ${CampaignWithoutTagsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCampaignByIdNoTagsGQL extends Apollo.Query<GetCampaignByIdNoTagsQuery, GetCampaignByIdNoTagsQueryVariables> {
    document = GetCampaignByIdNoTagsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCampaignDefaultCountryDocument = gql`
    query GetCampaignDefaultCountry($campaignId: ID!) {
  getCampaign(campaignId: $campaignId) {
    id
    name
    defaultCountry
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCampaignDefaultCountryGQL extends Apollo.Query<GetCampaignDefaultCountryQuery, GetCampaignDefaultCountryQueryVariables> {
    document = GetCampaignDefaultCountryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCampaignIdsDocument = gql`
    query GetCampaignIds($status: CampaignStatusType) {
  searchCampaigns(keyword: "", status: $status) {
    matchingIds
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCampaignIdsGQL extends Apollo.Query<GetCampaignIdsQuery, GetCampaignIdsQueryVariables> {
    document = GetCampaignIdsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCampaignIntegrationsDocument = gql`
    query GetCampaignIntegrations($campaignId: ID!) {
  getCampaign(campaignId: $campaignId) {
    id
    name
    integrations {
      id
      externalServiceId
    }
    campaignIntegrations {
      actionNetwork {
        ...ANCampaignIntegration
      }
    }
  }
}
    ${AnCampaignIntegrationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCampaignIntegrationsGQL extends Apollo.Query<GetCampaignIntegrationsQuery, GetCampaignIntegrationsQueryVariables> {
    document = GetCampaignIntegrationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCampaignPublicByIdDocument = gql`
    query GetCampaignPublicById($campaignId: ID!) {
  getCampaignPublic(campaignId: $campaignId) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCampaignPublicByIdGQL extends Apollo.Query<GetCampaignPublicByIdQuery, GetCampaignPublicByIdQueryVariables> {
    document = GetCampaignPublicByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCampaignSupportDocument = gql`
    query GetCampaignSupport($campaignId: ID!) {
  getCampaign(campaignId: $campaignId) {
    id
    name
    supportUser {
      id
      linkedEntityId
      firstName
      lastName
      email
      phoneNumber
      role
      disabled
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCampaignSupportGQL extends Apollo.Query<GetCampaignSupportQuery, GetCampaignSupportQueryVariables> {
    document = GetCampaignSupportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCampaignsCountDocument = gql`
    query GetCampaignsCount {
  searchCampaigns(keyword: null, first: 0) @connection(key: "getCampaignsCount") {
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCampaignsCountGQL extends Apollo.Query<GetCampaignsCountQuery, GetCampaignsCountQueryVariables> {
    document = GetCampaignsCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchCampaignsDocument = gql`
    query SearchCampaigns($keyword: String, $first: Int, $after: String, $status: CampaignStatusType, $withEntitiesCount: Boolean = false, $withMatchingIds: Boolean = false) {
  searchCampaigns(
    keyword: $keyword
    first: $first
    after: $after
    status: $status
  ) {
    edges {
      node {
        ...CampaignWithoutTags
        entitiesCount @include(if: $withEntitiesCount)
        participantsCount @include(if: $withEntitiesCount)
      }
      cursor
    }
    matchingIds @include(if: $withMatchingIds)
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${CampaignWithoutTagsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchCampaignsGQL extends Apollo.Query<SearchCampaignsQuery, SearchCampaignsQueryVariables> {
    document = SearchCampaignsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCampaignConnectionTypeConfigurationsDocument = gql`
    query GetCampaignConnectionTypeConfigurations($campaignId: ID!) {
  getCampaignEntityConnectionTypeConfigurations(campaignId: $campaignId) {
    ...CampaignConnectionTypeConfigDetails
  }
}
    ${CampaignConnectionTypeConfigDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCampaignConnectionTypeConfigurationsGQL extends Apollo.Query<GetCampaignConnectionTypeConfigurationsQuery, GetCampaignConnectionTypeConfigurationsQueryVariables> {
    document = GetCampaignConnectionTypeConfigurationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEntityConnectionTypeDocument = gql`
    query GetEntityConnectionType($id: ID!, $campaignId: ID) {
  getEntityConnectionType(id: $id, campaignId: $campaignId) {
    ...EntityConnectionTypeDetails
  }
}
    ${EntityConnectionTypeDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEntityConnectionTypeGQL extends Apollo.Query<GetEntityConnectionTypeQuery, GetEntityConnectionTypeQueryVariables> {
    document = GetEntityConnectionTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEntityConnectionTypesDocument = gql`
    query GetEntityConnectionTypes($campaignId: ID, $entityTypeId: ID) {
  getEntityConnectionTypes(campaignId: $campaignId, entityTypeId: $entityTypeId) {
    ...EntityConnectionTypeDetails
  }
}
    ${EntityConnectionTypeDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEntityConnectionTypesGQL extends Apollo.Query<GetEntityConnectionTypesQuery, GetEntityConnectionTypesQueryVariables> {
    document = GetEntityConnectionTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEntityConnectionDocument = gql`
    query GetEntityConnection($entityConnectionId: ID!, $campaignId: ID!, $withTags: Boolean = true, $withToplines: Boolean = true, $withNotes: Boolean = true) {
  getEntityConnection(
    entityConnectionId: $entityConnectionId
    campaignId: $campaignId
  ) {
    ...EntityConnectionCore
    ...EntityConnectionWithToplines @include(if: $withToplines)
    ...EntityConnectionWithTags @include(if: $withTags)
    ...EntityConnectionWithNotes @include(if: $withNotes)
  }
}
    ${EntityConnectionCoreFragmentDoc}
${EntityConnectionWithToplinesFragmentDoc}
${EntityConnectionWithTagsFragmentDoc}
${EntityConnectionWithNotesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEntityConnectionGQL extends Apollo.Query<GetEntityConnectionQuery, GetEntityConnectionQueryVariables> {
    document = GetEntityConnectionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEntityConnectionsDocument = gql`
    query GetEntityConnections($entityId: ID!, $campaignId: ID!, $entityConnectionTypeId: ID!, $includeInactive: Boolean, $first: Int, $after: String) {
  getEntityConnections(
    entityId: $entityId
    campaignId: $campaignId
    entityConnectionTypeId: $entityConnectionTypeId
    includeInactive: $includeInactive
    first: $first
    after: $after
  ) {
    nodes {
      ...EntityConnectionCore
      ...EntityConnectionWithHighlightedTopline
      ...EntityConnectionWithNotes
      tagsCount
    }
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${EntityConnectionCoreFragmentDoc}
${EntityConnectionWithHighlightedToplineFragmentDoc}
${EntityConnectionWithNotesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEntityConnectionsGQL extends Apollo.Query<GetEntityConnectionsQuery, GetEntityConnectionsQueryVariables> {
    document = GetEntityConnectionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEntityTypeDocument = gql`
    query GetEntityType($entityTypeId: ID!) {
  getEntityType(entityTypeId: $entityTypeId) {
    ...EntityTypeDetails
  }
}
    ${EntityTypeDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEntityTypeGQL extends Apollo.Query<GetEntityTypeQuery, GetEntityTypeQueryVariables> {
    document = GetEntityTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEntityTypesDocument = gql`
    query GetEntityTypes($first: Int, $after: String) {
  getEntityTypes(first: $first, after: $after) @connection(key: "getEntityTypes") {
    nodes {
      ...EntityTypeDetails
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${EntityTypeDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEntityTypesGQL extends Apollo.Query<GetEntityTypesQuery, GetEntityTypesQueryVariables> {
    document = GetEntityTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEntitiesForWallChartQueryDocument = gql`
    query GetEntitiesForWallChartQuery($entityIds: [ID!], $campaignId: ID!, $withToplines: Boolean = true) {
  getEntitiesByIds(entityIds: $entityIds, campaignId: $campaignId) {
    ...EntityCore
    ...EntityWithHighlightedTopline @skip(if: $withToplines)
    ...EntityWithToplines @include(if: $withToplines)
    ...EntityWithEntityType
    ...EntityWithBasicInfo
    ...EntityWithContactIcons
  }
}
    ${EntityCoreFragmentDoc}
${EntityWithHighlightedToplineFragmentDoc}
${EntityWithToplinesFragmentDoc}
${EntityWithEntityTypeFragmentDoc}
${EntityWithBasicInfoFragmentDoc}
${EntityWithContactIconsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEntitiesForWallChartQueryGQL extends Apollo.Query<GetEntitiesForWallChartQueryQuery, GetEntitiesForWallChartQueryQueryVariables> {
    document = GetEntitiesForWallChartQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWallChartDocument = gql`
    query GetWallChart($campaignId: ID!, $groupBy: AggregatorEntry, $thenBy: AggregatorEntry, $splitMatchesBy: AggregatorSplitMatchType, $splitMatchesByTagIds: [String!], $queryBody: String, $queryName: String) {
  wallchart3(
    campaignId: $campaignId
    groupBy: $groupBy
    thenBy: $thenBy
    splitMatchesBy: $splitMatchesBy
    splitMatchesByTagIds: $splitMatchesByTagIds
    queryBody: $queryBody
    queryName: $queryName
  ) {
    groupBy {
      label
      labelId
      matches {
        entities
        matchGroupId
        matchGroupLabel
        matchGroupMatched
      }
    }
    label
    labelId
    matches {
      entities
      matchGroupId
      matchGroupLabel
      matchGroupMatched
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWallChartGQL extends Apollo.Query<GetWallChartQuery, GetWallChartQueryVariables> {
    document = GetWallChartDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEntitiesForMapViewDocument = gql`
    query GetEntitiesForMapView($campaignId: ID!, $first: Int, $after: String, $last: Int, $before: String, $name: String, $body: String!, $orderBy: String) {
  entitiesQuery(
    campaignId: $campaignId
    first: $first
    after: $after
    last: $last
    before: $before
    name: $name
    body: $body
    orderBy: $orderBy
  ) @connection(key: "entitiesQueryForMap", filter: ["campaignId", "after", "first", "name", "orderBy"]) {
    nodes {
      ...EntityWithMapViewDetails
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    limitedCount
  }
}
    ${EntityWithMapViewDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEntitiesForMapViewGQL extends Apollo.Query<GetEntitiesForMapViewQuery, GetEntitiesForMapViewQueryVariables> {
    document = GetEntitiesForMapViewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EntitiesQueryDocument = gql`
    query EntitiesQuery($campaignId: ID!, $body: String!, $withToplines: Boolean = true, $withFollowUpDetails: Boolean = true, $keyword: String, $first: Int, $after: String, $last: Int, $before: String, $name: String, $orderBy: String) {
  entitiesQuery(
    campaignId: $campaignId
    first: $first
    after: $after
    last: $last
    before: $before
    name: $name
    body: $body
    keyword: $keyword
    orderBy: $orderBy
  ) @connection(key: "entitiesQuery", filter: ["campaignId", "after", "first", "name", "orderBy", "keyword", "withToplines", "withFollowUpDetails"]) {
    nodes {
      ...EntityCore
      ...EntityWithBasicInfo
      ...EntityWithEntityType
      ...EntityWithBestAddress
      ...EntityWithBestPhone
      ...EntityWithBestEmail
      ...EntityWithHighlightedTopline @skip(if: $withToplines)
      ...EntityWithToplines @include(if: $withToplines)
      ...EntityWithFollowUpDetails @include(if: $withFollowUpDetails)
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    limitedCount
    totalCount
  }
}
    ${EntityCoreFragmentDoc}
${EntityWithBasicInfoFragmentDoc}
${EntityWithEntityTypeFragmentDoc}
${EntityWithBestAddressFragmentDoc}
${EntityWithBestPhoneFragmentDoc}
${EntityWithBestEmailFragmentDoc}
${EntityWithHighlightedToplineFragmentDoc}
${EntityWithToplinesFragmentDoc}
${EntityWithFollowUpDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EntitiesQueryGQL extends Apollo.Query<EntitiesQueryQuery, EntitiesQueryQueryVariables> {
    document = EntitiesQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EntitiesTotalCountQueryDocument = gql`
    query EntitiesTotalCountQuery($campaignId: ID!, $body: String!, $keyword: String, $name: String) {
  entitiesQuery(
    campaignId: $campaignId
    name: $name
    body: $body
    keyword: $keyword
    first: 1
  ) {
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EntitiesTotalCountQueryGQL extends Apollo.Query<EntitiesTotalCountQueryQuery, EntitiesTotalCountQueryQueryVariables> {
    document = EntitiesTotalCountQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCurrentAssessmentsForEntitiesDocument = gql`
    query GetCurrentAssessmentsForEntities($entityIds: [ID!], $campaignId: ID!) {
  getEntitiesByIds(entityIds: $entityIds, campaignId: $campaignId) {
    campaignContextId
    id
    currentAssessmentLevel
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCurrentAssessmentsForEntitiesGQL extends Apollo.Query<GetCurrentAssessmentsForEntitiesQuery, GetCurrentAssessmentsForEntitiesQueryVariables> {
    document = GetCurrentAssessmentsForEntitiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEntityAssessmentsDocument = gql`
    query GetEntityAssessments($entityId: ID!, $campaignId: ID!) {
  getEntity(entityId: $entityId, campaignId: $campaignId) {
    ...EntityWithAssessments
  }
}
    ${EntityWithAssessmentsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEntityAssessmentsGQL extends Apollo.Query<GetEntityAssessmentsQuery, GetEntityAssessmentsQueryVariables> {
    document = GetEntityAssessmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEntityBasicDocument = gql`
    query GetEntityBasic($campaignId: ID!, $entityId: ID!) {
  getEntity(campaignId: $campaignId, entityId: $entityId) {
    ...EntityCore
    ...EntityWithBasicInfo
    ...EntityWithEntityType
  }
}
    ${EntityCoreFragmentDoc}
${EntityWithBasicInfoFragmentDoc}
${EntityWithEntityTypeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEntityBasicGQL extends Apollo.Query<GetEntityBasicQuery, GetEntityBasicQueryVariables> {
    document = GetEntityBasicDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEntityById2Document = gql`
    query GetEntityById2($entityId: ID!, $campaignId: ID!, $withHighligtedTopline: Boolean = true, $withToplines: Boolean = true, $withEntityType: Boolean = true, $withIds: Boolean = false, $withBestAddress: Boolean = false, $withBestEmail: Boolean = false, $withBestPhone: Boolean = false, $withEmails: Boolean = false, $withPhones: Boolean = false, $withSocials: Boolean = false, $withAddresses: Boolean = false, $withTags: Boolean = false, $withConnectionCounts: Boolean = false, $withFollowUpDetails: Boolean = false, $withAssessments: Boolean = false, $withCalendarResponses: Boolean = false, $withCalendarEventCounts: Boolean = false) {
  getEntity(entityId: $entityId, campaignId: $campaignId) {
    ...EntityCore
    ...EntityWithBasicInfo
    ...EntityWithHighlightedTopline @include(if: $withHighligtedTopline)
    ...EntityWithFollowUpDetails @include(if: $withFollowUpDetails)
    ...EntityWithEntityType @include(if: $withEntityType)
    ...EntityWithBestAddress @include(if: $withBestAddress)
    ...EntityWithBestPhone @include(if: $withBestPhone)
    ...EntityWithSocialProfiles @include(if: $withSocials)
    ...EntityWithBestEmail @include(if: $withBestEmail)
    ...EntityWithToplines @include(if: $withToplines)
    ...EntityWithEmails @include(if: $withEmails)
    ...EntityWithPhones @include(if: $withPhones)
    ...EntityWithAddresses @include(if: $withAddresses)
    ...EntityWithTags @include(if: $withTags)
    ...EntityWithConnectionCounts @include(if: $withConnectionCounts)
    ...EntityWithIds @include(if: $withIds)
    ...EntityWithAssessments @include(if: $withAssessments)
    ...EntityWithCalendarResponses @include(if: $withCalendarResponses)
    ...EntityWithCalendarEventCounts @include(if: $withCalendarEventCounts)
  }
}
    ${EntityCoreFragmentDoc}
${EntityWithBasicInfoFragmentDoc}
${EntityWithHighlightedToplineFragmentDoc}
${EntityWithFollowUpDetailsFragmentDoc}
${EntityWithEntityTypeFragmentDoc}
${EntityWithBestAddressFragmentDoc}
${EntityWithBestPhoneFragmentDoc}
${EntityWithSocialProfilesFragmentDoc}
${EntityWithBestEmailFragmentDoc}
${EntityWithToplinesFragmentDoc}
${EntityWithEmailsFragmentDoc}
${EntityWithPhonesFragmentDoc}
${EntityWithAddressesFragmentDoc}
${EntityWithTagsFragmentDoc}
${EntityWithConnectionCountsFragmentDoc}
${EntityWithIdsFragmentDoc}
${EntityWithAssessmentsFragmentDoc}
${EntityWithCalendarResponsesFragmentDoc}
${EntityWithCalendarEventCountsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEntityById2GQL extends Apollo.Query<GetEntityById2Query, GetEntityById2QueryVariables> {
    document = GetEntityById2Document;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEntityNameDocument = gql`
    query GetEntityName($campaignId: ID!, $entityId: ID!) {
  getEntity(campaignId: $campaignId, entityId: $entityId) {
    id
    campaignContextId
    firstName
    lastName
    middleName
    nickname
    pronouns
    suffix
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEntityNameGQL extends Apollo.Query<GetEntityNameQuery, GetEntityNameQueryVariables> {
    document = GetEntityNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEntityNotesDocument = gql`
    query GetEntityNotes($campaignId: ID!, $entityId: ID!) {
  getEntity(campaignId: $campaignId, entityId: $entityId) {
    ...EntityWithNotes
  }
}
    ${EntityWithNotesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEntityNotesGQL extends Apollo.Query<GetEntityNotesQuery, GetEntityNotesQueryVariables> {
    document = GetEntityNotesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEntityPublicDocument = gql`
    query GetEntityPublic($campaignId: ID!, $entityId: ID!) {
  getEntityPublic(campaignId: $campaignId, entityId: $entityId) {
    ...EntityPublicInfo
  }
}
    ${EntityPublicInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEntityPublicGQL extends Apollo.Query<GetEntityPublicQuery, GetEntityPublicQueryVariables> {
    document = GetEntityPublicDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPotentialDuplicatesDocument = gql`
    query GetPotentialDuplicates($entityId: ID!, $campaignId: ID!) {
  getPotentialEntityDuplicates(entityId: $entityId, campaignId: $campaignId) {
    duplicateReferenceId
    emailMatches {
      key
      entities {
        ...EntityWithHighlightedTopline
        ...EntityWithBasicInfo
        ...EntityCore
      }
    }
    phoneMatches {
      key
      entities {
        ...EntityWithHighlightedTopline
        ...EntityWithBasicInfo
        ...EntityCore
      }
    }
  }
}
    ${EntityWithHighlightedToplineFragmentDoc}
${EntityWithBasicInfoFragmentDoc}
${EntityCoreFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPotentialDuplicatesGQL extends Apollo.Query<GetPotentialDuplicatesQuery, GetPotentialDuplicatesQueryVariables> {
    document = GetPotentialDuplicatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSocialNetworksDocument = gql`
    query GetSocialNetworks {
  getSocialNetworks {
    ...SocialNetworkDetails
  }
}
    ${SocialNetworkDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSocialNetworksGQL extends Apollo.Query<GetSocialNetworksQuery, GetSocialNetworksQueryVariables> {
    document = GetSocialNetworksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchEntitiesPublicDocument = gql`
    query SearchEntitiesPublic($keyword: String!, $campaignId: ID, $assessmentCampaignId: ID, $entityTypeIds: [ID!], $accessibleEntitiesOnly: Boolean, $turfOnly: Boolean) {
  searchEntitiesPublic(
    first: 20
    keyword: $keyword
    campaignId: $campaignId
    entityTypeIds: $entityTypeIds
    assessmentCampaignId: $assessmentCampaignId
    accessibleEntitiesOnly: $accessibleEntitiesOnly
    turfOnly: $turfOnly
  ) {
    nodes {
      ...EntityPublicInfo
      ...EntityPublicWithCampaigns
    }
  }
}
    ${EntityPublicInfoFragmentDoc}
${EntityPublicWithCampaignsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchEntitiesPublicGQL extends Apollo.Query<SearchEntitiesPublicQuery, SearchEntitiesPublicQueryVariables> {
    document = SearchEntitiesPublicDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchEntitiesDocument = gql`
    query SearchEntities($keyword: String!, $assessmentCampaignId: ID, $entityTypeId: ID, $first: Int = 50) {
  searchEntities(
    first: $first
    keyword: $keyword
    assessmentCampaignId: $assessmentCampaignId
    entityTypeId: $entityTypeId
  ) {
    nodes {
      ...EntityCore
      ...EntityWithBasicInfo
      ...EntityWithEntityType
      ...EntityWithBestAddress
      ...EntityWithBestEmail
      ...EntityWithBestPhone
      campaigns {
        id
        name
      }
    }
  }
}
    ${EntityCoreFragmentDoc}
${EntityWithBasicInfoFragmentDoc}
${EntityWithEntityTypeFragmentDoc}
${EntityWithBestAddressFragmentDoc}
${EntityWithBestEmailFragmentDoc}
${EntityWithBestPhoneFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchEntitiesGQL extends Apollo.Query<SearchEntitiesQuery, SearchEntitiesQueryVariables> {
    document = SearchEntitiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCalendarEventResponseForEntityDocument = gql`
    query GetCalendarEventResponseForEntity($campaignId: ID!, $entityId: ID!, $calendarEventId: ID!) {
  getCalendarEventResponseForEntity(
    campaignId: $campaignId
    entityId: $entityId
    calendarEventId: $calendarEventId
  ) {
    ...CalendarEventResponseCore
  }
}
    ${CalendarEventResponseCoreFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCalendarEventResponseForEntityGQL extends Apollo.Query<GetCalendarEventResponseForEntityQuery, GetCalendarEventResponseForEntityQueryVariables> {
    document = GetCalendarEventResponseForEntityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCalendarEventResponseDocument = gql`
    query GetCalendarEventResponse($campaignId: ID!, $id: ID!) {
  getCalendarEventResponse(campaignId: $campaignId, id: $id) {
    ...CalendarEventResponseCore
  }
}
    ${CalendarEventResponseCoreFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCalendarEventResponseGQL extends Apollo.Query<GetCalendarEventResponseQuery, GetCalendarEventResponseQueryVariables> {
    document = GetCalendarEventResponseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCalendarEventDocument = gql`
    query GetCalendarEvent($campaignId: ID!, $id: ID!) {
  getCalendarEvent(campaignId: $campaignId, id: $id) {
    ...CalendarEventDetails
  }
}
    ${CalendarEventDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCalendarEventGQL extends Apollo.Query<GetCalendarEventQuery, GetCalendarEventQueryVariables> {
    document = GetCalendarEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchCalendarEventResponsesDocument = gql`
    query SearchCalendarEventResponses($campaignId: ID!, $calendarEventId: ID, $entityId: ID, $keyword: String, $dateRange: DateRangeInput) {
  searchCalendarEventResponses(
    campaignId: $campaignId
    calendarEventId: $calendarEventId
    entityId: $entityId
    keyword: $keyword
    dateRange: $dateRange
  ) {
    nodes {
      ...CalendarEventResponseCore
    }
  }
}
    ${CalendarEventResponseCoreFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchCalendarEventResponsesGQL extends Apollo.Query<SearchCalendarEventResponsesQuery, SearchCalendarEventResponsesQueryVariables> {
    document = SearchCalendarEventResponsesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchCalendarEventsDocument = gql`
    query SearchCalendarEvents($campaignId: ID!, $keyword: String, $dateRange: DateRangeInput, $entityId: ID = null) {
  searchCalendarEvents(
    campaignId: $campaignId
    keyword: $keyword
    dateRange: $dateRange
  ) {
    nodes {
      ...CalendarEventDetails
      entityResponse(entityId: $entityId) {
        ...CalendarEventResponseCore
      }
    }
  }
}
    ${CalendarEventDetailsFragmentDoc}
${CalendarEventResponseCoreFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchCalendarEventsGQL extends Apollo.Query<SearchCalendarEventsQuery, SearchCalendarEventsQueryVariables> {
    document = SearchCalendarEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAddressForEntityDocument = gql`
    query GetAddressForEntity($addressId: ID!, $entityId: ID!, $campaignId: ID!) {
  getAddress(addressId: $addressId, entityId: $entityId, campaignId: $campaignId) {
    ...AddressDetails
  }
}
    ${AddressDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAddressForEntityGQL extends Apollo.Query<GetAddressForEntityQuery, GetAddressForEntityQueryVariables> {
    document = GetAddressForEntityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCustomIdTypesDocument = gql`
    query GetCustomIdTypes {
  getCustomIdTypes {
    id
    active
    internalName
    label
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCustomIdTypesGQL extends Apollo.Query<GetCustomIdTypesQuery, GetCustomIdTypesQueryVariables> {
    document = GetCustomIdTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExternalServicesDocument = gql`
    query GetExternalServices {
  getExternalServices {
    id
    serviceName
    clientId
    workflowId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetExternalServicesGQL extends Apollo.Query<GetExternalServicesQuery, GetExternalServicesQueryVariables> {
    document = GetExternalServicesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrganizationDetailsDocument = gql`
    query GetOrganizationDetails {
  getOrganization {
    ...OrganizationDetails
  }
}
    ${OrganizationDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrganizationDetailsGQL extends Apollo.Query<GetOrganizationDetailsQuery, GetOrganizationDetailsQueryVariables> {
    document = GetOrganizationDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDefaultSavedQueryDocument = gql`
    query GetDefaultSavedQuery($campaignId: ID!) {
  getDefaultSavedQuery(campaignId: $campaignId) {
    ...SavedQueryDetails
  }
}
    ${SavedQueryDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDefaultSavedQueryGQL extends Apollo.Query<GetDefaultSavedQueryQuery, GetDefaultSavedQueryQueryVariables> {
    document = GetDefaultSavedQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSavedQueriesDocument = gql`
    query GetSavedQueries($campaignId: ID!, $keyword: String) {
  getSavedQueries(campaignId: $campaignId, keyword: $keyword, first: 2000) {
    edges {
      node {
        ...SavedQueryDetails
      }
    }
  }
}
    ${SavedQueryDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSavedQueriesGQL extends Apollo.Query<GetSavedQueriesQuery, GetSavedQueriesQueryVariables> {
    document = GetSavedQueriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSavedQueryDocument = gql`
    query GetSavedQuery($campaignId: ID!, $queryId: ID!) {
  getSavedQuery(campaignId: $campaignId, queryId: $queryId) {
    ...SavedQueryDetails
  }
}
    ${SavedQueryDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSavedQueryGQL extends Apollo.Query<GetSavedQueryQuery, GetSavedQueryQueryVariables> {
    document = GetSavedQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchSavedQueriesDocument = gql`
    query SearchSavedQueries($campaignId: ID!, $keyword: String, $queryType: String, $first: Int, $after: String) {
  getSavedQueries(
    campaignId: $campaignId
    keyword: $keyword
    queryType: $queryType
    first: $first
    after: $after
  ) {
    edges {
      node {
        ...SavedQueryDetails
      }
      cursor
    }
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${SavedQueryDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchSavedQueriesGQL extends Apollo.Query<SearchSavedQueriesQuery, SearchSavedQueriesQueryVariables> {
    document = SearchSavedQueriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchElectoralDistrictsDocument = gql`
    query SearchElectoralDistricts($keyword: String) {
  searchElectoralDistricts(keyword: $keyword, first: 50) {
    nodes {
      id
      name
      longName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchElectoralDistrictsGQL extends Apollo.Query<SearchElectoralDistrictsQuery, SearchElectoralDistrictsQueryVariables> {
    document = SearchElectoralDistrictsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchLocationsDocument = gql`
    query SearchLocations($keyword: String!, $campaignId: ID!, $type: String!) {
  searchLocations(keyword: $keyword, campaignId: $campaignId, type: $type) {
    text
    type
    value
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchLocationsGQL extends Apollo.Query<SearchLocationsQuery, SearchLocationsQueryVariables> {
    document = SearchLocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTagByIdForQueryDocument = gql`
    query GetTagByIdForQuery($tagId: ID!) {
  getTagById(tagId: $tagId) {
    ...TagInfo
  }
}
    ${TagInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTagByIdForQueryGQL extends Apollo.Query<GetTagByIdForQueryQuery, GetTagByIdForQueryQueryVariables> {
    document = GetTagByIdForQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTagCategoriesOnlyDocument = gql`
    query GetTagCategoriesOnly($campaignId: ID, $targetTypeId: ID, $targetType: String = "Entity") {
  getTagCategories(
    campaignId: $campaignId
    targetTypeId: $targetTypeId
    targetType: $targetType
  ) {
    nodes {
      ...TagCategoryOnly
    }
  }
}
    ${TagCategoryOnlyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTagCategoriesOnlyGQL extends Apollo.Query<GetTagCategoriesOnlyQuery, GetTagCategoriesOnlyQueryVariables> {
    document = GetTagCategoriesOnlyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTagCategoriesDocument = gql`
    query GetTagCategories($campaignId: ID, $targetTypeId: ID, $targetType: String = "Entity") {
  getTagCategories(
    campaignId: $campaignId
    targetTypeId: $targetTypeId
    targetType: $targetType
  ) {
    nodes {
      ...TagCategoryInfo
    }
  }
}
    ${TagCategoryInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTagCategoriesGQL extends Apollo.Query<GetTagCategoriesQuery, GetTagCategoriesQueryVariables> {
    document = GetTagCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTagCategoryByIdDocument = gql`
    query GetTagCategoryById($tagCategoryId: ID!, $campaignId: ID) {
  getTagCategoryById(tagCategoryId: $tagCategoryId, campaignId: $campaignId) {
    ...TagCategoryInfo
  }
}
    ${TagCategoryInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTagCategoryByIdGQL extends Apollo.Query<GetTagCategoryByIdQuery, GetTagCategoryByIdQueryVariables> {
    document = GetTagCategoryByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTagGroups2Document = gql`
    query GetTagGroups2($campaignId: ID, $targetTypeId: ID, $targetType: String, $isInCampaignId: ID = null, $includeNotInCampaign: Boolean) {
  getTagGroups(
    targetTypeId: $targetTypeId
    targetType: $targetType
    campaignId: $campaignId
    includeNotInCampaign: $includeNotInCampaign
  ) {
    nodes {
      isInCampaign(campaignId: $isInCampaignId)
      ...TagGroupInfo
      categories {
        id
        campaignContextId
        isInCampaign(campaignId: $isInCampaignId)
      }
    }
  }
}
    ${TagGroupInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTagGroups2GQL extends Apollo.Query<GetTagGroups2Query, GetTagGroups2QueryVariables> {
    document = GetTagGroups2Document;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTaggableLogbookByIdDocument = gql`
    query GetTaggableLogbookById($taggableLogbookId: ID!) {
  getTaggableLogbookById(taggableLogbookId: $taggableLogbookId) {
    ...TaggableLogbookDetails
  }
}
    ${TaggableLogbookDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTaggableLogbookByIdGQL extends Apollo.Query<GetTaggableLogbookByIdQuery, GetTaggableLogbookByIdQueryVariables> {
    document = GetTaggableLogbookByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTagsByIdsForQueryDocument = gql`
    query GetTagsByIdsForQuery($tagIds: [ID!]!) {
  getTagsByIds(tagIds: $tagIds) {
    ...TagInfo
  }
}
    ${TagInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTagsByIdsForQueryGQL extends Apollo.Query<GetTagsByIdsForQueryQuery, GetTagsByIdsForQueryQueryVariables> {
    document = GetTagsByIdsForQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTagsForCategoryDocument = gql`
    query GetTagsForCategory($tagCategoryId: ID!, $campaignId: ID) {
  getTags(tagCategoryId: $tagCategoryId, campaignId: $campaignId) {
    nodes {
      id
      name
      tagType
      archived
      ... on AddressTag {
        address {
          ...AddressDetails
        }
      }
    }
  }
}
    ${AddressDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTagsForCategoryGQL extends Apollo.Query<GetTagsForCategoryQuery, GetTagsForCategoryQueryVariables> {
    document = GetTagsForCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchTagsAndCategoriesDocument = gql`
    query SearchTagsAndCategories($keyword: String!, $status: TagStatus = Active, $targetType: String, $targetTypeId: ID, $campaignId: ID) {
  tags: searchTags(
    keyword: $keyword
    status: $status
    targetType: $targetType
    targetTypeId: $targetTypeId
    campaignId: $campaignId
    first: 25
  ) {
    nodes {
      id
      name
      archived
      category {
        id
        campaignContextId
        name
        groupName
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
  }
  categories: searchTagCategories(
    keyword: $keyword
    targetType: $targetType
    targetTypeId: $targetTypeId
    campaignId: $campaignId
    first: 25
  ) {
    nodes {
      id
      name
      campaignContextId
      groupName
      hasActiveTags
      hasAssociatedTags
      hasArchivedTags
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchTagsAndCategoriesGQL extends Apollo.Query<SearchTagsAndCategoriesQuery, SearchTagsAndCategoriesQueryVariables> {
    document = SearchTagsAndCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchTagsGetAllIdsDocument = gql`
    query SearchTagsGetAllIds($keyword: String = null, $status: TagStatus = Active, $tagTypes: [TagType] = null, $tagCategoryIds: [ID], $targetTypeId: ID, $targetType: String, $campaignId: ID, $includeNotInCampaign: Boolean, $orderBy: String, $first: Int, $after: String) {
  searchTags(
    keyword: $keyword
    status: $status
    campaignId: $campaignId
    tagCategoryIds: $tagCategoryIds
    targetType: $targetType
    targetTypeId: $targetTypeId
    tagTypes: $tagTypes
    includeNotInCampaign: $includeNotInCampaign
    orderBy: $orderBy
    first: $first
    after: $after
  ) {
    matchingIds
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchTagsGetAllIdsGQL extends Apollo.Query<SearchTagsGetAllIdsQuery, SearchTagsGetAllIdsQueryVariables> {
    document = SearchTagsGetAllIdsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchTagsDocument = gql`
    query SearchTags($keyword: String = null, $isInCampaignId: ID = null, $tagTypes: [TagType] = null, $status: TagStatus = Active, $tagCategoryIds: [ID], $targetTypeId: ID, $targetType: String, $campaignId: ID, $includeNotInCampaign: Boolean, $orderBy: String, $first: Int, $after: String) {
  searchTags(
    keyword: $keyword
    status: $status
    campaignId: $campaignId
    tagCategoryIds: $tagCategoryIds
    targetType: $targetType
    targetTypeId: $targetTypeId
    tagTypes: $tagTypes
    includeNotInCampaign: $includeNotInCampaign
    orderBy: $orderBy
    first: $first
    after: $after
  ) {
    edges {
      node {
        ...TagInfo
        isInCampaign(campaignId: $isInCampaignId)
      }
      cursor
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    ${TagInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchTagsGQL extends Apollo.Query<SearchTagsQuery, SearchTagsQueryVariables> {
    document = SearchTagsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  getCurrentUser {
    ...UserDetails
    ...UserWithTurfAssignments
  }
}
    ${UserDetailsFragmentDoc}
${UserWithTurfAssignmentsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCurrentUserGQL extends Apollo.Query<GetCurrentUserQuery, GetCurrentUserQueryVariables> {
    document = GetCurrentUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserByIdDocument = gql`
    query GetUserById($id: ID!) {
  getUserById(id: $id) {
    ...UserDetails
    ...UserWithTurfAssignments
  }
}
    ${UserDetailsFragmentDoc}
${UserWithTurfAssignmentsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserByIdGQL extends Apollo.Query<GetUserByIdQuery, GetUserByIdQueryVariables> {
    document = GetUserByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserByInviteTokenDocument = gql`
    query GetUserByInviteToken($invitationToken: String!) {
  getUserByInvitationToken(invitationToken: $invitationToken) {
    id
    email
    firstName
    lastName
    phoneNumber
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserByInviteTokenGQL extends Apollo.Query<GetUserByInviteTokenQuery, GetUserByInviteTokenQueryVariables> {
    document = GetUserByInviteTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUsersDocument = gql`
    query GetUsers($disabled: Boolean) {
  getUsers(disabled: $disabled) {
    edges {
      node {
        ...UserDetails
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${UserDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUsersGQL extends Apollo.Query<GetUsersQuery, GetUsersQueryVariables> {
    document = GetUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllUsersDocument = gql`
    query GetAllUsers($disabled: Boolean, $withTurfAssignments: Boolean = false) {
  getUsers(disabled: $disabled) {
    nodes {
      ...UserDetails
      ...UserWithTurfAssignments @include(if: $withTurfAssignments)
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${UserDetailsFragmentDoc}
${UserWithTurfAssignmentsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllUsersGQL extends Apollo.Query<GetAllUsersQuery, GetAllUsersQueryVariables> {
    document = GetAllUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchUserQueryDocument = gql`
    query SearchUserQuery($keyword: String, $campaignId: ID, $first: Int, $after: String, $disabled: Boolean, $activeOnly: Boolean, $pendingOnly: Boolean, $disabledOnly: Boolean) {
  searchUsers(
    keyword: $keyword
    campaignId: $campaignId
    first: $first
    after: $after
    disabled: $disabled
    activeOnly: $activeOnly
    pendingOnly: $pendingOnly
    disabledOnly: $disabledOnly
  ) {
    edges {
      node {
        ...UserDetails
      }
      cursor
    }
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${UserDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchUserQueryGQL extends Apollo.Query<SearchUserQueryQuery, SearchUserQueryQueryVariables> {
    document = SearchUserQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddActionFieldDocument = gql`
    mutation AddActionField($input: AddActionFieldInput!) {
  addActionField(input: $input) {
    action {
      id
      ...ActionCounts
      actionFields {
        ...ActionFieldDetails
      }
    }
  }
}
    ${ActionCountsFragmentDoc}
${ActionFieldDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddActionFieldGQL extends Apollo.Mutation<AddActionFieldMutation, AddActionFieldMutationVariables> {
    document = AddActionFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddAllEntitiesToActionDocument = gql`
    mutation AddAllEntitiesToAction($input: AddAllCampaignEntitiesToActionInput!) {
  addAllCampaignEntitiesToAction(input: $input) {
    action {
      ...ActionDetails
    }
  }
}
    ${ActionDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddAllEntitiesToActionGQL extends Apollo.Mutation<AddAllEntitiesToActionMutation, AddAllEntitiesToActionMutationVariables> {
    document = AddAllEntitiesToActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddEntitiesToActionAssignmentGroupDocument = gql`
    mutation AddEntitiesToActionAssignmentGroup($input: AddEntitiesToActionAssignmentGroupInput!) {
  addEntitiesToActionAssignmentGroup(input: $input) {
    actionAssignmentGroup {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddEntitiesToActionAssignmentGroupGQL extends Apollo.Mutation<AddEntitiesToActionAssignmentGroupMutation, AddEntitiesToActionAssignmentGroupMutationVariables> {
    document = AddEntitiesToActionAssignmentGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddEntitiesToActionDocument = gql`
    mutation AddEntitiesToAction($input: AddEntitiesToActionInput!) {
  addEntitiesToAction(input: $input) {
    action {
      ...ActionDetails
    }
  }
}
    ${ActionDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddEntitiesToActionGQL extends Apollo.Mutation<AddEntitiesToActionMutation, AddEntitiesToActionMutationVariables> {
    document = AddEntitiesToActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddUsersToAssignmentGroupDocument = gql`
    mutation AddUsersToAssignmentGroup($input: AddUsersToActionAssignmentGroupInput!) {
  addUsersToActionAssignmentGroup(input: $input) {
    actionAssignmentGroup {
      ...ActionAssignmentGroupInfo
    }
  }
}
    ${ActionAssignmentGroupInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddUsersToAssignmentGroupGQL extends Apollo.Mutation<AddUsersToAssignmentGroupMutation, AddUsersToAssignmentGroupMutationVariables> {
    document = AddUsersToAssignmentGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AssignActionTargetDocument = gql`
    mutation AssignActionTarget($input: AddEntityToActionAssignmentGroupInput!) {
  addEntityToActionAssignmentGroup(input: $input) {
    actionEntity {
      id
      hasContactInfo
      action {
        id
        campaign {
          id
          name
        }
      }
      entity {
        id
        campaignContextId
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignActionTargetGQL extends Apollo.Mutation<AssignActionTargetMutation, AssignActionTargetMutationVariables> {
    document = AssignActionTargetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateActionAssignmentGroupDocument = gql`
    mutation CreateActionAssignmentGroup($input: CreateActionAssignmentGroupInput!) {
  createActionAssignmentGroup(input: $input) {
    actionAssignmentGroup {
      id
      name
      action {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateActionAssignmentGroupGQL extends Apollo.Mutation<CreateActionAssignmentGroupMutation, CreateActionAssignmentGroupMutationVariables> {
    document = CreateActionAssignmentGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateActionDocument = gql`
    mutation CreateAction($input: CreateActionInput!) {
  createAction(input: $input) {
    action {
      ...ActionDetails
    }
  }
}
    ${ActionDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateActionGQL extends Apollo.Mutation<CreateActionMutation, CreateActionMutationVariables> {
    document = CreateActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAllActionAssignmentGroupsDocument = gql`
    mutation DeleteAllActionAssignmentGroups($input: DeleteAllActionAssignmentGroupsInput!) {
  deleteAllActionAssignmentGroups(input: $input) {
    action {
      ...ActionDetails
    }
  }
}
    ${ActionDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAllActionAssignmentGroupsGQL extends Apollo.Mutation<DeleteAllActionAssignmentGroupsMutation, DeleteAllActionAssignmentGroupsMutationVariables> {
    document = DeleteAllActionAssignmentGroupsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DuplicateActionDocument = gql`
    mutation DuplicateAction($input: DuplicateActionInput!) {
  duplicateAction(input: $input) {
    action {
      ...ActionDetails
    }
  }
}
    ${ActionDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DuplicateActionGQL extends Apollo.Mutation<DuplicateActionMutation, DuplicateActionMutationVariables> {
    document = DuplicateActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateActionAssignmentGroupsByStrategyDocument = gql`
    mutation GenerateActionAssignmentGroupsByStrategy($input: GenerateActionAssignmentGroupsByStrategyInput!) {
  generateActionAssignmentGroupsByStrategy(input: $input) {
    action {
      ...ActionDetails
    }
  }
}
    ${ActionDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateActionAssignmentGroupsByStrategyGQL extends Apollo.Mutation<GenerateActionAssignmentGroupsByStrategyMutation, GenerateActionAssignmentGroupsByStrategyMutationVariables> {
    document = GenerateActionAssignmentGroupsByStrategyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveActionAssignmentGroupDocument = gql`
    mutation RemoveActionAssignmentGroup($input: RemoveActionAssignmentGroupInput!) {
  removeActionAssignmentGroup(input: $input) {
    action {
      ...ActionDetails
    }
  }
}
    ${ActionDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveActionAssignmentGroupGQL extends Apollo.Mutation<RemoveActionAssignmentGroupMutation, RemoveActionAssignmentGroupMutationVariables> {
    document = RemoveActionAssignmentGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveActionFieldByIdDocument = gql`
    mutation RemoveActionFieldById($input: RemoveActionFieldByIdInput!) {
  removeActionFieldById(input: $input) {
    action {
      id
      ...ActionCounts
      actionFields {
        ...ActionFieldDetails
      }
    }
  }
}
    ${ActionCountsFragmentDoc}
${ActionFieldDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveActionFieldByIdGQL extends Apollo.Mutation<RemoveActionFieldByIdMutation, RemoveActionFieldByIdMutationVariables> {
    document = RemoveActionFieldByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveAssignmentGroupRoutingDocument = gql`
    mutation RemoveAssignmentGroupRouting($input: RemoveAssignmentGroupUserRoutingInput!) {
  removeAssignmentGroupUserRouting(input: $input) {
    assignmentRoutingOptions {
      ...AssignmentRoutingOptionsDetails
    }
  }
}
    ${AssignmentRoutingOptionsDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveAssignmentGroupRoutingGQL extends Apollo.Mutation<RemoveAssignmentGroupRoutingMutation, RemoveAssignmentGroupRoutingMutationVariables> {
    document = RemoveAssignmentGroupRoutingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveEntitiesFromActionAssignmentGroupDocument = gql`
    mutation RemoveEntitiesFromActionAssignmentGroup($input: RemoveEntitiesFromActionAssignmentGroupInput!) {
  removeEntitiesFromActionAssignmentGroup(input: $input) {
    actionAssignmentGroup {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveEntitiesFromActionAssignmentGroupGQL extends Apollo.Mutation<RemoveEntitiesFromActionAssignmentGroupMutation, RemoveEntitiesFromActionAssignmentGroupMutationVariables> {
    document = RemoveEntitiesFromActionAssignmentGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveEntitiesFromActionDocument = gql`
    mutation RemoveEntitiesFromAction($input: RemoveEntitiesFromActionInput!) {
  removeEntitiesFromAction(input: $input) {
    action {
      ...ActionDetails
    }
  }
}
    ${ActionDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveEntitiesFromActionGQL extends Apollo.Mutation<RemoveEntitiesFromActionMutation, RemoveEntitiesFromActionMutationVariables> {
    document = RemoveEntitiesFromActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveUsersFromAssignmentGroupDocument = gql`
    mutation RemoveUsersFromAssignmentGroup($input: RemoveUsersFromActionAssignmentGroupInput!) {
  removeUsersFromActionAssignmentGroup(input: $input) {
    actionAssignmentGroup {
      ...ActionAssignmentGroupInfo
    }
  }
}
    ${ActionAssignmentGroupInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveUsersFromAssignmentGroupGQL extends Apollo.Mutation<RemoveUsersFromAssignmentGroupMutation, RemoveUsersFromAssignmentGroupMutationVariables> {
    document = RemoveUsersFromAssignmentGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateActionEntitiesByQueryDocument = gql`
    mutation UpdateActionEntitiesByQuery($input: UpdateEntitiesOnActionByQueryInput!) {
  updateEntitiesOnActionByQuery(input: $input) {
    action {
      ...ActionDetails
    }
  }
}
    ${ActionDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateActionEntitiesByQueryGQL extends Apollo.Mutation<UpdateActionEntitiesByQueryMutation, UpdateActionEntitiesByQueryMutationVariables> {
    document = UpdateActionEntitiesByQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateActionFieldDocument = gql`
    mutation UpdateActionField($input: UpdateActionFieldInput!) {
  updateActionField(input: $input) {
    action {
      id
      dueDate
      text
      name
      canvassingType
      ...ActionCounts
      actionFields {
        ...ActionFieldDetails
      }
      actionAssignmentGroups {
        ...ActionAssignmentGroupCounts
      }
    }
  }
}
    ${ActionCountsFragmentDoc}
${ActionFieldDetailsFragmentDoc}
${ActionAssignmentGroupCountsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateActionFieldGQL extends Apollo.Mutation<UpdateActionFieldMutation, UpdateActionFieldMutationVariables> {
    document = UpdateActionFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateActionFieldsPositionsDocument = gql`
    mutation UpdateActionFieldsPositions($input: UpdateActionFieldsPositionsInput!) {
  updateActionFieldsPositions(input: $input) {
    actionFields {
      ...ActionFieldDetails
    }
  }
}
    ${ActionFieldDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateActionFieldsPositionsGQL extends Apollo.Mutation<UpdateActionFieldsPositionsMutation, UpdateActionFieldsPositionsMutationVariables> {
    document = UpdateActionFieldsPositionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateActionDocument = gql`
    mutation UpdateAction($input: UpdateActionInput!) {
  updateAction(input: $input) {
    action {
      ...ActionDetails
    }
  }
}
    ${ActionDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateActionGQL extends Apollo.Mutation<UpdateActionMutation, UpdateActionMutationVariables> {
    document = UpdateActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateActionAssignmentGroupNameDocument = gql`
    mutation UpdateActionAssignmentGroupName($input: UpdateActionAssignmentGroupInput!) {
  updateActionAssignmentGroup(input: $input) {
    actionAssignmentGroup {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateActionAssignmentGroupNameGQL extends Apollo.Mutation<UpdateActionAssignmentGroupNameMutation, UpdateActionAssignmentGroupNameMutationVariables> {
    document = UpdateActionAssignmentGroupNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAssignmentGroupEntitiesByQueryDocument = gql`
    mutation UpdateAssignmentGroupEntitiesByQuery($input: UpdateAssignmentGroupEntitiesByQueryInput!) {
  updateAssignmentGroupEntitiesByQuery(input: $input) {
    actionAssignmentGroup {
      id
      name
      targetsCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAssignmentGroupEntitiesByQueryGQL extends Apollo.Mutation<UpdateAssignmentGroupEntitiesByQueryMutation, UpdateAssignmentGroupEntitiesByQueryMutationVariables> {
    document = UpdateAssignmentGroupEntitiesByQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAssignmentGroupUserRoutingDocument = gql`
    mutation UpdateAssignmentGroupUserRouting($input: UpdateAssignmentGroupUserRoutingInput!) {
  updateAssignmentGroupUserRouting(input: $input) {
    assignmentRoutingOptions {
      ...AssignmentRoutingOptionsDetails
    }
  }
}
    ${AssignmentRoutingOptionsDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAssignmentGroupUserRoutingGQL extends Apollo.Mutation<UpdateAssignmentGroupUserRoutingMutation, UpdateAssignmentGroupUserRoutingMutationVariables> {
    document = UpdateAssignmentGroupUserRoutingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ActionTurfCuttingMapQueryDocument = gql`
    query ActionTurfCuttingMapQuery($actionId: ID!, $campaignId: ID!) {
  getAction(actionId: $actionId, campaignId: $campaignId) {
    id
    canvassingType
    targetIdsWithMappableAddresses
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ActionTurfCuttingMapQueryGQL extends Apollo.Query<ActionTurfCuttingMapQueryQuery, ActionTurfCuttingMapQueryQueryVariables> {
    document = ActionTurfCuttingMapQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActionAndGroupCountsDocument = gql`
    query GetActionAndGroupCounts($actionId: ID!, $campaignId: ID!) {
  getAction(actionId: $actionId, campaignId: $campaignId) {
    ...ActionCounts
    actionAssignmentGroups {
      ...ActionAssignmentGroupCounts
    }
  }
}
    ${ActionCountsFragmentDoc}
${ActionAssignmentGroupCountsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActionAndGroupCountsGQL extends Apollo.Query<GetActionAndGroupCountsQuery, GetActionAndGroupCountsQueryVariables> {
    document = GetActionAndGroupCountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActionAssignmentGroupBasicDocument = gql`
    query GetActionAssignmentGroupBasic($actionId: ID!, $actionAssignmentGroupId: ID!) {
  getActionAssignmentGroup(
    actionId: $actionId
    actionAssignmentGroupId: $actionAssignmentGroupId
  ) {
    id
    name
    uniqueGeocodesForBestAddressesCount
    ...ActionAssignmentGroupCounts
    action {
      name
      id
      dueDate
      text
      canvassingType
      entityType {
        ...EntityTypeDetails
      }
    }
  }
}
    ${ActionAssignmentGroupCountsFragmentDoc}
${EntityTypeDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActionAssignmentGroupBasicGQL extends Apollo.Query<GetActionAssignmentGroupBasicQuery, GetActionAssignmentGroupBasicQueryVariables> {
    document = GetActionAssignmentGroupBasicDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActionAssignmentGroupDocument = gql`
    query GetActionAssignmentGroup($actionId: ID!, $actionAssignmentGroupId: ID!, $withTargetIds: Boolean!, $withActionEntities: Boolean!, $withMappableAddresses: Boolean!, $withRouting: Boolean = false) {
  getActionAssignmentGroup(
    actionId: $actionId
    actionAssignmentGroupId: $actionAssignmentGroupId
  ) {
    action {
      name
      id
      targetIdsWithMappableAddresses(limit: 5000) @include(if: $withTargetIds)
      dueDate
      text
      targetsQueryJson
      canvassingType
      entityType {
        ...EntityTypeDetails
      }
    }
    ...ActionAssignmentGroupCounts
    ...ActionAssignmentGroupTargetIds @include(if: $withTargetIds)
    routingInfo @include(if: $withRouting) {
      ...AssignmentRoutingOptionsDetails
    }
    users {
      id
      firstName
      lastName
      email
    }
    actionEntities(withMappableAddresses: $withMappableAddresses) @include(if: $withActionEntities) {
      id
      status
      pendingCount
      completedCount
      completed
      mostRecentContactAttempt {
        ...ContactAttemptBasic
      }
      entity {
        ...EntityCore
        ...EntityWithBasicInfo
        ...EntityWithHighlightedTopline
        mappableAddresses @include(if: $withMappableAddresses) {
          ...AddressDetails
        }
      }
    }
  }
}
    ${EntityTypeDetailsFragmentDoc}
${ActionAssignmentGroupCountsFragmentDoc}
${ActionAssignmentGroupTargetIdsFragmentDoc}
${AssignmentRoutingOptionsDetailsFragmentDoc}
${ContactAttemptBasicFragmentDoc}
${EntityCoreFragmentDoc}
${EntityWithBasicInfoFragmentDoc}
${EntityWithHighlightedToplineFragmentDoc}
${AddressDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActionAssignmentGroupGQL extends Apollo.Query<GetActionAssignmentGroupQuery, GetActionAssignmentGroupQueryVariables> {
    document = GetActionAssignmentGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAssignmentGroupsForCurrentUserDocument = gql`
    query GetAssignmentGroupsForCurrentUser($campaignId: ID!, $startDate: Date, $endDate: Date) {
  getActionAssignmentGroupsForCurrentUser(
    campaignId: $campaignId
    startDate: $startDate
    endDate: $endDate
  ) {
    ...ActionAssignmentGroupInfo
  }
}
    ${ActionAssignmentGroupInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssignmentGroupsForCurrentUserGQL extends Apollo.Query<GetAssignmentGroupsForCurrentUserQuery, GetAssignmentGroupsForCurrentUserQueryVariables> {
    document = GetAssignmentGroupsForCurrentUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActionAssignmentGroupsDocument = gql`
    query GetActionAssignmentGroups($actionId: ID!, $campaignId: ID!) {
  getAction(actionId: $actionId, campaignId: $campaignId) {
    id
    name
    targetsCount
    canvassingType
    entityType {
      ...EntityTypeDetails
    }
    actionAssignmentGroups {
      ...ActionAssignmentGroupCounts
      users {
        id
        firstName
        lastName
        email
      }
    }
  }
}
    ${EntityTypeDetailsFragmentDoc}
${ActionAssignmentGroupCountsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActionAssignmentGroupsGQL extends Apollo.Query<GetActionAssignmentGroupsQuery, GetActionAssignmentGroupsQueryVariables> {
    document = GetActionAssignmentGroupsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActionHouseholdMatchesDocument = gql`
    query GetActionHouseholdMatches($actionEntityId: ID!, $actionAssignmentGroupId: ID!, $addressId: ID!) {
  getActionHouseholdMatches(
    actionEntityId: $actionEntityId
    actionAssignmentGroupId: $actionAssignmentGroupId
    addressId: $addressId
  ) {
    address {
      id
      streetAddress
    }
    matches {
      matchedAddressIds
      actionEntity {
        id
        status
        completed
        completedCount
        pendingCount
        hasContactInfo
        mostRecentContactAttempt {
          ...ContactAttemptDetails
        }
        entity {
          ...EntityCore
          ...EntityWithBasicInfo
        }
      }
    }
  }
}
    ${ContactAttemptDetailsFragmentDoc}
${EntityCoreFragmentDoc}
${EntityWithBasicInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActionHouseholdMatchesGQL extends Apollo.Query<GetActionHouseholdMatchesQuery, GetActionHouseholdMatchesQueryVariables> {
    document = GetActionHouseholdMatchesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActionEntityDocument = gql`
    query GetActionEntity($campaignId: ID!, $actionId: ID!, $entityId: ID!) {
  getActionEntity(
    campaignId: $campaignId
    actionId: $actionId
    entityId: $entityId
  ) {
    id
    status
    completed
    completedCount
    pendingCount
    hasContactInfo
    mostRecentContactAttempt {
      ...ContactAttemptDetails
    }
    entity {
      ...EntityCore
      ...EntityWithEntityType
      ...EntityWithBasicInfo
    }
    action {
      id
      name
      text
      householdingEnabled
      canvassingType
      actionFields {
        ...ActionFieldDetails
      }
    }
    tasks {
      id
      resolved
      actionField {
        ...ActionFieldDetails
      }
    }
  }
}
    ${ContactAttemptDetailsFragmentDoc}
${EntityCoreFragmentDoc}
${EntityWithEntityTypeFragmentDoc}
${EntityWithBasicInfoFragmentDoc}
${ActionFieldDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActionEntityGQL extends Apollo.Query<GetActionEntityQuery, GetActionEntityQueryVariables> {
    document = GetActionEntityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActionFieldsDocument = gql`
    query GetActionFields($actionId: ID!, $campaignId: ID!) {
  getAction(actionId: $actionId, campaignId: $campaignId) {
    id
    entityType {
      ...EntityTypeDetails
    }
    actionFields {
      ...ActionFieldDetails
    }
  }
}
    ${EntityTypeDetailsFragmentDoc}
${ActionFieldDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActionFieldsGQL extends Apollo.Query<GetActionFieldsQuery, GetActionFieldsQueryVariables> {
    document = GetActionFieldsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActionEntityAssignmentOrderingDocument = gql`
    query GetActionEntityAssignmentOrdering($actionId: ID!, $actionAssignmentGroupId: ID!) {
  getActionEntityAssignmentOrdering(
    actionId: $actionId
    actionAssignmentGroupId: $actionAssignmentGroupId
  ) {
    actionId
    actionAssignmentGroupId
    actionEntityIds
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActionEntityAssignmentOrderingGQL extends Apollo.Query<GetActionEntityAssignmentOrderingQuery, GetActionEntityAssignmentOrderingQueryVariables> {
    document = GetActionEntityAssignmentOrderingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActionTypeQueryDocument = gql`
    query GetActionTypeQuery($actionId: ID!, $campaignId: ID!) {
  getAction(actionId: $actionId, campaignId: $campaignId) {
    id
    canvassingType
    entityType {
      ...EntityTypeDetails
    }
  }
}
    ${EntityTypeDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActionTypeQueryGQL extends Apollo.Query<GetActionTypeQueryQuery, GetActionTypeQueryQueryVariables> {
    document = GetActionTypeQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActionDetailsDocument = gql`
    query GetActionDetails($actionId: ID!, $campaignId: ID!) {
  getAction(actionId: $actionId, campaignId: $campaignId) {
    ...ActionDetails
  }
}
    ${ActionDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActionDetailsGQL extends Apollo.Query<GetActionDetailsQuery, GetActionDetailsQueryVariables> {
    document = GetActionDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActionsCountsDocument = gql`
    query GetActionsCounts($campaignId: ID!, $endDate: Date, $startDate: Date) {
  getActions(campaignId: $campaignId, endDate: $endDate, startDate: $startDate) {
    id
    active
    name
    dueDate
    completed
    targetsCount
    campaign {
      id
      name
    }
    createdBy {
      ...UserPublicDetails
    }
    actionFields {
      calendarEventAction {
        calendarEvent {
          startDate
          endDate
        }
      }
    }
  }
}
    ${UserPublicDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActionsCountsGQL extends Apollo.Query<GetActionsCountsQuery, GetActionsCountsQueryVariables> {
    document = GetActionsCountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetContactAttemptsDocument = gql`
    query GetContactAttempts($actionEntityId: ID!, $contactInfoType: ContactAttemptInfoType) {
  getContactAttempts(
    actionEntityId: $actionEntityId
    contactInfoType: $contactInfoType
  ) {
    ...ContactAttemptBasic
  }
}
    ${ContactAttemptBasicFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetContactAttemptsGQL extends Apollo.Query<GetContactAttemptsQuery, GetContactAttemptsQueryVariables> {
    document = GetContactAttemptsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEntityAddressGeocodesDocument = gql`
    query GetEntityAddressGeocodes($campaignId: ID!, $entityIds: [ID!]) {
  getEntitiesByIds(campaignId: $campaignId, entityIds: $entityIds) {
    id
    campaignContextId
    mappableAddresses {
      id
      latitude
      longitude
      status
      geocodeBad
      accuracyType
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEntityAddressGeocodesGQL extends Apollo.Query<GetEntityAddressGeocodesQuery, GetEntityAddressGeocodesQueryVariables> {
    document = GetEntityAddressGeocodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEntityQueryCountsDocument = gql`
    query GetEntityQueryCounts($campaignId: ID!, $body: String!) {
  entitiesQuery(campaignId: $campaignId, body: $body, first: 1) {
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEntityQueryCountsGQL extends Apollo.Query<GetEntityQueryCountsQuery, GetEntityQueryCountsQueryVariables> {
    document = GetEntityQueryCountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSmallActionEntityDocument = gql`
    query GetSmallActionEntity($actionEntityId: ID!) {
  getActionEntityById(actionEntityId: $actionEntityId) {
    ...SmallActionEntity
  }
}
    ${SmallActionEntityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSmallActionEntityGQL extends Apollo.Query<GetSmallActionEntityQuery, GetSmallActionEntityQueryVariables> {
    document = GetSmallActionEntityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTargetsAssignedToOtherGroupsDocument = gql`
    query GetTargetsAssignedToOtherGroups($actionId: ID!, $actionAssignmentGroupId: ID!, $withTargetIds: Boolean = false) {
  getActionAssignmentGroup(
    actionId: $actionId
    actionAssignmentGroupId: $actionAssignmentGroupId
  ) {
    id
    name
    targetIdsAssignedToOtherGroups
    targetIds @include(if: $withTargetIds)
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTargetsAssignedToOtherGroupsGQL extends Apollo.Query<GetTargetsAssignedToOtherGroupsQuery, GetTargetsAssignedToOtherGroupsQueryVariables> {
    document = GetTargetsAssignedToOtherGroupsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchActionEntitiesDocument = gql`
    query SearchActionEntities($actionId: ID!, $campaignId: ID!, $actionAssignmentGroupId: ID, $keyword: String!, $first: Int, $after: String, $excludeCompleted: Boolean) {
  searchActionEntities(
    actionId: $actionId
    campaignId: $campaignId
    keyword: $keyword
    actionAssignmentGroupId: $actionAssignmentGroupId
    first: $first
    after: $after
    excludeCompleted: $excludeCompleted
  ) @connection(key: "searchActionEntities", filter: ["campaignId", "actionId", "actionAssignmentGroupId", "after", "first", "keyword", "excludeCompleted"]) {
    edges {
      node {
        id
        status
        completed
        completedCount
        pendingCount
        hasContactInfo
        mostRecentContactAttempt {
          ...ContactAttemptBasic
        }
        entity {
          ...EntityCore
          ...EntityWithBasicInfo
          ...EntityWithHighlightedTopline
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    limitedCount
  }
}
    ${ContactAttemptBasicFragmentDoc}
${EntityCoreFragmentDoc}
${EntityWithBasicInfoFragmentDoc}
${EntityWithHighlightedToplineFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchActionEntitiesGQL extends Apollo.Query<SearchActionEntitiesQuery, SearchActionEntitiesQueryVariables> {
    document = SearchActionEntitiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActionNameDocument = gql`
    query GetActionName($actionId: ID!, $campaignId: ID!) {
  getAction(actionId: $actionId, campaignId: $campaignId) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActionNameGQL extends Apollo.Query<GetActionNameQuery, GetActionNameQueryVariables> {
    document = GetActionNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchActivityEventsDocument = gql`
    query SearchActivityEvents($campaignId: ID!, $first: Int = 20, $after: String, $endDate: Date, $startDate: Date, $userIds: [ID!], $tagIds: [ID!], $connectionTagIds: [ID!], $entityTypeIds: [ID!], $names: [String!], $userRoles: [UserRole!], $entityId: ID, $noteText: String, $calendarEventIds: [ID!], $calendarEventResponseTagIds: [ID!]) {
  searchActivityEvents(
    campaignId: $campaignId
    first: $first
    after: $after
    endDate: $endDate
    startDate: $startDate
    userIds: $userIds
    tagIds: $tagIds
    connectionTagIds: $connectionTagIds
    entityTypeIds: $entityTypeIds
    names: $names
    userRoles: $userRoles
    entityId: $entityId
    noteText: $noteText
    calendarEventIds: $calendarEventIds
    calendarEventResponseTagIds: $calendarEventResponseTagIds
  ) @connection(key: "searchActivityEvents", filter: ["campaignId", "endDate", "startDate", "userIds", "names", "tagIds", "entityId", "connectionTagIds", "entityTypeIds", "noteText", "calendarEventIds", "calendarEventResponseTagIds", "first", "after"]) {
    edges {
      node {
        id
        name
        eventType
        payload
        itemId
        itemType
        createdAt
        user {
          id
          name
        }
        target {
          ... on CalendarEventResponse {
            status
            calendarEvent {
              ...CalendarEventWithUsersAndCounts
            }
            entity {
              id
              campaignContextId
              firstName
              middleName
              nickname
              lastName
              nickname
            }
          }
          ... on EntityConnection {
            ...EntityConnectionCore
          }
          ... on Entity {
            id
            campaignContextId
            firstName
            middleName
            nickname
            lastName
            nickname
            entityType {
              ...EntityTypeDetails
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    limitedCount
    entityCount
  }
}
    ${CalendarEventWithUsersAndCountsFragmentDoc}
${EntityConnectionCoreFragmentDoc}
${EntityTypeDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchActivityEventsGQL extends Apollo.Query<SearchActivityEventsQuery, SearchActivityEventsQueryVariables> {
    document = SearchActivityEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMergeConflictsDocument = gql`
    query GetMergeConflicts($targetId: ID!, $sourceId: ID!, $campaignId: ID!) {
  getMergeConflicts(
    targetId: $targetId
    sourceId: $sourceId
    campaignId: $campaignId
  ) {
    sourceId
    targetId
    campaignId
    coreConflicts
    preferredLanguageConflict
    entityCustomIdsConflicts {
      property
    }
    connectionConflicts {
      sourceId
      targetId
      campaignId
      taggableConflicts {
        tagCategoryId
        targetTaggableLogbookId
        sourceTaggableLogbookId
      }
    }
    taggableConflicts {
      tagCategoryId
      targetTaggableLogbookId
      sourceTaggableLogbookId
    }
    calendarEventResponseConflicts {
      sourceId
      targetId
      campaignId
      taggableConflicts {
        tagCategoryId
        targetTaggableLogbookId
        sourceTaggableLogbookId
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMergeConflictsGQL extends Apollo.Query<GetMergeConflictsQuery, GetMergeConflictsQueryVariables> {
    document = GetMergeConflictsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MergeEntitiesDocument = gql`
    mutation MergeEntities($input: MergeEntitiesInput!) {
  mergeEntities(input: $input) {
    entity {
      campaignContextId
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MergeEntitiesGQL extends Apollo.Mutation<MergeEntitiesMutation, MergeEntitiesMutationVariables> {
    document = MergeEntitiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCountsForEntityChartDocument = gql`
    query GetCountsForEntityChart($campaignId: ID!, $queryJson: String!, $startDate: ISO8601DateTime!, $endDate: ISO8601DateTime!, $period: ChartPeriodType!, $aggregationMethod: ChartAggregationMethodEnumType!) {
  getCountsForEntityChart(
    campaignId: $campaignId
    queryJson: $queryJson
    startDate: $startDate
    endDate: $endDate
    period: $period
    aggregationMethod: $aggregationMethod
  ) {
    entitiesCount
    aggregationMethod
    period
    rangeEnd
    rangeStart
    results {
      counts {
        groupLabel
        count
      }
      periodEnd
      periodStart
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCountsForEntityChartGQL extends Apollo.Query<GetCountsForEntityChartQuery, GetCountsForEntityChartQueryVariables> {
    document = GetCountsForEntityChartDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddActionNetworkGroupDocument = gql`
    mutation AddActionNetworkGroup($input: ActionNetworkAddGroupInput!) {
  addActionNetworkGroup(input: $input) {
    actionNetworkGroup {
      ...ActionNetworkGroupInfo
    }
  }
}
    ${ActionNetworkGroupInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddActionNetworkGroupGQL extends Apollo.Mutation<AddActionNetworkGroupMutation, AddActionNetworkGroupMutationVariables> {
    document = AddActionNetworkGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddAnIntegrationToCampaignDocument = gql`
    mutation AddANIntegrationToCampaign($input: ActionNetworkAddIntegrationToCampaignInput!) {
  addActionNetworkIntegrationToCampaign(input: $input) {
    campaign {
      id
      campaignIntegrations {
        actionNetwork {
          ...ANCampaignIntegration
        }
      }
    }
  }
}
    ${AnCampaignIntegrationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddAnIntegrationToCampaignGQL extends Apollo.Mutation<AddAnIntegrationToCampaignMutation, AddAnIntegrationToCampaignMutationVariables> {
    document = AddAnIntegrationToCampaignDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddActionNetworkTagMappingDocument = gql`
    mutation AddActionNetworkTagMapping($input: ActionNetworkAddCampaignTagMappingInput!) {
  addActionNetworkCampaignTagMapping(input: $input) {
    actionNetworkTagMapping {
      ...ActionNetworkTagMappingInfo
    }
  }
}
    ${ActionNetworkTagMappingInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddActionNetworkTagMappingGQL extends Apollo.Mutation<AddActionNetworkTagMappingMutation, AddActionNetworkTagMappingMutationVariables> {
    document = AddActionNetworkTagMappingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActionNetworkCustomFieldsDocument = gql`
    query GetActionNetworkCustomFields($groupId: String!) {
  getActionNetworkCustomFields(groupId: $groupId) {
    name
    uuid: name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActionNetworkCustomFieldsGQL extends Apollo.Query<GetActionNetworkCustomFieldsQuery, GetActionNetworkCustomFieldsQueryVariables> {
    document = GetActionNetworkCustomFieldsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActionNetworkEventDocument = gql`
    query GetActionNetworkEvent($calendarEventId: ID!) {
  getActionNetworkEvent(calendarEventId: $calendarEventId) {
    administrativeTitle
    id
    permalink
    startDate: startAt
    timezone
    title
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActionNetworkEventGQL extends Apollo.Query<GetActionNetworkEventQuery, GetActionNetworkEventQueryVariables> {
    document = GetActionNetworkEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActionNetworkEventsDocument = gql`
    query GetActionNetworkEvents($groupId: String!, $first: Int = 50) {
  getActionNetworkEvents(groupId: $groupId, first: $first) {
    nodes {
      id
      administrativeTitle
      title
      startDate: startAt
      timezone
      permalink
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActionNetworkEventsGQL extends Apollo.Query<GetActionNetworkEventsQuery, GetActionNetworkEventsQueryVariables> {
    document = GetActionNetworkEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActionNetworkGroupsDocument = gql`
    query GetActionNetworkGroups {
  getActionNetworkGroups {
    ...ActionNetworkGroupInfo
  }
}
    ${ActionNetworkGroupInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActionNetworkGroupsGQL extends Apollo.Query<GetActionNetworkGroupsQuery, GetActionNetworkGroupsQueryVariables> {
    document = GetActionNetworkGroupsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActionNetworkTagsDocument = gql`
    query GetActionNetworkTags($groupId: String!) {
  getActionNetworkTags(groupId: $groupId) {
    name
    uuid
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActionNetworkTagsGQL extends Apollo.Query<GetActionNetworkTagsQuery, GetActionNetworkTagsQueryVariables> {
    document = GetActionNetworkTagsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAnCampaignIntegrationDocument = gql`
    query GetANCampaignIntegration($campaignId: ID!) {
  getCampaign(campaignId: $campaignId) {
    id
    name
    campaignIntegrations {
      actionNetwork {
        ...ANCampaignIntegration
      }
    }
    entityTypes {
      ...EntityTypeDetails
    }
  }
}
    ${AnCampaignIntegrationFragmentDoc}
${EntityTypeDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAnCampaignIntegrationGQL extends Apollo.Query<GetAnCampaignIntegrationQuery, GetAnCampaignIntegrationQueryVariables> {
    document = GetAnCampaignIntegrationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveAnIntegrationFromCampaignDocument = gql`
    mutation RemoveANIntegrationFromCampaign($input: ActionNetworkRemoveCampaignIntegrationInput!) {
  removeActionNetworkIntegrationFromCampaign(input: $input) {
    campaign {
      id
      campaignIntegrations {
        actionNetwork {
          ...ANCampaignIntegration
        }
      }
    }
  }
}
    ${AnCampaignIntegrationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveAnIntegrationFromCampaignGQL extends Apollo.Mutation<RemoveAnIntegrationFromCampaignMutation, RemoveAnIntegrationFromCampaignMutationVariables> {
    document = RemoveAnIntegrationFromCampaignDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveAnTagMappingDocument = gql`
    mutation RemoveANTagMapping($input: ActionNetworkRemoveCampaignTagMappingInput!) {
  removeActionNetworkCampaignTagMapping(input: $input) {
    actionNetworkTagMapping {
      ...ActionNetworkTagMappingInfo
    }
  }
}
    ${ActionNetworkTagMappingInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveAnTagMappingGQL extends Apollo.Mutation<RemoveAnTagMappingMutation, RemoveAnTagMappingMutationVariables> {
    document = RemoveAnTagMappingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAnCampaignIntegrationDocument = gql`
    mutation UpdateANCampaignIntegration($input: ActionNetworkUpdateIntegrationInput!) {
  updateActionNetworkIntegration(input: $input) {
    integration {
      ...ANCampaignIntegration
    }
  }
}
    ${AnCampaignIntegrationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAnCampaignIntegrationGQL extends Apollo.Mutation<UpdateAnCampaignIntegrationMutation, UpdateAnCampaignIntegrationMutationVariables> {
    document = UpdateAnCampaignIntegrationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddApiKeyDocument = gql`
    mutation AddApiKey($input: AddAPIKeyInput!) {
  addApiKey(input: $input) {
    apiKey {
      ...ApiKeyDetails
    }
  }
}
    ${ApiKeyDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddApiKeyGQL extends Apollo.Mutation<AddApiKeyMutation, AddApiKeyMutationVariables> {
    document = AddApiKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetApiKeysDocument = gql`
    query GetApiKeys {
  getApiKeys(target: rest) {
    ...ApiKeyDetails
  }
}
    ${ApiKeyDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetApiKeysGQL extends Apollo.Query<GetApiKeysQuery, GetApiKeysQueryVariables> {
    document = GetApiKeysDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevokeApiKeyDocument = gql`
    mutation RevokeApiKey($input: RevokeAPIKeyInput!) {
  revokeApiKey(input: $input) {
    apiKey {
      ...ApiKeyDetails
    }
  }
}
    ${ApiKeyDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RevokeApiKeyGQL extends Apollo.Mutation<RevokeApiKeyMutation, RevokeApiKeyMutationVariables> {
    document = RevokeApiKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActionEntitiesByIdPrintDocument = gql`
    query GetActionEntitiesByIdPrint($entityIds: [ID!]!, $campaignId: ID!, $actionId: ID!, $tagCategoryIds: [ID!]) {
  getActionEntities(
    entityIds: $entityIds
    campaignId: $campaignId
    actionId: $actionId
  ) {
    ...ActionEntityPrintViewDetails
  }
}
    ${ActionEntityPrintViewDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActionEntitiesByIdPrintGQL extends Apollo.Query<GetActionEntitiesByIdPrintQuery, GetActionEntitiesByIdPrintQueryVariables> {
    document = GetActionEntitiesByIdPrintDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEntitiesByIdsPrintDocument = gql`
    query GetEntitiesByIdsPrint($entityIds: [ID!], $campaignId: ID!) {
  getEntitiesByIds(entityIds: $entityIds, campaignId: $campaignId) {
    ...EntityPrintDetails
  }
}
    ${EntityPrintDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEntitiesByIdsPrintGQL extends Apollo.Query<GetEntitiesByIdsPrintQuery, GetEntitiesByIdsPrintQueryVariables> {
    document = GetEntitiesByIdsPrintDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEntityConnectionsPrintViewDocument = gql`
    query GetEntityConnectionsPrintView($entityId: ID!, $campaignId: ID!, $entityConnectionTypeId: ID!) {
  getEntityConnections(
    entityId: $entityId
    campaignId: $campaignId
    entityConnectionTypeId: $entityConnectionTypeId
    includeInactive: false
    first: 1
  ) {
    nodes {
      id
      active
      entity1 {
        id
        firstName
        middleName
        lastName
        nickname
        pronouns
        suffix
      }
      entity2 {
        id
        firstName
        middleName
        lastName
        nickname
        pronouns
        suffix
      }
      appliedToplines {
        id
        item0 {
          ...AppliedTagToplineValuePrint
        }
        item1 {
          ...AppliedTagToplineValuePrint
        }
        item2 {
          ...AppliedTagToplineValuePrint
        }
        item3 {
          ...AppliedTagToplineValuePrint
        }
        item4 {
          ...AppliedTagToplineValuePrint
        }
        item5 {
          ...AppliedTagToplineValuePrint
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${AppliedTagToplineValuePrintFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEntityConnectionsPrintViewGQL extends Apollo.Query<GetEntityConnectionsPrintViewQuery, GetEntityConnectionsPrintViewQueryVariables> {
    document = GetEntityConnectionsPrintViewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUploadsDocument = gql`
    query GetUploads($first: Int, $after: String, $visibilityStatus: UploadVisibilityStatusType) {
  getUploads(first: $first, after: $after, visibilityStatus: $visibilityStatus) {
    nodes {
      ...UploadDetails
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    ${UploadDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUploadsGQL extends Apollo.Query<GetUploadsQuery, GetUploadsQueryVariables> {
    document = GetUploadsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUploadByIdQueryDocument = gql`
    query GetUploadByIdQuery($uploadId: ID!) {
  getUploadById(uploadId: $uploadId) {
    ...UploadDetails
  }
}
    ${UploadDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUploadByIdQueryGQL extends Apollo.Query<GetUploadByIdQueryQuery, GetUploadByIdQueryQueryVariables> {
    document = GetUploadByIdQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEntityImportFieldsQueryDocument = gql`
    query GetEntityImportFieldsQuery($entityTypeId: ID!) {
  getEntityImportFields(entityTypeId: $entityTypeId) {
    displayName
    field
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEntityImportFieldsQueryGQL extends Apollo.Query<GetEntityImportFieldsQueryQuery, GetEntityImportFieldsQueryQueryVariables> {
    document = GetEntityImportFieldsQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUploadDownloadUrlDocument = gql`
    query GetUploadDownloadUrl($uploadId: ID!) {
  getUploadDownloadUrl(uploadId: $uploadId) {
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUploadDownloadUrlGQL extends Apollo.Query<GetUploadDownloadUrlQuery, GetUploadDownloadUrlQueryVariables> {
    document = GetUploadDownloadUrlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUploadErrorsUrlDocument = gql`
    query GetUploadErrorsUrl($uploadId: ID!) {
  getUploadErrorsUrl(uploadId: $uploadId) {
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUploadErrorsUrlGQL extends Apollo.Query<GetUploadErrorsUrlQuery, GetUploadErrorsUrlQueryVariables> {
    document = GetUploadErrorsUrlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateImportDocument = gql`
    mutation CreateImport($input: CreateImportInput!) {
  createImport(input: $input) {
    import {
      ...ImportDetails
    }
  }
}
    ${ImportDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateImportGQL extends Apollo.Mutation<CreateImportMutation, CreateImportMutationVariables> {
    document = CreateImportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteEntitiesDocument = gql`
    mutation DeleteEntities($input: DeleteEntitiesInput!) {
  deleteEntities(input: $input) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteEntitiesGQL extends Apollo.Mutation<DeleteEntitiesMutation, DeleteEntitiesMutationVariables> {
    document = DeleteEntitiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveEntitiesFromCampaignsDocument = gql`
    mutation RemoveEntitiesFromCampaigns($input: RemoveEntitiesFromCampaignsInput!) {
  removeEntitiesFromCampaigns(input: $input) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveEntitiesFromCampaignsGQL extends Apollo.Mutation<RemoveEntitiesFromCampaignsMutation, RemoveEntitiesFromCampaignsMutationVariables> {
    document = RemoveEntitiesFromCampaignsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateImportDocument = gql`
    mutation UpdateImport($input: UpdateImportInput!) {
  updateImport(input: $input) {
    import {
      ...ImportDetails
    }
  }
}
    ${ImportDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateImportGQL extends Apollo.Mutation<UpdateImportMutation, UpdateImportMutationVariables> {
    document = UpdateImportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDeleteEntitiesOperationDocument = gql`
    query GetDeleteEntitiesOperation($first: Int, $after: String) {
  getDeleteEntitiesOperations(first: $first, after: $after) {
    nodes {
      completedAt
      createdAt
      createdBy {
        email
        name
      }
      id
      notFound
      status
      totalDeleted
      totalSent
      updatedAt
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDeleteEntitiesOperationGQL extends Apollo.Query<GetDeleteEntitiesOperationQuery, GetDeleteEntitiesOperationQueryVariables> {
    document = GetDeleteEntitiesOperationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetImportErrorsUrlDocument = gql`
    query GetImportErrorsUrl($importId: ID!) {
  getImportErrorsUrl(importId: $importId) {
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetImportErrorsUrlGQL extends Apollo.Query<GetImportErrorsUrlQuery, GetImportErrorsUrlQueryVariables> {
    document = GetImportErrorsUrlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetImportDownloadUrlDocument = gql`
    query GetImportDownloadUrl($importId: ID!) {
  getImportDownloadUrl(importId: $importId) {
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetImportDownloadUrlGQL extends Apollo.Query<GetImportDownloadUrlQuery, GetImportDownloadUrlQueryVariables> {
    document = GetImportDownloadUrlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetImportsDocument = gql`
    query GetImports($first: Int, $after: String, $visibilityStatus: ImportVisibilityStatusType, $orderBy: String) {
  getImports(
    first: $first
    after: $after
    visibilityStatus: $visibilityStatus
    orderBy: $orderBy
  ) {
    nodes {
      ...ImportDetails
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    ${ImportDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetImportsGQL extends Apollo.Query<GetImportsQuery, GetImportsQueryVariables> {
    document = GetImportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRemoveEntitiesFromCampaignsOperationsDocument = gql`
    query GetRemoveEntitiesFromCampaignsOperations($first: Int, $after: String) {
  getRemoveEntitiesFromCampaignsOperations(first: $first, after: $after) {
    nodes {
      completedAt
      createdAt
      createdBy {
        email
        name
      }
      id
      notFoundIds
      removalCounts {
        entitiesRemoved
        campaign {
          id
          name
        }
      }
      status
      totalProcessed
      totalSent
      updatedAt
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRemoveEntitiesFromCampaignsOperationsGQL extends Apollo.Query<GetRemoveEntitiesFromCampaignsOperationsQuery, GetRemoveEntitiesFromCampaignsOperationsQueryVariables> {
    document = GetRemoveEntitiesFromCampaignsOperationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTagCategoriesFastDocument = gql`
    query GetTagCategoriesFast($campaignId: ID, $targetTypeId: ID, $targetType: String) {
  getTagCategories(
    campaignId: $campaignId
    targetTypeId: $targetTypeId
    targetType: $targetType
  ) {
    nodes {
      id
      name
      groupName
      allowToCreateTagType
      isUniversal
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTagCategoriesFastGQL extends Apollo.Query<GetTagCategoriesFastQuery, GetTagCategoriesFastQueryVariables> {
    document = GetTagCategoriesFastDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }